const AmexRegionOptions = (countryName) => {
  const regions = [
    {
      countryName: "AFGHANISTAN",
      regionCode: "BDS",
      regionName: "BADAKHSHAN",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "BDG",
      regionName: "BADGHIS",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "BGL",
      regionName: "BAGHLAN",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "BAL",
      regionName: "BALKH",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "BAM",
      regionName: "BAMIAN",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "DAY",
      regionName: "DAYKONDI",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "FRA",
      regionName: "FARAH",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "FYB",
      regionName: "FARYAB",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "GHA",
      regionName: "GHAZNI",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "GHO",
      regionName: "GHOWR",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "HEL",
      regionName: "HELMAND",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "HER",
      regionName: "HERAT",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "JOW",
      regionName: "JOWZJAN",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "KAB",
      regionName: "KABUL (KABOL)",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "KAN",
      regionName: "KANDAHAR",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "KAP",
      regionName: "KAPISA",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "KHO",
      regionName: "KHOWST",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "KNR",
      regionName: "KONAR (KUNAR)",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "KDZ",
      regionName: "KONDOZ (KUNDUZ)",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "LAG",
      regionName: "LAGHMAN",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "LOW",
      regionName: "LOWGAR",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "NAN",
      regionName: "NANGRAHAR (NANGARHAR)",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "NIM",
      regionName: "NIMRUZ",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "NUR",
      regionName: "NURESTAN",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "ORU",
      regionName: "ORUZGAN (URUZGAN)",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "PIA",
      regionName: "PAKTIA",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "PKA",
      regionName: "PAKTIKA",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "PAN",
      regionName: "PANJSHIR",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "PAR",
      regionName: "PARWAN",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "SAM",
      regionName: "SAMANGAN",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "SAR",
      regionName: "SAR-E POL",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "TAK",
      regionName: "TAKHAR",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "WAR",
      regionName: "WARDAK (WARDAG)",
    },
    {
      countryName: "AFGHANISTAN",
      regionCode: "ZAB",
      regionName: "ZABOL (ZABUL)",
    },
    {
      countryName: "ALAND ISLANDS",
      regionCode: "AX",
      regionName: "ALAND ISLANDS",
    },
    {
      countryName: "ALBANIA",
      regionCode: "BR",
      regionName: "BERAT",
    },
    {
      countryName: "ALBANIA",
      regionCode: "BU",
      regionName: "BULQIZE",
    },
    {
      countryName: "ALBANIA",
      regionCode: "DI",
      regionName: "DIBER",
    },
    {
      countryName: "ALBANIA",
      regionCode: "DL",
      regionName: "DELVINE",
    },
    {
      countryName: "ALBANIA",
      regionCode: "DR",
      regionName: "DURRES",
    },
    {
      countryName: "ALBANIA",
      regionCode: "DV",
      regionName: "DEVOLL",
    },
    {
      countryName: "ALBANIA",
      regionCode: "EL",
      regionName: "ELBASAN",
    },
    {
      countryName: "ALBANIA",
      regionCode: "ER",
      regionName: "KOLONJE",
    },
    {
      countryName: "ALBANIA",
      regionCode: "FR",
      regionName: "FIER",
    },
    {
      countryName: "ALBANIA",
      regionCode: "GJ",
      regionName: "GJIROKASTER",
    },
    {
      countryName: "ALBANIA",
      regionCode: "GR",
      regionName: "GRAMSH",
    },
    {
      countryName: "ALBANIA",
      regionCode: "HA",
      regionName: "HAS",
    },
    {
      countryName: "ALBANIA",
      regionCode: "KA",
      regionName: "KAVAJE",
    },
    {
      countryName: "ALBANIA",
      regionCode: "KB",
      regionName: "KURBIN",
    },
    {
      countryName: "ALBANIA",
      regionCode: "KC",
      regionName: "KUCOVE",
    },
    {
      countryName: "ALBANIA",
      regionCode: "KO",
      regionName: "KORCE",
    },
    {
      countryName: "ALBANIA",
      regionCode: "KR",
      regionName: "KRUJE",
    },
    {
      countryName: "ALBANIA",
      regionCode: "KU",
      regionName: "KUKES",
    },
    {
      countryName: "ALBANIA",
      regionCode: "LB",
      regionName: "LIBRAZHD",
    },
    {
      countryName: "ALBANIA",
      regionCode: "LE",
      regionName: "LEZHE",
    },
    {
      countryName: "ALBANIA",
      regionCode: "LU",
      regionName: "LUSHNJE",
    },
    {
      countryName: "ALBANIA",
      regionCode: "MK",
      regionName: "MALLAKASTER",
    },
    {
      countryName: "ALBANIA",
      regionCode: "MM",
      regionName: "MALESI E MADHE",
    },
    {
      countryName: "ALBANIA",
      regionCode: "MR",
      regionName: "MIRDITE",
    },
    {
      countryName: "ALBANIA",
      regionCode: "MT",
      regionName: "MAT",
    },
    {
      countryName: "ALBANIA",
      regionCode: "PG",
      regionName: "POGRADEC",
    },
    {
      countryName: "ALBANIA",
      regionCode: "PQ",
      regionName: "PEQIN",
    },
    {
      countryName: "ALBANIA",
      regionCode: "PR",
      regionName: "PERMET",
    },
    {
      countryName: "ALBANIA",
      regionCode: "PU",
      regionName: "PUKE",
    },
    {
      countryName: "ALBANIA",
      regionCode: "SH",
      regionName: "SHKODER",
    },
    {
      countryName: "ALBANIA",
      regionCode: "SK",
      regionName: "SKRAPAR",
    },
    {
      countryName: "ALBANIA",
      regionCode: "SR",
      regionName: "SARANDE",
    },
    {
      countryName: "ALBANIA",
      regionCode: "TE",
      regionName: "TEPELENE",
    },
    {
      countryName: "ALBANIA",
      regionCode: "TP",
      regionName: "TROPOJE",
    },
    {
      countryName: "ALBANIA",
      regionCode: "TR",
      regionName: "TIRANE",
    },
    {
      countryName: "ALBANIA",
      regionCode: "VL",
      regionName: "VLORE",
    },
    {
      countryName: "ALGERIA",
      regionCode: 1,
      regionName: "ADRAR",
    },
    {
      countryName: "ALGERIA",
      regionCode: 44,
      regionName: "AIN DEFLA",
    },
    {
      countryName: "ALGERIA",
      regionCode: 46,
      regionName: "AIN TEMOUCHENT",
    },
    {
      countryName: "ALGERIA",
      regionCode: 16,
      regionName: "ALGER",
    },
    {
      countryName: "ALGERIA",
      regionCode: 23,
      regionName: "ANNABA",
    },
    {
      countryName: "ALGERIA",
      regionCode: 5,
      regionName: "BATNA",
    },
    {
      countryName: "ALGERIA",
      regionCode: 8,
      regionName: "BECHAR",
    },
    {
      countryName: "ALGERIA",
      regionCode: 6,
      regionName: "BEJAIA",
    },
    {
      countryName: "ALGERIA",
      regionCode: 7,
      regionName: "BISKRA",
    },
    {
      countryName: "ALGERIA",
      regionCode: 9,
      regionName: "BLIDA",
    },
    {
      countryName: "ALGERIA",
      regionCode: 34,
      regionName: "BORDJ BOU ARRERIDJ",
    },
    {
      countryName: "ALGERIA",
      regionCode: 10,
      regionName: "BOUIRA",
    },
    {
      countryName: "ALGERIA",
      regionCode: 35,
      regionName: "BOUMERDES",
    },
    {
      countryName: "ALGERIA",
      regionCode: 2,
      regionName: "CHLEF",
    },
    {
      countryName: "ALGERIA",
      regionCode: 25,
      regionName: "CONSTANTINE",
    },
    {
      countryName: "ALGERIA",
      regionCode: 17,
      regionName: "DJELFA",
    },
    {
      countryName: "ALGERIA",
      regionCode: 32,
      regionName: "EL BAYADH",
    },
    {
      countryName: "ALGERIA",
      regionCode: 39,
      regionName: "EL OUED",
    },
    {
      countryName: "ALGERIA",
      regionCode: 36,
      regionName: "EL TARF",
    },
    {
      countryName: "ALGERIA",
      regionCode: 47,
      regionName: "GHARDAIA",
    },
    {
      countryName: "ALGERIA",
      regionCode: 24,
      regionName: "GUELMA",
    },
    {
      countryName: "ALGERIA",
      regionCode: 33,
      regionName: "ILLIZI",
    },
    {
      countryName: "ALGERIA",
      regionCode: 18,
      regionName: "JIJEL",
    },
    {
      countryName: "ALGERIA",
      regionCode: 40,
      regionName: "KHENCHELA",
    },
    {
      countryName: "ALGERIA",
      regionCode: 3,
      regionName: "LAGHOUAT",
    },
    {
      countryName: "ALGERIA",
      regionCode: 29,
      regionName: "MASCARA",
    },
    {
      countryName: "ALGERIA",
      regionCode: 26,
      regionName: "MEDEA",
    },
    {
      countryName: "ALGERIA",
      regionCode: 43,
      regionName: "MILA",
    },
    {
      countryName: "ALGERIA",
      regionCode: 27,
      regionName: "MOSTAGANEM",
    },
    {
      countryName: "ALGERIA",
      regionCode: 28,
      regionName: "MSILA",
    },
    {
      countryName: "ALGERIA",
      regionCode: 45,
      regionName: "NAAMA",
    },
    {
      countryName: "ALGERIA",
      regionCode: 31,
      regionName: "ORAN",
    },
    {
      countryName: "ALGERIA",
      regionCode: 30,
      regionName: "OUARGLA",
    },
    {
      countryName: "ALGERIA",
      regionCode: 4,
      regionName: "OUM EL",
    },
    {
      countryName: "ALGERIA",
      regionCode: 48,
      regionName: "RELIZANE",
    },
    {
      countryName: "ALGERIA",
      regionCode: 20,
      regionName: "SAIDA",
    },
    {
      countryName: "ALGERIA",
      regionCode: 19,
      regionName: "SETIF",
    },
    {
      countryName: "ALGERIA",
      regionCode: 22,
      regionName: "SIDI BEL",
    },
    {
      countryName: "ALGERIA",
      regionCode: 21,
      regionName: "SKIKDA",
    },
    {
      countryName: "ALGERIA",
      regionCode: 41,
      regionName: "SOUK AHRAS",
    },
    {
      countryName: "ALGERIA",
      regionCode: 11,
      regionName: "TAMANGHASSET",
    },
    {
      countryName: "ALGERIA",
      regionCode: 12,
      regionName: "TEBESSA",
    },
    {
      countryName: "ALGERIA",
      regionCode: 14,
      regionName: "TIARET",
    },
    {
      countryName: "ALGERIA",
      regionCode: 37,
      regionName: "TINDOUF",
    },
    {
      countryName: "ALGERIA",
      regionCode: 42,
      regionName: "TIPAZA",
    },
    {
      countryName: "ALGERIA",
      regionCode: 38,
      regionName: "TISSEMSILT",
    },
    {
      countryName: "ALGERIA",
      regionCode: 15,
      regionName: "TIZI OUZOU",
    },
    {
      countryName: "ALGERIA",
      regionCode: 13,
      regionName: "TLEMCEN",
    },
    {
      countryName: "AMERICAN SAMOA",
      regionCode: "AS",
      regionName: "AMERICAN SAMOA",
    },
    {
      countryName: "ANDORRA",
      regionCode: 7,
      regionName: "ANDORRA LA VELLA",
    },
    {
      countryName: "ANDORRA",
      regionCode: 2,
      regionName: "CANILLO",
    },
    {
      countryName: "ANDORRA",
      regionCode: 3,
      regionName: "ENCAMP",
    },
    {
      countryName: "ANDORRA",
      regionCode: 8,
      regionName: "ESCALDES-ENGORDANY",
    },
    {
      countryName: "ANDORRA",
      regionCode: 4,
      regionName: "LA MASSANA",
    },
    {
      countryName: "ANDORRA",
      regionCode: 5,
      regionName: "ORDIO",
    },
    {
      countryName: "ANDORRA",
      regionCode: 6,
      regionName: "SANT JULIA DE LORIA",
    },
    {
      countryName: "ANGOLA",
      regionCode: "BGO",
      regionName: "BENGO",
    },
    {
      countryName: "ANGOLA",
      regionCode: "BGU",
      regionName: "BENGUELA",
    },
    {
      countryName: "ANGOLA",
      regionCode: "BIE",
      regionName: "BIE",
    },
    {
      countryName: "ANGOLA",
      regionCode: "CAB",
      regionName: "CABINDA",
    },
    {
      countryName: "ANGOLA",
      regionCode: "CCU",
      regionName: "CUANCUBANGO",
    },
    {
      countryName: "ANGOLA",
      regionCode: "CNN",
      regionName: "CUNENE",
    },
    {
      countryName: "ANGOLA",
      regionCode: "CNO",
      regionName: "CUANZA NORTE",
    },
    {
      countryName: "ANGOLA",
      regionCode: "CUS",
      regionName: "CUANZA SUL",
    },
    {
      countryName: "ANGOLA",
      regionCode: "HUA",
      regionName: "HUAMBO",
    },
    {
      countryName: "ANGOLA",
      regionCode: "HUI",
      regionName: "HUILA",
    },
    {
      countryName: "ANGOLA",
      regionCode: "LNO",
      regionName: "LUNDA NORTE",
    },
    {
      countryName: "ANGOLA",
      regionCode: "LSU",
      regionName: "LUNDA SUL",
    },
    {
      countryName: "ANGOLA",
      regionCode: "LUA",
      regionName: "LUANDA",
    },
    {
      countryName: "ANGOLA",
      regionCode: "MAL",
      regionName: "MALANGE",
    },
    {
      countryName: "ANGOLA",
      regionCode: "MOX",
      regionName: "MOXICO",
    },
    {
      countryName: "ANGOLA",
      regionCode: "NAM",
      regionName: "NAMIBE",
    },
    {
      countryName: "ANGOLA",
      regionCode: "UIG",
      regionName: "UIGE",
    },
    {
      countryName: "ANGOLA",
      regionCode: "ZAI",
      regionName: "ZAIRE",
    },
    {
      countryName: "ANGUILLA",
      regionCode: "AI",
      regionName: "ANGUILLA",
    },
    {
      countryName: "ANTARCTICA",
      regionCode: "AQ",
      regionName: "ANTARCTICA",
    },
    {
      countryName: "ANTIGUA AND BARBUDA",
      regionCode: 10,
      regionName: "BARBUDA",
    },
    {
      countryName: "ANTIGUA AND BARBUDA",
      regionCode: 3,
      regionName: "SAINT GEORGE",
    },
    {
      countryName: "ANTIGUA AND BARBUDA",
      regionCode: 4,
      regionName: "SAINT JOHN’S",
    },
    {
      countryName: "ANTIGUA AND BARBUDA",
      regionCode: 5,
      regionName: "SAINT MARY",
    },
    {
      countryName: "ANTIGUA AND BARBUDA",
      regionCode: 6,
      regionName: "SAINT PAUL",
    },
    {
      countryName: "ANTIGUA AND BARBUDA",
      regionCode: 7,
      regionName: "SAINT PETER",
    },
    {
      countryName: "ANTIGUA AND BARBUDA",
      regionCode: 8,
      regionName: "SAINT PHILIP",
    },
    {
      countryName: "ARGENTINA",
      regionCode: "B",
      regionName: "BUENOS AIRES",
    },
    {
      countryName: "ARGENTINA",
      regionCode: "K",
      regionName: "CATAMARCA",
    },
    {
      countryName: "ARGENTINA",
      regionCode: "H",
      regionName: "CHACO",
    },
    {
      countryName: "ARGENTINA",
      regionCode: "U",
      regionName: "CHUBUT",
    },
    {
      countryName: "ARGENTINA",
      regionCode: "C",
      regionName: "CIUDAD DE BUENOS AIRES",
    },
    {
      countryName: "ARGENTINA",
      regionCode: "X",
      regionName: "CORDOBA",
    },
    {
      countryName: "ARGENTINA",
      regionCode: "W",
      regionName: "CORRIENTES",
    },
    {
      countryName: "ARGENTINA",
      regionCode: "E",
      regionName: "ENTRE RIOS",
    },
    {
      countryName: "ARGENTINA",
      regionCode: "P",
      regionName: "FORMOSA",
    },
    {
      countryName: "ARGENTINA",
      regionCode: "Y",
      regionName: "JUJUY",
    },
    {
      countryName: "ARGENTINA",
      regionCode: "L",
      regionName: "LA PAMPA",
    },
    {
      countryName: "ARGENTINA",
      regionCode: "F",
      regionName: "LA RIOJA",
    },
    {
      countryName: "ARGENTINA",
      regionCode: "M",
      regionName: "MENDOZA",
    },
    {
      countryName: "ARGENTINA",
      regionCode: "N",
      regionName: "MISIONES",
    },
    {
      countryName: "ARGENTINA",
      regionCode: "Q",
      regionName: "NEUQUEN",
    },
    {
      countryName: "ARGENTINA",
      regionCode: "R",
      regionName: "RIO NEGRO",
    },
    {
      countryName: "ARGENTINA",
      regionCode: "A",
      regionName: "SALTA",
    },
    {
      countryName: "ARGENTINA",
      regionCode: "J",
      regionName: "SAN JUAN",
    },
    {
      countryName: "ARGENTINA",
      regionCode: "D",
      regionName: "SAN LUIS",
    },
    {
      countryName: "ARGENTINA",
      regionCode: "Z",
      regionName: "SANTA CRUZ",
    },
    {
      countryName: "ARGENTINA",
      regionCode: "S",
      regionName: "SANTA FE",
    },
    {
      countryName: "ARGENTINA",
      regionCode: "G",
      regionName: "SANTIAGO DEL ESTERO",
    },
    {
      countryName: "ARGENTINA",
      regionCode: "V",
      regionName: "TIERRA DEL FUEGO",
    },
    {
      countryName: "ARGENTINA",
      regionCode: "T",
      regionName: "TUCUMAN",
    },
    {
      countryName: "ARMENIA",
      regionCode: "AG",
      regionName: "ARAGACOTN",
    },
    {
      countryName: "ARMENIA",
      regionCode: "AR",
      regionName: "ARARAT",
    },
    {
      countryName: "ARMENIA",
      regionCode: "AV",
      regionName: "ARMAVIR",
    },
    {
      countryName: "ARMENIA",
      regionCode: "ER",
      regionName: "EREVAN",
    },
    {
      countryName: "ARMENIA",
      regionCode: "GR",
      regionName: "GEGARK UNIK",
    },
    {
      countryName: "ARMENIA",
      regionCode: "KT",
      regionName: "KOTAYK",
    },
    {
      countryName: "ARMENIA",
      regionCode: "LO",
      regionName: "LORY",
    },
    {
      countryName: "ARMENIA",
      regionCode: "SH",
      regionName: "SIRAK",
    },
    {
      countryName: "ARMENIA",
      regionCode: "SU",
      regionName: "SYUNIK",
    },
    {
      countryName: "ARMENIA",
      regionCode: "TV",
      regionName: "TAVUS",
    },
    {
      countryName: "ARMENIA",
      regionCode: "VD",
      regionName: "VAYOC JOR",
    },
    {
      countryName: "ARUBA",
      regionCode: "AW",
      regionName: "ARUBA",
    },
    {
      countryName: "AUSTRALIA",
      regionCode: "ACT",
      regionName: "AUSTRALIAN CAPITAL TERRITORY",
    },
    {
      countryName: "AUSTRALIA",
      regionCode: "NSW",
      regionName: "NEW SOUTH WALES",
    },
    {
      countryName: "AUSTRALIA",
      regionCode: "NT",
      regionName: "NORTHERN TERRITORY",
    },
    {
      countryName: "AUSTRALIA",
      regionCode: "QLD",
      regionName: "QUEENSLAND",
    },
    {
      countryName: "AUSTRALIA",
      regionCode: "SA",
      regionName: "SOUTH AUSTRALIA",
    },
    {
      countryName: "AUSTRALIA",
      regionCode: "TAS",
      regionName: "TASMANIA",
    },
    {
      countryName: "AUSTRALIA",
      regionCode: "VIC",
      regionName: "VICTORIA",
    },
    {
      countryName: "AUSTRALIA",
      regionCode: "WA",
      regionName: "WESTERN AUSTRALIA",
    },
    {
      countryName: "AUSTRIA",
      regionCode: 1,
      regionName: "BURGENLAND",
    },
    {
      countryName: "AUSTRIA",
      regionCode: 2,
      regionName: "KARNTEN",
    },
    {
      countryName: "AUSTRIA",
      regionCode: 3,
      regionName: "NIEDEROSTERREICH",
    },
    {
      countryName: "AUSTRIA",
      regionCode: 4,
      regionName: "OBEROSTERREICH",
    },
    {
      countryName: "AUSTRIA",
      regionCode: 5,
      regionName: "SALZBURG",
    },
    {
      countryName: "AUSTRIA",
      regionCode: 6,
      regionName: "STEIERMARK",
    },
    {
      countryName: "AUSTRIA",
      regionCode: 7,
      regionName: "TIROL",
    },
    {
      countryName: "AUSTRIA",
      regionCode: 8,
      regionName: "VORARLBERG",
    },
    {
      countryName: "AUSTRIA",
      regionCode: 9,
      regionName: "WIEN",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "AB",
      regionName: "ALI BAYRAMLI",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "ABS",
      regionName: "ABSERON",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "AGA",
      regionName: "AGSTAFA",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "AGC",
      regionName: "AGCABADI",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "AGM",
      regionName: "AGDAM",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "AGS",
      regionName: "AGDAS",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "AGU",
      regionName: "AGSU",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "AST",
      regionName: "ASTARA",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "BA",
      regionName: "BAKI",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "BAB",
      regionName: "BABAK",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "BAL",
      regionName: "BALAKAN",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "BAR",
      regionName: "BARDA",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "BEY",
      regionName: "BEYLAQAN",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "BIL",
      regionName: "BILASUVAR",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "CAB",
      regionName: "CABRAYIL",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "CAL",
      regionName: "CALILABAD",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "CUL",
      regionName: "CULFA",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "DAS",
      regionName: "DASKASAN",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "DAV",
      regionName: "DAVACI",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "FUZ",
      regionName: "FUZULI",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "GA",
      regionName: "GANCA",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "GAD",
      regionName: "GADABAY",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "GOR",
      regionName: "GORANBOY",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "GOY",
      regionName: "GOYCAY",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "HAC",
      regionName: "HACIQABUL",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "IMI",
      regionName: "IMISLI",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "ISM",
      regionName: "ISMAYILLI",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "KAL",
      regionName: "KALBACAR",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "KUR",
      regionName: "KURDAMIR",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "LA",
      regionName: "LANKARAN",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "LAC",
      regionName: "LACIN",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "LAN",
      regionName: "LANKARAN",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "LER",
      regionName: "LERIK",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "MAS",
      regionName: "MASALLI",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "MI",
      regionName: "MINGACEVIR",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "NA",
      regionName: "NAFTALAN",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "NEF",
      regionName: "NEFTCALA",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "NX",
      regionName: "NAXCIVAN",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "OGU",
      regionName: "OGUZ",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "ORD",
      regionName: "ORDUBAD",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "QAB",
      regionName: "QABALA",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "QAX",
      regionName: "QAX",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "QAZ",
      regionName: "QAZAX",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "QBA",
      regionName: "QUBA",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "QBI",
      regionName: "QUBADLI",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "QOB",
      regionName: "QOBUSTAN",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "QUS",
      regionName: "QUSAR",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "SA",
      regionName: "SAKI",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "SAB",
      regionName: "SABIRABAD",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "SAD",
      regionName: "SADARAK",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "SAH",
      regionName: "SAHBUZ",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "SAK",
      regionName: "SAKI",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "SAL",
      regionName: "SALYAN",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "SAR",
      regionName: "SARUR",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "SAT",
      regionName: "SAATLI",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "SIY",
      regionName: "SIYAZAN",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "SKR",
      regionName: "SAMKIR",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "SM",
      regionName: "SUMQAYIT",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "SMI",
      regionName: "SAMAXI",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "SMX",
      regionName: "SAMUX",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "SS",
      regionName: "SUSA",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "SUS",
      regionName: "SUSA",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "TAR",
      regionName: "TARTAR",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "TOV",
      regionName: "TOVUZ",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "UCA",
      regionName: "UCAR",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "XA",
      regionName: "XANKANDI",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "XAC",
      regionName: "XACMAZ",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "XAN",
      regionName: "XANLAR",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "XCI",
      regionName: "XOCALI",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "XIZ",
      regionName: "XIZI",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "XVD",
      regionName: "XOCAVAND",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "YAR",
      regionName: "YARDIMLI",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "YE",
      regionName: "YEVLAX",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "YEV",
      regionName: "YEVLAX",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "ZAN",
      regionName: "ZANGILAN",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "ZAQ",
      regionName: "ZAQATALA",
    },
    {
      countryName: "AZERBAIJAN",
      regionCode: "ZAR",
      regionName: "ZARDAB",
    },
    {
      countryName: "BAHAMAS",
      regionCode: "AC",
      regionName: "ACKLINS AND CROOKED ISLANDS",
    },
    {
      countryName: "BAHAMAS",
      regionCode: "BI",
      regionName: "BIMINI",
    },
    {
      countryName: "BAHAMAS",
      regionCode: "CI",
      regionName: "CAT ISLAND",
    },
    {
      countryName: "BAHAMAS",
      regionCode: "EX",
      regionName: "EXUMA",
    },
    {
      countryName: "BAHAMAS",
      regionCode: "FC",
      regionName: "FRESH CREEK",
    },
    {
      countryName: "BAHAMAS",
      regionCode: "FP",
      regionName: "FREEPORT",
    },
    {
      countryName: "BAHAMAS",
      regionCode: "GH",
      regionName: "GOVERNOR’S HARBOUR",
    },
    {
      countryName: "BAHAMAS",
      regionCode: "GT",
      regionName: "GREEN TURTLE CAY",
    },
    {
      countryName: "BAHAMAS",
      regionCode: "HI",
      regionName: "HARBOUR ISLAND",
    },
    {
      countryName: "BAHAMAS",
      regionCode: "HR",
      regionName: "HIGH ROCK",
    },
    {
      countryName: "BAHAMAS",
      regionCode: "IN",
      regionName: "INAGUA",
    },
    {
      countryName: "BAHAMAS",
      regionCode: "KB",
      regionName: "KEMPS BAY",
    },
    {
      countryName: "BAHAMAS",
      regionCode: "LI",
      regionName: "LONG ISLAND",
    },
    {
      countryName: "BAHAMAS",
      regionCode: "MG",
      regionName: "MAYAGUANA",
    },
    {
      countryName: "BAHAMAS",
      regionCode: "MH",
      regionName: "MARSH HARBOUR",
    },
    {
      countryName: "BAHAMAS",
      regionCode: "NB",
      regionName: "NICHOLLS TOWN AND BERRY ISLAND",
    },
    {
      countryName: "BAHAMAS",
      regionCode: "NP",
      regionName: "NEW PROVIDENCE",
    },
    {
      countryName: "BAHAMAS",
      regionCode: "RI",
      regionName: "RAGGED ISLAND",
    },
    {
      countryName: "BAHAMAS",
      regionCode: "RS",
      regionName: "ROCK SOUND",
    },
    {
      countryName: "BAHAMAS",
      regionCode: "SP",
      regionName: "SANDY POINT",
    },
    {
      countryName: "BAHAMAS",
      regionCode: "SR",
      regionName: "SAN SALVADOR AND RUM CAY",
    },
    {
      countryName: "BAHRAIN",
      regionCode: 14,
      regionName: "AL JANUBIYAH",
    },
    {
      countryName: "BAHRAIN",
      regionCode: 13,
      regionName: "AL MANAMAH (AL ASIMAH)",
    },
    {
      countryName: "BAHRAIN",
      regionCode: 15,
      regionName: "AL MUHARRAQ",
    },
    {
      countryName: "BAHRAIN",
      regionCode: 16,
      regionName: "AL WUSTA",
    },
    {
      countryName: "BAHRAIN",
      regionCode: 17,
      regionName: "ASH SHAMALIYAH",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 1,
      regionName: "BANDARBAN ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 2,
      regionName: "BARGUNA ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 3,
      regionName: "BOGRA ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 4,
      regionName: "BRAHMANBARIA ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 5,
      regionName: "BAGERHAT ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 6,
      regionName: "BARISAL ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 7,
      regionName: "BHOLA ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 8,
      regionName: "COMILLA ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 9,
      regionName: "CHANDPUR ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 10,
      regionName: "CHITTAGONG ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 11,
      regionName: "COX’S BAZAR ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 12,
      regionName: "CHUADANGA ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 13,
      regionName: "DHAKA ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 14,
      regionName: "DINAJPUR ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 15,
      regionName: "FARIDPUR ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 16,
      regionName: "FENI ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 17,
      regionName: "GOPALGANJ ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 18,
      regionName: "GAZIPUR ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 19,
      regionName: "GAIBANDHA ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 20,
      regionName: "HABIGANJ ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 21,
      regionName: "JAMALPUR ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 22,
      regionName: "JESSORE ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 23,
      regionName: "JHENAIDAH ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 24,
      regionName: "JAIPURHAT ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 25,
      regionName: "JHALAKATI ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 26,
      regionName: "KISHOREGANJ ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 27,
      regionName: "KHULNA ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 28,
      regionName: "KURIGRAM ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 29,
      regionName: "KHAGRACHARI ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 30,
      regionName: "KUSHTIA ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 31,
      regionName: "LAKSHMIPUR ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 32,
      regionName: "LALMONIRHAT ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 33,
      regionName: "MANIKGANJ ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 34,
      regionName: "MYMENSINGH ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 35,
      regionName: "MUNSHIGANJ ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 36,
      regionName: "MADARIPUR ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 37,
      regionName: "MAGURA ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 38,
      regionName: "MOULVIBAZAR ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 39,
      regionName: "MEHERPUR ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 40,
      regionName: "NARAYANGANJ ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 41,
      regionName: "NETRAKONA ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 42,
      regionName: "NARSINGDI ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 43,
      regionName: "NARAIL ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 44,
      regionName: "NATORE ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 45,
      regionName: "NAWABGANJ ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 46,
      regionName: "NILPHAMARI ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 47,
      regionName: "NOAKHALI ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 48,
      regionName: "NAOGAON ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 49,
      regionName: "PABNA ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 50,
      regionName: "PIROJPUR ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 51,
      regionName: "PATUAKHALI ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 52,
      regionName: "PANCHAGARH ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 53,
      regionName: "RAJBARI ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 54,
      regionName: "RAJSHAHI ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 55,
      regionName: "RANGPUR ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 56,
      regionName: "RANGAMATI ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 57,
      regionName: "SHERPUR ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 58,
      regionName: "SATKHIRA ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 59,
      regionName: "SIRAJGANJ ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 60,
      regionName: "SYLHET ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 61,
      regionName: "SUNAMGANJ ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 62,
      regionName: "SHARIATPUR ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 63,
      regionName: "TANGAIL ZILA",
    },
    {
      countryName: "BANGLADESH",
      regionCode: 64,
      regionName: "THAKURGAON ZILA",
    },
    {
      countryName: "BARBADOS",
      regionCode: 1,
      regionName: "CHRIST CHURCH",
    },
    {
      countryName: "BARBADOS",
      regionCode: 2,
      regionName: "SAINT ANDREW",
    },
    {
      countryName: "BARBADOS",
      regionCode: 3,
      regionName: "SAINT GEORGE",
    },
    {
      countryName: "BARBADOS",
      regionCode: 4,
      regionName: "SAINT JAMES",
    },
    {
      countryName: "BARBADOS",
      regionCode: 5,
      regionName: "SAINT JOHN",
    },
    {
      countryName: "BARBADOS",
      regionCode: 6,
      regionName: "SAINT JOSEPH",
    },
    {
      countryName: "BARBADOS",
      regionCode: 7,
      regionName: "SAINT LUCY",
    },
    {
      countryName: "BARBADOS",
      regionCode: 8,
      regionName: "SAINT MICHAEL",
    },
    {
      countryName: "BARBADOS",
      regionCode: 9,
      regionName: "SAINT PETER",
    },
    {
      countryName: "BARBADOS",
      regionCode: 10,
      regionName: "SAINT PHILIP",
    },
    {
      countryName: "BARBADOS",
      regionCode: 11,
      regionName: "SAINT THOMAS",
    },
    {
      countryName: "BELARUS",
      regionCode: "BR",
      regionName: "BRESTSKAYA VOBLASTS (BE)",
    },
    {
      countryName: "BELARUS",
      regionCode: "HO",
      regionName: "HOMYEL SKAYA VOBLASTS (BE)",
    },
    {
      countryName: "BELARUS",
      regionCode: "HR",
      regionName: "HRODZENSKAYA VOBLASTS (BE)",
    },
    {
      countryName: "BELARUS",
      regionCode: "MA",
      regionName: "MAHILYOWSKAYA VOBLASTS (BE)",
    },
    {
      countryName: "BELARUS",
      regionCode: "MI",
      regionName: "MINSKAYA VOBLASTS (BE)",
    },
    {
      countryName: "BELARUS",
      regionCode: "VI",
      regionName: "VITSYEBSKAYA VOBLASTS (BE)",
    },
    {
      countryName: "BELGIUM",
      regionCode: "VAN",
      regionName: "ANTWERPEN",
    },
    {
      countryName: "BELGIUM",
      regionCode: "WBR",
      regionName: "BRABANT WALLON",
    },
    {
      countryName: "BELGIUM",
      regionCode: "WHT",
      regionName: "HAINAUT",
    },
    {
      countryName: "BELGIUM",
      regionCode: "WLG",
      regionName: "LIEGE",
    },
    {
      countryName: "BELGIUM",
      regionCode: "VLI",
      regionName: "LIMBURG",
    },
    {
      countryName: "BELGIUM",
      regionCode: "WLX",
      regionName: "LUXEMBOURG",
    },
    {
      countryName: "BELGIUM",
      regionCode: "WNA",
      regionName: "NAMUR",
    },
    {
      countryName: "BELGIUM",
      regionCode: "VOV",
      regionName: "OOST-VLAANDEREN",
    },
    {
      countryName: "BELGIUM",
      regionCode: "VBR",
      regionName: "VLAAMS BRABANT",
    },
    {
      countryName: "BELGIUM",
      regionCode: "VWV",
      regionName: "WEST-VLAANDEREN",
    },
    {
      countryName: "BELIZE",
      regionCode: "CY",
      regionName: "CAYO",
    },
    {
      countryName: "BELIZE",
      regionCode: "CZL",
      regionName: "COROZAL",
    },
    {
      countryName: "BELIZE",
      regionCode: "OW",
      regionName: "ORANGE WALK",
    },
    {
      countryName: "BELIZE",
      regionCode: "SC",
      regionName: "STANN CREEK",
    },
    {
      countryName: "BELIZE",
      regionCode: "TOL",
      regionName: "TOLEDO",
    },
    {
      countryName: "BENIN",
      regionCode: "AK",
      regionName: "ATAKORA",
    },
    {
      countryName: "BENIN",
      regionCode: "AL",
      regionName: "ALIBORI",
    },
    {
      countryName: "BENIN",
      regionCode: "AQ",
      regionName: "ATLANTIQUE",
    },
    {
      countryName: "BENIN",
      regionCode: "BO",
      regionName: "BORGOU",
    },
    {
      countryName: "BENIN",
      regionCode: "CO",
      regionName: "COLLINES",
    },
    {
      countryName: "BENIN",
      regionCode: "DO",
      regionName: "DONGA",
    },
    {
      countryName: "BENIN",
      regionCode: "KO",
      regionName: "KOUFFO",
    },
    {
      countryName: "BENIN",
      regionCode: "LI",
      regionName: "LITTORAL",
    },
    {
      countryName: "BENIN",
      regionCode: "MO",
      regionName: "MONO",
    },
    {
      countryName: "BENIN",
      regionCode: "OU",
      regionName: "OUEME",
    },
    {
      countryName: "BENIN",
      regionCode: "PL",
      regionName: "PLATEAU",
    },
    {
      countryName: "BENIN",
      regionCode: "ZO",
      regionName: "ZOU",
    },
    {
      countryName: "BERMUDA",
      regionCode: "BM",
      regionName: "BERMUDA",
    },
    {
      countryName: "BHUTAN",
      regionCode: 33,
      regionName: "BUMTHANG",
    },
    {
      countryName: "BHUTAN",
      regionCode: 12,
      regionName: "CHHUKHA",
    },
    {
      countryName: "BHUTAN",
      regionCode: 22,
      regionName: "DAGANA",
    },
    {
      countryName: "BHUTAN",
      regionCode: "GA",
      regionName: "GASA",
    },
    {
      countryName: "BHUTAN",
      regionCode: 13,
      regionName: "HA",
    },
    {
      countryName: "BHUTAN",
      regionCode: 44,
      regionName: "LHUENTSE",
    },
    {
      countryName: "BHUTAN",
      regionCode: 42,
      regionName: "MONGGAR",
    },
    {
      countryName: "BHUTAN",
      regionCode: 11,
      regionName: "PARO",
    },
    {
      countryName: "BHUTAN",
      regionCode: 43,
      regionName: "PEMAGATSHEL",
    },
    {
      countryName: "BHUTAN",
      regionCode: 23,
      regionName: "PUNAKHA",
    },
    {
      countryName: "BHUTAN",
      regionCode: 45,
      regionName: "SAMDRUP JONGKHA",
    },
    {
      countryName: "BHUTAN",
      regionCode: 14,
      regionName: "SAMTSE",
    },
    {
      countryName: "BHUTAN",
      regionCode: 31,
      regionName: "SARPANG",
    },
    {
      countryName: "BHUTAN",
      regionCode: 15,
      regionName: "THIMPHU",
    },
    {
      countryName: "BHUTAN",
      regionCode: "TY",
      regionName: "TRASHI YANGTSE",
    },
    {
      countryName: "BHUTAN",
      regionCode: 41,
      regionName: "TRASHIGANG",
    },
    {
      countryName: "BHUTAN",
      regionCode: 32,
      regionName: "TRONGSA",
    },
    {
      countryName: "BHUTAN",
      regionCode: 21,
      regionName: "TSIRANG",
    },
    {
      countryName: "BHUTAN",
      regionCode: 24,
      regionName: "WANGDUE PHODRANG",
    },
    {
      countryName: "BHUTAN",
      regionCode: 34,
      regionName: "ZHEMGANG",
    },
    {
      countryName: "BOLIVIA (Plurinational State of)",
      regionCode: "H",
      regionName: "CHUQUISACA",
    },
    {
      countryName: "BOLIVIA (Plurinational State of)",
      regionCode: "C",
      regionName: "COCHABAMBA",
    },
    {
      countryName: "BOLIVIA (Plurinational State of)",
      regionCode: "B",
      regionName: "EL BENI",
    },
    {
      countryName: "BOLIVIA (Plurinational State of)",
      regionCode: "L",
      regionName: "LA PAZ",
    },
    {
      countryName: "BOLIVIA (Plurinational State of)",
      regionCode: "O",
      regionName: "ORURO",
    },
    {
      countryName: "BOLIVIA (Plurinational State of)",
      regionCode: "N",
      regionName: "PANDO",
    },
    {
      countryName: "BOLIVIA (Plurinational State of)",
      regionCode: "P",
      regionName: "POTOSI",
    },
    {
      countryName: "BOLIVIA (Plurinational State of)",
      regionCode: "S",
      regionName: "SANTA CRUZ",
    },
    {
      countryName: "BOLIVIA (Plurinational State of)",
      regionCode: "T",
      regionName: "TARIJA",
    },
    {
      countryName: "BONAIRE, SINT EUSTATIUS & SABA",
      regionCode: "BQ",
      regionName: "BONAIRE, SINT EUSTATIUS AND SABA",
    },
    {
      countryName: "BOSNIA AND HERZEGOVINA",
      regionCode: 5,
      regionName: "BOSANSKO-PODRINJSKI KANTON",
    },
    {
      countryName: "BOSNIA AND HERZEGOVINA",
      regionCode: 10,
      regionName: "HERCEGOVACKO-BOSANSKI     KANTON",
    },
    {
      countryName: "BOSNIA AND HERZEGOVINA",
      regionCode: 7,
      regionName: "HERCEGOVACKO-NERETVANSKI     KANTON",
    },
    {
      countryName: "BOSNIA AND HERZEGOVINA",
      regionCode: 9,
      regionName: "KANTON SARAJEVO",
    },
    {
      countryName: "BOSNIA AND HERZEGOVINA",
      regionCode: 2,
      regionName: "POSAVSKI KANTON",
    },
    {
      countryName: "BOSNIA AND HERZEGOVINA",
      regionCode: 6,
      regionName: "SREDNJOBOSANSKI KANTON",
    },
    {
      countryName: "BOSNIA AND HERZEGOVINA",
      regionCode: 3,
      regionName: "TUZLANSKI KANTON",
    },
    {
      countryName: "BOSNIA AND HERZEGOVINA",
      regionCode: 1,
      regionName: "UNSKO-SANSKI KANTON",
    },
    {
      countryName: "BOSNIA AND HERZEGOVINA",
      regionCode: 8,
      regionName: "ZAPADNO-HERCEGOVACKI KANTON",
    },
    {
      countryName: "BOSNIA AND HERZEGOVINA",
      regionCode: 4,
      regionName: "ZENICKO-DOBOJSKI KANTON",
    },
    {
      countryName: "BOTSWANA",
      regionCode: "CE",
      regionName: "CENTRAL",
    },
    {
      countryName: "BOTSWANA",
      regionCode: "GH",
      regionName: "GHANZI",
    },
    {
      countryName: "BOTSWANA",
      regionCode: "KG",
      regionName: "KGALAGADI",
    },
    {
      countryName: "BOTSWANA",
      regionCode: "KL",
      regionName: "KGATLENG",
    },
    {
      countryName: "BOTSWANA",
      regionCode: "KW",
      regionName: "KWENENG",
    },
    {
      countryName: "BOTSWANA",
      regionCode: "NE",
      regionName: "NORTH-EAST",
    },
    {
      countryName: "BOTSWANA",
      regionCode: "NW",
      regionName: "NORTH-WEST",
    },
    {
      countryName: "BOTSWANA",
      regionCode: "SE",
      regionName: "SOUTH-EAST",
    },
    {
      countryName: "BOTSWANA",
      regionCode: "SO",
      regionName: "SOUTHERN",
    },
    {
      countryName: "BOUVET ISLAND",
      regionCode: "BV",
      regionName: "BOUVET ISLAND",
    },
    {
      countryName: "BRAZIL",
      regionCode: "AC",
      regionName: "ACRE",
    },
    {
      countryName: "BRAZIL",
      regionCode: "AL",
      regionName: "ALAGOAS",
    },
    {
      countryName: "BRAZIL",
      regionCode: "AM",
      regionName: "AMAZONAS",
    },
    {
      countryName: "BRAZIL",
      regionCode: "AP",
      regionName: "AMAPA",
    },
    {
      countryName: "BRAZIL",
      regionCode: "BA",
      regionName: "BAHIA",
    },
    {
      countryName: "BRAZIL",
      regionCode: "CE",
      regionName: "CEARA",
    },
    {
      countryName: "BRAZIL",
      regionCode: "DF",
      regionName: "DISTRITO FEDERAL",
    },
    {
      countryName: "BRAZIL",
      regionCode: "ES",
      regionName: "ESPIRITO SANTO",
    },
    {
      countryName: "BRAZIL",
      regionCode: "GO",
      regionName: "GOIAS",
    },
    {
      countryName: "BRAZIL",
      regionCode: "MA",
      regionName: "MARANHAO",
    },
    {
      countryName: "BRAZIL",
      regionCode: "MG",
      regionName: "MINAS GERAIS",
    },
    {
      countryName: "BRAZIL",
      regionCode: "MS",
      regionName: "MATO GROSSO DO SUL",
    },
    {
      countryName: "BRAZIL",
      regionCode: "MT",
      regionName: "MATO GROSSO",
    },
    {
      countryName: "BRAZIL",
      regionCode: "PA",
      regionName: "PARA",
    },
    {
      countryName: "BRAZIL",
      regionCode: "PB",
      regionName: "PARAIBA",
    },
    {
      countryName: "BRAZIL",
      regionCode: "PE",
      regionName: "PERNAMBUCO",
    },
    {
      countryName: "BRAZIL",
      regionCode: "PI",
      regionName: "PIAUI",
    },
    {
      countryName: "BRAZIL",
      regionCode: "PR",
      regionName: "PARANA",
    },
    {
      countryName: "BRAZIL",
      regionCode: "RJ",
      regionName: "RIO DE JANEIRO",
    },
    {
      countryName: "BRAZIL",
      regionCode: "RN",
      regionName: "RIO GRANDE DO NORTE",
    },
    {
      countryName: "BRAZIL",
      regionCode: "RO",
      regionName: "RONDONIA",
    },
    {
      countryName: "BRAZIL",
      regionCode: "RR",
      regionName: "RORAIMA",
    },
    {
      countryName: "BRAZIL",
      regionCode: "RS",
      regionName: "RIO GRANDE DO SUL",
    },
    {
      countryName: "BRAZIL",
      regionCode: "SC",
      regionName: "SANTA CATARINA",
    },
    {
      countryName: "BRAZIL",
      regionCode: "SE",
      regionName: "SERGIPE",
    },
    {
      countryName: "BRAZIL",
      regionCode: "SP",
      regionName: "SAO PAULO",
    },
    {
      countryName: "BRAZIL",
      regionCode: "TO",
      regionName: "TOCANTINS",
    },
    {
      countryName: "BRITISH INDIAN OCEAN TERRITORY (The)",
      regionCode: "IO",
      regionName: "BRITISH INDIAN OCEAN TERRITORY (The)",
    },
    {
      countryName: "BRUNEI DARUSSALAM",
      regionCode: "BE",
      regionName: "BELAIT",
    },
    {
      countryName: "BRUNEI DARUSSALAM",
      regionCode: "BM",
      regionName: "BRUNEI-MUARA",
    },
    {
      countryName: "BRUNEI DARUSSALAM",
      regionCode: "TE",
      regionName: "TEMBURONG",
    },
    {
      countryName: "BRUNEI DARUSSALAM",
      regionCode: "TU",
      regionName: "TUTONG",
    },
    {
      countryName: "BULGARIA",
      regionCode: 1,
      regionName: "BLAGOEVGRAD",
    },
    {
      countryName: "BULGARIA",
      regionCode: 2,
      regionName: "BURGAS",
    },
    {
      countryName: "BULGARIA",
      regionCode: 8,
      regionName: "DOBRICH",
    },
    {
      countryName: "BULGARIA",
      regionCode: 7,
      regionName: "GABROVO",
    },
    {
      countryName: "BULGARIA",
      regionCode: 26,
      regionName: "HASKOVO",
    },
    {
      countryName: "BULGARIA",
      regionCode: 9,
      regionName: "KARDZHALI",
    },
    {
      countryName: "BULGARIA",
      regionCode: 10,
      regionName: "KYUESTENDIL",
    },
    {
      countryName: "BULGARIA",
      regionCode: 11,
      regionName: "LOVECH",
    },
    {
      countryName: "BULGARIA",
      regionCode: 12,
      regionName: "MONTANA",
    },
    {
      countryName: "BULGARIA",
      regionCode: 13,
      regionName: "PAZARDZHIK",
    },
    {
      countryName: "BULGARIA",
      regionCode: 14,
      regionName: "PERNIK",
    },
    {
      countryName: "BULGARIA",
      regionCode: 15,
      regionName: "PLEVEN",
    },
    {
      countryName: "BULGARIA",
      regionCode: 16,
      regionName: "PLOVDIV",
    },
    {
      countryName: "BULGARIA",
      regionCode: 17,
      regionName: "RAZGRAD",
    },
    {
      countryName: "BULGARIA",
      regionCode: 18,
      regionName: "RUSE",
    },
    {
      countryName: "BULGARIA",
      regionCode: 27,
      regionName: "SHUMEN",
    },
    {
      countryName: "BULGARIA",
      regionCode: 19,
      regionName: "SILISTRA",
    },
    {
      countryName: "BULGARIA",
      regionCode: 20,
      regionName: "SLIVEN",
    },
    {
      countryName: "BULGARIA",
      regionCode: 21,
      regionName: "SMOLYAN",
    },
    {
      countryName: "BULGARIA",
      regionCode: 23,
      regionName: "SOFIA",
    },
    {
      countryName: "BULGARIA",
      regionCode: 22,
      regionName: "SOFIA-GRAD",
    },
    {
      countryName: "BULGARIA",
      regionCode: 24,
      regionName: "STARA ZAGORA",
    },
    {
      countryName: "BULGARIA",
      regionCode: 25,
      regionName: "TARGOVISHTE",
    },
    {
      countryName: "BULGARIA",
      regionCode: 3,
      regionName: "VARNA",
    },
    {
      countryName: "BULGARIA",
      regionCode: 4,
      regionName: "VELIKO TARNOVO",
    },
    {
      countryName: "BULGARIA",
      regionCode: 5,
      regionName: "VIDIN",
    },
    {
      countryName: "BULGARIA",
      regionCode: 6,
      regionName: "VRATSA",
    },
    {
      countryName: "BULGARIA",
      regionCode: 28,
      regionName: "YAMBOL",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "BAL",
      regionName: "BALE",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "BAM",
      regionName: "BAM",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "BAN",
      regionName: "BANWA",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "BAZ",
      regionName: "BAZEGA",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "BGR",
      regionName: "BOUGOURIBA",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "BLG",
      regionName: "BOULGOU",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "BLK",
      regionName: "BOULKIEMDE",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "COM",
      regionName: "COMOE",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "GAN",
      regionName: "GANZOURGOU",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "GNA",
      regionName: "GNAGNA",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "GOU",
      regionName: "GOURMA",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "HOU",
      regionName: "HOUET",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "IOB",
      regionName: "IOBA",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "KAD",
      regionName: "KADIOGO",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "KEN",
      regionName: "KENEDOUGOU",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "KMD",
      regionName: "KOMONDJARI",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "KMP",
      regionName: "KOMPIENGA",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "KOP",
      regionName: "KOULPELOGO",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "KOS",
      regionName: "KOSSI",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "KOT",
      regionName: "KOURITENGA",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "KOW",
      regionName: "KOURWEOGO",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "LER",
      regionName: "LERABA",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "LOR",
      regionName: "LOROUM",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "MOU",
      regionName: "MOUHOUN",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "NAM",
      regionName: "NAMENTENGA",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "NAO",
      regionName: "NAHOURI",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "NAY",
      regionName: "NAYALA",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "NOU",
      regionName: "NOUMBIEL",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "OUB",
      regionName: "OUBRITENGA",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "OUD",
      regionName: "OUDALAN",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "PAS",
      regionName: "PASSORE",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "PON",
      regionName: "PONI",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "SEN",
      regionName: "SENO",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "SIS",
      regionName: "SISSILI",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "SMT",
      regionName: "SANMATENGA",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "SNG",
      regionName: "SANGUIE",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "SOM",
      regionName: "SOUM",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "SOR",
      regionName: "SOUROU",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "TAP",
      regionName: "TAPOA",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "TUI",
      regionName: "TUI",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "YAG",
      regionName: "YAGHA",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "YAT",
      regionName: "YATENGA",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "ZIR",
      regionName: "ZIRO",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "ZON",
      regionName: "ZONDOMA",
    },
    {
      countryName: "BURKINA FASO",
      regionCode: "ZOU",
      regionName: "ZOUNDWEOGO",
    },
    {
      countryName: "BURUNDI",
      regionCode: "BB",
      regionName: "BUBANZA",
    },
    {
      countryName: "BURUNDI",
      regionCode: "BJ",
      regionName: "BUJUMBURA",
    },
    {
      countryName: "BURUNDI",
      regionCode: "BR",
      regionName: "BURURI",
    },
    {
      countryName: "BURUNDI",
      regionCode: "CA",
      regionName: "CANKUZO",
    },
    {
      countryName: "BURUNDI",
      regionCode: "CI",
      regionName: "CIBITOKE",
    },
    {
      countryName: "BURUNDI",
      regionCode: "GI",
      regionName: "GITEGA",
    },
    {
      countryName: "BURUNDI",
      regionCode: "KI",
      regionName: "KIRUNDO",
    },
    {
      countryName: "BURUNDI",
      regionCode: "KR",
      regionName: "KARUZI",
    },
    {
      countryName: "BURUNDI",
      regionCode: "KY",
      regionName: "KAYANZA",
    },
    {
      countryName: "BURUNDI",
      regionCode: "MA",
      regionName: "MAKAMBA",
    },
    {
      countryName: "BURUNDI",
      regionCode: "MU",
      regionName: "MURAMVYA",
    },
    {
      countryName: "BURUNDI",
      regionCode: "MW",
      regionName: "MWARO",
    },
    {
      countryName: "BURUNDI",
      regionCode: "MY",
      regionName: "MUYINGA",
    },
    {
      countryName: "BURUNDI",
      regionCode: "NG",
      regionName: "NGOZI",
    },
    {
      countryName: "BURUNDI",
      regionCode: "RT",
      regionName: "RUTANA",
    },
    {
      countryName: "BURUNDI",
      regionCode: "RY",
      regionName: "RUYIGI",
    },
    {
      countryName: "CABO VERDE",
      regionCode: "BV",
      regionName: "BOA VISTA",
    },
    {
      countryName: "CABO VERDE",
      regionCode: "BR",
      regionName: "BRAVA",
    },
    {
      countryName: "CABO VERDE",
      regionCode: "CS",
      regionName: "CALHETA DE SAO MIGUEL",
    },
    {
      countryName: "CABO VERDE",
      regionCode: "MA",
      regionName: "MAIO",
    },
    {
      countryName: "CABO VERDE",
      regionCode: "MO",
      regionName: "MOSTEIROS",
    },
    {
      countryName: "CABO VERDE",
      regionCode: "PA",
      regionName: "PAUL",
    },
    {
      countryName: "CABO VERDE",
      regionCode: "PN",
      regionName: "PORTO NOVO",
    },
    {
      countryName: "CABO VERDE",
      regionCode: "PR",
      regionName: "PRAIA",
    },
    {
      countryName: "CABO VERDE",
      regionCode: "RG",
      regionName: "RIBEIRA GRANDE",
    },
    {
      countryName: "CABO VERDE",
      regionCode: "SL",
      regionName: "SAL",
    },
    {
      countryName: "CABO VERDE",
      regionCode: "CA",
      regionName: "SANTA CATARINA",
    },
    {
      countryName: "CABO VERDE",
      regionCode: "CR",
      regionName: "SANTA CRUZ",
    },
    {
      countryName: "CABO VERDE",
      regionCode: "SD",
      regionName: "SAO DOMINGOS",
    },
    {
      countryName: "CABO VERDE",
      regionCode: "SF",
      regionName: "SAO FILIPE",
    },
    {
      countryName: "CABO VERDE",
      regionCode: "SN",
      regionName: "SAO NICOLAU",
    },
    {
      countryName: "CABO VERDE",
      regionCode: "SV",
      regionName: "SAO VICENTE",
    },
    {
      countryName: "CABO VERDE",
      regionCode: "TA",
      regionName: "TARRAFAL",
    },
    {
      countryName: "CAMBODIA",
      regionCode: 2,
      regionName: "BAAT DAMBANG",
    },
    {
      countryName: "CAMBODIA",
      regionCode: 1,
      regionName: "BANTEAY MEAN CHEY",
    },
    {
      countryName: "CAMBODIA",
      regionCode: 3,
      regionName: "KAMPONG CHAAM",
    },
    {
      countryName: "CAMBODIA",
      regionCode: 4,
      regionName: "KAMPONG CHHNANG",
    },
    {
      countryName: "CAMBODIA",
      regionCode: 5,
      regionName: "KAMPONG SPUEU",
    },
    {
      countryName: "CAMBODIA",
      regionCode: 6,
      regionName: "KAMPONG THUM",
    },
    {
      countryName: "CAMBODIA",
      regionCode: 7,
      regionName: "KAMPOT",
    },
    {
      countryName: "CAMBODIA",
      regionCode: 8,
      regionName: "KANDAAL",
    },
    {
      countryName: "CAMBODIA",
      regionCode: 9,
      regionName: "KAOH KONG",
    },
    {
      countryName: "CAMBODIA",
      regionCode: 10,
      regionName: "KRACHEH",
    },
    {
      countryName: "CAMBODIA",
      regionCode: 23,
      regionName: "KRONG KAEB",
    },
    {
      countryName: "CAMBODIA",
      regionCode: 24,
      regionName: "KRONG PAILIN",
    },
    {
      countryName: "CAMBODIA",
      regionCode: 18,
      regionName: "KRONG PREAH",
    },
    {
      countryName: "CAMBODIA",
      regionCode: 11,
      regionName: "MONDOL KIRI",
    },
    {
      countryName: "CAMBODIA",
      regionCode: 22,
      regionName: "OTDAR MEAN CHEY",
    },
    {
      countryName: "CAMBODIA",
      regionCode: 12,
      regionName: "PHNOM PENH",
    },
    {
      countryName: "CAMBODIA",
      regionCode: 15,
      regionName: "POUSAAT",
    },
    {
      countryName: "CAMBODIA",
      regionCode: 13,
      regionName: "PREAH VIHEAR",
    },
    {
      countryName: "CAMBODIA",
      regionCode: 14,
      regionName: "PREY VEAENG",
    },
    {
      countryName: "CAMBODIA",
      regionCode: 16,
      regionName: "ROTANAK KIRI",
    },
    {
      countryName: "CAMBODIA",
      regionCode: 17,
      regionName: "SIEM REAB",
    },
    {
      countryName: "CAMBODIA",
      regionCode: 19,
      regionName: "STUENG TRAENG",
    },
    {
      countryName: "CAMBODIA",
      regionCode: 20,
      regionName: "SVAAY RIENG",
    },
    {
      countryName: "CAMBODIA",
      regionCode: 21,
      regionName: "TAAKAEV",
    },
    {
      countryName: "CAMEROON",
      regionCode: "AD",
      regionName: "ADAMAOUA",
    },
    {
      countryName: "CAMEROON",
      regionCode: "CE",
      regionName: "CENTRE",
    },
    {
      countryName: "CAMEROON",
      regionCode: "EN",
      regionName: "FAR NORTH",
    },
    {
      countryName: "CAMEROON",
      regionCode: "ES",
      regionName: "EAST",
    },
    {
      countryName: "CAMEROON",
      regionCode: "LT",
      regionName: "LITTORAL",
    },
    {
      countryName: "CAMEROON",
      regionCode: "NO",
      regionName: "NORTH",
    },
    {
      countryName: "CAMEROON",
      regionCode: "NW",
      regionName: "NORTH-WEST",
    },
    {
      countryName: "CAMEROON",
      regionCode: "OU",
      regionName: "WEST",
    },
    {
      countryName: "CAMEROON",
      regionCode: "SU",
      regionName: "SOUTH",
    },
    {
      countryName: "CAMEROON",
      regionCode: "SW",
      regionName: "SOUTH-WEST",
    },
    {
      countryName: "CANADA",
      regionCode: "AB",
      regionName: "ALBERTA",
    },
    {
      countryName: "CANADA",
      regionCode: "BC",
      regionName: "BRITISH COLUMBIA",
    },
    {
      countryName: "CANADA",
      regionCode: "MB",
      regionName: "MANITOBA",
    },
    {
      countryName: "CANADA",
      regionCode: "NB",
      regionName: "NEW BRUNSWICK",
    },
    {
      countryName: "CANADA",
      regionCode: "NL",
      regionName: "NEWFOUNDLAND / LABRADOR",
    },
    {
      countryName: "CANADA",
      regionCode: "NT",
      regionName: "NORTHWEST TERRITORIES",
    },
    {
      countryName: "CANADA",
      regionCode: "NS",
      regionName: "NOVA SCOTIA",
    },
    {
      countryName: "CANADA",
      regionCode: "NU",
      regionName: "NUNAVUT",
    },
    {
      countryName: "CANADA",
      regionCode: "ON",
      regionName: "ONTARIO",
    },
    {
      countryName: "CANADA",
      regionCode: "PE",
      regionName: "PRINCE EDWARD ISLAND",
    },
    {
      countryName: "CANADA",
      regionCode: "QC",
      regionName: "QUEBEC",
    },
    {
      countryName: "CANADA",
      regionCode: "SK",
      regionName: "SASKATCHEWAN",
    },
    {
      countryName: "CANADA",
      regionCode: "YT",
      regionName: "YUKON TERRITORY",
    },
    {
      countryName: "CAYMAN ISLANDS (THE)",
      regionCode: "KY",
      regionName: "CAYMAN ISLANDS (THE)",
    },
    {
      countryName: "CENTRAL AFRICAN REPUBLIC (THE)",
      regionCode: "BB",
      regionName: "BAMINGUI-BANGORAN",
    },
    {
      countryName: "CENTRAL AFRICAN REPUBLIC (THE)",
      regionCode: "BGF",
      regionName: "BANGUI",
    },
    {
      countryName: "CENTRAL AFRICAN REPUBLIC (THE)",
      regionCode: "BK",
      regionName: "BASSE-KOTTO",
    },
    {
      countryName: "CENTRAL AFRICAN REPUBLIC (THE)",
      regionCode: "HK",
      regionName: "HAUTE-KOTTO",
    },
    {
      countryName: "CENTRAL AFRICAN REPUBLIC (THE)",
      regionCode: "HM",
      regionName: "HAUT-MBOMOU",
    },
    {
      countryName: "CENTRAL AFRICAN REPUBLIC (THE)",
      regionCode: "KG",
      regionName: "KEMO",
    },
    {
      countryName: "CENTRAL AFRICAN REPUBLIC (THE)",
      regionCode: "LB",
      regionName: "LOBAYE",
    },
    {
      countryName: "CENTRAL AFRICAN REPUBLIC (THE)",
      regionCode: "HS",
      regionName: "MAMBERE-KADEI",
    },
    {
      countryName: "CENTRAL AFRICAN REPUBLIC (THE)",
      regionCode: "MB",
      regionName: "MBOMOU",
    },
    {
      countryName: "CENTRAL AFRICAN REPUBLIC (THE)",
      regionCode: "KB",
      regionName: "NANA-GREBIZI",
    },
    {
      countryName: "CENTRAL AFRICAN REPUBLIC (THE)",
      regionCode: "NM",
      regionName: "NANA-MAMBERE",
    },
    {
      countryName: "CENTRAL AFRICAN REPUBLIC (THE)",
      regionCode: "MP",
      regionName: "OMBELLA-MPOKO",
    },
    {
      countryName: "CENTRAL AFRICAN REPUBLIC (THE)",
      regionCode: "UK",
      regionName: "OUAKA",
    },
    {
      countryName: "CENTRAL AFRICAN REPUBLIC (THE)",
      regionCode: "AC",
      regionName: "OUHAM",
    },
    {
      countryName: "CENTRAL AFRICAN REPUBLIC (THE)",
      regionCode: "OP",
      regionName: "OUHAM-PENDE",
    },
    {
      countryName: "CENTRAL AFRICAN REPUBLIC (THE)",
      regionCode: "SE",
      regionName: "SANGHA-MBAERE",
    },
    {
      countryName: "CENTRAL AFRICAN REPUBLIC (THE)",
      regionCode: "VK",
      regionName: "VAKAGA",
    },
    {
      countryName: "CHAD",
      regionCode: "BA",
      regionName: "BATHA",
    },
    {
      countryName: "CHAD",
      regionCode: "BET",
      regionName: "BORKOU-ENNEDI-TIBESTI",
    },
    {
      countryName: "CHAD",
      regionCode: "CB",
      regionName: "CHARI-BAGUIRMI",
    },
    {
      countryName: "CHAD",
      regionCode: "GR",
      regionName: "GUERA",
    },
    {
      countryName: "CHAD",
      regionCode: "HL",
      regionName: "HADJER LAMIS",
    },
    {
      countryName: "CHAD",
      regionCode: "KA",
      regionName: "KANEM",
    },
    {
      countryName: "CHAD",
      regionCode: "LC",
      regionName: "LAC",
    },
    {
      countryName: "CHAD",
      regionCode: "LO",
      regionName: "LOGONE-OCCIDENTAL",
    },
    {
      countryName: "CHAD",
      regionCode: "LR",
      regionName: "LOGONE-ORIENTAL",
    },
    {
      countryName: "CHAD",
      regionCode: "MA",
      regionName: "MANDOUL",
    },
    {
      countryName: "CHAD",
      regionCode: "MC",
      regionName: "MOYEN-CHARI",
    },
    {
      countryName: "CHAD",
      regionCode: "ME",
      regionName: "MAYO-KEBBI-EST",
    },
    {
      countryName: "CHAD",
      regionCode: "MO",
      regionName: "MAYO-KEBBI-OUEST",
    },
    {
      countryName: "CHAD",
      regionCode: "ND",
      regionName: "NDJAMENA",
    },
    {
      countryName: "CHAD",
      regionCode: "OD",
      regionName: "OUADDAI",
    },
    {
      countryName: "CHAD",
      regionCode: "SA",
      regionName: "SALAMAT",
    },
    {
      countryName: "CHAD",
      regionCode: "TA",
      regionName: "TANDJILE",
    },
    {
      countryName: "CHAD",
      regionCode: "WF",
      regionName: "WADI FIRA",
    },
    {
      countryName: "CHILE",
      regionCode: "AI",
      regionName: "AISEN DEL GENERAL CARLOS IBANE",
    },
    {
      countryName: "CHILE",
      regionCode: "AN",
      regionName: "ANTOFAGASTA",
    },
    {
      countryName: "CHILE",
      regionCode: "AR",
      regionName: "ARAUCANIA",
    },
    {
      countryName: "CHILE",
      regionCode: "AT",
      regionName: "ATACAMA",
    },
    {
      countryName: "CHILE",
      regionCode: "BI",
      regionName: "BIO-BIO",
    },
    {
      countryName: "CHILE",
      regionCode: "CO",
      regionName: "COQUIMBO",
    },
    {
      countryName: "CHILE",
      regionCode: "LI",
      regionName: "LIBERTADOR GENERAL BERNARDO",
    },
    {
      countryName: "CHILE",
      regionCode: "LL",
      regionName: "LOS LAGOS",
    },
    {
      countryName: "CHILE",
      regionCode: "MA",
      regionName: "MAGALLANES",
    },
    {
      countryName: "CHILE",
      regionCode: "ML",
      regionName: "MAULE",
    },
    {
      countryName: "CHILE",
      regionCode: "RM",
      regionName: "REGION METROPLITANA DE SANTIA",
    },
    {
      countryName: "CHILE",
      regionCode: "TA",
      regionName: "TARAPACA",
    },
    {
      countryName: "CHILE",
      regionCode: "VS",
      regionName: "VALPARAISO",
    },
    {
      countryName: "CHINA",
      regionCode: 34,
      regionName: "ANHUI",
    },
    {
      countryName: "CHINA",
      regionCode: 92,
      regionName: "AOMEN",
    },
    {
      countryName: "CHINA",
      regionCode: 11,
      regionName: "BEIJING",
    },
    {
      countryName: "CHINA",
      regionCode: 50,
      regionName: "CHONGQING",
    },
    {
      countryName: "CHINA",
      regionCode: 35,
      regionName: "FUJIAN",
    },
    {
      countryName: "CHINA",
      regionCode: 62,
      regionName: "GANSU",
    },
    {
      countryName: "CHINA",
      regionCode: 44,
      regionName: "GUANGDONG",
    },
    {
      countryName: "CHINA",
      regionCode: 45,
      regionName: "GUANGXI",
    },
    {
      countryName: "CHINA",
      regionCode: 52,
      regionName: "GUIZHOU",
    },
    {
      countryName: "CHINA",
      regionCode: 46,
      regionName: "HAINAN",
    },
    {
      countryName: "CHINA",
      regionCode: 13,
      regionName: "HEBEI",
    },
    {
      countryName: "CHINA",
      regionCode: 23,
      regionName: "HEILONGJIANG",
    },
    {
      countryName: "CHINA",
      regionCode: 41,
      regionName: "HENAN",
    },
    {
      countryName: "CHINA",
      regionCode: 42,
      regionName: "HUBEI",
    },
    {
      countryName: "CHINA",
      regionCode: 43,
      regionName: "HUNAN",
    },
    {
      countryName: "CHINA",
      regionCode: 32,
      regionName: "JIANGSU",
    },
    {
      countryName: "CHINA",
      regionCode: 36,
      regionName: "JIANGXI",
    },
    {
      countryName: "CHINA",
      regionCode: 22,
      regionName: "JILIN",
    },
    {
      countryName: "CHINA",
      regionCode: 21,
      regionName: "LIAONING",
    },
    {
      countryName: "CHINA",
      regionCode: 15,
      regionName: "NEI MONGOL",
    },
    {
      countryName: "CHINA",
      regionCode: 64,
      regionName: "NINGXIA",
    },
    {
      countryName: "CHINA",
      regionCode: 63,
      regionName: "QINGHAI",
    },
    {
      countryName: "CHINA",
      regionCode: 61,
      regionName: "SHAANXI",
    },
    {
      countryName: "CHINA",
      regionCode: 37,
      regionName: "SHANDONG",
    },
    {
      countryName: "CHINA",
      regionCode: 31,
      regionName: "SHANGHAI",
    },
    {
      countryName: "CHINA",
      regionCode: 14,
      regionName: "SHANXING",
    },
    {
      countryName: "CHINA",
      regionCode: 51,
      regionName: "SICHUAN",
    },
    {
      countryName: "CHINA",
      regionCode: 71,
      regionName: "TAIWANN",
    },
    {
      countryName: "CHINA",
      regionCode: 12,
      regionName: "TIANJIN",
    },
    {
      countryName: "CHINA",
      regionCode: 91,
      regionName: "XIANGGANG",
    },
    {
      countryName: "CHINA",
      regionCode: 65,
      regionName: "XINJIANG",
    },
    {
      countryName: "CHINA",
      regionCode: 54,
      regionName: "XIZANG",
    },
    {
      countryName: "CHINA",
      regionCode: 53,
      regionName: "YUNNAN",
    },
    {
      countryName: "CHINA",
      regionCode: 33,
      regionName: "ZHEJIANG",
    },
    {
      countryName: "CHRISTMAS ISLAND",
      regionCode: "CX",
      regionName: "CHRISTMAS ISLAND",
    },
    {
      countryName: "COCOS (KEELING) ISLANDS (THE)",
      regionCode: "CC",
      regionName: "COCOS (KEELING) ISLANDS (THE)",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "AMA",
      regionName: "AMAZONAS",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "ANT",
      regionName: "ANTIOQUIA",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "ARA",
      regionName: "ARAUCA",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "ATL",
      regionName: "ATLANTICO",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "BOL",
      regionName: "BOLIVAR",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "BOY",
      regionName: "BOYACA",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "CAL",
      regionName: "CALDAS",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "CAQ",
      regionName: "CAQUETA",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "CAS",
      regionName: "CASANARE",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "CAU",
      regionName: "CAUCA",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "CES",
      regionName: "CESAR",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "CHO",
      regionName: "CHOCO",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "COR",
      regionName: "CORDOBA",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "CUN",
      regionName: "CUNDINAMARCA",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "DC",
      regionName: "DISTRITO CAPITAL DE BOGOTA",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "GUA",
      regionName: "GUAINIA",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "GUV",
      regionName: "GUAVIARE",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "HUI",
      regionName: "HUILA",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "LAG",
      regionName: "LA GUAJIRA",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "MAG",
      regionName: "MAGDALENA",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "MET",
      regionName: "META",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "NAR",
      regionName: "NARINO",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "NSA",
      regionName: "NORTE DE SANTANDER",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "PUT",
      regionName: "PUTUMAYO",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "QUI",
      regionName: "QUINDIO",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "RIS",
      regionName: "RISARALDA",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "SAN",
      regionName: "SANTANDER",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "SANTA",
      regionName: "SAN ANDRES, PROVIDENCIA Y",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "SUC",
      regionName: "SUCRE",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "TOL",
      regionName: "TOLIMA",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "VAC",
      regionName: "VALLE DEL CAUCA",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "VAU",
      regionName: "VAUPES",
    },
    {
      countryName: "COLOMBIA",
      regionCode: "VID",
      regionName: "VICHADA",
    },
    {
      countryName: "COMOROS (THE)",
      regionCode: "A",
      regionName: "ANJOUAN",
    },
    {
      countryName: "COMOROS (THE)",
      regionCode: "G",
      regionName: "GRANDE COMORE",
    },
    {
      countryName: "COMOROS (THE)",
      regionCode: "M",
      regionName: "MOHELI",
    },
    {
      countryName: "CONGO (THE DEMOCRATIC REPUBLIC OF)",
      regionCode: "BC",
      regionName: "BAS-CONGO",
    },
    {
      countryName: "CONGO (THE DEMOCRATIC REPUBLIC OF)",
      regionCode: "BN",
      regionName: "BANDUNDU",
    },
    {
      countryName: "CONGO (THE DEMOCRATIC REPUBLIC OF)",
      regionCode: "EQ",
      regionName: "EQUATEUR",
    },
    {
      countryName: "CONGO (THE DEMOCRATIC REPUBLIC OF)",
      regionCode: "KA",
      regionName: "KATANGA",
    },
    {
      countryName: "CONGO (THE DEMOCRATIC REPUBLIC OF)",
      regionCode: "KE",
      regionName: "KASAI-ORIENTAL",
    },
    {
      countryName: "CONGO (THE DEMOCRATIC REPUBLIC OF)",
      regionCode: "KN",
      regionName: "KINSHASA",
    },
    {
      countryName: "CONGO (THE DEMOCRATIC REPUBLIC OF)",
      regionCode: "KW",
      regionName: "KASAI-OCCIDENTAL",
    },
    {
      countryName: "CONGO (THE DEMOCRATIC REPUBLIC OF)",
      regionCode: "MA",
      regionName: "MANIEMA",
    },
    {
      countryName: "CONGO (THE DEMOCRATIC REPUBLIC OF)",
      regionCode: "NK",
      regionName: "NORD-KIVU",
    },
    {
      countryName: "CONGO (THE DEMOCRATIC REPUBLIC OF)",
      regionCode: "OR",
      regionName: "ORIENTALE",
    },
    {
      countryName: "CONGO (THE DEMOCRATIC REPUBLIC OF)",
      regionCode: "SK",
      regionName: "SUD-KIVU",
    },
    {
      countryName: "CONGO (THE)",
      regionCode: 2,
      regionName: "BOUENZA",
    },
    {
      countryName: "CONGO (THE)",
      regionCode: 5,
      regionName: "BRAZZAVILLE",
    },
    {
      countryName: "CONGO (THE)",
      regionCode: 7,
      regionName: "CUVETTE",
    },
    {
      countryName: "CONGO (THE)",
      regionCode: 8,
      regionName: "CUVETTE-OUEST",
    },
    {
      countryName: "CONGO (THE)",
      regionCode: 9,
      regionName: "KOUILOU",
    },
    {
      countryName: "CONGO (THE)",
      regionCode: 11,
      regionName: "LEKOUMOU",
    },
    {
      countryName: "CONGO (THE)",
      regionCode: 12,
      regionName: "LIKOUALA",
    },
    {
      countryName: "CONGO (THE)",
      regionCode: 13,
      regionName: "NIARI",
    },
    {
      countryName: "CONGO (THE)",
      regionCode: 14,
      regionName: "PLATEAUX",
    },
    {
      countryName: "CONGO (THE)",
      regionCode: 15,
      regionName: "POOL",
    },
    {
      countryName: "CONGO (THE)",
      regionCode: "BZV",
      regionName: "SANGHA",
    },
    {
      countryName: "COOK ISLANDS (THE)",
      regionCode: "CK",
      regionName: "COOK ISLANDS (THE)",
    },
    {
      countryName: "COSTA RICA",
      regionCode: "A",
      regionName: "ALAJUELA",
    },
    {
      countryName: "COSTA RICA",
      regionCode: "C",
      regionName: "CARTAGO",
    },
    {
      countryName: "COSTA RICA",
      regionCode: "G",
      regionName: "GUANACASTE",
    },
    {
      countryName: "COSTA RICA",
      regionCode: "H",
      regionName: "HEREDIA",
    },
    {
      countryName: "COSTA RICA",
      regionCode: "L",
      regionName: "LIMON",
    },
    {
      countryName: "COSTA RICA",
      regionCode: "P",
      regionName: "PUNTARENAS",
    },
    {
      countryName: "COSTA RICA",
      regionCode: "SJ",
      regionName: "SAN JOSE",
    },
    {
      countryName: "CÔTE D’IVOIRE",
      regionCode: 6,
      regionName: "18 MONTAGNES",
    },
    {
      countryName: "CÔTE D’IVOIRE",
      regionCode: 16,
      regionName: "AGNEBI",
    },
    {
      countryName: "CÔTE D’IVOIRE",
      regionCode: 17,
      regionName: "BAFING",
    },
    {
      countryName: "CÔTE D’IVOIRE",
      regionCode: 9,
      regionName: "BAS-SASSANDRA",
    },
    {
      countryName: "CÔTE D’IVOIRE",
      regionCode: 10,
      regionName: "DENGUELE",
    },
    {
      countryName: "CÔTE D’IVOIRE",
      regionCode: 18,
      regionName: "FROMAGER",
    },
    {
      countryName: "CÔTE D’IVOIRE",
      regionCode: 2,
      regionName: "HAUT-SASSANDRA",
    },
    {
      countryName: "CÔTE D’IVOIRE",
      regionCode: 7,
      regionName: "LACS",
    },
    {
      countryName: "CÔTE D’IVOIRE",
      regionCode: 1,
      regionName: "LAGUNES",
    },
    {
      countryName: "CÔTE D’IVOIRE",
      regionCode: 12,
      regionName: "MARAHOUE",
    },
    {
      countryName: "CÔTE D’IVOIRE",
      regionCode: 19,
      regionName: "MOYEN-CAVALLY",
    },
    {
      countryName: "CÔTE D’IVOIRE",
      regionCode: 5,
      regionName: "MOYEN-COMOE",
    },
    {
      countryName: "CÔTE D’IVOIRE",
      regionCode: 11,
      regionName: "NZI-COMOE",
    },
    {
      countryName: "CÔTE D’IVOIRE",
      regionCode: 3,
      regionName: "SAVANES",
    },
    {
      countryName: "CÔTE D’IVOIRE",
      regionCode: 15,
      regionName: "SUD-BANDAMA",
    },
    {
      countryName: "CÔTE D’IVOIRE",
      regionCode: 13,
      regionName: "SUD-COMOE",
    },
    {
      countryName: "CÔTE D’IVOIRE",
      regionCode: 4,
      regionName: "VALLEE DU BANDAMA",
    },
    {
      countryName: "CÔTE D’IVOIRE",
      regionCode: 14,
      regionName: "WORODOUGOU",
    },
    {
      countryName: "CÔTE D’IVOIRE",
      regionCode: 8,
      regionName: "ZANZAN",
    },
    {
      countryName: "CROATIA",
      regionCode: 7,
      regionName: "BJELOVARSKO-BILOGORSKA UPANIJA",
    },
    {
      countryName: "CROATIA",
      regionCode: 12,
      regionName: "BRODSKO-POSAVSKA UPANIJA",
    },
    {
      countryName: "CROATIA",
      regionCode: 19,
      regionName: "DUBROVAEKO-NERETVANSKA UPANIJA",
    },
    {
      countryName: "CROATIA",
      regionCode: 21,
      regionName: "GRAD ZAGREB",
    },
    {
      countryName: "CROATIA",
      regionCode: 15,
      regionName: "IBENSKO-KNINSKA UPANIJA",
    },
    {
      countryName: "CROATIA",
      regionCode: 18,
      regionName: "ISTARSKA UPANIJA",
    },
    {
      countryName: "CROATIA",
      regionCode: 4,
      regionName: "KARLOVAEKA UPANIJA",
    },
    {
      countryName: "CROATIA",
      regionCode: 6,
      regionName: "KOPRIVNIEKO-KRIEVAEKA UPANIJA",
    },
    {
      countryName: "CROATIA",
      regionCode: 2,
      regionName: "KRAPINSKO-ZAGORSKA UPANIJA",
    },
    {
      countryName: "CROATIA",
      regionCode: 9,
      regionName: "LIEKO-SENJSKA UPANIJA",
    },
    {
      countryName: "CROATIA",
      regionCode: 20,
      regionName: "MEDIMURSKA UPANIJA",
    },
    {
      countryName: "CROATIA",
      regionCode: 14,
      regionName: "OSJEEKO-BARANJSKA UPANIJA",
    },
    {
      countryName: "CROATIA",
      regionCode: 11,
      regionName: "POEKO-SLAVONSKA UPANIJA",
    },
    {
      countryName: "CROATIA",
      regionCode: 8,
      regionName: "PRIMORSKO-GORANSKA UPANIJA",
    },
    {
      countryName: "CROATIA",
      regionCode: 3,
      regionName: "SISAEKO-MOSLAVAEKA UPANIJA",
    },
    {
      countryName: "CROATIA",
      regionCode: 17,
      regionName: "SPLITSKO-DALMATINSKA UPANIJA",
    },
    {
      countryName: "CROATIA",
      regionCode: 5,
      regionName: "VARADINSKA UPANIJA",
    },
    {
      countryName: "CROATIA",
      regionCode: 10,
      regionName: "VIROVITIEKO-PODRAVSKA UPANIJA",
    },
    {
      countryName: "CROATIA",
      regionCode: 16,
      regionName: "VUKOVARSKO-SRIJEMSKA UPANIJA",
    },
    {
      countryName: "CROATIA",
      regionCode: 13,
      regionName: "ZADARSKA UPANIJA",
    },
    {
      countryName: "CROATIA",
      regionCode: 1,
      regionName: "ZAGREBAEKA UPANIJA",
    },
    {
      countryName: "CURACAO",
      regionCode: "CW",
      regionName: "CURACAO",
    },
    {
      countryName: "CYPRUS",
      regionCode: 4,
      regionName: "AMMOCHOSTOS",
    },
    {
      countryName: "CYPRUS",
      regionCode: 6,
      regionName: "KERYNEIA",
    },
    {
      countryName: "CYPRUS",
      regionCode: 3,
      regionName: "LARNAKA",
    },
    {
      countryName: "CYPRUS",
      regionCode: 1,
      regionName: "LEFKOSIA",
    },
    {
      countryName: "CYPRUS",
      regionCode: 2,
      regionName: "LEMESOS",
    },
    {
      countryName: "CYPRUS",
      regionCode: 5,
      regionName: "PAFOS",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 201,
      regionName: "BENESOV",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 202,
      regionName: "BEROUN",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 621,
      regionName: "BLANSKO",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 624,
      regionName: "BRECLAV",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 622,
      regionName: "BRNO-MESTO",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 623,
      regionName: "BRNO-VENKOV",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 801,
      regionName: "BRUNTAL",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 511,
      regionName: "CESKA LIPA",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 311,
      regionName: "CESKE BUDEJOVICE",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 312,
      regionName: "CESKY KRUMLOV",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 411,
      regionName: "CHEB",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 422,
      regionName: "CHOMUTOV",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 531,
      regionName: "CHRUDIM",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 421,
      regionName: "DECIN",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 321,
      regionName: "DOMAZLICE",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 802,
      regionName: "FRYDEK-MISTEK",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 611,
      regionName: "HAVLICKUV BROD",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 625,
      regionName: "HODONIN",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 521,
      regionName: "HRADEC KRALOVE",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 512,
      regionName: "JABLONEC NAD NISOU",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 711,
      regionName: "JESENIK",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 522,
      regionName: "JICIN",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 612,
      regionName: "JIHLAVA",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: "JC",
      regionName: "JIHOCESKY KRAJ",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: "JM",
      regionName: "JIHOMORAVSKY KRAJ",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 313,
      regionName: "JINDRICHUV HRADEC",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: "KA",
      regionName: "KARLOVARSKY KRAJ",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 412,
      regionName: "KARLOVY VARY",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 803,
      regionName: "KARVINA",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 203,
      regionName: "KLADNO",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 322,
      regionName: "KLATOVY",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 204,
      regionName: "KOLIN",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: "KR",
      regionName: "KRALOVEHRADECKY KRAJ",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 721,
      regionName: "KROMERIZ",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 205,
      regionName: "KUTNA HORA",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 513,
      regionName: "LIBEREC",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: "LI",
      regionName: "LIBERECKY KRAJ",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 423,
      regionName: "LITOMERICE",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 424,
      regionName: "LOUNY",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 206,
      regionName: "MELNIK",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 207,
      regionName: "MLADA BOLESLAV",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: "MO",
      regionName: "MORAVSKOSLEZSKY KRAJ",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 425,
      regionName: "MOST",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 523,
      regionName: "NACHOD",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 804,
      regionName: "NOVY JICIN",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 208,
      regionName: "NYMBURK",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 712,
      regionName: "OLOMOUC",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: "OL",
      regionName: "OLOMOUCKY KRAJ",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 805,
      regionName: "OPAVA",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 806,
      regionName: "OSTRAVA - MESTO",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 532,
      regionName: "PARDUBICE",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: "PA",
      regionName: "PARDUBICKY KRAJ",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 613,
      regionName: "PELHRIMOV",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 314,
      regionName: "PISEK",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 324,
      regionName: "PLZEN-JIH",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 323,
      regionName: "PLZEN-MESTO",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 325,
      regionName: "PLZEN-SEVER",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: "PL",
      regionName: "PLZENSKY KRAJ",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 315,
      regionName: "PRACHATICE",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 101,
      regionName: "PRAHA 1",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: "10A",
      regionName: "PRAHA 10",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: "10B",
      regionName: "PRAHA 11",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: "10C",
      regionName: "PRAHA 12",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: "10D",
      regionName: "PRAHA 13",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: "10E",
      regionName: "PRAHA 14",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: "10F",
      regionName: "PRAHA 15",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 102,
      regionName: "PRAHA 2",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 103,
      regionName: "PRAHA 3",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 104,
      regionName: "PRAHA 4",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 105,
      regionName: "PRAHA 5",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 106,
      regionName: "PRAHA 6",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 107,
      regionName: "PRAHA 7",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 108,
      regionName: "PRAHA 8",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 109,
      regionName: "PRAHA 9",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: "PR",
      regionName: "PRAHA, HLAVNI MESTO",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 209,
      regionName: "PRAHA-VYCHOD",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: "20A",
      regionName: "PRAHA-ZAPAD",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 714,
      regionName: "PREROV",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: "20B",
      regionName: "PRIBRAM",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 713,
      regionName: "PROSTEJOV",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: "20C",
      regionName: "RAKOVNIK",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 326,
      regionName: "ROKYCANY",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 524,
      regionName: "RYCHNOV NAD KNEZNOU",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 514,
      regionName: "SEMILY",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 413,
      regionName: "SOKOLOV",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 316,
      regionName: "STRAKONICE",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: "ST",
      regionName: "STREDOCESKY KRAJ",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 715,
      regionName: "SUMPERK",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 533,
      regionName: "SVITAVY",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 317,
      regionName: "TABOR",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 327,
      regionName: "TACHOV",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 426,
      regionName: "TEPLICE",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 614,
      regionName: "TREBIC",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 525,
      regionName: "TRUTNOV",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 722,
      regionName: "UHERSKE HRADISTE",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: "US",
      regionName: "USTECKY KRAJ",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 427,
      regionName: "USTI NAD LABEM",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 534,
      regionName: "USTI NAD ORLICI",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 723,
      regionName: "VSETIN",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 626,
      regionName: "VYSKOV",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: "VY",
      regionName: "VYSOCINA",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 615,
      regionName: "ZD’AR NAD SAZAVOU",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 724,
      regionName: "ZLIN",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: "ZL",
      regionName: "ZLINSKY KRAJ",
    },
    {
      countryName: "CZECH REPUBLIC (THE)",
      regionCode: 627,
      regionName: "ZNOJMO",
    },
    {
      countryName: "DENMARK",
      regionCode: 84,
      regionName: "HOVEDSTADEN",
    },
    {
      countryName: "DENMARK",
      regionCode: 82,
      regionName: "MIDTJYLLAND",
    },
    {
      countryName: "DENMARK",
      regionCode: 81,
      regionName: "NORDJYLLAND",
    },
    {
      countryName: "DENMARK",
      regionCode: 85,
      regionName: "SJAELLAND",
    },
    {
      countryName: "DENMARK",
      regionCode: 83,
      regionName: "SYDDANMARK",
    },
    {
      countryName: "DJIBOUTI",
      regionCode: "AR",
      regionName: "ARTA",
    },
    {
      countryName: "DJIBOUTI",
      regionCode: "AS",
      regionName: "ALI SABIEH",
    },
    {
      countryName: "DJIBOUTI",
      regionCode: "DI",
      regionName: "DIKHIL",
    },
    {
      countryName: "DJIBOUTI",
      regionCode: "DJ",
      regionName: "DJIBOUTI",
    },
    {
      countryName: "DJIBOUTI",
      regionCode: "OB",
      regionName: "OBOCK",
    },
    {
      countryName: "DJIBOUTI",
      regionCode: "TA",
      regionName: "TADJOURA",
    },
    {
      countryName: "DOMINICA",
      regionCode: 2,
      regionName: "SAINT ANDREW",
    },
    {
      countryName: "DOMINICA",
      regionCode: 3,
      regionName: "SAINT DAVID",
    },
    {
      countryName: "DOMINICA",
      regionCode: 4,
      regionName: "SAINT GEORGE",
    },
    {
      countryName: "DOMINICA",
      regionCode: 5,
      regionName: "SAINT JOHN",
    },
    {
      countryName: "DOMINICA",
      regionCode: 6,
      regionName: "SAINT JOSEPH",
    },
    {
      countryName: "DOMINICA",
      regionCode: 7,
      regionName: "SAINT LUKE",
    },
    {
      countryName: "DOMINICA",
      regionCode: 8,
      regionName: "SAINT MARK",
    },
    {
      countryName: "DOMINICA",
      regionCode: 9,
      regionName: "SAINT PATRICK",
    },
    {
      countryName: "DOMINICA",
      regionCode: 10,
      regionName: "SAINT PAUL",
    },
    {
      countryName: "DOMINICA",
      regionCode: 11,
      regionName: "SAINT PETER",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 2,
      regionName: "AZUA",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 3,
      regionName: "BAHORUCO",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 4,
      regionName: "BARAHONA",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 5,
      regionName: "DAJABON",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 1,
      regionName: "DISTRITO NACIONAL",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 6,
      regionName: "DUARTE",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 8,
      regionName: "EL SEYBO (EL SEIBO)",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 9,
      regionName: "ESPAILLAT",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 30,
      regionName: "HATO MAYOR",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 10,
      regionName: "INDEPENDENCIA",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 11,
      regionName: "LA ALTAGRACIA",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 7,
      regionName: "LA ESTRELLETA (ELIAS PINA)",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 12,
      regionName: "LA ROMANA",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 13,
      regionName: "LA VEGA",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 14,
      regionName: "MARIA TRINIDAD SANCHEZ",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 28,
      regionName: "MONSENOR NOUEL",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 15,
      regionName: "MONTE CRISTI",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 29,
      regionName: "MONTE PLATA",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 16,
      regionName: "PEDERNALES",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 17,
      regionName: "PERAVIA",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 18,
      regionName: "PUERTO PLATA",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 19,
      regionName: "SALCEDO",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 20,
      regionName: "SAMANA",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 21,
      regionName: "SAN CRISTOBAL",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 31,
      regionName: "SAN JOSE DE OCOA",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 22,
      regionName: "SAN JUAN",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 23,
      regionName: "SAN PEDRO DE MACORIS",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 24,
      regionName: "SANCHEZ RAMIREZ",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 25,
      regionName: "SANTIAGO",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 26,
      regionName: "SANTIAGO RODRIGUEZ",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 32,
      regionName: "SANTO DOMINGO",
    },
    {
      countryName: "DOMINICAN REPUBLIC (THE)",
      regionCode: 27,
      regionName: "VALVERDE",
    },
    {
      countryName: "ECUADOR",
      regionCode: "A",
      regionName: "AZUAY",
    },
    {
      countryName: "ECUADOR",
      regionCode: "B",
      regionName: "BOLIVAR",
    },
    {
      countryName: "ECUADOR",
      regionCode: "F",
      regionName: "CANAR",
    },
    {
      countryName: "ECUADOR",
      regionCode: "C",
      regionName: "CARCHI",
    },
    {
      countryName: "ECUADOR",
      regionCode: "H",
      regionName: "CHIMBORAZO",
    },
    {
      countryName: "ECUADOR",
      regionCode: "X",
      regionName: "COTOPAXI",
    },
    {
      countryName: "ECUADOR",
      regionCode: "O",
      regionName: "EL ORO",
    },
    {
      countryName: "ECUADOR",
      regionCode: "E",
      regionName: "ESMERALDAS",
    },
    {
      countryName: "ECUADOR",
      regionCode: "W",
      regionName: "GALAPAGOS",
    },
    {
      countryName: "ECUADOR",
      regionCode: "G",
      regionName: "GUAYAS",
    },
    {
      countryName: "ECUADOR",
      regionCode: "I",
      regionName: "IMBABURA",
    },
    {
      countryName: "ECUADOR",
      regionCode: "L",
      regionName: "LOJA",
    },
    {
      countryName: "ECUADOR",
      regionCode: "R",
      regionName: "LOS RIOS",
    },
    {
      countryName: "ECUADOR",
      regionCode: "M",
      regionName: "MANABI",
    },
    {
      countryName: "ECUADOR",
      regionCode: "S",
      regionName: "MORONA-SANTIAGO",
    },
    {
      countryName: "ECUADOR",
      regionCode: "N",
      regionName: "NAPO",
    },
    {
      countryName: "ECUADOR",
      regionCode: "D",
      regionName: "ORELLANA",
    },
    {
      countryName: "ECUADOR",
      regionCode: "Y",
      regionName: "PASTAZA",
    },
    {
      countryName: "ECUADOR",
      regionCode: "P",
      regionName: "PICHINCHA",
    },
    {
      countryName: "ECUADOR",
      regionCode: "U",
      regionName: "SUCUMBIOS",
    },
    {
      countryName: "ECUADOR",
      regionCode: "T",
      regionName: "TUNGURAHUA",
    },
    {
      countryName: "ECUADOR",
      regionCode: "Z",
      regionName: "ZAMORA-CHINCHIPE",
    },
    {
      countryName: "EGYPT",
      regionCode: "DK",
      regionName: "AD DAQAHLIYAH",
    },
    {
      countryName: "EGYPT",
      regionCode: "BA",
      regionName: "AL BAHR AL AHMAR",
    },
    {
      countryName: "EGYPT",
      regionCode: "BH",
      regionName: "AL BUHAYRAH",
    },
    {
      countryName: "EGYPT",
      regionCode: "FYM",
      regionName: "AL FAYYUM",
    },
    {
      countryName: "EGYPT",
      regionCode: "GH",
      regionName: "AL GHARBIYAH",
    },
    {
      countryName: "EGYPT",
      regionCode: "ALX",
      regionName: "AL ISKANDARIYAH",
    },
    {
      countryName: "EGYPT",
      regionCode: "IS",
      regionName: "AL ISMAILIYAH",
    },
    {
      countryName: "EGYPT",
      regionCode: "GZ",
      regionName: "AL JIZAH",
    },
    {
      countryName: "EGYPT",
      regionCode: "MNF",
      regionName: "AL MINUFIYAH",
    },
    {
      countryName: "EGYPT",
      regionCode: "MN",
      regionName: "AL MINYA",
    },
    {
      countryName: "EGYPT",
      regionCode: "C",
      regionName: "AL QAHIRAH",
    },
    {
      countryName: "EGYPT",
      regionCode: "KB",
      regionName: "AL QALYUBIYAH",
    },
    {
      countryName: "EGYPT",
      regionCode: "LX",
      regionName: "AL UQSUR",
    },
    {
      countryName: "EGYPT",
      regionCode: "WAD",
      regionName: "AL WADI AL JADID",
    },
    {
      countryName: "EGYPT",
      regionCode: "SUZ",
      regionName: "AS SUWAYS",
    },
    {
      countryName: "EGYPT",
      regionCode: "SHR",
      regionName: "ASH SHARQIYAH",
    },
    {
      countryName: "EGYPT",
      regionCode: "ASN",
      regionName: "ASWAN",
    },
    {
      countryName: "EGYPT",
      regionCode: "AST",
      regionName: "ASYUT",
    },
    {
      countryName: "EGYPT",
      regionCode: "BNS",
      regionName: "BANI SUWAYF",
    },
    {
      countryName: "EGYPT",
      regionCode: "PTS",
      regionName: "BUR SAID",
    },
    {
      countryName: "EGYPT",
      regionCode: "DT",
      regionName: "DUMYAT",
    },
    {
      countryName: "EGYPT",
      regionCode: "JS",
      regionName: "JANUB SINA",
    },
    {
      countryName: "EGYPT",
      regionCode: "KFS",
      regionName: "KAFR ASH SHAYKH",
    },
    {
      countryName: "EGYPT",
      regionCode: "MT",
      regionName: "MATRUH",
    },
    {
      countryName: "EGYPT",
      regionCode: "KN",
      regionName: "QINA",
    },
    {
      countryName: "EGYPT",
      regionCode: "SIN",
      regionName: "SHAMAL SINA",
    },
    {
      countryName: "EGYPT",
      regionCode: "SHG",
      regionName: "SUHAJ",
    },
    {
      countryName: "EL SALVADOR",
      regionCode: "AH",
      regionName: "AHUACHAPAN",
    },
    {
      countryName: "EL SALVADOR",
      regionCode: "CA",
      regionName: "CABANAS",
    },
    {
      countryName: "EL SALVADOR",
      regionCode: "CH",
      regionName: "CHALATENANGO",
    },
    {
      countryName: "EL SALVADOR",
      regionCode: "CU",
      regionName: "CUSCATLAN",
    },
    {
      countryName: "EL SALVADOR",
      regionCode: "LI",
      regionName: "LA LIBERTAD",
    },
    {
      countryName: "EL SALVADOR",
      regionCode: "PA",
      regionName: "LA PAZ",
    },
    {
      countryName: "EL SALVADOR",
      regionCode: "UN",
      regionName: "LA UNION",
    },
    {
      countryName: "EL SALVADOR",
      regionCode: "MO",
      regionName: "MORAZAN",
    },
    {
      countryName: "EL SALVADOR",
      regionCode: "SM",
      regionName: "SAN MIGUEL",
    },
    {
      countryName: "EL SALVADOR",
      regionCode: "SS",
      regionName: "SAN SALVADOR",
    },
    {
      countryName: "EL SALVADOR",
      regionCode: "SV",
      regionName: "SAN VICENTE",
    },
    {
      countryName: "EL SALVADOR",
      regionCode: "SA",
      regionName: "SANTA ANA",
    },
    {
      countryName: "EL SALVADOR",
      regionCode: "SO",
      regionName: "SONSONATE",
    },
    {
      countryName: "EL SALVADOR",
      regionCode: "US",
      regionName: "USULUTAN",
    },
    {
      countryName: "EQUATORIAL GUINEA",
      regionCode: "AN",
      regionName: "ANNOBON",
    },
    {
      countryName: "EQUATORIAL GUINEA",
      regionCode: "BN",
      regionName: "BIOKO NORTE",
    },
    {
      countryName: "EQUATORIAL GUINEA",
      regionCode: "BS",
      regionName: "BIOKO SUR",
    },
    {
      countryName: "EQUATORIAL GUINEA",
      regionCode: "CS",
      regionName: "CENTRO SUR",
    },
    {
      countryName: "EQUATORIAL GUINEA",
      regionCode: "KN",
      regionName: "KIE-NTEM",
    },
    {
      countryName: "EQUATORIAL GUINEA",
      regionCode: "LI",
      regionName: "LITORAL",
    },
    {
      countryName: "EQUATORIAL GUINEA",
      regionCode: "WN",
      regionName: "WELE-NZAS",
    },
    {
      countryName: "ERITREA",
      regionCode: "AN",
      regionName: "ANSEBA",
    },
    {
      countryName: "ERITREA",
      regionCode: "DK",
      regionName: "DEBUBAWI KEYIH BAHRI",
    },
    {
      countryName: "ERITREA",
      regionCode: "DU",
      regionName: "DEBUB",
    },
    {
      countryName: "ERITREA",
      regionCode: "GB",
      regionName: "GASH-BARKA",
    },
    {
      countryName: "ERITREA",
      regionCode: "MA",
      regionName: "MAAKEL (MAEKEL)",
    },
    {
      countryName: "ERITREA",
      regionCode: "SK",
      regionName: "SEMENAWI KEYIH BAHRI",
    },
    {
      countryName: "ESTONIA",
      regionCode: 37,
      regionName: "HARJUMAA",
    },
    {
      countryName: "ESTONIA",
      regionCode: 39,
      regionName: "HIIUMAA",
    },
    {
      countryName: "ESTONIA",
      regionCode: 44,
      regionName: "IDA-VIRUMAA",
    },
    {
      countryName: "ESTONIA",
      regionCode: 49,
      regionName: "JOGEVAMAA",
    },
    {
      countryName: "ESTONIA",
      regionCode: 51,
      regionName: "JARVAMAA",
    },
    {
      countryName: "ESTONIA",
      regionCode: 57,
      regionName: "LAANEMAA",
    },
    {
      countryName: "ESTONIA",
      regionCode: 59,
      regionName: "LAANE-VIRUMAA",
    },
    {
      countryName: "ESTONIA",
      regionCode: 65,
      regionName: "POLVAMAA",
    },
    {
      countryName: "ESTONIA",
      regionCode: 67,
      regionName: "PARNUMAA",
    },
    {
      countryName: "ESTONIA",
      regionCode: 70,
      regionName: "RAPLAMAA",
    },
    {
      countryName: "ESTONIA",
      regionCode: 74,
      regionName: "SAAREMAA",
    },
    {
      countryName: "ESTONIA",
      regionCode: 78,
      regionName: "TARTUMAA",
    },
    {
      countryName: "ESTONIA",
      regionCode: 82,
      regionName: "VALGAMAA",
    },
    {
      countryName: "ESTONIA",
      regionCode: 84,
      regionName: "VILJANDIMAA",
    },
    {
      countryName: "ESTONIA",
      regionCode: 86,
      regionName: "VORUMAA",
    },
    {
      countryName: "ETHIOPIA",
      regionCode: "AA",
      regionName: "ADDIS ABABA",
    },
    {
      countryName: "ETHIOPIA",
      regionCode: "AF",
      regionName: "AFAR",
    },
    {
      countryName: "ETHIOPIA",
      regionCode: "AM",
      regionName: "AMARA",
    },
    {
      countryName: "ETHIOPIA",
      regionCode: "BE",
      regionName: "BENSHANGUL-GUMAZ",
    },
    {
      countryName: "ETHIOPIA",
      regionCode: "DD",
      regionName: "DIRE DAWA",
    },
    {
      countryName: "ETHIOPIA",
      regionCode: "GA",
      regionName: "GAMBELA PEOPLES",
    },
    {
      countryName: "ETHIOPIA",
      regionCode: "HA",
      regionName: "HARARI PEOPLE",
    },
    {
      countryName: "ETHIOPIA",
      regionCode: "OR",
      regionName: "OROMIA",
    },
    {
      countryName: "ETHIOPIA",
      regionCode: "SN",
      regionName: "YEDEBUB BIHEROCH BIHERESEBOCH",
    },
    {
      countryName: "ETHIOPIA",
      regionCode: "SO",
      regionName: "SOMALI, FEDERAL REPUBLIC OF",
    },
    {
      countryName: "ETHIOPIA",
      regionCode: "TI",
      regionName: "TIGRAI",
    },
    {
      countryName: "FALKLAND ISLANDS (MALVINAS)",
      regionCode: "FK",
      regionName: "FALKLAND ISLANDS (THE) [MALVINAS]",
    },
    {
      countryName: "FAROE ISLANDS (THE)",
      regionCode: "FO",
      regionName: "FAROE ISLANDS (THE)",
    },
    {
      countryName: "FIJI",
      regionCode: "C",
      regionName: "CENTRAL",
    },
    {
      countryName: "FIJI",
      regionCode: "E",
      regionName: "EASTERN",
    },
    {
      countryName: "FIJI",
      regionCode: "N",
      regionName: "NORTHERN",
    },
    {
      countryName: "FIJI",
      regionCode: "R",
      regionName: "ROTUMA",
    },
    {
      countryName: "FIJI",
      regionCode: "W",
      regionName: "WESTERN",
    },
    {
      countryName: "FINLAND",
      regionCode: "AL",
      regionName: "AHVENANMAAN LAANI",
    },
    {
      countryName: "FINLAND",
      regionCode: "ES",
      regionName: "ETELA-SUOMEN LAANI",
    },
    {
      countryName: "FINLAND",
      regionCode: "IS",
      regionName: "ITA-SUOMEN LAANI",
    },
    {
      countryName: "FINLAND",
      regionCode: "LL",
      regionName: "LAPIN LAANI",
    },
    {
      countryName: "FINLAND",
      regionCode: "LS",
      regionName: "LANSI-SUOMEN LAANI",
    },
    {
      countryName: "FINLAND",
      regionCode: "OL",
      regionName: "OULUN LAANI",
    },
    {
      countryName: "FRANCE",
      regionCode: 1,
      regionName: "AIN",
    },
    {
      countryName: "FRANCE",
      regionCode: 2,
      regionName: "AISNE",
    },
    {
      countryName: "FRANCE",
      regionCode: 3,
      regionName: "ALLIER",
    },
    {
      countryName: "FRANCE",
      regionCode: 4,
      regionName: "ALPES-DE-HAUTE-PROVENC E",
    },
    {
      countryName: "FRANCE",
      regionCode: 6,
      regionName: "ALPES-MARITIMES",
    },
    {
      countryName: "FRANCE",
      regionCode: "A",
      regionName: "ALSACE",
    },
    {
      countryName: "FRANCE",
      regionCode: "B",
      regionName: "AQUITAINE",
    },
    {
      countryName: "FRANCE",
      regionCode: 7,
      regionName: "ARDECHE",
    },
    {
      countryName: "FRANCE",
      regionCode: 8,
      regionName: "ARDENNES",
    },
    {
      countryName: "FRANCE",
      regionCode: 9,
      regionName: "ARIEGE",
    },
    {
      countryName: "FRANCE",
      regionCode: 10,
      regionName: "AUBE",
    },
    {
      countryName: "FRANCE",
      regionCode: 11,
      regionName: "AUDE",
    },
    {
      countryName: "FRANCE",
      regionCode: "C",
      regionName: "AUVERGNE",
    },
    {
      countryName: "FRANCE",
      regionCode: 12,
      regionName: "AVEYRON",
    },
    {
      countryName: "FRANCE",
      regionCode: 67,
      regionName: "BAS-RHIN",
    },
    {
      countryName: "FRANCE",
      regionCode: "P",
      regionName: "BASSE-NORMANDIE",
    },
    {
      countryName: "FRANCE",
      regionCode: 13,
      regionName: "BOUCHES-DU-RHONE",
    },
    {
      countryName: "FRANCE",
      regionCode: "D",
      regionName: "BOURGOGNE",
    },
    {
      countryName: "FRANCE",
      regionCode: "E",
      regionName: "BRETAGNE",
    },
    {
      countryName: "FRANCE",
      regionCode: 14,
      regionName: "CALVADOS",
    },
    {
      countryName: "FRANCE",
      regionCode: 15,
      regionName: "CANTAL",
    },
    {
      countryName: "FRANCE",
      regionCode: "F",
      regionName: "CENTRE",
    },
    {
      countryName: "FRANCE",
      regionCode: "G",
      regionName: "CHAMPAGNE-ARDENNE",
    },
    {
      countryName: "FRANCE",
      regionCode: 16,
      regionName: "CHARENTE",
    },
    {
      countryName: "FRANCE",
      regionCode: 17,
      regionName: "CHARENTE-MARITIME",
    },
    {
      countryName: "FRANCE",
      regionCode: 18,
      regionName: "CHER",
    },
    {
      countryName: "FRANCE",
      regionCode: "CP",
      regionName: "CLIPPERTON",
    },
    {
      countryName: "FRANCE",
      regionCode: 19,
      regionName: "CORREZE",
    },
    {
      countryName: "FRANCE",
      regionCode: "H",
      regionName: "CORSE",
    },
    {
      countryName: "FRANCE",
      regionCode: "2A",
      regionName: "CORSE-DU-SUD",
    },
    {
      countryName: "FRANCE",
      regionCode: 21,
      regionName: "COTE-D’OR",
    },
    {
      countryName: "FRANCE",
      regionCode: 22,
      regionName: "COTES-D’ARMOR",
    },
    {
      countryName: "FRANCE",
      regionCode: 23,
      regionName: "CREUSE",
    },
    {
      countryName: "FRANCE",
      regionCode: 79,
      regionName: "DEUX-SEVRES",
    },
    {
      countryName: "FRANCE",
      regionCode: 24,
      regionName: "DORDOGNE",
    },
    {
      countryName: "FRANCE",
      regionCode: 25,
      regionName: "DOUBS",
    },
    {
      countryName: "FRANCE",
      regionCode: 26,
      regionName: "DROME",
    },
    {
      countryName: "FRANCE",
      regionCode: 91,
      regionName: "ESSONNE",
    },
    {
      countryName: "FRANCE",
      regionCode: 27,
      regionName: "EURE",
    },
    {
      countryName: "FRANCE",
      regionCode: 28,
      regionName: "EURE-ET-LOIR",
    },
    {
      countryName: "FRANCE",
      regionCode: 29,
      regionName: "FINISTERE",
    },
    {
      countryName: "FRANCE",
      regionCode: "I",
      regionName: "FRANCHE-COMTE",
    },
    {
      countryName: "FRANCE",
      regionCode: 30,
      regionName: "GARD",
    },
    {
      countryName: "FRANCE",
      regionCode: 32,
      regionName: "GERS",
    },
    {
      countryName: "FRANCE",
      regionCode: 33,
      regionName: "GIRONDE",
    },
    {
      countryName: "FRANCE",
      regionCode: "GP",
      regionName: "GUADELOUPE",
    },
    {
      countryName: "FRANCE",
      regionCode: "GF",
      regionName: "GUYANE",
    },
    {
      countryName: "FRANCE",
      regionCode: "2B",
      regionName: "HAUTE-CORSE",
    },
    {
      countryName: "FRANCE",
      regionCode: 31,
      regionName: "HAUTE-GARONNE",
    },
    {
      countryName: "FRANCE",
      regionCode: 43,
      regionName: "HAUTE-LOIRE",
    },
    {
      countryName: "FRANCE",
      regionCode: 52,
      regionName: "HAUTE-MARNE",
    },
    {
      countryName: "FRANCE",
      regionCode: "Q",
      regionName: "HAUTE-NORMANDIE",
    },
    {
      countryName: "FRANCE",
      regionCode: 5,
      regionName: "HAUTES-ALPES",
    },
    {
      countryName: "FRANCE",
      regionCode: 70,
      regionName: "HAUTE-SAONE",
    },
    {
      countryName: "FRANCE",
      regionCode: 74,
      regionName: "HAUTE-SAVOIE",
    },
    {
      countryName: "FRANCE",
      regionCode: 65,
      regionName: "HAUTES-PYRENEES",
    },
    {
      countryName: "FRANCE",
      regionCode: 87,
      regionName: "HAUTE-VIENNE",
    },
    {
      countryName: "FRANCE",
      regionCode: 68,
      regionName: "HAUT-RHIN",
    },
    {
      countryName: "FRANCE",
      regionCode: 92,
      regionName: "HAUTS-DE-SEINE",
    },
    {
      countryName: "FRANCE",
      regionCode: 34,
      regionName: "HERAULT",
    },
    {
      countryName: "FRANCE",
      regionCode: "J",
      regionName: "ILE-DE-FRANCE",
    },
    {
      countryName: "FRANCE",
      regionCode: 35,
      regionName: "ILLE-ET-VILAINE",
    },
    {
      countryName: "FRANCE",
      regionCode: 36,
      regionName: "INDRE",
    },
    {
      countryName: "FRANCE",
      regionCode: 37,
      regionName: "INDRE-ET-LOIRE",
    },
    {
      countryName: "FRANCE",
      regionCode: 38,
      regionName: "ISERE",
    },
    {
      countryName: "FRANCE",
      regionCode: 39,
      regionName: "JURA",
    },
    {
      countryName: "FRANCE",
      regionCode: "RE",
      regionName: "LA REUNION",
    },
    {
      countryName: "FRANCE",
      regionCode: 40,
      regionName: "LANDES",
    },
    {
      countryName: "FRANCE",
      regionCode: "K",
      regionName: "LANGUEDOC-ROUSSILLON",
    },
    {
      countryName: "FRANCE",
      regionCode: "L",
      regionName: "LIMOUSIN",
    },
    {
      countryName: "FRANCE",
      regionCode: 42,
      regionName: "LOIRE",
    },
    {
      countryName: "FRANCE",
      regionCode: 44,
      regionName: "LOIRE-ATLANTIQUE",
    },
    {
      countryName: "FRANCE",
      regionCode: 45,
      regionName: "LOIRET",
    },
    {
      countryName: "FRANCE",
      regionCode: 41,
      regionName: "LOIR-ET-CHER",
    },
    {
      countryName: "FRANCE",
      regionCode: "M",
      regionName: "LORRAINE",
    },
    {
      countryName: "FRANCE",
      regionCode: 46,
      regionName: "LOT",
    },
    {
      countryName: "FRANCE",
      regionCode: 47,
      regionName: "LOT-ET-GARONNE",
    },
    {
      countryName: "FRANCE",
      regionCode: 48,
      regionName: "LOZERE",
    },
    {
      countryName: "FRANCE",
      regionCode: 49,
      regionName: "MAINE-ET-LOIRE",
    },
    {
      countryName: "FRANCE",
      regionCode: 50,
      regionName: "MANCHE",
    },
    {
      countryName: "FRANCE",
      regionCode: 51,
      regionName: "MARNE",
    },
    {
      countryName: "FRANCE",
      regionCode: "MQ",
      regionName: "MARTINIQUE",
    },
    {
      countryName: "FRANCE",
      regionCode: 53,
      regionName: "MAYENNE",
    },
    {
      countryName: "FRANCE",
      regionCode: "YT",
      regionName: "MAYOTTE",
    },
    {
      countryName: "FRANCE",
      regionCode: 54,
      regionName: "MEURTHE-ET-MOSELLE",
    },
    {
      countryName: "FRANCE",
      regionCode: 55,
      regionName: "MEUSE",
    },
    {
      countryName: "FRANCE",
      regionCode: "N",
      regionName: "MIDI-PYRENEES",
    },
    {
      countryName: "FRANCE",
      regionCode: 56,
      regionName: "MORBIHAN",
    },
    {
      countryName: "FRANCE",
      regionCode: 57,
      regionName: "MOSELLE",
    },
    {
      countryName: "FRANCE",
      regionCode: 58,
      regionName: "NIEVRE",
    },
    {
      countryName: "FRANCE",
      regionCode: 59,
      regionName: "NORD",
    },
    {
      countryName: "FRANCE",
      regionCode: "O",
      regionName: "NORD-PAS-DE-CALAIS",
    },
    {
      countryName: "FRANCE",
      regionCode: "NC",
      regionName: "NOUVELLE-CALEDONIE",
    },
    {
      countryName: "FRANCE",
      regionCode: 60,
      regionName: "OISE",
    },
    {
      countryName: "FRANCE",
      regionCode: 61,
      regionName: "ORNE",
    },
    {
      countryName: "FRANCE",
      regionCode: 75,
      regionName: "PARIS",
    },
    {
      countryName: "FRANCE",
      regionCode: 62,
      regionName: "PAS-DE-CALAIS",
    },
    {
      countryName: "FRANCE",
      regionCode: "R",
      regionName: "PAYS-DE-LA-LOIRE",
    },
    {
      countryName: "FRANCE",
      regionCode: "S",
      regionName: "PICARDIE",
    },
    {
      countryName: "FRANCE",
      regionCode: "T",
      regionName: "POITOU-CHARENTES",
    },
    {
      countryName: "FRANCE",
      regionCode: "PF",
      regionName: "POLYNESIE FRANCAISE",
    },
    {
      countryName: "FRANCE",
      regionCode: "U",
      regionName: "PROVENCE-ALPES-COTE-D’AZUR",
    },
    {
      countryName: "FRANCE",
      regionCode: 63,
      regionName: "PUY-DE-DOME",
    },
    {
      countryName: "FRANCE",
      regionCode: 64,
      regionName: "PYRENEES-ATLANTIQUES",
    },
    {
      countryName: "FRANCE",
      regionCode: 66,
      regionName: "PYRENEES-ORIENTALES",
    },
    {
      countryName: "FRANCE",
      regionCode: 69,
      regionName: "RHONE",
    },
    {
      countryName: "FRANCE",
      regionCode: "V",
      regionName: "RHONE-ALPES",
    },
    {
      countryName: "FRANCE",
      regionCode: "BL",
      regionName: "SAINT-BARTHELEMY",
    },
    {
      countryName: "FRANCE",
      regionCode: "MF",
      regionName: "SAINT-MARTIN",
    },
    {
      countryName: "FRANCE",
      regionCode: "PM",
      regionName: "SAINT-PIERRE-ET-MIQUELON",
    },
    {
      countryName: "FRANCE",
      regionCode: 71,
      regionName: "SAONE-ET-LOIRE",
    },
    {
      countryName: "FRANCE",
      regionCode: 72,
      regionName: "SARTHE",
    },
    {
      countryName: "FRANCE",
      regionCode: 73,
      regionName: "SAVOIE",
    },
    {
      countryName: "FRANCE",
      regionCode: 77,
      regionName: "SEINE-ET-MARNE",
    },
    {
      countryName: "FRANCE",
      regionCode: 76,
      regionName: "SEINE-MARITIME",
    },
    {
      countryName: "FRANCE",
      regionCode: 93,
      regionName: "SEINE-SAINT-DENIS",
    },
    {
      countryName: "FRANCE",
      regionCode: 80,
      regionName: "SOMME",
    },
    {
      countryName: "FRANCE",
      regionCode: 81,
      regionName: "TARN",
    },
    {
      countryName: "FRANCE",
      regionCode: 82,
      regionName: "TARN-ET-GARONNE",
    },
    {
      countryName: "FRANCE",
      regionCode: "TF",
      regionName: "TERRES AUSTRALES FRANCAISES",
    },
    {
      countryName: "FRANCE",
      regionCode: 90,
      regionName: "TERRITOIRE DE BELFORT",
    },
    {
      countryName: "FRANCE",
      regionCode: 95,
      regionName: "VAL-D’OISE",
    },
    {
      countryName: "FRANCE",
      regionCode: 94,
      regionName: "VAL-DE-MARNE",
    },
    {
      countryName: "FRANCE",
      regionCode: 83,
      regionName: "VAR",
    },
    {
      countryName: "FRANCE",
      regionCode: 84,
      regionName: "VAUCLUSE",
    },
    {
      countryName: "FRANCE",
      regionCode: 85,
      regionName: "VENDEE",
    },
    {
      countryName: "FRANCE",
      regionCode: 86,
      regionName: "VIENNE",
    },
    {
      countryName: "FRANCE",
      regionCode: 88,
      regionName: "VOSGES",
    },
    {
      countryName: "FRANCE",
      regionCode: "WF",
      regionName: "WALLISAND-FUTUNA",
    },
    {
      countryName: "FRANCE",
      regionCode: 89,
      regionName: "YONNE",
    },
    {
      countryName: "FRANCE",
      regionCode: 78,
      regionName: "YVELINES",
    },
    {
      countryName: "FRENCH GUIANA",
      regionCode: "GF",
      regionName: "FRENCH GUIANA",
    },
    {
      countryName: "FRENCH POLYNESIA",
      regionCode: "PF",
      regionName: "FRENCH POLYNESIA",
    },
    {
      countryName: "FRENCH SOUTHERN TERRITORIES (THE)",
      regionCode: "TF",
      regionName: "FRENCH SOUTHERN TERRITORIES (THE)",
    },
    {
      countryName: "GABON",
      regionCode: 1,
      regionName: "ESTUAIRE",
    },
    {
      countryName: "GABON",
      regionCode: 2,
      regionName: "HAUT-OGOOUE",
    },
    {
      countryName: "GABON",
      regionCode: 3,
      regionName: "MOYEN-OGOOUE",
    },
    {
      countryName: "GABON",
      regionCode: 4,
      regionName: "NGOUNIE",
    },
    {
      countryName: "GABON",
      regionCode: 5,
      regionName: "NYANGA",
    },
    {
      countryName: "GABON",
      regionCode: 6,
      regionName: "OGOOUE-IVINDO",
    },
    {
      countryName: "GABON",
      regionCode: 7,
      regionName: "OGOOUE-LOLO",
    },
    {
      countryName: "GABON",
      regionCode: 8,
      regionName: "OGOOUE-MARITIME",
    },
    {
      countryName: "GABON",
      regionCode: 9,
      regionName: "WOLEU-NTEM",
    },
    {
      countryName: "GAMBIA (THE)",
      regionCode: "B",
      regionName: "BANJUL",
    },
    {
      countryName: "GAMBIA (THE)",
      regionCode: "M",
      regionName: "CENTRAL RIVER",
    },
    {
      countryName: "GAMBIA (THE)",
      regionCode: "L",
      regionName: "LOWER RIVER",
    },
    {
      countryName: "GAMBIA (THE)",
      regionCode: "N",
      regionName: "NORTH BANK",
    },
    {
      countryName: "GAMBIA (THE)",
      regionCode: "U",
      regionName: "UPPER RIVER",
    },
    {
      countryName: "GAMBIA (THE)",
      regionCode: "W",
      regionName: "WESTERN",
    },
    {
      countryName: "GEORGIA",
      regionCode: "AB",
      regionName: "ABKHAZIA",
    },
    {
      countryName: "GEORGIA",
      regionCode: "AJ",
      regionName: "AJARIA",
    },
    {
      countryName: "GEORGIA",
      regionCode: "GU",
      regionName: "GURIA",
    },
    {
      countryName: "GEORGIA",
      regionCode: "IM",
      regionName: "IMERETI",
    },
    {
      countryName: "GEORGIA",
      regionCode: "KA",
      regionName: "KAKHETI",
    },
    {
      countryName: "GEORGIA",
      regionCode: "KK",
      regionName: "KVEMO KARTLI",
    },
    {
      countryName: "GEORGIA",
      regionCode: "MM",
      regionName: "MTSKHETA-MTIANETI",
    },
    {
      countryName: "GEORGIA",
      regionCode: "RL",
      regionName: "RACHA-LECHKHUMI-KVEMO SVANETI",
    },
    {
      countryName: "GEORGIA",
      regionCode: "SJ",
      regionName: "SAMTSKHE-JAVAKHETI",
    },
    {
      countryName: "GEORGIA",
      regionCode: "SK",
      regionName: "SHIDA KARTLI",
    },
    {
      countryName: "GEORGIA",
      regionCode: "SZ",
      regionName: "SAMEGRELO-ZEMO SVANETI",
    },
    {
      countryName: "GEORGIA",
      regionCode: "TB",
      regionName: "TBILISI",
    },
    {
      countryName: "GERMANY",
      regionCode: "BB",
      regionName: "BRANDENBURG",
    },
    {
      countryName: "GERMANY",
      regionCode: "BE",
      regionName: "BERLIN",
    },
    {
      countryName: "GERMANY",
      regionCode: "BW",
      regionName: "BADEN-WURTTEMBERG",
    },
    {
      countryName: "GERMANY",
      regionCode: "BY",
      regionName: "BAYERN",
    },
    {
      countryName: "GERMANY",
      regionCode: "HB",
      regionName: "BREMEN",
    },
    {
      countryName: "GERMANY",
      regionCode: "HE",
      regionName: "HESSEN",
    },
    {
      countryName: "GERMANY",
      regionCode: "HH",
      regionName: "HAMBURG",
    },
    {
      countryName: "GERMANY",
      regionCode: "MV",
      regionName: "MECKLENBURG-VORPOMMER N",
    },
    {
      countryName: "GERMANY",
      regionCode: "NI",
      regionName: "NIEDERSACHSEN",
    },
    {
      countryName: "GERMANY",
      regionCode: "NW",
      regionName: "NORDRHEIN-WESTFALEN",
    },
    {
      countryName: "GERMANY",
      regionCode: "RP",
      regionName: "RHEINLAND-PFALZ",
    },
    {
      countryName: "GERMANY",
      regionCode: "SH",
      regionName: "SCHLESWIG-HOLSTEIN",
    },
    {
      countryName: "GERMANY",
      regionCode: "SL",
      regionName: "SAARLAND",
    },
    {
      countryName: "GERMANY",
      regionCode: "SN",
      regionName: "SACHSEN",
    },
    {
      countryName: "GERMANY",
      regionCode: "ST",
      regionName: "SACHSEN-ANHALT",
    },
    {
      countryName: "GERMANY",
      regionCode: "TH",
      regionName: "THURINGEN",
    },
    {
      countryName: "GHANA",
      regionCode: "AH",
      regionName: "ASHANTI",
    },
    {
      countryName: "GHANA",
      regionCode: "BA",
      regionName: "BRONG-AHAFO",
    },
    {
      countryName: "GHANA",
      regionCode: "CP",
      regionName: "CENTRAL",
    },
    {
      countryName: "GHANA",
      regionCode: "EP",
      regionName: "EASTERN",
    },
    {
      countryName: "GHANA",
      regionCode: "AA",
      regionName: "GREATER ACCRA",
    },
    {
      countryName: "GHANA",
      regionCode: "NP",
      regionName: "NORTHERN",
    },
    {
      countryName: "GHANA",
      regionCode: "UE",
      regionName: "UPPER EAST",
    },
    {
      countryName: "GHANA",
      regionCode: "UW",
      regionName: "UPPER WEST",
    },
    {
      countryName: "GHANA",
      regionCode: "TV",
      regionName: "VOLTA",
    },
    {
      countryName: "GHANA",
      regionCode: "WP",
      regionName: "WESTERN",
    },
    {
      countryName: "GIBRALTAR",
      regionCode: "GI",
      regionName: "GIBRALTAR",
    },
    {
      countryName: "GREECE",
      regionCode: 13,
      regionName: "ACHAIA",
    },
    {
      countryName: "GREECE",
      regionCode: 69,
      regionName: "AGIO OROS",
    },
    {
      countryName: "GREECE",
      regionCode: 1,
      regionName: "AITOLIA-AKARNANIA",
    },
    {
      countryName: "GREECE",
      regionCode: 11,
      regionName: "ARGOLIS",
    },
    {
      countryName: "GREECE",
      regionCode: 12,
      regionName: "ARKADIA",
    },
    {
      countryName: "GREECE",
      regionCode: 31,
      regionName: "ARTA",
    },
    {
      countryName: "GREECE",
      regionCode: "A1",
      regionName: "ATTIKI",
    },
    {
      countryName: "GREECE",
      regionCode: 64,
      regionName: "CHALKIDIKI",
    },
    {
      countryName: "GREECE",
      regionCode: 94,
      regionName: "CHANIA",
    },
    {
      countryName: "GREECE",
      regionCode: 85,
      regionName: "CHIOS",
    },
    {
      countryName: "GREECE",
      regionCode: 81,
      regionName: "DODEKANISOS",
    },
    {
      countryName: "GREECE",
      regionCode: 52,
      regionName: "DRAMA",
    },
    {
      countryName: "GREECE",
      regionCode: 71,
      regionName: "EVROS",
    },
    {
      countryName: "GREECE",
      regionCode: 5,
      regionName: "EVRYTANIA",
    },
    {
      countryName: "GREECE",
      regionCode: 4,
      regionName: "EVVOIA",
    },
    {
      countryName: "GREECE",
      regionCode: 63,
      regionName: "FLORINA",
    },
    {
      countryName: "GREECE",
      regionCode: 7,
      regionName: "FOKIS",
    },
    {
      countryName: "GREECE",
      regionCode: 6,
      regionName: "FTHIOTIS",
    },
    {
      countryName: "GREECE",
      regionCode: 51,
      regionName: "GREVENA",
    },
    {
      countryName: "GREECE",
      regionCode: 14,
      regionName: "ILEIA",
    },
    {
      countryName: "GREECE",
      regionCode: 53,
      regionName: "IMATHIA",
    },
    {
      countryName: "GREECE",
      regionCode: 33,
      regionName: "IOANNINA",
    },
    {
      countryName: "GREECE",
      regionCode: 91,
      regionName: "IRAKLEION",
    },
    {
      countryName: "GREECE",
      regionCode: 41,
      regionName: "KARDITSA",
    },
    {
      countryName: "GREECE",
      regionCode: 56,
      regionName: "KASTORIA",
    },
    {
      countryName: "GREECE",
      regionCode: 55,
      regionName: "KAVALLA",
    },
    {
      countryName: "GREECE",
      regionCode: 23,
      regionName: "KEFALLINIA",
    },
    {
      countryName: "GREECE",
      regionCode: 22,
      regionName: "KERKYRA",
    },
    {
      countryName: "GREECE",
      regionCode: 57,
      regionName: "KILKIS",
    },
    {
      countryName: "GREECE",
      regionCode: 15,
      regionName: "KORINTHIA",
    },
    {
      countryName: "GREECE",
      regionCode: 58,
      regionName: "KOZANI",
    },
    {
      countryName: "GREECE",
      regionCode: 82,
      regionName: "KYKLADES",
    },
    {
      countryName: "GREECE",
      regionCode: 16,
      regionName: "LAKONIA",
    },
    {
      countryName: "GREECE",
      regionCode: 42,
      regionName: "LARISA",
    },
    {
      countryName: "GREECE",
      regionCode: 92,
      regionName: "LASITHION",
    },
    {
      countryName: "GREECE",
      regionCode: 24,
      regionName: "LEFKAS",
    },
    {
      countryName: "GREECE",
      regionCode: 83,
      regionName: "LESVOS",
    },
    {
      countryName: "GREECE",
      regionCode: 43,
      regionName: "MAGNISIA",
    },
    {
      countryName: "GREECE",
      regionCode: 17,
      regionName: "MESSINIA",
    },
    {
      countryName: "GREECE",
      regionCode: 59,
      regionName: "PELLA",
    },
    {
      countryName: "GREECE",
      regionCode: 61,
      regionName: "PIERIA",
    },
    {
      countryName: "GREECE",
      regionCode: 34,
      regionName: "PREVEZA",
    },
    {
      countryName: "GREECE",
      regionCode: 93,
      regionName: "RETHYMNON",
    },
    {
      countryName: "GREECE",
      regionCode: 73,
      regionName: "RODOPI",
    },
    {
      countryName: "GREECE",
      regionCode: 84,
      regionName: "SAMOS",
    },
    {
      countryName: "GREECE",
      regionCode: 62,
      regionName: "SERRAI",
    },
    {
      countryName: "GREECE",
      regionCode: 32,
      regionName: "THESPROTIA",
    },
    {
      countryName: "GREECE",
      regionCode: 54,
      regionName: "THESSALONIKI",
    },
    {
      countryName: "GREECE",
      regionCode: 44,
      regionName: "TRIKALA",
    },
    {
      countryName: "GREECE",
      regionCode: 3,
      regionName: "VIOTIA",
    },
    {
      countryName: "GREECE",
      regionCode: 72,
      regionName: "XANTHI",
    },
    {
      countryName: "GREECE",
      regionCode: 21,
      regionName: "ZAKYNTHOS",
    },
    {
      countryName: "GREENLAND",
      regionCode: "GL",
      regionName: "GREENLAND",
    },
    {
      countryName: "GRENADA",
      regionCode: 1,
      regionName: "SAINT ANDREW",
    },
    {
      countryName: "GRENADA",
      regionCode: 2,
      regionName: "SAINT DAVID",
    },
    {
      countryName: "GRENADA",
      regionCode: 3,
      regionName: "SAINT GEORGE",
    },
    {
      countryName: "GRENADA",
      regionCode: 4,
      regionName: "SAINT JOHN",
    },
    {
      countryName: "GRENADA",
      regionCode: 5,
      regionName: "SAINT MARK",
    },
    {
      countryName: "GRENADA",
      regionCode: 6,
      regionName: "SAINT PATRICK",
    },
    {
      countryName: "GRENADA",
      regionCode: 10,
      regionName: "SOUTHERN GRENADINE ISLANDS",
    },
    {
      countryName: "GUADELOUPE",
      regionCode: "GP",
      regionName: "GUADELOUPE",
    },
    {
      countryName: "GUAM",
      regionCode: "GU",
      regionName: "GUAM",
    },
    {
      countryName: "GUATEMALA",
      regionCode: "AV",
      regionName: "ALTA VERAPAZ",
    },
    {
      countryName: "GUATEMALA",
      regionCode: "BV",
      regionName: "BAJA VERAPAZ",
    },
    {
      countryName: "GUATEMALA",
      regionCode: "CM",
      regionName: "CHIMALTENANGO",
    },
    {
      countryName: "GUATEMALA",
      regionCode: "CQ",
      regionName: "CHIQUIMULA",
    },
    {
      countryName: "GUATEMALA",
      regionCode: "PR",
      regionName: "EL PROGRESO",
    },
    {
      countryName: "GUATEMALA",
      regionCode: "ES",
      regionName: "ESCUINTLA",
    },
    {
      countryName: "GUATEMALA",
      regionCode: "GU",
      regionName: "GUATEMALA",
    },
    {
      countryName: "GUATEMALA",
      regionCode: "HU",
      regionName: "HUEHUETENANGO",
    },
    {
      countryName: "GUATEMALA",
      regionCode: "IZ",
      regionName: "IZABAL",
    },
    {
      countryName: "GUATEMALA",
      regionCode: "JA",
      regionName: "JALAPA",
    },
    {
      countryName: "GUATEMALA",
      regionCode: "JU",
      regionName: "JUTIAPA",
    },
    {
      countryName: "GUATEMALA",
      regionCode: "PE",
      regionName: "PETEN",
    },
    {
      countryName: "GUATEMALA",
      regionCode: "QZ",
      regionName: "QUETZALTENANGO",
    },
    {
      countryName: "GUATEMALA",
      regionCode: "QC",
      regionName: "QUICHE",
    },
    {
      countryName: "GUATEMALA",
      regionCode: "RE",
      regionName: "RETALHULEU",
    },
    {
      countryName: "GUATEMALA",
      regionCode: "SA",
      regionName: "SACATEPEQUEZ",
    },
    {
      countryName: "GUATEMALA",
      regionCode: "SM",
      regionName: "SAN MARCOS",
    },
    {
      countryName: "GUATEMALA",
      regionCode: "SR",
      regionName: "SANTA ROSA",
    },
    {
      countryName: "GUATEMALA",
      regionCode: "SO",
      regionName: "SOLOLA",
    },
    {
      countryName: "GUATEMALA",
      regionCode: "SU",
      regionName: "SUCHITEPEQUEZ",
    },
    {
      countryName: "GUATEMALA",
      regionCode: "TO",
      regionName: "TOTONICAPAN",
    },
    {
      countryName: "GUATEMALA",
      regionCode: "ZA",
      regionName: "ZACAPA",
    },
    {
      countryName: "GUERNSEY",
      regionCode: "GG",
      regionName: "GUERNSEY",
    },
    {
      countryName: "GUINEA",
      regionCode: "BE",
      regionName: "BEYLA",
    },
    {
      countryName: "GUINEA",
      regionCode: "BF",
      regionName: "BOFFA",
    },
    {
      countryName: "GUINEA",
      regionCode: "BK",
      regionName: "BOKE",
    },
    {
      countryName: "GUINEA",
      regionCode: "C",
      regionName: "CONAKRY",
    },
    {
      countryName: "GUINEA",
      regionCode: "CO",
      regionName: "COYAH",
    },
    {
      countryName: "GUINEA",
      regionCode: "DB",
      regionName: "DABOLA",
    },
    {
      countryName: "GUINEA",
      regionCode: "DI",
      regionName: "DINGUIRAYE",
    },
    {
      countryName: "GUINEA",
      regionCode: "DL",
      regionName: "DALABA",
    },
    {
      countryName: "GUINEA",
      regionCode: "DU",
      regionName: "DUBREKA",
    },
    {
      countryName: "GUINEA",
      regionCode: "FA",
      regionName: "FARANAH",
    },
    {
      countryName: "GUINEA",
      regionCode: "FO",
      regionName: "FORECARIAH",
    },
    {
      countryName: "GUINEA",
      regionCode: "FR",
      regionName: "FRIA",
    },
    {
      countryName: "GUINEA",
      regionCode: "GA",
      regionName: "GAOUAL",
    },
    {
      countryName: "GUINEA",
      regionCode: "GU",
      regionName: "GUEKEDOU",
    },
    {
      countryName: "GUINEA",
      regionCode: "KA",
      regionName: "KANKAN",
    },
    {
      countryName: "GUINEA",
      regionCode: "KB",
      regionName: "KOUBIA",
    },
    {
      countryName: "GUINEA",
      regionCode: "KD",
      regionName: "KINDIA",
    },
    {
      countryName: "GUINEA",
      regionCode: "KE",
      regionName: "KEROUANE",
    },
    {
      countryName: "GUINEA",
      regionCode: "KN",
      regionName: "KOUNDARA",
    },
    {
      countryName: "GUINEA",
      regionCode: "KO",
      regionName: "KOUROUSSA",
    },
    {
      countryName: "GUINEA",
      regionCode: "KS",
      regionName: "KISSIDOUGOU",
    },
    {
      countryName: "GUINEA",
      regionCode: "LA",
      regionName: "LABE",
    },
    {
      countryName: "GUINEA",
      regionCode: "LE",
      regionName: "LELOUMA",
    },
    {
      countryName: "GUINEA",
      regionCode: "LO",
      regionName: "LOLA",
    },
    {
      countryName: "GUINEA",
      regionCode: "MC",
      regionName: "MACENTA",
    },
    {
      countryName: "GUINEA",
      regionCode: "MD",
      regionName: "MANDIANA",
    },
    {
      countryName: "GUINEA",
      regionCode: "ML",
      regionName: "MALI",
    },
    {
      countryName: "GUINEA",
      regionCode: "MM",
      regionName: "MAMOU",
    },
    {
      countryName: "GUINEA",
      regionCode: "NZ",
      regionName: "NZEREKORE",
    },
    {
      countryName: "GUINEA",
      regionCode: "PI",
      regionName: "PITA",
    },
    {
      countryName: "GUINEA",
      regionCode: "SI",
      regionName: "SIGUIRI",
    },
    {
      countryName: "GUINEA",
      regionCode: "TE",
      regionName: "TELIMELE",
    },
    {
      countryName: "GUINEA",
      regionCode: "TO",
      regionName: "TOUGUE",
    },
    {
      countryName: "GUINEA",
      regionCode: "YO",
      regionName: "YOMOU",
    },
    {
      countryName: "GUINEA-BISSAU",
      regionCode: "BA",
      regionName: "BAFATA",
    },
    {
      countryName: "GUINEA-BISSAU",
      regionCode: "BL",
      regionName: "BOLAMA",
    },
    {
      countryName: "GUINEA-BISSAU",
      regionCode: "BM",
      regionName: "BIOMBO",
    },
    {
      countryName: "GUINEA-BISSAU",
      regionCode: "BS",
      regionName: "BISSAU",
    },
    {
      countryName: "GUINEA-BISSAU",
      regionCode: "CA",
      regionName: "CASHEU",
    },
    {
      countryName: "GUINEA-BISSAU",
      regionCode: "GA",
      regionName: "GABU",
    },
    {
      countryName: "GUINEA-BISSAU",
      regionCode: "OI",
      regionName: "OIO",
    },
    {
      countryName: "GUINEA-BISSAU",
      regionCode: "QU",
      regionName: "QUINARA",
    },
    {
      countryName: "GUINEA-BISSAU",
      regionCode: "TO",
      regionName: "TOMBALI",
    },
    {
      countryName: "GUYANA",
      regionCode: "BA",
      regionName: "BARIMA-WAINI",
    },
    {
      countryName: "GUYANA",
      regionCode: "CU",
      regionName: "CUYUNI-MAZARUNI",
    },
    {
      countryName: "GUYANA",
      regionCode: "DE",
      regionName: "DEMERARA-MAHAICA",
    },
    {
      countryName: "GUYANA",
      regionCode: "EB",
      regionName: "EAST BERBICE-CORENTYNE",
    },
    {
      countryName: "GUYANA",
      regionCode: "ES",
      regionName: "ESSEQUIBO ISLANDS-WEST DEMERARA",
    },
    {
      countryName: "GUYANA",
      regionCode: "MA",
      regionName: "MAHAICA-BERBICE",
    },
    {
      countryName: "GUYANA",
      regionCode: "PM",
      regionName: "POMEROON-SUPENAAM",
    },
    {
      countryName: "GUYANA",
      regionCode: "PT",
      regionName: "POTARO-SIPARUNI",
    },
    {
      countryName: "GUYANA",
      regionCode: "UD",
      regionName: "UPER DEMERARA-BERBICE",
    },
    {
      countryName: "GUYANA",
      regionCode: "UT",
      regionName: "UPPER TAKUTU-UPPER ESSEQUIBO",
    },
    {
      countryName: "HAITI",
      regionCode: "AR",
      regionName: "ARTIBONITE",
    },
    {
      countryName: "HAITI",
      regionCode: "CE",
      regionName: "CENTRE",
    },
    {
      countryName: "HAITI",
      regionCode: "GA",
      regionName: "GRANDE-ANSE",
    },
    {
      countryName: "HAITI",
      regionCode: "ND",
      regionName: "NORD",
    },
    {
      countryName: "HAITI",
      regionCode: "NE",
      regionName: "NORD-EST",
    },
    {
      countryName: "HAITI",
      regionCode: "NI",
      regionName: "NIPPES",
    },
    {
      countryName: "HAITI",
      regionCode: "NO",
      regionName: "NORD-OUEST",
    },
    {
      countryName: "HAITI",
      regionCode: "OU",
      regionName: "OUEST",
    },
    {
      countryName: "HAITI",
      regionCode: "SD",
      regionName: "SUD",
    },
    {
      countryName: "HAITI",
      regionCode: "SE",
      regionName: "SUD-EST",
    },
    {
      countryName: "HEARD ISLAND AND MCDONALD ISLANDS",
      regionCode: "HM",
      regionName: "HEARD ISLAND AND MCDONALD ISLANDS",
    },
    {
      countryName: "VATICAN CITY STATE (HOLY SEE)",
      regionCode: "VA",
      regionName: "HOLY SEE (THE)",
    },
    {
      countryName: "HONDURAS",
      regionCode: "AT",
      regionName: "ATLANTIDA",
    },
    {
      countryName: "HONDURAS",
      regionCode: "CH",
      regionName: "CHOLUTECA",
    },
    {
      countryName: "HONDURAS",
      regionCode: "CL",
      regionName: "COLON",
    },
    {
      countryName: "HONDURAS",
      regionCode: "CM",
      regionName: "COMAYAGUA",
    },
    {
      countryName: "HONDURAS",
      regionCode: "CP",
      regionName: "COPAN",
    },
    {
      countryName: "HONDURAS",
      regionCode: "CR",
      regionName: "CORTES",
    },
    {
      countryName: "HONDURAS",
      regionCode: "EP",
      regionName: "EL PARAISO",
    },
    {
      countryName: "HONDURAS",
      regionCode: "FM",
      regionName: "FRANCISCO MORAZAN",
    },
    {
      countryName: "HONDURAS",
      regionCode: "GD",
      regionName: "GRACIAS A DIOS",
    },
    {
      countryName: "HONDURAS",
      regionCode: "IB",
      regionName: "ISLAS DE LA BAHIA",
    },
    {
      countryName: "HONDURAS",
      regionCode: "IN",
      regionName: "INTIBUCA",
    },
    {
      countryName: "HONDURAS",
      regionCode: "LE",
      regionName: "LEMPIRA",
    },
    {
      countryName: "HONDURAS",
      regionCode: "LP",
      regionName: "LA PAZ",
    },
    {
      countryName: "HONDURAS",
      regionCode: "OC",
      regionName: "OCOTEPEQUE",
    },
    {
      countryName: "HONDURAS",
      regionCode: "OL",
      regionName: "OLANCHO",
    },
    {
      countryName: "HONDURAS",
      regionCode: "SB",
      regionName: "SANTA BARBARA",
    },
    {
      countryName: "HONDURAS",
      regionCode: "VA",
      regionName: "VALLE",
    },
    {
      countryName: "HONDURAS",
      regionCode: "YO",
      regionName: "YORO",
    },
    {
      countryName: "HONG KONG",
      regionCode: "HK",
      regionName: "HONG KONG",
    },
    {
      countryName: "HUNGARY",
      regionCode: "BA",
      regionName: "BARANYA",
    },
    {
      countryName: "HUNGARY",
      regionCode: "BC",
      regionName: "BEKESCSABA",
    },
    {
      countryName: "HUNGARY",
      regionCode: "BE",
      regionName: "BEKES",
    },
    {
      countryName: "HUNGARY",
      regionCode: "BK",
      regionName: "BACS-KISKUN",
    },
    {
      countryName: "HUNGARY",
      regionCode: "BU",
      regionName: "BUDAPEST",
    },
    {
      countryName: "HUNGARY",
      regionCode: "BZ",
      regionName: "BORSOD-ABAUJ-ZEMPLEN",
    },
    {
      countryName: "HUNGARY",
      regionCode: "CS",
      regionName: "CSONGRAD",
    },
    {
      countryName: "HUNGARY",
      regionCode: "DE",
      regionName: "DEBRECEN",
    },
    {
      countryName: "HUNGARY",
      regionCode: "DU",
      regionName: "DUNAUJVAROS",
    },
    {
      countryName: "HUNGARY",
      regionCode: "EG",
      regionName: "EGER",
    },
    {
      countryName: "HUNGARY",
      regionCode: "FE",
      regionName: "FEJER",
    },
    {
      countryName: "HUNGARY",
      regionCode: "GS",
      regionName: "GYOR-MOSON-SOPRON",
    },
    {
      countryName: "HUNGARY",
      regionCode: "GY",
      regionName: "GYOR",
    },
    {
      countryName: "HUNGARY",
      regionCode: "HB",
      regionName: "HAJDU-BIHAR",
    },
    {
      countryName: "HUNGARY",
      regionCode: "HE",
      regionName: "HEVES",
    },
    {
      countryName: "HUNGARY",
      regionCode: "HV",
      regionName: "HODMEZOVASARHELY",
    },
    {
      countryName: "HUNGARY",
      regionCode: "JN",
      regionName: "JASZ-NAGYKUN-SZOLNOK",
    },
    {
      countryName: "HUNGARY",
      regionCode: "KE",
      regionName: "KOMAROM-ESZTERG OM",
    },
    {
      countryName: "HUNGARY",
      regionCode: "KM",
      regionName: "KECSKEMET",
    },
    {
      countryName: "HUNGARY",
      regionCode: "KV",
      regionName: "KAPOSVAR",
    },
    {
      countryName: "HUNGARY",
      regionCode: "MI",
      regionName: "MISKOLC",
    },
    {
      countryName: "HUNGARY",
      regionCode: "NK",
      regionName: "NAGYKANIZSA",
    },
    {
      countryName: "HUNGARY",
      regionCode: "NO",
      regionName: "NOGRAD",
    },
    {
      countryName: "HUNGARY",
      regionCode: "NY",
      regionName: "NYIREGYHAZA",
    },
    {
      countryName: "HUNGARY",
      regionCode: "PE",
      regionName: "PEST",
    },
    {
      countryName: "HUNGARY",
      regionCode: "PS",
      regionName: "PECS",
    },
    {
      countryName: "HUNGARY",
      regionCode: "SD",
      regionName: "SZEGED",
    },
    {
      countryName: "HUNGARY",
      regionCode: "SF",
      regionName: "SZEKESFEHERVAR",
    },
    {
      countryName: "HUNGARY",
      regionCode: "SH",
      regionName: "SZOMBATHELY",
    },
    {
      countryName: "HUNGARY",
      regionCode: "SK",
      regionName: "SZOLNOK",
    },
    {
      countryName: "HUNGARY",
      regionCode: "SN",
      regionName: "SOPRON",
    },
    {
      countryName: "HUNGARY",
      regionCode: "SO",
      regionName: "SOMOGY",
    },
    {
      countryName: "HUNGARY",
      regionCode: "SS",
      regionName: "SZEKSZARD",
    },
    {
      countryName: "HUNGARY",
      regionCode: "ST",
      regionName: "SALGOTARJAN",
    },
    {
      countryName: "HUNGARY",
      regionCode: "SZ",
      regionName: "SZABOLCS-SZATMAR-BER EG",
    },
    {
      countryName: "HUNGARY",
      regionCode: "TB",
      regionName: "TATABANYA",
    },
    {
      countryName: "HUNGARY",
      regionCode: "TO",
      regionName: "TOLNA",
    },
    {
      countryName: "HUNGARY",
      regionCode: "VA",
      regionName: "VAS",
    },
    {
      countryName: "HUNGARY",
      regionCode: "VE",
      regionName: "VESZPREM",
    },
    {
      countryName: "HUNGARY",
      regionCode: "VM",
      regionName: "VESZPREM",
    },
    {
      countryName: "HUNGARY",
      regionCode: "ZA",
      regionName: "ZALA",
    },
    {
      countryName: "HUNGARY",
      regionCode: "ZE",
      regionName: "ZALAEGERSZEG",
    },
    {
      countryName: "ICELAND",
      regionCode: 7,
      regionName: "AUSTURLAND",
    },
    {
      countryName: "ICELAND",
      regionCode: 1,
      regionName: "HOFUOBORGARSVAEOI UTAN REYKJAV",
    },
    {
      countryName: "ICELAND",
      regionCode: 6,
      regionName: "NOROURLAND EYSTRA",
    },
    {
      countryName: "ICELAND",
      regionCode: 5,
      regionName: "NOROURLAND VESTRA",
    },
    {
      countryName: "ICELAND",
      regionCode: 0,
      regionName: "REYKJAVIK",
    },
    {
      countryName: "ICELAND",
      regionCode: 8,
      regionName: "SUOURLAND",
    },
    {
      countryName: "ICELAND",
      regionCode: 2,
      regionName: "SUOURNES",
    },
    {
      countryName: "ICELAND",
      regionCode: 4,
      regionName: "VESTFIROIR",
    },
    {
      countryName: "ICELAND",
      regionCode: 3,
      regionName: "VESTURLAND",
    },
    {
      countryName: "INDIA",
      regionCode: "AN",
      regionName: "ANDAMAN AND NICOBAR ISLANDS",
    },
    {
      countryName: "INDIA",
      regionCode: "AP",
      regionName: "ANDHRA PRADESH",
    },
    {
      countryName: "INDIA",
      regionCode: "AR",
      regionName: "ARUNACHAL PRADESH",
    },
    {
      countryName: "INDIA",
      regionCode: "AS",
      regionName: "ASSAM",
    },
    {
      countryName: "INDIA",
      regionCode: "BR",
      regionName: "BIHAR",
    },
    {
      countryName: "INDIA",
      regionCode: "CH",
      regionName: "CHANDIGARH",
    },
    {
      countryName: "INDIA",
      regionCode: "CT",
      regionName: "CHHATTISGARH",
    },
    {
      countryName: "INDIA",
      regionCode: "DD",
      regionName: "DAMAN AND DIU",
    },
    {
      countryName: "INDIA",
      regionCode: "DL",
      regionName: "DELHI",
    },
    {
      countryName: "INDIA",
      regionCode: "DN",
      regionName: "DADRA AND NAGAR HAVELI",
    },
    {
      countryName: "INDIA",
      regionCode: "GA",
      regionName: "GOA",
    },
    {
      countryName: "INDIA",
      regionCode: "GJ",
      regionName: "GUJARAT",
    },
    {
      countryName: "INDIA",
      regionCode: "HP",
      regionName: "HIMACHAL PRADESH",
    },
    {
      countryName: "INDIA",
      regionCode: "HR",
      regionName: "HARYANA",
    },
    {
      countryName: "INDIA",
      regionCode: "JH",
      regionName: "JHARKHAND",
    },
    {
      countryName: "INDIA",
      regionCode: "JK",
      regionName: "JAMMU AND KASHMIR",
    },
    {
      countryName: "INDIA",
      regionCode: "KA",
      regionName: "KARNATAKA",
    },
    {
      countryName: "INDIA",
      regionCode: "KL",
      regionName: "KERALA",
    },
    {
      countryName: "INDIA",
      regionCode: "LD",
      regionName: "LAKSHADWEEP",
    },
    {
      countryName: "INDIA",
      regionCode: "MH",
      regionName: "MAHARASHTRA",
    },
    {
      countryName: "INDIA",
      regionCode: "ML",
      regionName: "MEGHALAYA",
    },
    {
      countryName: "INDIA",
      regionCode: "MN",
      regionName: "MANIPUR",
    },
    {
      countryName: "INDIA",
      regionCode: "MP",
      regionName: "MADHYA PRADESH",
    },
    {
      countryName: "INDIA",
      regionCode: "MZ",
      regionName: "MIZORAM",
    },
    {
      countryName: "INDIA",
      regionCode: "NL",
      regionName: "NAGALAND",
    },
    {
      countryName: "INDIA",
      regionCode: "OR",
      regionName: "ODISHA",
    },
    {
      countryName: "INDIA",
      regionCode: "PB",
      regionName: "PUNJAB",
    },
    {
      countryName: "INDIA",
      regionCode: "PY",
      regionName: "PUDUCHERRY",
    },
    {
      countryName: "INDIA",
      regionCode: "RJ",
      regionName: "RAJASTHAN",
    },
    {
      countryName: "INDIA",
      regionCode: "SK",
      regionName: "SIKKIM",
    },
    {
      countryName: "INDIA",
      regionCode: "TG",
      regionName: "TELANGANA",
    },
    {
      countryName: "INDIA",
      regionCode: "TN",
      regionName: "TAMIL NADU",
    },
    {
      countryName: "INDIA",
      regionCode: "TR",
      regionName: "TRIPURA",
    },
    {
      countryName: "INDIA",
      regionCode: "UL",
      regionName: "UTTARAKHAND",
    },
    {
      countryName: "INDIA",
      regionCode: "UP",
      regionName: "UTTAR PRADESH",
    },
    {
      countryName: "INDIA",
      regionCode: "WB",
      regionName: "WEST BENGAL",
    },
    {
      countryName: "INDONESIA",
      regionCode: "AC",
      regionName: "ACEH",
    },
    {
      countryName: "INDONESIA",
      regionCode: "BA",
      regionName: "BALI",
    },
    {
      countryName: "INDONESIA",
      regionCode: "BB",
      regionName: "BANGKA BELITUNG",
    },
    {
      countryName: "INDONESIA",
      regionCode: "BE",
      regionName: "BENGKULU",
    },
    {
      countryName: "INDONESIA",
      regionCode: "BT",
      regionName: "BANTEN",
    },
    {
      countryName: "INDONESIA",
      regionCode: "GO",
      regionName: "GORONTALO",
    },
    {
      countryName: "INDONESIA",
      regionCode: "JA",
      regionName: "JAMBI",
    },
    {
      countryName: "INDONESIA",
      regionCode: "JB",
      regionName: "JAWA BARAT",
    },
    {
      countryName: "INDONESIA",
      regionCode: "JI",
      regionName: "JAWA TIMUR",
    },
    {
      countryName: "INDONESIA",
      regionCode: "JK",
      regionName: "JAKARTA RAYA",
    },
    {
      countryName: "INDONESIA",
      regionCode: "JT",
      regionName: "JAWA TENGAH",
    },
    {
      countryName: "INDONESIA",
      regionCode: "KB",
      regionName: "KALIMANTAN BARAT",
    },
    {
      countryName: "INDONESIA",
      regionCode: "KI",
      regionName: "KALIMANTAN TIMUR",
    },
    {
      countryName: "INDONESIA",
      regionCode: "KR",
      regionName: "KEPULAUAN RIAU",
    },
    {
      countryName: "INDONESIA",
      regionCode: "KS",
      regionName: "KALIMANTAN SELATAN",
    },
    {
      countryName: "INDONESIA",
      regionCode: "KT",
      regionName: "KALIMANTAN TENGAH",
    },
    {
      countryName: "INDONESIA",
      regionCode: "LA",
      regionName: "LAMPUNG",
    },
    {
      countryName: "INDONESIA",
      regionCode: "MA",
      regionName: "MALUKU",
    },
    {
      countryName: "INDONESIA",
      regionCode: "MU",
      regionName: "MALUKU UTARA",
    },
    {
      countryName: "INDONESIA",
      regionCode: "NB",
      regionName: "NUSA TENGGARA BARAT",
    },
    {
      countryName: "INDONESIA",
      regionCode: "NT",
      regionName: "NUSA TENGGARA TIMUR",
    },
    {
      countryName: "INDONESIA",
      regionCode: "PA",
      regionName: "PAPUA",
    },
    {
      countryName: "INDONESIA",
      regionCode: "RI",
      regionName: "RIAU",
    },
    {
      countryName: "INDONESIA",
      regionCode: "SA",
      regionName: "SULAWESI UTARA",
    },
    {
      countryName: "INDONESIA",
      regionCode: "SB",
      regionName: "SUMATERA BARAT",
    },
    {
      countryName: "INDONESIA",
      regionCode: "SG",
      regionName: "SULAWESI TENGGARA",
    },
    {
      countryName: "INDONESIA",
      regionCode: "SN",
      regionName: "SULAWESI SELATAN",
    },
    {
      countryName: "INDONESIA",
      regionCode: "SR",
      regionName: "SULAWESI BARAT",
    },
    {
      countryName: "INDONESIA",
      regionCode: "SS",
      regionName: "SUMATERA SELATAN",
    },
    {
      countryName: "INDONESIA",
      regionCode: "ST",
      regionName: "SULAWESI TENGAH",
    },
    {
      countryName: "INDONESIA",
      regionCode: "SU",
      regionName: "SUMATERA UTARA",
    },
    {
      countryName: "INDONESIA",
      regionCode: "YO",
      regionName: "YOGYAKARTA",
    },
    {
      countryName: "IRAQ",
      regionCode: "AN",
      regionName: "AL ANBAR",
    },
    {
      countryName: "IRAQ",
      regionCode: "BA",
      regionName: "AL BASRAH",
    },
    {
      countryName: "IRAQ",
      regionCode: "MU",
      regionName: "AL MUTHANNA",
    },
    {
      countryName: "IRAQ",
      regionCode: "QA",
      regionName: "AL QADISIYAH",
    },
    {
      countryName: "IRAQ",
      regionCode: "NA",
      regionName: "AN NAJAF",
    },
    {
      countryName: "IRAQ",
      regionCode: "AR",
      regionName: "ARBIL",
    },
    {
      countryName: "IRAQ",
      regionCode: "SU",
      regionName: "AS SULAYMANIYAH",
    },
    {
      countryName: "IRAQ",
      regionCode: "TS",
      regionName: "AT TAMIM",
    },
    {
      countryName: "IRAQ",
      regionCode: "BB",
      regionName: "BABIL",
    },
    {
      countryName: "IRAQ",
      regionCode: "BG",
      regionName: "BAGHDAD",
    },
    {
      countryName: "IRAQ",
      regionCode: "DA",
      regionName: "DAHUK",
    },
    {
      countryName: "IRAQ",
      regionCode: "DQ",
      regionName: "DHI QAR",
    },
    {
      countryName: "IRAQ",
      regionCode: "DI",
      regionName: "DIYALA",
    },
    {
      countryName: "IRAQ",
      regionCode: "KA",
      regionName: "KARBALA",
    },
    {
      countryName: "IRAQ",
      regionCode: "MA",
      regionName: "MAYSAN",
    },
    {
      countryName: "IRAQ",
      regionCode: "NI",
      regionName: "NINAWA",
    },
    {
      countryName: "IRAQ",
      regionCode: "SD",
      regionName: "SALAH AD DIN",
    },
    {
      countryName: "IRAQ",
      regionCode: "WA",
      regionName: "WASIT",
    },
    {
      countryName: "IRELAND",
      regionCode: "C",
      regionName: "CORK",
    },
    {
      countryName: "IRELAND",
      regionCode: "CE",
      regionName: "CLARE",
    },
    {
      countryName: "IRELAND",
      regionCode: "CN",
      regionName: "CAVAN",
    },
    {
      countryName: "IRELAND",
      regionCode: "CW",
      regionName: "CARLOW",
    },
    {
      countryName: "IRELAND",
      regionCode: "D",
      regionName: "DUBLIN",
    },
    {
      countryName: "IRELAND",
      regionCode: "DL",
      regionName: "DONEGAL",
    },
    {
      countryName: "IRELAND",
      regionCode: "G",
      regionName: "GALWAY",
    },
    {
      countryName: "IRELAND",
      regionCode: "KE",
      regionName: "KILDARE",
    },
    {
      countryName: "IRELAND",
      regionCode: "KK",
      regionName: "KILKENNY",
    },
    {
      countryName: "IRELAND",
      regionCode: "KY",
      regionName: "KERRY",
    },
    {
      countryName: "IRELAND",
      regionCode: "LD",
      regionName: "LONGFORD",
    },
    {
      countryName: "IRELAND",
      regionCode: "LH",
      regionName: "LOUTH",
    },
    {
      countryName: "IRELAND",
      regionCode: "LK",
      regionName: "LIMERICK",
    },
    {
      countryName: "IRELAND",
      regionCode: "LM",
      regionName: "LEITRIM",
    },
    {
      countryName: "IRELAND",
      regionCode: "LS",
      regionName: "LAOIS",
    },
    {
      countryName: "IRELAND",
      regionCode: "MH",
      regionName: "MEATH",
    },
    {
      countryName: "IRELAND",
      regionCode: "MN",
      regionName: "MONAGHAN",
    },
    {
      countryName: "IRELAND",
      regionCode: "MO",
      regionName: "MAYO",
    },
    {
      countryName: "IRELAND",
      regionCode: "OY",
      regionName: "OFFALY",
    },
    {
      countryName: "IRELAND",
      regionCode: "RN",
      regionName: "ROSCOMMON",
    },
    {
      countryName: "IRELAND",
      regionCode: "SO",
      regionName: "SLIGO",
    },
    {
      countryName: "IRELAND",
      regionCode: "TA",
      regionName: "TIPPERARY",
    },
    {
      countryName: "IRELAND",
      regionCode: "WD",
      regionName: "WATERFORD",
    },
    {
      countryName: "IRELAND",
      regionCode: "WH",
      regionName: "WESTMEATH",
    },
    {
      countryName: "IRELAND",
      regionCode: "WW",
      regionName: "WICKLOW",
    },
    {
      countryName: "IRELAND",
      regionCode: "WX",
      regionName: "WEXFORD",
    },
    {
      countryName: "ISLE OF MAN",
      regionCode: "IM",
      regionName: "ISLE OF MAN",
    },
    {
      countryName: "ISRAEL",
      regionCode: "D",
      regionName: "HADAROM",
    },
    {
      countryName: "ISRAEL",
      regionCode: "M",
      regionName: "HAMERKAZ",
    },
    {
      countryName: "ISRAEL",
      regionCode: "Z",
      regionName: "HAZAFON",
    },
    {
      countryName: "ISRAEL",
      regionCode: "HA",
      regionName: "HEFA",
    },
    {
      countryName: "ISRAEL",
      regionCode: "TA",
      regionName: "TEL-AVIV",
    },
    {
      countryName: "ISRAEL",
      regionCode: "JM",
      regionName: "YERUSHALAYIM",
    },
    {
      countryName: "ITALY",
      regionCode: "AG",
      regionName: "AGRIGENTO",
    },
    {
      countryName: "ITALY",
      regionCode: "AL",
      regionName: "ALESSANDRIA",
    },
    {
      countryName: "ITALY",
      regionCode: "AN",
      regionName: "ANCONA",
    },
    {
      countryName: "ITALY",
      regionCode: "AO",
      regionName: "AOSTA",
    },
    {
      countryName: "ITALY",
      regionCode: "AR",
      regionName: "AREZZO",
    },
    {
      countryName: "ITALY",
      regionCode: "AP",
      regionName: "ASCOLI PICENO",
    },
    {
      countryName: "ITALY",
      regionCode: "AT",
      regionName: "ASTI",
    },
    {
      countryName: "ITALY",
      regionCode: "AV",
      regionName: "AVELLINO",
    },
    {
      countryName: "ITALY",
      regionCode: "BA",
      regionName: "BARI",
    },
    {
      countryName: "ITALY",
      regionCode: "BL",
      regionName: "BELLUNO",
    },
    {
      countryName: "ITALY",
      regionCode: "BN",
      regionName: "BENEVENTO",
    },
    {
      countryName: "ITALY",
      regionCode: "BG",
      regionName: "BERGAMO",
    },
    {
      countryName: "ITALY",
      regionCode: "BI",
      regionName: "BIELLA",
    },
    {
      countryName: "ITALY",
      regionCode: "BO",
      regionName: "BOLOGNA",
    },
    {
      countryName: "ITALY",
      regionCode: "BZ",
      regionName: "BOLZANO",
    },
    {
      countryName: "ITALY",
      regionCode: "BS",
      regionName: "BRESCIA",
    },
    {
      countryName: "ITALY",
      regionCode: "BR",
      regionName: "BRINDISI",
    },
    {
      countryName: "ITALY",
      regionCode: "CA",
      regionName: "CAGLIARI",
    },
    {
      countryName: "ITALY",
      regionCode: "CL",
      regionName: "CALTANISSETTA",
    },
    {
      countryName: "ITALY",
      regionCode: "CB",
      regionName: "CAMPOBASSO",
    },
    {
      countryName: "ITALY",
      regionCode: "CI",
      regionName: "CARBONIA-IGLESIAS",
    },
    {
      countryName: "ITALY",
      regionCode: "CE",
      regionName: "CASERTA",
    },
    {
      countryName: "ITALY",
      regionCode: "CT",
      regionName: "CATANIA",
    },
    {
      countryName: "ITALY",
      regionCode: "CZ",
      regionName: "CATANZARO",
    },
    {
      countryName: "ITALY",
      regionCode: "CH",
      regionName: "CHIETI",
    },
    {
      countryName: "ITALY",
      regionCode: "CO",
      regionName: "COMO",
    },
    {
      countryName: "ITALY",
      regionCode: "CS",
      regionName: "COSENZA",
    },
    {
      countryName: "ITALY",
      regionCode: "CR",
      regionName: "CREMONA",
    },
    {
      countryName: "ITALY",
      regionCode: "KR",
      regionName: "CROTONE",
    },
    {
      countryName: "ITALY",
      regionCode: "CN",
      regionName: "CUNEO",
    },
    {
      countryName: "ITALY",
      regionCode: "EN",
      regionName: "ENNA",
    },
    {
      countryName: "ITALY",
      regionCode: "FM",
      regionName: "FERMO",
    },
    {
      countryName: "ITALY",
      regionCode: "FE",
      regionName: "FERRARA",
    },
    {
      countryName: "ITALY",
      regionCode: "FI",
      regionName: "FIRENZE",
    },
    {
      countryName: "ITALY",
      regionCode: "FG",
      regionName: "FOGGIA",
    },
    {
      countryName: "ITALY",
      regionCode: "FO",
      regionName: "FORLI",
    },
    {
      countryName: "ITALY",
      regionCode: "FC",
      regionName: "FORLI-CESENA",
    },
    {
      countryName: "ITALY",
      regionCode: "FR",
      regionName: "FROSINONE",
    },
    {
      countryName: "ITALY",
      regionCode: "GE",
      regionName: "GENOVA",
    },
    {
      countryName: "ITALY",
      regionCode: "GO",
      regionName: "GORIZIA",
    },
    {
      countryName: "ITALY",
      regionCode: "GR",
      regionName: "GROSSETO",
    },
    {
      countryName: "ITALY",
      regionCode: "IM",
      regionName: "IMPERIA",
    },
    {
      countryName: "ITALY",
      regionCode: "IS",
      regionName: "ISERNIA",
    },
    {
      countryName: "ITALY",
      regionCode: "AQ",
      regionName: "L’AQUILA",
    },
    {
      countryName: "ITALY",
      regionCode: "SP",
      regionName: "LA SPEZIA",
    },
    {
      countryName: "ITALY",
      regionCode: "LT",
      regionName: "LATINA",
    },
    {
      countryName: "ITALY",
      regionCode: "LE",
      regionName: "LECCE",
    },
    {
      countryName: "ITALY",
      regionCode: "LC",
      regionName: "LECCO",
    },
    {
      countryName: "ITALY",
      regionCode: "LI",
      regionName: "LIVORNO",
    },
    {
      countryName: "ITALY",
      regionCode: "LO",
      regionName: "LODI",
    },
    {
      countryName: "ITALY",
      regionCode: "LU",
      regionName: "LUCCA",
    },
    {
      countryName: "ITALY",
      regionCode: "MC",
      regionName: "MACERATA",
    },
    {
      countryName: "ITALY",
      regionCode: "MN",
      regionName: "MANTOVA",
    },
    {
      countryName: "ITALY",
      regionCode: "MS",
      regionName: "MASSA-CARRARA",
    },
    {
      countryName: "ITALY",
      regionCode: "MT",
      regionName: "MATERA",
    },
    {
      countryName: "ITALY",
      regionCode: "MA",
      regionName: "MEDIO CAMPIDANO",
    },
    {
      countryName: "ITALY",
      regionCode: "ME",
      regionName: "MESSINA",
    },
    {
      countryName: "ITALY",
      regionCode: "MI",
      regionName: "MILANO",
    },
    {
      countryName: "ITALY",
      regionCode: "MO",
      regionName: "MODENA",
    },
    {
      countryName: "ITALY",
      regionCode: "MB",
      regionName: "MONA E BRIANZA",
    },
    {
      countryName: "ITALY",
      regionCode: "NA",
      regionName: "NAPOLI",
    },
    {
      countryName: "ITALY",
      regionCode: "NO",
      regionName: "NOVARA",
    },
    {
      countryName: "ITALY",
      regionCode: "NU",
      regionName: "NUORO",
    },
    {
      countryName: "ITALY",
      regionCode: "OG",
      regionName: "OGLIASTRA",
    },
    {
      countryName: "ITALY",
      regionCode: "OL",
      regionName: "OLBIA-TEMPIO",
    },
    {
      countryName: "ITALY",
      regionCode: "OR",
      regionName: "ORISTANO",
    },
    {
      countryName: "ITALY",
      regionCode: "PD",
      regionName: "PADOVA",
    },
    {
      countryName: "ITALY",
      regionCode: "PA",
      regionName: "PALERMO",
    },
    {
      countryName: "ITALY",
      regionCode: "PR",
      regionName: "PARMA",
    },
    {
      countryName: "ITALY",
      regionCode: "PV",
      regionName: "PAVIA",
    },
    {
      countryName: "ITALY",
      regionCode: "PG",
      regionName: "PERUGIA",
    },
    {
      countryName: "ITALY",
      regionCode: "PS",
      regionName: "PESARO E URBINO",
    },
    {
      countryName: "ITALY",
      regionCode: "PE",
      regionName: "PESCARA",
    },
    {
      countryName: "ITALY",
      regionCode: "PC",
      regionName: "PIACENZA",
    },
    {
      countryName: "ITALY",
      regionCode: "PI",
      regionName: "PISA",
    },
    {
      countryName: "ITALY",
      regionCode: "PT",
      regionName: "PISTOIA",
    },
    {
      countryName: "ITALY",
      regionCode: "PN",
      regionName: "PORDENONE",
    },
    {
      countryName: "ITALY",
      regionCode: "PZ",
      regionName: "POTENZA",
    },
    {
      countryName: "ITALY",
      regionCode: "PO",
      regionName: "PRATO",
    },
    {
      countryName: "ITALY",
      regionCode: "RG",
      regionName: "RAGUSA",
    },
    {
      countryName: "ITALY",
      regionCode: "RA",
      regionName: "RAVENNA",
    },
    {
      countryName: "ITALY",
      regionCode: "RC",
      regionName: "REGGIO CALABRIA",
    },
    {
      countryName: "ITALY",
      regionCode: "RE",
      regionName: "REGGIO EMILIA",
    },
    {
      countryName: "ITALY",
      regionCode: "RI",
      regionName: "RIETI",
    },
    {
      countryName: "ITALY",
      regionCode: "RN",
      regionName: "RIMINI",
    },
    {
      countryName: "ITALY",
      regionCode: "RM",
      regionName: "ROMA",
    },
    {
      countryName: "ITALY",
      regionCode: "RO",
      regionName: "ROVIGO",
    },
    {
      countryName: "ITALY",
      regionCode: "SA",
      regionName: "SALERNO",
    },
    {
      countryName: "ITALY",
      regionCode: "SS",
      regionName: "SASSARI",
    },
    {
      countryName: "ITALY",
      regionCode: "SV",
      regionName: "SAVONA",
    },
    {
      countryName: "ITALY",
      regionCode: "SI",
      regionName: "SIENA",
    },
    {
      countryName: "ITALY",
      regionCode: "SR",
      regionName: "SIRACUSA",
    },
    {
      countryName: "ITALY",
      regionCode: "SO",
      regionName: "SONDRIO",
    },
    {
      countryName: "ITALY",
      regionCode: "TA",
      regionName: "TARANTO",
    },
    {
      countryName: "ITALY",
      regionCode: "TE",
      regionName: "TERAMO",
    },
    {
      countryName: "ITALY",
      regionCode: "TR",
      regionName: "TERNI",
    },
    {
      countryName: "ITALY",
      regionCode: "TO",
      regionName: "TORINO",
    },
    {
      countryName: "ITALY",
      regionCode: "TP",
      regionName: "TRAPANI",
    },
    {
      countryName: "ITALY",
      regionCode: 32,
      regionName: "TRENTINO-SUDTIROL",
    },
    {
      countryName: "ITALY",
      regionCode: "TN",
      regionName: "TRENTO",
    },
    {
      countryName: "ITALY",
      regionCode: "TV",
      regionName: "TREVISO",
    },
    {
      countryName: "ITALY",
      regionCode: "TS",
      regionName: "TRIESTE",
    },
    {
      countryName: "ITALY",
      regionCode: "UD",
      regionName: "UDINE",
    },
    {
      countryName: "ITALY",
      regionCode: "VA",
      regionName: "VARESE",
    },
    {
      countryName: "ITALY",
      regionCode: "VE",
      regionName: "VENEZIA",
    },
    {
      countryName: "ITALY",
      regionCode: "VB",
      regionName: "VERBANO-CUSIO-OSSOLA",
    },
    {
      countryName: "ITALY",
      regionCode: "VC",
      regionName: "VERCELLI",
    },
    {
      countryName: "ITALY",
      regionCode: "VR",
      regionName: "VERONA",
    },
    {
      countryName: "ITALY",
      regionCode: "VV",
      regionName: "VIBO VALENTIA",
    },
    {
      countryName: "ITALY",
      regionCode: "VI",
      regionName: "VICENZA",
    },
    {
      countryName: "ITALY",
      regionCode: "VT",
      regionName: "VITERBO",
    },
    {
      countryName: "JAMAICA",
      regionCode: 13,
      regionName: "CLARENDON",
    },
    {
      countryName: "JAMAICA",
      regionCode: 9,
      regionName: "HANOVER",
    },
    {
      countryName: "JAMAICA",
      regionCode: 1,
      regionName: "KINGSTON",
    },
    {
      countryName: "JAMAICA",
      regionCode: 12,
      regionName: "MANCHESTER",
    },
    {
      countryName: "JAMAICA",
      regionCode: 4,
      regionName: "PORTLAND",
    },
    {
      countryName: "JAMAICA",
      regionCode: 2,
      regionName: "SAINT ANDREW",
    },
    {
      countryName: "JAMAICA",
      regionCode: 6,
      regionName: "SAINT ANN",
    },
    {
      countryName: "JAMAICA",
      regionCode: 14,
      regionName: "SAINT CATHERINE",
    },
    {
      countryName: "JAMAICA",
      regionCode: 11,
      regionName: "SAINT ELIZABETH",
    },
    {
      countryName: "JAMAICA",
      regionCode: 8,
      regionName: "SAINT JAMES",
    },
    {
      countryName: "JAMAICA",
      regionCode: 5,
      regionName: "SAINT MARY",
    },
    {
      countryName: "JAMAICA",
      regionCode: 3,
      regionName: "SAINT THOMAS",
    },
    {
      countryName: "JAMAICA",
      regionCode: 7,
      regionName: "TRELAWNY",
    },
    {
      countryName: "JAMAICA",
      regionCode: 10,
      regionName: "WESTMORELAND",
    },
    {
      countryName: "JAPAN",
      regionCode: 23,
      regionName: "AITI",
    },
    {
      countryName: "JAPAN",
      regionCode: 5,
      regionName: "AKITA",
    },
    {
      countryName: "JAPAN",
      regionCode: 2,
      regionName: "AOMORI",
    },
    {
      countryName: "JAPAN",
      regionCode: 38,
      regionName: "EHIME",
    },
    {
      countryName: "JAPAN",
      regionCode: 21,
      regionName: "GIHU",
    },
    {
      countryName: "JAPAN",
      regionCode: 10,
      regionName: "GUNMA",
    },
    {
      countryName: "JAPAN",
      regionCode: 34,
      regionName: "HIROSIMA",
    },
    {
      countryName: "JAPAN",
      regionCode: 1,
      regionName: "HOKKAIDO",
    },
    {
      countryName: "JAPAN",
      regionCode: 18,
      regionName: "HUKUI",
    },
    {
      countryName: "JAPAN",
      regionCode: 40,
      regionName: "HUKUOKA",
    },
    {
      countryName: "JAPAN",
      regionCode: 7,
      regionName: "HUKUSIMA",
    },
    {
      countryName: "JAPAN",
      regionCode: 28,
      regionName: "HYOGO",
    },
    {
      countryName: "JAPAN",
      regionCode: 8,
      regionName: "IBARAKI",
    },
    {
      countryName: "JAPAN",
      regionCode: 17,
      regionName: "ISIKAWA",
    },
    {
      countryName: "JAPAN",
      regionCode: 3,
      regionName: "IWATE",
    },
    {
      countryName: "JAPAN",
      regionCode: 37,
      regionName: "KAGAWA",
    },
    {
      countryName: "JAPAN",
      regionCode: 46,
      regionName: "KAGOSIMA",
    },
    {
      countryName: "JAPAN",
      regionCode: 14,
      regionName: "KANAGAWA",
    },
    {
      countryName: "JAPAN",
      regionCode: 39,
      regionName: "KOTI",
    },
    {
      countryName: "JAPAN",
      regionCode: 43,
      regionName: "KUMAMOTO",
    },
    {
      countryName: "JAPAN",
      regionCode: 26,
      regionName: "KYOTO",
    },
    {
      countryName: "JAPAN",
      regionCode: 24,
      regionName: "MIE",
    },
    {
      countryName: "JAPAN",
      regionCode: 4,
      regionName: "MIYAGI",
    },
    {
      countryName: "JAPAN",
      regionCode: 45,
      regionName: "MIYAZAKI",
    },
    {
      countryName: "JAPAN",
      regionCode: 20,
      regionName: "NAGANO",
    },
    {
      countryName: "JAPAN",
      regionCode: 42,
      regionName: "NAGASAKI",
    },
    {
      countryName: "JAPAN",
      regionCode: 29,
      regionName: "NARA",
    },
    {
      countryName: "JAPAN",
      regionCode: 15,
      regionName: "NIIGATA",
    },
    {
      countryName: "JAPAN",
      regionCode: 44,
      regionName: "OITA",
    },
    {
      countryName: "JAPAN",
      regionCode: 33,
      regionName: "OKAYAMA",
    },
    {
      countryName: "JAPAN",
      regionCode: 47,
      regionName: "OKINAWA",
    },
    {
      countryName: "JAPAN",
      regionCode: 27,
      regionName: "OSAKA",
    },
    {
      countryName: "JAPAN",
      regionCode: 41,
      regionName: "SAGA",
    },
    {
      countryName: "JAPAN",
      regionCode: 11,
      regionName: "SAITAMA",
    },
    {
      countryName: "JAPAN",
      regionCode: 25,
      regionName: "SIGA",
    },
    {
      countryName: "JAPAN",
      regionCode: 32,
      regionName: "SIMANE",
    },
    {
      countryName: "JAPAN",
      regionCode: 22,
      regionName: "SIZUOKA",
    },
    {
      countryName: "JAPAN",
      regionCode: 12,
      regionName: "TIBA",
    },
    {
      countryName: "JAPAN",
      regionCode: 36,
      regionName: "TOKUSIMA",
    },
    {
      countryName: "JAPAN",
      regionCode: 13,
      regionName: "TOKYO",
    },
    {
      countryName: "JAPAN",
      regionCode: 9,
      regionName: "TOTIGI",
    },
    {
      countryName: "JAPAN",
      regionCode: 31,
      regionName: "TOTTORI",
    },
    {
      countryName: "JAPAN",
      regionCode: 16,
      regionName: "TOYAMA",
    },
    {
      countryName: "JAPAN",
      regionCode: 30,
      regionName: "WAKAYAMA",
    },
    {
      countryName: "JAPAN",
      regionCode: 6,
      regionName: "YAMAGATA",
    },
    {
      countryName: "JAPAN",
      regionCode: 35,
      regionName: "YAMAGUTI",
    },
    {
      countryName: "JAPAN",
      regionCode: 19,
      regionName: "YAMANASI",
    },
    {
      countryName: "JERSEY",
      regionCode: "JE",
      regionName: "JERSEY",
    },
    {
      countryName: "JORDAN",
      regionCode: "AJ",
      regionName: "AJLUN",
    },
    {
      countryName: "JORDAN",
      regionCode: "BA",
      regionName: "AL BALQA",
    },
    {
      countryName: "JORDAN",
      regionCode: "AQ",
      regionName: "AL IAQABA",
    },
    {
      countryName: "JORDAN",
      regionCode: "KA",
      regionName: "AL KARAK",
    },
    {
      countryName: "JORDAN",
      regionCode: "MA",
      regionName: "AL MAFRAQ",
    },
    {
      countryName: "JORDAN",
      regionCode: "AM",
      regionName: "AMMAN",
    },
    {
      countryName: "JORDAN",
      regionCode: "AT",
      regionName: "AT TAFILAH",
    },
    {
      countryName: "JORDAN",
      regionCode: "AZ",
      regionName: "AZ ZARQA",
    },
    {
      countryName: "JORDAN",
      regionCode: "IR",
      regionName: "IRBID",
    },
    {
      countryName: "JORDAN",
      regionCode: "JA",
      regionName: "JARASH",
    },
    {
      countryName: "JORDAN",
      regionCode: "MN",
      regionName: "MAAN",
    },
    {
      countryName: "JORDAN",
      regionCode: "MD",
      regionName: "MADABAH",
    },
    {
      countryName: "KAZAKHSTAN",
      regionCode: "AKM",
      regionName: "AQMOLA OBLYSY",
    },
    {
      countryName: "KAZAKHSTAN",
      regionCode: "AKT",
      regionName: "AQTOBE OBLYSY",
    },
    {
      countryName: "KAZAKHSTAN",
      regionCode: "ALA",
      regionName: "ALMATY",
    },
    {
      countryName: "KAZAKHSTAN",
      regionCode: "ALM",
      regionName: "ALMATY OBLYSY",
    },
    {
      countryName: "KAZAKHSTAN",
      regionCode: "AST",
      regionName: "ASTANA",
    },
    {
      countryName: "KAZAKHSTAN",
      regionCode: "ATY",
      regionName: "ATYRAU OBLYSY",
    },
    {
      countryName: "KAZAKHSTAN",
      regionCode: "KAR",
      regionName: "QARAGHANDY OBLYSY",
    },
    {
      countryName: "KAZAKHSTAN",
      regionCode: "KUS",
      regionName: "QOSTANAY OBLYSY",
    },
    {
      countryName: "KAZAKHSTAN",
      regionCode: "KZY",
      regionName: "QYZYLORDA OBLYSY",
    },
    {
      countryName: "KAZAKHSTAN",
      regionCode: "MAN",
      regionName: "MANGGHYSTAU OBLYSY",
    },
    {
      countryName: "KAZAKHSTAN",
      regionCode: "PAV",
      regionName: "PAVLODAR OBLYSY",
    },
    {
      countryName: "KAZAKHSTAN",
      regionCode: "SEV",
      regionName: "SOLTUSTIK QAZAQSTAN",
    },
    {
      countryName: "KAZAKHSTAN",
      regionCode: "VOS",
      regionName: "SHYGHYS QAZAQSTAN",
    },
    {
      countryName: "KAZAKHSTAN",
      regionCode: "YUZ",
      regionName: "ONGTUSTIK QAZAQSTAN",
    },
    {
      countryName: "KAZAKHSTAN",
      regionCode: "ZAP",
      regionName: "BATYS QAZAQSTAN OBLYSY",
    },
    {
      countryName: "KAZAKHSTAN",
      regionCode: "ZHA",
      regionName: "ZHAMBYL OBLYSY",
    },
    {
      countryName: "KENYA",
      regionCode: 200,
      regionName: "CENTRAL",
    },
    {
      countryName: "KENYA",
      regionCode: 300,
      regionName: "COAST",
    },
    {
      countryName: "KENYA",
      regionCode: 400,
      regionName: "EASTERN",
    },
    {
      countryName: "KENYA",
      regionCode: 110,
      regionName: "NAIROBI",
    },
    {
      countryName: "KENYA",
      regionCode: 500,
      regionName: "NORTH-EASTERN",
    },
    {
      countryName: "KENYA",
      regionCode: 600,
      regionName: "NYANZA",
    },
    {
      countryName: "KENYA",
      regionCode: 700,
      regionName: "RIFT VALLEY",
    },
    {
      countryName: "KENYA",
      regionCode: 800,
      regionName: "WESTERN",
    },
    {
      countryName: "KIRIBATI",
      regionCode: "G",
      regionName: "GILBERT ISLANDS",
    },
    {
      countryName: "KIRIBATI",
      regionCode: "L",
      regionName: "LINE ISLANDS",
    },
    {
      countryName: "KIRIBATI",
      regionCode: "P",
      regionName: "PHOENIX ISLANDS",
    },
    {
      countryName: "KOREA, REPUBLIC OF",
      regionCode: 26,
      regionName: "BUSAN GWANG’YEOGSI",
    },
    {
      countryName: "KOREA, REPUBLIC OF",
      regionCode: 43,
      regionName: "CHUNGCHEONGBUGDO",
    },
    {
      countryName: "KOREA, REPUBLIC OF",
      regionCode: 44,
      regionName: "CHUNGCHEONGNAMDO",
    },
    {
      countryName: "KOREA, REPUBLIC OF",
      regionCode: 27,
      regionName: "DAEGU GWANG’YEOGSI",
    },
    {
      countryName: "KOREA, REPUBLIC OF",
      regionCode: 30,
      regionName: "DAEJEON GWANG’YEOGSI",
    },
    {
      countryName: "KOREA, REPUBLIC OF",
      regionCode: 42,
      regionName: "GANG’WEONDO",
    },
    {
      countryName: "KOREA, REPUBLIC OF",
      regionCode: 29,
      regionName: "GWANGJU GWANG’YEOGSI",
    },
    {
      countryName: "KOREA, REPUBLIC OF",
      regionCode: 41,
      regionName: "GYEONGGIDO",
    },
    {
      countryName: "KOREA, REPUBLIC OF",
      regionCode: 47,
      regionName: "GYEONGSANGBUGDO",
    },
    {
      countryName: "KOREA, REPUBLIC OF",
      regionCode: 48,
      regionName: "GYEONGSANGNAMDO",
    },
    {
      countryName: "KOREA, REPUBLIC OF",
      regionCode: 28,
      regionName: "INCHEON GWANG’YEOGSI",
    },
    {
      countryName: "KOREA, REPUBLIC OF",
      regionCode: 49,
      regionName: "JEJUDO",
    },
    {
      countryName: "KOREA, REPUBLIC OF",
      regionCode: 45,
      regionName: "JEONRABUGDO",
    },
    {
      countryName: "KOREA, REPUBLIC OF",
      regionCode: 46,
      regionName: "JEONRANAMDO",
    },
    {
      countryName: "KOREA, REPUBLIC OF",
      regionCode: 11,
      regionName: "SEOUL TEUGBYEOLSI",
    },
    {
      countryName: "KOREA, REPUBLIC OF",
      regionCode: 31,
      regionName: "ULSAN GWANG’YEOGSI",
    },
    {
      countryName: "KUWAIT",
      regionCode: "AH",
      regionName: "AL AHMADI",
    },
    {
      countryName: "KUWAIT",
      regionCode: "FA",
      regionName: "AL FARWANIYAH",
    },
    {
      countryName: "KUWAIT",
      regionCode: "JA",
      regionName: "AL JAHRAH",
    },
    {
      countryName: "KUWAIT",
      regionCode: "KU",
      regionName: "AL KUWAYT",
    },
    {
      countryName: "KUWAIT",
      regionCode: "HA",
      regionName: "HAWALLI",
    },
    {
      countryName: "KUWAIT",
      regionCode: "MU",
      regionName: "MUBARAK AL KABIR",
    },
    {
      countryName: "KYRGYZSTAN",
      regionCode: "B",
      regionName: "BATKEN",
    },
    {
      countryName: "KYRGYZSTAN",
      regionCode: "GB",
      regionName: "BISHKEK",
    },
    {
      countryName: "KYRGYZSTAN",
      regionCode: "C",
      regionName: "CHU",
    },
    {
      countryName: "KYRGYZSTAN",
      regionCode: "J",
      regionName: "JALAL-ABAD",
    },
    {
      countryName: "KYRGYZSTAN",
      regionCode: "N",
      regionName: "NARYN",
    },
    {
      countryName: "KYRGYZSTAN",
      regionCode: "O",
      regionName: "OSH",
    },
    {
      countryName: "KYRGYZSTAN",
      regionCode: "T",
      regionName: "TALAS",
    },
    {
      countryName: "KYRGYZSTAN",
      regionCode: "Y",
      regionName: "YSYK-KOL",
    },
    {
      countryName: "LAO PEOPLE’S DEMOCRATIC REPUBLIC",
      regionCode: "AT",
      regionName: "ATTAPU (ATTOPEU)",
    },
    {
      countryName: "LAO PEOPLE’S DEMOCRATIC REPUBLIC",
      regionCode: "BK",
      regionName: "BOKEO",
    },
    {
      countryName: "LAO PEOPLE’S DEMOCRATIC REPUBLIC",
      regionCode: "BL",
      regionName: "BOLIKHAMXAI (BORIKHANE)",
    },
    {
      countryName: "LAO PEOPLE’S DEMOCRATIC REPUBLIC",
      regionCode: "CH",
      regionName: "CHAMPASAK (CHAMPASSAK)",
    },
    {
      countryName: "LAO PEOPLE’S DEMOCRATIC REPUBLIC",
      regionCode: "HO",
      regionName: "HOUAPHAN",
    },
    {
      countryName: "LAO PEOPLE’S DEMOCRATIC REPUBLIC",
      regionCode: "KH",
      regionName: "KHAMMOUAN",
    },
    {
      countryName: "LAO PEOPLE’S DEMOCRATIC REPUBLIC",
      regionCode: "LM",
      regionName: "LOUANG NAMTHA",
    },
    {
      countryName: "LAO PEOPLE’S DEMOCRATIC REPUBLIC",
      regionCode: "LP",
      regionName: "LOUANGPHABANG (LOUANG PRABANG)",
    },
    {
      countryName: "LAO PEOPLE’S DEMOCRATIC REPUBLIC",
      regionCode: "OU",
      regionName: "OUDOMXAI (OUDOMSAI)",
    },
    {
      countryName: "LAO PEOPLE’S DEMOCRATIC REPUBLIC",
      regionCode: "PH",
      regionName: "PHONGSALI (PHONG SALY)",
    },
    {
      countryName: "LAO PEOPLE’S DEMOCRATIC REPUBLIC",
      regionCode: "SL",
      regionName: "SALAVAN (SARAVANE)",
    },
    {
      countryName: "LAO PEOPLE’S DEMOCRATIC REPUBLIC",
      regionCode: "SV",
      regionName: "SAVANNAKHET",
    },
    {
      countryName: "LAO PEOPLE’S DEMOCRATIC REPUBLIC",
      regionCode: "VI",
      regionName: "VIENTIANE",
    },
    {
      countryName: "LAO PEOPLE’S DEMOCRATIC REPUBLIC",
      regionCode: "VT",
      regionName: "VIENTIANE",
    },
    {
      countryName: "LAO PEOPLE’S DEMOCRATIC REPUBLIC",
      regionCode: "XA",
      regionName: "XAIGNABOULI (SAYABOURY)",
    },
    {
      countryName: "LAO PEOPLE’S DEMOCRATIC REPUBLIC",
      regionCode: "XE",
      regionName: "XEKONG (SEKONG)",
    },
    {
      countryName: "LAO PEOPLE’S DEMOCRATIC REPUBLIC",
      regionCode: "XI",
      regionName: "XIANGKHOANG (XIENG KHOUANG)",
    },
    {
      countryName: "LAO PEOPLE’S DEMOCRATIC REPUBLIC",
      regionCode: "XN",
      regionName: "XAISOMBOUN",
    },
    {
      countryName: "LATVIA",
      regionCode: "AI",
      regionName: "AIZKRAUKLES APRINKIS",
    },
    {
      countryName: "LATVIA",
      regionCode: "AL",
      regionName: "ALUKSNES APRINKIS",
    },
    {
      countryName: "LATVIA",
      regionCode: "BL",
      regionName: "BALVU APRINKIS",
    },
    {
      countryName: "LATVIA",
      regionCode: "BU",
      regionName: "BAUSKAS APRINKIS",
    },
    {
      countryName: "LATVIA",
      regionCode: "CE",
      regionName: "CESU APRINKIS",
    },
    {
      countryName: "LATVIA",
      regionCode: "DA",
      regionName: "DAUGAVPILS APRINKIS",
    },
    {
      countryName: "LATVIA",
      regionCode: "DGV",
      regionName: "DAUGAVPILS",
    },
    {
      countryName: "LATVIA",
      regionCode: "DO",
      regionName: "DOBELES APRINKIS",
    },
    {
      countryName: "LATVIA",
      regionCode: "GU",
      regionName: "GULBENES APRINKIS",
    },
    {
      countryName: "LATVIA",
      regionCode: "JEL",
      regionName: "JELGAVA",
    },
    {
      countryName: "LATVIA",
      regionCode: "JK",
      regionName: "JEKABPILS APRINKIS",
    },
    {
      countryName: "LATVIA",
      regionCode: "JL",
      regionName: "JELGAVAS APRINKIS",
    },
    {
      countryName: "LATVIA",
      regionCode: "JUR",
      regionName: "JURMALA",
    },
    {
      countryName: "LATVIA",
      regionCode: "KR",
      regionName: "KRASLAVAS APRINKIS",
    },
    {
      countryName: "LATVIA",
      regionCode: "KU",
      regionName: "KULDIGAS APRINKIS",
    },
    {
      countryName: "LATVIA",
      regionCode: "LE",
      regionName: "LIEPAJAS APRINKIS",
    },
    {
      countryName: "LATVIA",
      regionCode: "LM",
      regionName: "LIMBAU APRINKIS",
    },
    {
      countryName: "LATVIA",
      regionCode: "LPX",
      regionName: "LIEPAJA",
    },
    {
      countryName: "LATVIA",
      regionCode: "LU",
      regionName: "LUDZAS APRINKIS",
    },
    {
      countryName: "LATVIA",
      regionCode: "MA",
      regionName: "MADONAS APRINKIS",
    },
    {
      countryName: "LATVIA",
      regionCode: "OG",
      regionName: "OGRES APRINKIS",
    },
    {
      countryName: "LATVIA",
      regionCode: "PR",
      regionName: "PREILU APRINKIS",
    },
    {
      countryName: "LATVIA",
      regionCode: "RE",
      regionName: "REZEKNES APRINKIS",
    },
    {
      countryName: "LATVIA",
      regionCode: "REZ",
      regionName: "REZEKNE",
    },
    {
      countryName: "LATVIA",
      regionCode: "RI",
      regionName: "RIGAS APRINKIS",
    },
    {
      countryName: "LATVIA",
      regionCode: "RIX",
      regionName: "RIGA",
    },
    {
      countryName: "LATVIA",
      regionCode: "SA",
      regionName: "SALDUS APRINKIS",
    },
    {
      countryName: "LATVIA",
      regionCode: "TA",
      regionName: "TALSU APRINKIS",
    },
    {
      countryName: "LATVIA",
      regionCode: "TU",
      regionName: "TUKUMA APRINKIS",
    },
    {
      countryName: "LATVIA",
      regionCode: "VE",
      regionName: "VENTPILS APRINKIS",
    },
    {
      countryName: "LATVIA",
      regionCode: "VEN",
      regionName: "VENTSPILS",
    },
    {
      countryName: "LATVIA",
      regionCode: "VK",
      regionName: "VALKAS APRINKIS",
    },
    {
      countryName: "LATVIA",
      regionCode: "VM",
      regionName: "VALMIERAS APRINKIS",
    },
    {
      countryName: "LEBANON",
      regionCode: "AK",
      regionName: "AAKKAR",
    },
    {
      countryName: "LEBANON",
      regionCode: "BH",
      regionName: "BAALBEK-HERMEL",
    },
    {
      countryName: "LEBANON",
      regionCode: "BI",
      regionName: "BEQAA",
    },
    {
      countryName: "LEBANON",
      regionCode: "BA",
      regionName: "BEYROUTH",
    },
    {
      countryName: "LEBANON",
      regionCode: "AS",
      regionName: "LIBAN-NORD",
    },
    {
      countryName: "LEBANON",
      regionCode: "JA",
      regionName: "LIBAN-SUD",
    },
    {
      countryName: "LEBANON",
      regionCode: "JL",
      regionName: "MONT-LIBAN",
    },
    {
      countryName: "LEBANON",
      regionCode: "NA",
      regionName: "NABATIYE",
    },
    {
      countryName: "LESOTHO",
      regionCode: "D",
      regionName: "BEREA",
    },
    {
      countryName: "LESOTHO",
      regionCode: "B",
      regionName: "BUTHA-BUTHE",
    },
    {
      countryName: "LESOTHO",
      regionCode: "C",
      regionName: "LERIBE",
    },
    {
      countryName: "LESOTHO",
      regionCode: "E",
      regionName: "MAFETENG",
    },
    {
      countryName: "LESOTHO",
      regionCode: "A",
      regionName: "MASERU",
    },
    {
      countryName: "LESOTHO",
      regionCode: "F",
      regionName: "MOHALE’S HOEK",
    },
    {
      countryName: "LESOTHO",
      regionCode: "J",
      regionName: "MOKHOTLONG",
    },
    {
      countryName: "LESOTHO",
      regionCode: "H",
      regionName: "QACHA’S NEK",
    },
    {
      countryName: "LESOTHO",
      regionCode: "G",
      regionName: "QUTHING",
    },
    {
      countryName: "LESOTHO",
      regionCode: "K",
      regionName: "THABA-TSEKA",
    },
    {
      countryName: "LIBERIA",
      regionCode: "BG",
      regionName: "BONG",
    },
    {
      countryName: "LIBERIA",
      regionCode: "BM",
      regionName: "BOMI",
    },
    {
      countryName: "LIBERIA",
      regionCode: "CM",
      regionName: "GRAND CAPE MOUNT",
    },
    {
      countryName: "LIBERIA",
      regionCode: "GB",
      regionName: "GRAND BASSA",
    },
    {
      countryName: "LIBERIA",
      regionCode: "GG",
      regionName: "GRAND GEDEH",
    },
    {
      countryName: "LIBERIA",
      regionCode: "GK",
      regionName: "GRAND KRU",
    },
    {
      countryName: "LIBERIA",
      regionCode: "GP",
      regionName: "GBARPOLU",
    },
    {
      countryName: "LIBERIA",
      regionCode: "LO",
      regionName: "LOFA",
    },
    {
      countryName: "LIBERIA",
      regionCode: "MG",
      regionName: "MARGIBI",
    },
    {
      countryName: "LIBERIA",
      regionCode: "MO",
      regionName: "MONTSERRADO",
    },
    {
      countryName: "LIBERIA",
      regionCode: "MY",
      regionName: "MARYLAND",
    },
    {
      countryName: "LIBERIA",
      regionCode: "NI",
      regionName: "NIMBA",
    },
    {
      countryName: "LIBERIA",
      regionCode: "RG",
      regionName: "RIVER GEE",
    },
    {
      countryName: "LIBERIA",
      regionCode: "RI",
      regionName: "RIVERCESS",
    },
    {
      countryName: "LIBERIA",
      regionCode: "SI",
      regionName: "SINOE",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "AJ",
      regionName: "AJDABIYA",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "BU",
      regionName: "AL BUPNAN",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "HZ",
      regionName: "AL HIZAM AL AKHARDAR",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "JA",
      regionName: "AL JABAL AL AKHDAR",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "JI",
      regionName: "AL JIFARAH",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "JU",
      regionName: "AL JUFRAH",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "KF",
      regionName: "AL KUFRAH",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "MJ",
      regionName: "AL MARJ",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "MB",
      regionName: "AL MARQAB",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "QT",
      regionName: "AL QAPRUN",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "QB",
      regionName: "AL QUBBAH",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "WA",
      regionName: "AL WAHAH",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "NQ",
      regionName: "AN NUQAT AL KHAMS",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "SH",
      regionName: "ASH SHATI",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "ZA",
      regionName: "AZ ZAWIYAH",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "BA",
      regionName: "BANGHAZI",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "BW",
      regionName: "BANI WALID",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "DR",
      regionName: "DARNAH",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "GD",
      regionName: "GHADAMIS",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "GR",
      regionName: "GHARYAN",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "GT",
      regionName: "GHAT",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "JB",
      regionName: "JAGHBUB",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "MI",
      regionName: "MISRATAH",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "MZ",
      regionName: "MIZDAH",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "MQ",
      regionName: "MURZUQ",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "NL",
      regionName: "NALUT",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "SB",
      regionName: "SABHA",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "SS",
      regionName: "SABRATAH SURMAN",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "SR",
      regionName: "SURT",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "TN",
      regionName: "TAJURA WA AN NAWAHHI AL ARBA",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "TB",
      regionName: "TARABULUS",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "TM",
      regionName: "TARHUNAH-MASALLATAH",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "WD",
      regionName: "WADI AL HAYAT",
    },
    {
      countryName: "LIBYAN ARAB JAMAHIRIYA",
      regionCode: "YJ",
      regionName: "YAFRAN-JADU",
    },
    {
      countryName: "LIECHTENSTEIN",
      regionCode: 1,
      regionName: "BALZERS",
    },
    {
      countryName: "LIECHTENSTEIN",
      regionCode: 2,
      regionName: "ESCHEN",
    },
    {
      countryName: "LIECHTENSTEIN",
      regionCode: 3,
      regionName: "GAMPRIN",
    },
    {
      countryName: "LIECHTENSTEIN",
      regionCode: 4,
      regionName: "MAUREN",
    },
    {
      countryName: "LIECHTENSTEIN",
      regionCode: 5,
      regionName: "PLANKEN",
    },
    {
      countryName: "LIECHTENSTEIN",
      regionCode: 6,
      regionName: "RUGGELL",
    },
    {
      countryName: "LIECHTENSTEIN",
      regionCode: 7,
      regionName: "SCHAAN",
    },
    {
      countryName: "LIECHTENSTEIN",
      regionCode: 8,
      regionName: "SCHELLENBERG",
    },
    {
      countryName: "LIECHTENSTEIN",
      regionCode: 9,
      regionName: "TRIESEN",
    },
    {
      countryName: "LIECHTENSTEIN",
      regionCode: 10,
      regionName: "TRIESENBERG",
    },
    {
      countryName: "LIECHTENSTEIN",
      regionCode: 11,
      regionName: "VADUZ",
    },
    {
      countryName: "LITHUANIA",
      regionCode: "AL",
      regionName: "ALYTAUS APSKRITIS",
    },
    {
      countryName: "LITHUANIA",
      regionCode: "SA",
      regionName: "IAULIU APSKRITIS",
    },
    {
      countryName: "LITHUANIA",
      regionCode: "KU",
      regionName: "KAUNO APSKRITIS",
    },
    {
      countryName: "LITHUANIA",
      regionCode: "KL",
      regionName: "KLAIPEDOS APSKRITIS",
    },
    {
      countryName: "LITHUANIA",
      regionCode: "MR",
      regionName: "MARIJAMPOLES APSKRITIS",
    },
    {
      countryName: "LITHUANIA",
      regionCode: "PN",
      regionName: "PANEVEIO APSKRITIS",
    },
    {
      countryName: "LITHUANIA",
      regionCode: "TA",
      regionName: "TAURAGES APSKRITIS",
    },
    {
      countryName: "LITHUANIA",
      regionCode: "TE",
      regionName: "TELIU APSKRITIS",
    },
    {
      countryName: "LITHUANIA",
      regionCode: "UT",
      regionName: "UTENOS APSKRITIS",
    },
    {
      countryName: "LITHUANIA",
      regionCode: "VL",
      regionName: "VILNIAUS APSKRITIS",
    },
    {
      countryName: "LUXEMBOURG",
      regionCode: "D",
      regionName: "DIEKIRCH",
    },
    {
      countryName: "LUXEMBOURG",
      regionCode: "G",
      regionName: "GREVENMACHER",
    },
    {
      countryName: "LUXEMBOURG",
      regionCode: "L",
      regionName: "LUXEMBOURG",
    },
    {
      countryName: "MACAO",
      regionCode: "MO",
      regionName: "MACAO",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 1,
      regionName: "AERODROM",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 2,
      regionName: "ARACINOVO",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 3,
      regionName: "BEROVO",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 4,
      regionName: "BITOLA",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 5,
      regionName: "BOGDANCI",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 6,
      regionName: "BOGOVINJE",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 7,
      regionName: "BOSILOVO",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 8,
      regionName: "BRVENICA",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 9,
      regionName: "BUTEL",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 79,
      regionName: "CAIR",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 80,
      regionName: "CASKA",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 77,
      regionName: "CENTAR",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 78,
      regionName: "CENTAR ZUPA",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 81,
      regionName: "CESINOVO-OBLESEVO",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 82,
      regionName: "CUCER SANDEVO",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 21,
      regionName: "DEBAR",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 22,
      regionName: "DEBARCA",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 23,
      regionName: "DELCEVO",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 25,
      regionName: "DEMIR HISAR",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 24,
      regionName: "DEMIR KAPIJA",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 26,
      regionName: "DOJRAN",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 27,
      regionName: "DOLNENI",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 28,
      regionName: "DRUGOVO",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 17,
      regionName: "GAZI BABA",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 18,
      regionName: "GEVGELIJA",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 29,
      regionName: "GJORCE PETROV",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 19,
      regionName: "GOSTIVAR",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 20,
      regionName: "GRADSKO",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 34,
      regionName: "ILINDEN",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 35,
      regionName: "JEGUNOVCE",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 37,
      regionName: "KARBINCI",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 38,
      regionName: "KARPOS",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 36,
      regionName: "KAVADARCI",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 40,
      regionName: "KICEVO",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 39,
      regionName: "KISELA VODA",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 42,
      regionName: "KOCANI",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 41,
      regionName: "KONCE",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 43,
      regionName: "KRATOVO",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 44,
      regionName: "KRIVA PALANKA",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 45,
      regionName: "KRIVOGASTANI",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 46,
      regionName: "KRUSEVO",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 47,
      regionName: "KUMANOVO",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 48,
      regionName: "LIPKOVO",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 49,
      regionName: "LOZOVO",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 51,
      regionName: "MAKEDONSKA KAMENICA",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 52,
      regionName: "MAKEDONSKI BROD",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 50,
      regionName: "MAVROVO I ROSTUSA",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 53,
      regionName: "MOGILA",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 54,
      regionName: "NEGOTINO",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 55,
      regionName: "NOVACI",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 56,
      regionName: "NOVO SELO",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 58,
      regionName: "OHRID",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 57,
      regionName: "OSLOMEJ",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 60,
      regionName: "PEHCEVO",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 59,
      regionName: "PETROVEC",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 61,
      regionName: "PLASNICA",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 62,
      regionName: "PRILEP",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 63,
      regionName: "PROBISTIP",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 64,
      regionName: "RADOVIS",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 65,
      regionName: "RANKOVCE",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 66,
      regionName: "RESEN",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 67,
      regionName: "ROSOMAN",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 68,
      regionName: "SARAJ",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 70,
      regionName: "SOPISTE",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 71,
      regionName: "STARO NAGORICANE",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 83,
      regionName: "STIP",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 72,
      regionName: "STRUGA",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 73,
      regionName: "STRUMICA",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 74,
      regionName: "STUDENICANI",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 84,
      regionName: "SUTO ORIZARI",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 69,
      regionName: "SVETI NIKOLE",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 75,
      regionName: "TEARCE",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 76,
      regionName: "TETOVO",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 10,
      regionName: "VALANDOVO",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 11,
      regionName: "VASILEVO",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 13,
      regionName: "VELES",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 12,
      regionName: "VEVCANI",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 14,
      regionName: "VINICA",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 15,
      regionName: "VRANESTICA",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 16,
      regionName: "VRAPCISTE",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 31,
      regionName: "ZAJAS",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 32,
      regionName: "ZELENIKOVO",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 30,
      regionName: "ZELINO",
    },
    {
      countryName: "MACEDONIA (THE FORMER YOGSLAV REPUBLIC OF)",
      regionCode: 33,
      regionName: "ZRNOVCI",
    },
    {
      countryName: "MADAGASCAR",
      regionCode: "T",
      regionName: "ANTANANARIVO",
    },
    {
      countryName: "MADAGASCAR",
      regionCode: "D",
      regionName: "ANTSIRANANA",
    },
    {
      countryName: "MADAGASCAR",
      regionCode: "F",
      regionName: "FIANARANTSOA",
    },
    {
      countryName: "MADAGASCAR",
      regionCode: "M",
      regionName: "MAHAJANGA",
    },
    {
      countryName: "MADAGASCAR",
      regionCode: "A",
      regionName: "TOAMASINA",
    },
    {
      countryName: "MADAGASCAR",
      regionCode: "U",
      regionName: "TOLIARA",
    },
    {
      countryName: "MALAWI",
      regionCode: "BA",
      regionName: "BALAKA",
    },
    {
      countryName: "MALAWI",
      regionCode: "BL",
      regionName: "BLANTYRE",
    },
    {
      countryName: "MALAWI",
      regionCode: "CK",
      regionName: "CHIKWAWA",
    },
    {
      countryName: "MALAWI",
      regionCode: "CR",
      regionName: "CHIRADZULU",
    },
    {
      countryName: "MALAWI",
      regionCode: "CT",
      regionName: "CHITIPA",
    },
    {
      countryName: "MALAWI",
      regionCode: "DE",
      regionName: "DEDZA",
    },
    {
      countryName: "MALAWI",
      regionCode: "DO",
      regionName: "DOWA",
    },
    {
      countryName: "MALAWI",
      regionCode: "KR",
      regionName: "KARONGA",
    },
    {
      countryName: "MALAWI",
      regionCode: "KS",
      regionName: "KASUNGU",
    },
    {
      countryName: "MALAWI",
      regionCode: "LI",
      regionName: "LILONGWE",
    },
    {
      countryName: "MALAWI",
      regionCode: "LK",
      regionName: "LIKOMA ISLAND",
    },
    {
      countryName: "MALAWI",
      regionCode: "MC",
      regionName: "MCHINJI",
    },
    {
      countryName: "MALAWI",
      regionCode: "MG",
      regionName: "MANGOCHI",
    },
    {
      countryName: "MALAWI",
      regionCode: "MH",
      regionName: "MACHINGA",
    },
    {
      countryName: "MALAWI",
      regionCode: "MU",
      regionName: "MULANJE",
    },
    {
      countryName: "MALAWI",
      regionCode: "MW",
      regionName: "MWANZA",
    },
    {
      countryName: "MALAWI",
      regionCode: "MZ",
      regionName: "MZIMBA",
    },
    {
      countryName: "MALAWI",
      regionCode: "NB",
      regionName: "NKHATA BAY",
    },
    {
      countryName: "MALAWI",
      regionCode: "NI",
      regionName: "NTCHISI",
    },
    {
      countryName: "MALAWI",
      regionCode: "NK",
      regionName: "NKHOTAKOTA",
    },
    {
      countryName: "MALAWI",
      regionCode: "NS",
      regionName: "NSANJE",
    },
    {
      countryName: "MALAWI",
      regionCode: "NU",
      regionName: "NTCHEU",
    },
    {
      countryName: "MALAWI",
      regionCode: "PH",
      regionName: "PHALOMBE",
    },
    {
      countryName: "MALAWI",
      regionCode: "RU",
      regionName: "RUMPHI",
    },
    {
      countryName: "MALAWI",
      regionCode: "SA",
      regionName: "SALIMA",
    },
    {
      countryName: "MALAWI",
      regionCode: "TH",
      regionName: "THYOLO",
    },
    {
      countryName: "MALAWI",
      regionCode: "ZO",
      regionName: "ZOMBA",
    },
    {
      countryName: "MALAYSIA",
      regionCode: 1,
      regionName: "JOHOR",
    },
    {
      countryName: "MALAYSIA",
      regionCode: 2,
      regionName: "KEDAH",
    },
    {
      countryName: "MALAYSIA",
      regionCode: 3,
      regionName: "KELANTAN",
    },
    {
      countryName: "MALAYSIA",
      regionCode: 4,
      regionName: "MELAKA",
    },
    {
      countryName: "MALAYSIA",
      regionCode: 5,
      regionName: "NEGERI SEMBILAN",
    },
    {
      countryName: "MALAYSIA",
      regionCode: 6,
      regionName: "PAHANG",
    },
    {
      countryName: "MALAYSIA",
      regionCode: 7,
      regionName: "PULAU PINANG",
    },
    {
      countryName: "MALAYSIA",
      regionCode: 8,
      regionName: "PERAK",
    },
    {
      countryName: "MALAYSIA",
      regionCode: 9,
      regionName: "PERLIS",
    },
    {
      countryName: "MALAYSIA",
      regionCode: 10,
      regionName: "SELANGOR",
    },
    {
      countryName: "MALAYSIA",
      regionCode: 11,
      regionName: "TERENGGANU",
    },
    {
      countryName: "MALAYSIA",
      regionCode: 12,
      regionName: "SABAH",
    },
    {
      countryName: "MALAYSIA",
      regionCode: 13,
      regionName: "SARAWAK",
    },
    {
      countryName: "MALAYSIA",
      regionCode: 14,
      regionName: "WILAYAH PERSEKUTUAN KUALA LUMPUR",
    },
    {
      countryName: "MALAYSIA",
      regionCode: 15,
      regionName: "WILAYAH PERSEKUTUAN  LABUAN",
    },
    {
      countryName: "MALAYSIA",
      regionCode: 16,
      regionName: "WILAYAH PERSEKUTUAN PUTRAJAYA",
    },
    {
      countryName: "MALDIVES",
      regionCode: 2,
      regionName: "ALIF",
    },
    {
      countryName: "MALDIVES",
      regionCode: 20,
      regionName: "BAA",
    },
    {
      countryName: "MALDIVES",
      regionCode: 17,
      regionName: "DHAALU",
    },
    {
      countryName: "MALDIVES",
      regionCode: 14,
      regionName: "FAAFU",
    },
    {
      countryName: "MALDIVES",
      regionCode: 27,
      regionName: "GAAF ALIF",
    },
    {
      countryName: "MALDIVES",
      regionCode: 28,
      regionName: "GAAFU DHAALU",
    },
    {
      countryName: "MALDIVES",
      regionCode: 29,
      regionName: "GNAVIYANI",
    },
    {
      countryName: "MALDIVES",
      regionCode: 7,
      regionName: "HAA ALIF",
    },
    {
      countryName: "MALDIVES",
      regionCode: 23,
      regionName: "HAA DHAALU",
    },
    {
      countryName: "MALDIVES",
      regionCode: 26,
      regionName: "KAAFU",
    },
    {
      countryName: "MALDIVES",
      regionCode: 5,
      regionName: "LAAMU",
    },
    {
      countryName: "MALDIVES",
      regionCode: 3,
      regionName: "LHAVIYANI",
    },
    {
      countryName: "MALDIVES",
      regionCode: "MLE",
      regionName: "MALE",
    },
    {
      countryName: "MALDIVES",
      regionCode: 12,
      regionName: "MEEMU",
    },
    {
      countryName: "MALDIVES",
      regionCode: 25,
      regionName: "NOONU",
    },
    {
      countryName: "MALDIVES",
      regionCode: 13,
      regionName: "RAA",
    },
    {
      countryName: "MALDIVES",
      regionCode: 1,
      regionName: "SEENU",
    },
    {
      countryName: "MALDIVES",
      regionCode: 24,
      regionName: "SHAVIYANI",
    },
    {
      countryName: "MALDIVES",
      regionCode: 8,
      regionName: "THAA",
    },
    {
      countryName: "MALDIVES",
      regionCode: 4,
      regionName: "VAAVU",
    },
    {
      countryName: "MALI",
      regionCode: "BKO",
      regionName: "BAMAKO",
    },
    {
      countryName: "MALI",
      regionCode: 7,
      regionName: "GAO",
    },
    {
      countryName: "MALI",
      regionCode: 1,
      regionName: "KAYES",
    },
    {
      countryName: "MALI",
      regionCode: 8,
      regionName: "KIDAL",
    },
    {
      countryName: "MALI",
      regionCode: 2,
      regionName: "KOULIKORO",
    },
    {
      countryName: "MALI",
      regionCode: 5,
      regionName: "MOPTI",
    },
    {
      countryName: "MALI",
      regionCode: 4,
      regionName: "SEGOU",
    },
    {
      countryName: "MALI",
      regionCode: 3,
      regionName: "SIKASSO",
    },
    {
      countryName: "MALI",
      regionCode: 6,
      regionName: "TOMBOUCTOU",
    },
    {
      countryName: "MALTA",
      regionCode: 1,
      regionName: "ATTARD",
    },
    {
      countryName: "MALTA",
      regionCode: 2,
      regionName: "BALZAN",
    },
    {
      countryName: "MALTA",
      regionCode: 3,
      regionName: "BIRGU",
    },
    {
      countryName: "MALTA",
      regionCode: 4,
      regionName: "BIRKIRKARA",
    },
    {
      countryName: "MALTA",
      regionCode: 5,
      regionName: "BIRZEBBUGA",
    },
    {
      countryName: "MALTA",
      regionCode: 6,
      regionName: "BORMLA",
    },
    {
      countryName: "MALTA",
      regionCode: 7,
      regionName: "DINGLI",
    },
    {
      countryName: "MALTA",
      regionCode: 8,
      regionName: "FGURA",
    },
    {
      countryName: "MALTA",
      regionCode: 9,
      regionName: "FLORIANA",
    },
    {
      countryName: "MALTA",
      regionCode: 10,
      regionName: "FONTANA",
    },
    {
      countryName: "MALTA",
      regionCode: 11,
      regionName: "GUDJA",
    },
    {
      countryName: "MALTA",
      regionCode: 12,
      regionName: "GZIRA",
    },
    {
      countryName: "MALTA",
      regionCode: 13,
      regionName: "GHAJNSIELEM",
    },
    {
      countryName: "MALTA",
      regionCode: 14,
      regionName: "GHARB",
    },
    {
      countryName: "MALTA",
      regionCode: 15,
      regionName: "GHARGHUR",
    },
    {
      countryName: "MALTA",
      regionCode: 16,
      regionName: "GHASRI",
    },
    {
      countryName: "MALTA",
      regionCode: 17,
      regionName: "GHAXAQ",
    },
    {
      countryName: "MALTA",
      regionCode: 18,
      regionName: "HAMRUN",
    },
    {
      countryName: "MALTA",
      regionCode: 19,
      regionName: "IKLIN",
    },
    {
      countryName: "MALTA",
      regionCode: 20,
      regionName: "ISLA",
    },
    {
      countryName: "MALTA",
      regionCode: 21,
      regionName: "KALKARA",
    },
    {
      countryName: "MALTA",
      regionCode: 22,
      regionName: "KERHEM",
    },
    {
      countryName: "MALTA",
      regionCode: 23,
      regionName: "KIRKOP",
    },
    {
      countryName: "MALTA",
      regionCode: 24,
      regionName: "LIJA",
    },
    {
      countryName: "MALTA",
      regionCode: 25,
      regionName: "LUQA",
    },
    {
      countryName: "MALTA",
      regionCode: 26,
      regionName: "MARSA",
    },
    {
      countryName: "MALTA",
      regionCode: 27,
      regionName: "MARSASKALA",
    },
    {
      countryName: "MALTA",
      regionCode: 28,
      regionName: "MARSAXLOKK",
    },
    {
      countryName: "MALTA",
      regionCode: 29,
      regionName: "MDINA",
    },
    {
      countryName: "MALTA",
      regionCode: 30,
      regionName: "MELLIEHA",
    },
    {
      countryName: "MALTA",
      regionCode: 31,
      regionName: "MHARR",
    },
    {
      countryName: "MALTA",
      regionCode: 32,
      regionName: "MOSTA",
    },
    {
      countryName: "MALTA",
      regionCode: 33,
      regionName: "MQABBA",
    },
    {
      countryName: "MALTA",
      regionCode: 34,
      regionName: "MSIDA",
    },
    {
      countryName: "MALTA",
      regionCode: 35,
      regionName: "MTARFA",
    },
    {
      countryName: "MALTA",
      regionCode: 36,
      regionName: "MUNXAR",
    },
    {
      countryName: "MALTA",
      regionCode: 37,
      regionName: "NADUR",
    },
    {
      countryName: "MALTA",
      regionCode: 38,
      regionName: "NAXXAR",
    },
    {
      countryName: "MALTA",
      regionCode: 39,
      regionName: "PAOLA",
    },
    {
      countryName: "MALTA",
      regionCode: 40,
      regionName: "PEMBROKE",
    },
    {
      countryName: "MALTA",
      regionCode: 41,
      regionName: "PIETA",
    },
    {
      countryName: "MALTA",
      regionCode: 42,
      regionName: "QALA",
    },
    {
      countryName: "MALTA",
      regionCode: 43,
      regionName: "QORMI",
    },
    {
      countryName: "MALTA",
      regionCode: 44,
      regionName: "QRENDI",
    },
    {
      countryName: "MALTA",
      regionCode: 45,
      regionName: "RABAT GHAWDEX (RABAT GOZO)",
    },
    {
      countryName: "MALTA",
      regionCode: 46,
      regionName: "RABAT MALTA",
    },
    {
      countryName: "MALTA",
      regionCode: 47,
      regionName: "SAFI",
    },
    {
      countryName: "MALTA",
      regionCode: 48,
      regionName: "SAN GILJAN (SAINT JULIANS)",
    },
    {
      countryName: "MALTA",
      regionCode: 49,
      regionName: "SAN GWANN (SAINT JOHN)",
    },
    {
      countryName: "MALTA",
      regionCode: 50,
      regionName: "SAN LAWRENZ (SAINT LAWRENCE)",
    },
    {
      countryName: "MALTA",
      regionCode: 51,
      regionName: "SAN PAWL BAHAR (SAINT PAULS BAY)",
    },
    {
      countryName: "MALTA",
      regionCode: 52,
      regionName: "SANNAT",
    },
    {
      countryName: "MALTA",
      regionCode: 53,
      regionName: "SANTA LUCIJA (SAINT LUCIAS)",
    },
    {
      countryName: "MALTA",
      regionCode: 54,
      regionName: "SANTA VENERA",
    },
    {
      countryName: "MALTA",
      regionCode: 55,
      regionName: "SIGGIEWI",
    },
    {
      countryName: "MALTA",
      regionCode: 56,
      regionName: "SLIEMA",
    },
    {
      countryName: "MALTA",
      regionCode: 57,
      regionName: "SWIEQI",
    },
    {
      countryName: "MALTA",
      regionCode: 58,
      regionName: "TA XBIEX",
    },
    {
      countryName: "MALTA",
      regionCode: 59,
      regionName: "TARXIEN",
    },
    {
      countryName: "MALTA",
      regionCode: 60,
      regionName: "VALLETTA",
    },
    {
      countryName: "MALTA",
      regionCode: 61,
      regionName: "XAGHRA",
    },
    {
      countryName: "MALTA",
      regionCode: 62,
      regionName: "XEWKIJA",
    },
    {
      countryName: "MALTA",
      regionCode: 63,
      regionName: "XGHAJRA",
    },
    {
      countryName: "MALTA",
      regionCode: 64,
      regionName: "ZABBAR",
    },
    {
      countryName: "MALTA",
      regionCode: 65,
      regionName: "ZEBBUG GHAWDEX (ZEBBUG GOZO)",
    },
    {
      countryName: "MALTA",
      regionCode: 66,
      regionName: "ZEBBUG MALTA",
    },
    {
      countryName: "MALTA",
      regionCode: 67,
      regionName: "ZEJTUN",
    },
    {
      countryName: "MALTA",
      regionCode: 68,
      regionName: "ZURRIEQ",
    },
    {
      countryName: "MARSHALL ISLANDS (THE)",
      regionCode: "ALK",
      regionName: "AILUK",
    },
    {
      countryName: "MARSHALL ISLANDS (THE)",
      regionCode: "ALL",
      regionName: "AILINGLAPALAP",
    },
    {
      countryName: "MARSHALL ISLANDS (THE)",
      regionCode: "ARN",
      regionName: "ARNO",
    },
    {
      countryName: "MARSHALL ISLANDS (THE)",
      regionCode: "AUR",
      regionName: "AUR",
    },
    {
      countryName: "MARSHALL ISLANDS (THE)",
      regionCode: "EBO",
      regionName: "EBON",
    },
    {
      countryName: "MARSHALL ISLANDS (THE)",
      regionCode: "ENI",
      regionName: "ENIWETOK",
    },
    {
      countryName: "MARSHALL ISLANDS (THE)",
      regionCode: "JAL",
      regionName: "JALUIT",
    },
    {
      countryName: "MARSHALL ISLANDS (THE)",
      regionCode: "KIL",
      regionName: "KILI",
    },
    {
      countryName: "MARSHALL ISLANDS (THE)",
      regionCode: "KWA",
      regionName: "KWAJALEIN",
    },
    {
      countryName: "MARSHALL ISLANDS (THE)",
      regionCode: "LAE",
      regionName: "LAE",
    },
    {
      countryName: "MARSHALL ISLANDS (THE)",
      regionCode: "LIB",
      regionName: "LIB",
    },
    {
      countryName: "MARSHALL ISLANDS (THE)",
      regionCode: "LIK",
      regionName: "LIKIEP",
    },
    {
      countryName: "MARSHALL ISLANDS (THE)",
      regionCode: "MAJ",
      regionName: "MAJURO",
    },
    {
      countryName: "MARSHALL ISLANDS (THE)",
      regionCode: "MAL",
      regionName: "MALEOLAP",
    },
    {
      countryName: "MARSHALL ISLANDS (THE)",
      regionCode: "MEJ",
      regionName: "MEJIT",
    },
    {
      countryName: "MARSHALL ISLANDS (THE)",
      regionCode: "MIL",
      regionName: "MILI",
    },
    {
      countryName: "MARSHALL ISLANDS (THE)",
      regionCode: "NMK",
      regionName: "NAMORIK",
    },
    {
      countryName: "MARSHALL ISLANDS (THE)",
      regionCode: "NMU",
      regionName: "NAMU",
    },
    {
      countryName: "MARSHALL ISLANDS (THE)",
      regionCode: "RON",
      regionName: "RONGELAP",
    },
    {
      countryName: "MARSHALL ISLANDS (THE)",
      regionCode: "UJA",
      regionName: "UJAE",
    },
    {
      countryName: "MARSHALL ISLANDS (THE)",
      regionCode: "UJL",
      regionName: "UJELANG",
    },
    {
      countryName: "MARSHALL ISLANDS (THE)",
      regionCode: "UTI",
      regionName: "UTIRIK",
    },
    {
      countryName: "MARSHALL ISLANDS (THE)",
      regionCode: "WTH",
      regionName: "WOTHO",
    },
    {
      countryName: "MARSHALL ISLANDS (THE)",
      regionCode: "WTJ",
      regionName: "WOTJE",
    },
    {
      countryName: "MARTINIQUE",
      regionCode: "MQ",
      regionName: "MARTINIQUE",
    },
    {
      countryName: "MAURITANIA",
      regionCode: 7,
      regionName: "ADRAR",
    },
    {
      countryName: "MAURITANIA",
      regionCode: 3,
      regionName: "ASSABA",
    },
    {
      countryName: "MAURITANIA",
      regionCode: 5,
      regionName: "BRAKNA",
    },
    {
      countryName: "MAURITANIA",
      regionCode: 8,
      regionName: "DAKHLET NOUADHIBOU",
    },
    {
      countryName: "MAURITANIA",
      regionCode: 4,
      regionName: "GORGOL",
    },
    {
      countryName: "MAURITANIA",
      regionCode: 10,
      regionName: "GUIDIMAKA",
    },
    {
      countryName: "MAURITANIA",
      regionCode: 1,
      regionName: "HODH ECH CHARGUI",
    },
    {
      countryName: "MAURITANIA",
      regionCode: 2,
      regionName: "HODH EL GHARBI",
    },
    {
      countryName: "MAURITANIA",
      regionCode: 12,
      regionName: "INCHIRI",
    },
    {
      countryName: "MAURITANIA",
      regionCode: "NKC",
      regionName: "NOUAKCHOTT",
    },
    {
      countryName: "MAURITANIA",
      regionCode: 9,
      regionName: "TAGANT",
    },
    {
      countryName: "MAURITANIA",
      regionCode: 11,
      regionName: "TIRIS ZEMMOUR",
    },
    {
      countryName: "MAURITANIA",
      regionCode: 6,
      regionName: "TRARZA",
    },
    {
      countryName: "MAURITIUS",
      regionCode: "AG",
      regionName: "AGALEGA ISLANDS",
    },
    {
      countryName: "MAURITIUS",
      regionCode: "BL",
      regionName: "BLACK RIVER",
    },
    {
      countryName: "MAURITIUS",
      regionCode: "BR",
      regionName: "BEAU BASSIN-ROSE HILL",
    },
    {
      countryName: "MAURITIUS",
      regionCode: "CC",
      regionName: "CARGADOS CARAJOS SHOALS",
    },
    {
      countryName: "MAURITIUS",
      regionCode: "CU",
      regionName: "CUREPIPE",
    },
    {
      countryName: "MAURITIUS",
      regionCode: "FL",
      regionName: "FLACQ",
    },
    {
      countryName: "MAURITIUS",
      regionCode: "GP",
      regionName: "GRAND PORT",
    },
    {
      countryName: "MAURITIUS",
      regionCode: "MO",
      regionName: "MOKA",
    },
    {
      countryName: "MAURITIUS",
      regionCode: "PA",
      regionName: "PAMPLEMOUSSES",
    },
    {
      countryName: "MAURITIUS",
      regionCode: "PL",
      regionName: "PORT LOUIS",
    },
    {
      countryName: "MAURITIUS",
      regionCode: "PU",
      regionName: "PORT LOUIS",
    },
    {
      countryName: "MAURITIUS",
      regionCode: "PW",
      regionName: "PLAINES WILHEMS",
    },
    {
      countryName: "MAURITIUS",
      regionCode: "QB",
      regionName: "QUATRE BORNES",
    },
    {
      countryName: "MAURITIUS",
      regionCode: "RO",
      regionName: "RODRIGUES ISLAND",
    },
    {
      countryName: "MAURITIUS",
      regionCode: "RR",
      regionName: "RIVIERE DU REMPART",
    },
    {
      countryName: "MAURITIUS",
      regionCode: "SA",
      regionName: "SAVANNE",
    },
    {
      countryName: "MAURITIUS",
      regionCode: "VP",
      regionName: "VACOAS-PHOENIX",
    },
    {
      countryName: "MAYOTTE",
      regionCode: "YT",
      regionName: "MAYOTTE",
    },
    {
      countryName: "MEXICO",
      regionCode: "AGU",
      regionName: "AGUASCALIENTES",
    },
    {
      countryName: "MEXICO",
      regionCode: "BCN",
      regionName: "BAJA CALIFORNIA",
    },
    {
      countryName: "MEXICO",
      regionCode: "BCS",
      regionName: "BAJA CALIFORNIA SUR",
    },
    {
      countryName: "MEXICO",
      regionCode: "CAM",
      regionName: "CAMPECHE",
    },
    {
      countryName: "MEXICO",
      regionCode: "CHH",
      regionName: "CHIHUAHUA",
    },
    {
      countryName: "MEXICO",
      regionCode: "CHP",
      regionName: "CHIAPAS",
    },
    {
      countryName: "MEXICO",
      regionCode: "COA",
      regionName: "COAHUILA",
    },
    {
      countryName: "MEXICO",
      regionCode: "COL",
      regionName: "COLIMA",
    },
    {
      countryName: "MEXICO",
      regionCode: "CMX",
      regionName: "CIUDAD",
    },
    {
      countryName: "MEXICO",
      regionCode: "DUR",
      regionName: "DURANGO",
    },
    {
      countryName: "MEXICO",
      regionCode: "GRO",
      regionName: "GUERRERO",
    },
    {
      countryName: "MEXICO",
      regionCode: "GUA",
      regionName: "GUANAJUATO",
    },
    {
      countryName: "MEXICO",
      regionCode: "HID",
      regionName: "HIDALGO",
    },
    {
      countryName: "MEXICO",
      regionCode: "JAL",
      regionName: "JALISCO",
    },
    {
      countryName: "MEXICO",
      regionCode: "MEX",
      regionName: "MEXICO",
    },
    {
      countryName: "MEXICO",
      regionCode: "MIC",
      regionName: "MICHOACAN",
    },
    {
      countryName: "MEXICO",
      regionCode: "MOR",
      regionName: "MORELOS",
    },
    {
      countryName: "MEXICO",
      regionCode: "NAY",
      regionName: "NAYARIT",
    },
    {
      countryName: "MEXICO",
      regionCode: "NLE",
      regionName: "NUEVO LEON",
    },
    {
      countryName: "MEXICO",
      regionCode: "OAX",
      regionName: "OAXACA",
    },
    {
      countryName: "MEXICO",
      regionCode: "PUE",
      regionName: "PUEBLA",
    },
    {
      countryName: "MEXICO",
      regionCode: "QUE",
      regionName: "QUERETARO",
    },
    {
      countryName: "MEXICO",
      regionCode: "ROO",
      regionName: "QUINTANA ROO",
    },
    {
      countryName: "MEXICO",
      regionCode: "SIN",
      regionName: "SINALOA",
    },
    {
      countryName: "MEXICO",
      regionCode: "SLP",
      regionName: "SAN LUIS POTOSI",
    },
    {
      countryName: "MEXICO",
      regionCode: "SON",
      regionName: "SONORA",
    },
    {
      countryName: "MEXICO",
      regionCode: "TAB",
      regionName: "TABASCO",
    },
    {
      countryName: "MEXICO",
      regionCode: "TAM",
      regionName: "TAMAULIPAS",
    },
    {
      countryName: "MEXICO",
      regionCode: "TLA",
      regionName: "TLAXCALA",
    },
    {
      countryName: "MEXICO",
      regionCode: "VER",
      regionName: "VERACRUZ",
    },
    {
      countryName: "MEXICO",
      regionCode: "YUC",
      regionName: "YUCATAN",
    },
    {
      countryName: "MEXICO",
      regionCode: "ZAC",
      regionName: "ZACATECAS",
    },
    {
      countryName: "MICRONESIA (FEDERATED STATES OF)",
      regionCode: "TRK",
      regionName: "CHUUK",
    },
    {
      countryName: "MICRONESIA (FEDERATED STATES OF)",
      regionCode: "KSA",
      regionName: "KOSRAE",
    },
    {
      countryName: "MICRONESIA (FEDERATED STATES OF)",
      regionCode: "PNI",
      regionName: "POHNPEI",
    },
    {
      countryName: "MICRONESIA (FEDERATED STATES OF)",
      regionCode: "YAP",
      regionName: "YAP",
    },
    {
      countryName: "MOLDOVA (THE REPUBLIC OF)",
      regionCode: "BA",
      regionName: "BALTI",
    },
    {
      countryName: "MOLDOVA (THE REPUBLIC OF)",
      regionCode: "CA",
      regionName: "CAHUL",
    },
    {
      countryName: "MOLDOVA (THE REPUBLIC OF)",
      regionCode: "CH",
      regionName: "CHISINAU",
    },
    {
      countryName: "MOLDOVA (THE REPUBLIC OF)",
      regionCode: "CU",
      regionName: "CHISINAU",
    },
    {
      countryName: "MOLDOVA (THE REPUBLIC OF)",
      regionCode: "ED",
      regionName: "EDINET",
    },
    {
      countryName: "MOLDOVA (THE REPUBLIC OF)",
      regionCode: "GA",
      regionName: "GAGAUZIA",
    },
    {
      countryName: "MOLDOVA (THE REPUBLIC OF)",
      regionCode: "LA",
      regionName: "LAPUSNA",
    },
    {
      countryName: "MOLDOVA (THE REPUBLIC OF)",
      regionCode: "OR",
      regionName: "ORHEI",
    },
    {
      countryName: "MOLDOVA (THE REPUBLIC OF)",
      regionCode: "SN",
      regionName: "STINGA NISTRULUI",
    },
    {
      countryName: "MOLDOVA (THE REPUBLIC OF)",
      regionCode: "SO",
      regionName: "SOROCA",
    },
    {
      countryName: "MOLDOVA (THE REPUBLIC OF)",
      regionCode: "TA",
      regionName: "TARACLIA",
    },
    {
      countryName: "MOLDOVA (THE REPUBLIC OF)",
      regionCode: "TI",
      regionName: "TIGHINA",
    },
    {
      countryName: "MOLDOVA (THE REPUBLIC OF)",
      regionCode: "UN",
      regionName: "UNGHENI",
    },
    {
      countryName: "MONACO",
      regionCode: "MC",
      regionName: "MONACO",
    },
    {
      countryName: "MONGOLIA",
      regionCode: 73,
      regionName: "ARHANGAY",
    },
    {
      countryName: "MONGOLIA",
      regionCode: 69,
      regionName: "BAYANHONGOR",
    },
    {
      countryName: "MONGOLIA",
      regionCode: 71,
      regionName: "BAYAN-OLGIY",
    },
    {
      countryName: "MONGOLIA",
      regionCode: 67,
      regionName: "BULGAN",
    },
    {
      countryName: "MONGOLIA",
      regionCode: 37,
      regionName: "DARHAN UUL",
    },
    {
      countryName: "MONGOLIA",
      regionCode: 61,
      regionName: "DORNOD",
    },
    {
      countryName: "MONGOLIA",
      regionCode: 63,
      regionName: "DORNOGOVI",
    },
    {
      countryName: "MONGOLIA",
      regionCode: 59,
      regionName: "DUNDGOVI",
    },
    {
      countryName: "MONGOLIA",
      regionCode: 57,
      regionName: "DZAVHAN",
    },
    {
      countryName: "MONGOLIA",
      regionCode: 65,
      regionName: "GOVI-ALTAY",
    },
    {
      countryName: "MONGOLIA",
      regionCode: 64,
      regionName: "GOVI-SUMBER",
    },
    {
      countryName: "MONGOLIA",
      regionCode: 39,
      regionName: "HENTIY",
    },
    {
      countryName: "MONGOLIA",
      regionCode: 43,
      regionName: "HOVD",
    },
    {
      countryName: "MONGOLIA",
      regionCode: 41,
      regionName: "HOVSGOL",
    },
    {
      countryName: "MONGOLIA",
      regionCode: 53,
      regionName: "OMNOGOVI",
    },
    {
      countryName: "MONGOLIA",
      regionCode: 35,
      regionName: "ORHON",
    },
    {
      countryName: "MONGOLIA",
      regionCode: 55,
      regionName: "OVORHANGAY",
    },
    {
      countryName: "MONGOLIA",
      regionCode: 49,
      regionName: "SELENGE",
    },
    {
      countryName: "MONGOLIA",
      regionCode: 51,
      regionName: "SUHBAATAR",
    },
    {
      countryName: "MONGOLIA",
      regionCode: 47,
      regionName: "TOV",
    },
    {
      countryName: "MONGOLIA",
      regionCode: 1,
      regionName: "ULAANBAATAR",
    },
    {
      countryName: "MONGOLIA",
      regionCode: 46,
      regionName: "UVS",
    },
    {
      countryName: "MONTENEGRO",
      regionCode: 1,
      regionName: "ANDRIJEVICA",
    },
    {
      countryName: "MONTENEGRO",
      regionCode: 2,
      regionName: "BAR",
    },
    {
      countryName: "MONTENEGRO",
      regionCode: 3,
      regionName: "BERANE",
    },
    {
      countryName: "MONTENEGRO",
      regionCode: 4,
      regionName: "BIJELO POLJE",
    },
    {
      countryName: "MONTENEGRO",
      regionCode: 5,
      regionName: "BUDVA",
    },
    {
      countryName: "MONTENEGRO",
      regionCode: 6,
      regionName: "CETINJE",
    },
    {
      countryName: "MONTENEGRO",
      regionCode: 7,
      regionName: "DANILOVGRAD",
    },
    {
      countryName: "MONTENEGRO",
      regionCode: 8,
      regionName: "HERCEG-NOVI",
    },
    {
      countryName: "MONTENEGRO",
      regionCode: 9,
      regionName: "KOLASIN",
    },
    {
      countryName: "MONTENEGRO",
      regionCode: 10,
      regionName: "KOTOR",
    },
    {
      countryName: "MONTENEGRO",
      regionCode: 11,
      regionName: "MOJKOVAC",
    },
    {
      countryName: "MONTENEGRO",
      regionCode: 12,
      regionName: "NIKSIC",
    },
    {
      countryName: "MONTENEGRO",
      regionCode: 13,
      regionName: "PLAV",
    },
    {
      countryName: "MONTENEGRO",
      regionCode: 14,
      regionName: "PLJEVLJA",
    },
    {
      countryName: "MONTENEGRO",
      regionCode: 15,
      regionName: "PLUZINE",
    },
    {
      countryName: "MONTENEGRO",
      regionCode: 16,
      regionName: "PODGORICA",
    },
    {
      countryName: "MONTENEGRO",
      regionCode: 17,
      regionName: "ROZAJE",
    },
    {
      countryName: "MONTENEGRO",
      regionCode: 18,
      regionName: "SAVNIK",
    },
    {
      countryName: "MONTENEGRO",
      regionCode: 19,
      regionName: "TIVAT",
    },
    {
      countryName: "MONTENEGRO",
      regionCode: 20,
      regionName: "ULCINJ",
    },
    {
      countryName: "MONTENEGRO",
      regionCode: 21,
      regionName: "ZABLJAK",
    },
    {
      countryName: "MONTSERRAT",
      regionCode: "MS",
      regionName: "MONTSERRAT",
    },
    {
      countryName: "MOROCCO",
      regionCode: "AGD",
      regionName: "AGADIR",
    },
    {
      countryName: "MOROCCO",
      regionCode: "BAH",
      regionName: "AIT BAHA",
    },
    {
      countryName: "MOROCCO",
      regionCode: "MEL",
      regionName: "AIT MELLOUL",
    },
    {
      countryName: "MOROCCO",
      regionCode: "HAO",
      regionName: "AL HAOUZ",
    },
    {
      countryName: "MOROCCO",
      regionCode: "HOC",
      regionName: "AL HOCEIMA",
    },
    {
      countryName: "MOROCCO",
      regionCode: "ASZ",
      regionName: "ASSA-ZAG",
    },
    {
      countryName: "MOROCCO",
      regionCode: "AZI",
      regionName: "AZILAL",
    },
    {
      countryName: "MOROCCO",
      regionCode: "BES",
      regionName: "BEN SLIMANE",
    },
    {
      countryName: "MOROCCO",
      regionCode: "BEM",
      regionName: "BENI MELLAL",
    },
    {
      countryName: "MOROCCO",
      regionCode: "BER",
      regionName: "BERKANE",
    },
    {
      countryName: "MOROCCO",
      regionCode: "BOD",
      regionName: "BOUJDOUR",
    },
    {
      countryName: "MOROCCO",
      regionCode: "BOM",
      regionName: "BOULEMANE",
    },
    {
      countryName: "MOROCCO",
      regionCode: "CAS",
      regionName: "CASABLANCA",
    },
    {
      countryName: "MOROCCO",
      regionCode: "CHE",
      regionName: "CHEFCHAOUENE",
    },
    {
      countryName: "MOROCCO",
      regionCode: "CHI",
      regionName: "CHICHAOUA",
    },
    {
      countryName: "MOROCCO",
      regionCode: "HAJ",
      regionName: "EL HAJEB",
    },
    {
      countryName: "MOROCCO",
      regionCode: "JDI",
      regionName: "EL JADIDA",
    },
    {
      countryName: "MOROCCO",
      regionCode: "ERR",
      regionName: "ERRACHIDIA",
    },
    {
      countryName: "MOROCCO",
      regionCode: "ESM",
      regionName: "ES SMARA",
    },
    {
      countryName: "MOROCCO",
      regionCode: "ESI",
      regionName: "ESSAOUIRA",
    },
    {
      countryName: "MOROCCO",
      regionCode: "FES",
      regionName: "FES",
    },
    {
      countryName: "MOROCCO",
      regionCode: "FIG",
      regionName: "FIGUIG",
    },
    {
      countryName: "MOROCCO",
      regionCode: "GUE",
      regionName: "GUELMIM",
    },
    {
      countryName: "MOROCCO",
      regionCode: "IFR",
      regionName: "IFRANE",
    },
    {
      countryName: "MOROCCO",
      regionCode: "JRA",
      regionName: "JERADA",
    },
    {
      countryName: "MOROCCO",
      regionCode: "KES",
      regionName: "KELAAT SRAGHNA",
    },
    {
      countryName: "MOROCCO",
      regionCode: "KEN",
      regionName: "KENITRA",
    },
    {
      countryName: "MOROCCO",
      regionCode: "KHE",
      regionName: "KHEMISSET",
    },
    {
      countryName: "MOROCCO",
      regionCode: "KHN",
      regionName: "KHENIFRA",
    },
    {
      countryName: "MOROCCO",
      regionCode: "KHO",
      regionName: "KHOURIBGA",
    },
    {
      countryName: "MOROCCO",
      regionCode: "LAA",
      regionName: "LAAYOUNE",
    },
    {
      countryName: "MOROCCO",
      regionCode: "LAR",
      regionName: "LARACHE",
    },
    {
      countryName: "MOROCCO",
      regionCode: "MAR",
      regionName: "MARRAKECH",
    },
    {
      countryName: "MOROCCO",
      regionCode: "MEK",
      regionName: "MEKNES",
    },
    {
      countryName: "MOROCCO",
      regionCode: "NAD",
      regionName: "NADOR",
    },
    {
      countryName: "MOROCCO",
      regionCode: "OUA",
      regionName: "OUARZAZATE",
    },
    {
      countryName: "MOROCCO",
      regionCode: "OUD",
      regionName: "OUED ED DAHAB",
    },
    {
      countryName: "MOROCCO",
      regionCode: "OUJ",
      regionName: "OUJDA",
    },
    {
      countryName: "MOROCCO",
      regionCode: "RBA",
      regionName: "RABAT-SALE",
    },
    {
      countryName: "MOROCCO",
      regionCode: "SAF",
      regionName: "SAFI",
    },
    {
      countryName: "MOROCCO",
      regionCode: "SEF",
      regionName: "SEFROU",
    },
    {
      countryName: "MOROCCO",
      regionCode: "SET",
      regionName: "SETTAT",
    },
    {
      countryName: "MOROCCO",
      regionCode: "SIK",
      regionName: "SIDI KACEM",
    },
    {
      countryName: "MOROCCO",
      regionCode: "TNG",
      regionName: "TANGER",
    },
    {
      countryName: "MOROCCO",
      regionCode: "TNT",
      regionName: "TAN-TAN",
    },
    {
      countryName: "MOROCCO",
      regionCode: "TAO",
      regionName: "TAOUNATE",
    },
    {
      countryName: "MOROCCO",
      regionCode: "TAR",
      regionName: "TAROUDANNT",
    },
    {
      countryName: "MOROCCO",
      regionCode: "TAT",
      regionName: "TATA",
    },
    {
      countryName: "MOROCCO",
      regionCode: "TAZ",
      regionName: "TAZA",
    },
    {
      countryName: "MOROCCO",
      regionCode: "TET",
      regionName: "TETOUAN",
    },
    {
      countryName: "MOROCCO",
      regionCode: "TIZ",
      regionName: "TIZNIT",
    },
    {
      countryName: "MOZAMBIQUE",
      regionCode: "P",
      regionName: "CABO DELGADO",
    },
    {
      countryName: "MOZAMBIQUE",
      regionCode: "G",
      regionName: "GAZA",
    },
    {
      countryName: "MOZAMBIQUE",
      regionCode: "I",
      regionName: "INHAMBANE",
    },
    {
      countryName: "MOZAMBIQUE",
      regionCode: "B",
      regionName: "MANICA",
    },
    {
      countryName: "MOZAMBIQUE",
      regionCode: "L",
      regionName: "MAPUTO",
    },
    {
      countryName: "MOZAMBIQUE",
      regionCode: "MPM",
      regionName: "MAPUTO",
    },
    {
      countryName: "MOZAMBIQUE",
      regionCode: "N",
      regionName: "NAMPULA",
    },
    {
      countryName: "MOZAMBIQUE",
      regionCode: "A",
      regionName: "NIASSA",
    },
    {
      countryName: "MOZAMBIQUE",
      regionCode: "S",
      regionName: "SOFALA",
    },
    {
      countryName: "MOZAMBIQUE",
      regionCode: "T",
      regionName: "TETE",
    },
    {
      countryName: "MOZAMBIQUE",
      regionCode: "Q",
      regionName: "ZAMBEZIA",
    },
    {
      countryName: "MYANMAR",
      regionCode: 0,
      regionName: "MYANMAR",
    },
    {
      countryName: "MYANMAR",
      regionCode: 17,
      regionName: "AYEYARWADY",
    },
    {
      countryName: "MYANMAR",
      regionCode: 16,
      regionName: "BAGO",
    },
    {
      countryName: "MYANMAR",
      regionCode: 8,
      regionName: "CHIN",
    },
    {
      countryName: "MYANMAR",
      regionCode: 9,
      regionName: "KACHIN",
    },
    {
      countryName: "MYANMAR",
      regionCode: 11,
      regionName: "KAYAH",
    },
    {
      countryName: "MYANMAR",
      regionCode: 10,
      regionName: "KAYIN",
    },
    {
      countryName: "MYANMAR",
      regionCode: 2,
      regionName: "MAGWAY",
    },
    {
      countryName: "MYANMAR",
      regionCode: 19,
      regionName: "MANDALAY",
    },
    {
      countryName: "MYANMAR",
      regionCode: 12,
      regionName: "MON",
    },
    {
      countryName: "MYANMAR",
      regionCode: 13,
      regionName: "RAKHINE",
    },
    {
      countryName: "MYANMAR",
      regionCode: 6,
      regionName: "SAGAING",
    },
    {
      countryName: "MYANMAR",
      regionCode: 14,
      regionName: "SHAN",
    },
    {
      countryName: "MYANMAR",
      regionCode: 18,
      regionName: "TANINTHARYI",
    },
    {
      countryName: "MYANMAR",
      regionCode: 15,
      regionName: "YANGON",
    },
    {
      countryName: "NAMIBIA",
      regionCode: "CA",
      regionName: "CAPRIVI",
    },
    {
      countryName: "NAMIBIA",
      regionCode: "ER",
      regionName: "ERONGO",
    },
    {
      countryName: "NAMIBIA",
      regionCode: "HA",
      regionName: "HARDAP",
    },
    {
      countryName: "NAMIBIA",
      regionCode: "KA",
      regionName: "KARAS",
    },
    {
      countryName: "NAMIBIA",
      regionCode: "KH",
      regionName: "KHOMAS",
    },
    {
      countryName: "NAMIBIA",
      regionCode: "KU",
      regionName: "KUNENE",
    },
    {
      countryName: "NAMIBIA",
      regionCode: "OD",
      regionName: "OTJOZONDJUPA",
    },
    {
      countryName: "NAMIBIA",
      regionCode: "OH",
      regionName: "OMAHEKE",
    },
    {
      countryName: "NAMIBIA",
      regionCode: "OK",
      regionName: "OKAVANGO",
    },
    {
      countryName: "NAMIBIA",
      regionCode: "ON",
      regionName: "OSHANA",
    },
    {
      countryName: "NAMIBIA",
      regionCode: "OS",
      regionName: "OMUSATI",
    },
    {
      countryName: "NAMIBIA",
      regionCode: "OT",
      regionName: "OSHIKOTO",
    },
    {
      countryName: "NAMIBIA",
      regionCode: "OW",
      regionName: "OHANGWENA",
    },
    {
      countryName: "NAURU",
      regionCode: 1,
      regionName: "AIWO",
    },
    {
      countryName: "NAURU",
      regionCode: 2,
      regionName: "ANABAR",
    },
    {
      countryName: "NAURU",
      regionCode: 3,
      regionName: "ANETAN",
    },
    {
      countryName: "NAURU",
      regionCode: 4,
      regionName: "ANIBARE",
    },
    {
      countryName: "NAURU",
      regionCode: 5,
      regionName: "BAITI",
    },
    {
      countryName: "NAURU",
      regionCode: 6,
      regionName: "BOE",
    },
    {
      countryName: "NAURU",
      regionCode: 7,
      regionName: "BUADA",
    },
    {
      countryName: "NAURU",
      regionCode: 8,
      regionName: "DENIGOMODU",
    },
    {
      countryName: "NAURU",
      regionCode: 9,
      regionName: "EWA",
    },
    {
      countryName: "NAURU",
      regionCode: 10,
      regionName: "IJUW",
    },
    {
      countryName: "NAURU",
      regionCode: 11,
      regionName: "MENENG",
    },
    {
      countryName: "NAURU",
      regionCode: 12,
      regionName: "NIBOK",
    },
    {
      countryName: "NAURU",
      regionCode: 13,
      regionName: "UABOE",
    },
    {
      countryName: "NAURU",
      regionCode: 14,
      regionName: "YAREN",
    },
    {
      countryName: "NEPAL",
      regionCode: "BA",
      regionName: "BAGMATI",
    },
    {
      countryName: "NEPAL",
      regionCode: "BH",
      regionName: "BHERI",
    },
    {
      countryName: "NEPAL",
      regionCode: "DH",
      regionName: "DHAWALAGIRI",
    },
    {
      countryName: "NEPAL",
      regionCode: "GA",
      regionName: "GANDAKI",
    },
    {
      countryName: "NEPAL",
      regionCode: "JA",
      regionName: "JANAKPUR",
    },
    {
      countryName: "NEPAL",
      regionCode: "KA",
      regionName: "KARNALI",
    },
    {
      countryName: "NEPAL",
      regionCode: "KO",
      regionName: "KOSI (KOSHI)",
    },
    {
      countryName: "NEPAL",
      regionCode: "LU",
      regionName: "LUMBINI",
    },
    {
      countryName: "NEPAL",
      regionCode: "MA",
      regionName: "MAHAKALI",
    },
    {
      countryName: "NEPAL",
      regionCode: "ME",
      regionName: "MECHI",
    },
    {
      countryName: "NEPAL",
      regionCode: "NA",
      regionName: "NARAYANI",
    },
    {
      countryName: "NEPAL",
      regionCode: "RA",
      regionName: "RAPTI",
    },
    {
      countryName: "NEPAL",
      regionCode: "SA",
      regionName: "SAGARMATHA",
    },
    {
      countryName: "NEPAL",
      regionCode: "SE",
      regionName: "SETI",
    },
    {
      countryName: "NETHERLANDS (THE)",
      regionCode: "DR",
      regionName: "DRENTHE",
    },
    {
      countryName: "NETHERLANDS (THE)",
      regionCode: "FL",
      regionName: "FLEVOLAND",
    },
    {
      countryName: "NETHERLANDS (THE)",
      regionCode: "FR",
      regionName: "FRYSLAN (FY)",
    },
    {
      countryName: "NETHERLANDS (THE)",
      regionCode: "GE",
      regionName: "GELDERLAND",
    },
    {
      countryName: "NETHERLANDS (THE)",
      regionCode: "GR",
      regionName: "GRONINGEN",
    },
    {
      countryName: "NETHERLANDS (THE)",
      regionCode: "LI",
      regionName: "LIMBURG",
    },
    {
      countryName: "NETHERLANDS (THE)",
      regionCode: "NB",
      regionName: "NOORD-BRABANT",
    },
    {
      countryName: "NETHERLANDS (THE)",
      regionCode: "NH",
      regionName: "NOORD-HOLLAND",
    },
    {
      countryName: "NETHERLANDS (THE)",
      regionCode: "OV",
      regionName: "OVERIJSSEL",
    },
    {
      countryName: "NETHERLANDS (THE)",
      regionCode: "UT",
      regionName: "UTRECHT",
    },
    {
      countryName: "NETHERLANDS (THE)",
      regionCode: "ZE",
      regionName: "ZEELAND",
    },
    {
      countryName: "NETHERLANDS (THE)",
      regionCode: "ZH",
      regionName: "ZUHOLLAND",
    },
    {
      countryName: "NETHERLANDS ANTILLES",
      regionCode: "DR",
      regionName: "DRENTHE",
    },
    {
      countryName: "NETHERLANDS ANTILLES",
      regionCode: "FL",
      regionName: "FLEVOLAND",
    },
    {
      countryName: "NETHERLANDS ANTILLES",
      regionCode: "FR",
      regionName: "FRYSLAN (FY)",
    },
    {
      countryName: "NETHERLANDS ANTILLES",
      regionCode: "GE",
      regionName: "GELDERLAND",
    },
    {
      countryName: "NETHERLANDS ANTILLES",
      regionCode: "GR",
      regionName: "GRONINGEN",
    },
    {
      countryName: "NETHERLANDS ANTILLES",
      regionCode: "LI",
      regionName: "LIMBURG",
    },
    {
      countryName: "NETHERLANDS ANTILLES",
      regionCode: "NB",
      regionName: "NOORD-BRABANT",
    },
    {
      countryName: "NETHERLANDS ANTILLES",
      regionCode: "NH",
      regionName: "NOORD-HOLLAND",
    },
    {
      countryName: "NETHERLANDS ANTILLES",
      regionCode: "OV",
      regionName: "OVERIJSSEL",
    },
    {
      countryName: "NETHERLANDS ANTILLES",
      regionCode: "UT",
      regionName: "UTRECHT",
    },
    {
      countryName: "NETHERLANDS ANTILLES",
      regionCode: "ZE",
      regionName: "ZEELAND",
    },
    {
      countryName: "NETHERLANDS ANTILLES",
      regionCode: "ZH",
      regionName: "ZUHOLLAND",
    },
    {
      countryName: "NEW CALEDONIA",
      regionCode: "NC",
      regionName: "NEW CALEDONIA",
    },
    {
      countryName: "NEW ZEALAND",
      regionCode: "AUK",
      regionName: "AUCKLAND",
    },
    {
      countryName: "NEW ZEALAND",
      regionCode: "BOP",
      regionName: "BAY OF PLENTY",
    },
    {
      countryName: "NEW ZEALAND",
      regionCode: "CAN",
      regionName: "CANTERBURY",
    },
    {
      countryName: "NEW ZEALAND",
      regionCode: "GIS",
      regionName: "GISBORNE",
    },
    {
      countryName: "NEW ZEALAND",
      regionCode: "HKB",
      regionName: "HAWKES’S BAY",
    },
    {
      countryName: "NEW ZEALAND",
      regionCode: "MBH",
      regionName: "MARLBOROUGH",
    },
    {
      countryName: "NEW ZEALAND",
      regionCode: "MWT",
      regionName: "MANAWATU-WANGANUI",
    },
    {
      countryName: "NEW ZEALAND",
      regionCode: "NSN",
      regionName: "NELSON",
    },
    {
      countryName: "NEW ZEALAND",
      regionCode: "NTL",
      regionName: "NORTHLAND",
    },
    {
      countryName: "NEW ZEALAND",
      regionCode: "OTA",
      regionName: "OTAGO",
    },
    {
      countryName: "NEW ZEALAND",
      regionCode: "STL",
      regionName: "SOUTHLAND",
    },
    {
      countryName: "NEW ZEALAND",
      regionCode: "TAS",
      regionName: "TASMAN",
    },
    {
      countryName: "NEW ZEALAND",
      regionCode: "TKI",
      regionName: "TARANAKI",
    },
    {
      countryName: "NEW ZEALAND",
      regionCode: "WGN",
      regionName: "WELLINGTON",
    },
    {
      countryName: "NEW ZEALAND",
      regionCode: "WKO",
      regionName: "WAIKATO",
    },
    {
      countryName: "NEW ZEALAND",
      regionCode: "WTC",
      regionName: "WEST COAST",
    },
    {
      countryName: "NICARAGUA",
      regionCode: "AN",
      regionName: "ATLANTICO NORTE",
    },
    {
      countryName: "NICARAGUA",
      regionCode: "AS",
      regionName: "ATLANTICO SUR",
    },
    {
      countryName: "NICARAGUA",
      regionCode: "BO",
      regionName: "BOACO",
    },
    {
      countryName: "NICARAGUA",
      regionCode: "CA",
      regionName: "CARAZO",
    },
    {
      countryName: "NICARAGUA",
      regionCode: "CI",
      regionName: "CHINANDEGA",
    },
    {
      countryName: "NICARAGUA",
      regionCode: "CO",
      regionName: "CHONTALES",
    },
    {
      countryName: "NICARAGUA",
      regionCode: "ES",
      regionName: "ESTELI",
    },
    {
      countryName: "NICARAGUA",
      regionCode: "GR",
      regionName: "GRANADA",
    },
    {
      countryName: "NICARAGUA",
      regionCode: "JI",
      regionName: "JINOTEGA",
    },
    {
      countryName: "NICARAGUA",
      regionCode: "LE",
      regionName: "LEON",
    },
    {
      countryName: "NICARAGUA",
      regionCode: "MD",
      regionName: "MADRIZ",
    },
    {
      countryName: "NICARAGUA",
      regionCode: "MN",
      regionName: "MANAGUA",
    },
    {
      countryName: "NICARAGUA",
      regionCode: "MS",
      regionName: "MASAYA",
    },
    {
      countryName: "NICARAGUA",
      regionCode: "MT",
      regionName: "MATAGALPA",
    },
    {
      countryName: "NICARAGUA",
      regionCode: "NS",
      regionName: "NUEVA SEGOVIA",
    },
    {
      countryName: "NICARAGUA",
      regionCode: "RI",
      regionName: "RIVAS",
    },
    {
      countryName: "NICARAGUA",
      regionCode: "SJ",
      regionName: "RIO SAN JUAN",
    },
    {
      countryName: "NIGER (THE)",
      regionCode: 1,
      regionName: "AGADEZ",
    },
    {
      countryName: "NIGER (THE)",
      regionCode: 2,
      regionName: "DIFFA",
    },
    {
      countryName: "NIGER (THE)",
      regionCode: 3,
      regionName: "DOSSO",
    },
    {
      countryName: "NIGER (THE)",
      regionCode: 4,
      regionName: "MARADI",
    },
    {
      countryName: "NIGER (THE)",
      regionCode: 8,
      regionName: "NIAMEY",
    },
    {
      countryName: "NIGER (THE)",
      regionCode: 5,
      regionName: "TAHOUA",
    },
    {
      countryName: "NIGER (THE)",
      regionCode: 6,
      regionName: "TILLABERI",
    },
    {
      countryName: "NIGER (THE)",
      regionCode: 7,
      regionName: "ZINDER",
    },
    {
      countryName: "NIGERIA",
      regionCode: "AB",
      regionName: "ABIA",
    },
    {
      countryName: "NIGERIA",
      regionCode: "AD",
      regionName: "ADAMAWA",
    },
    {
      countryName: "NIGERIA",
      regionCode: "AK",
      regionName: "ARWA IBOM",
    },
    {
      countryName: "NIGERIA",
      regionCode: "AN",
      regionName: "ANAMBRA",
    },
    {
      countryName: "NIGERIA",
      regionCode: "BA",
      regionName: "BAUCHI",
    },
    {
      countryName: "NIGERIA",
      regionCode: "BE",
      regionName: "BENUE",
    },
    {
      countryName: "NIGERIA",
      regionCode: "BO",
      regionName: "BORNO",
    },
    {
      countryName: "NIGERIA",
      regionCode: "BY",
      regionName: "BAYELSA",
    },
    {
      countryName: "NIGERIA",
      regionCode: "CR",
      regionName: "CROSS RIVER",
    },
    {
      countryName: "NIGERIA",
      regionCode: "DE",
      regionName: "DELTA",
    },
    {
      countryName: "NIGERIA",
      regionCode: "EB",
      regionName: "EBONYI",
    },
    {
      countryName: "NIGERIA",
      regionCode: "ED",
      regionName: "EDO",
    },
    {
      countryName: "NIGERIA",
      regionCode: "EK",
      regionName: "EKITI",
    },
    {
      countryName: "NIGERIA",
      regionCode: "EN",
      regionName: "ENUGU",
    },
    {
      countryName: "NIGERIA",
      regionCode: "FC",
      regionName: "ABUJA FEDERAL CAPITAL TERRITORY",
    },
    {
      countryName: "NIGERIA",
      regionCode: "GO",
      regionName: "GOMBE",
    },
    {
      countryName: "NIGERIA",
      regionCode: "IM",
      regionName: "IMO",
    },
    {
      countryName: "NIGERIA",
      regionCode: "JI",
      regionName: "JIGAWA",
    },
    {
      countryName: "NIGERIA",
      regionCode: "KD",
      regionName: "KADUNA",
    },
    {
      countryName: "NIGERIA",
      regionCode: "KE",
      regionName: "KEBBI",
    },
    {
      countryName: "NIGERIA",
      regionCode: "KN",
      regionName: "KANO",
    },
    {
      countryName: "NIGERIA",
      regionCode: "KO",
      regionName: "KOGI",
    },
    {
      countryName: "NIGERIA",
      regionCode: "KT",
      regionName: "KATSINA",
    },
    {
      countryName: "NIGERIA",
      regionCode: "KW",
      regionName: "KWARA",
    },
    {
      countryName: "NIGERIA",
      regionCode: "LA",
      regionName: "LAGOS",
    },
    {
      countryName: "NIGERIA",
      regionCode: "NA",
      regionName: "NASSARAWA",
    },
    {
      countryName: "NIGERIA",
      regionCode: "NI",
      regionName: "NIGER",
    },
    {
      countryName: "NIGERIA",
      regionCode: "OG",
      regionName: "OGUN",
    },
    {
      countryName: "NIGERIA",
      regionCode: "ON",
      regionName: "ONDO",
    },
    {
      countryName: "NIGERIA",
      regionCode: "OS",
      regionName: "OSUN",
    },
    {
      countryName: "NIGERIA",
      regionCode: "OY",
      regionName: "OYO",
    },
    {
      countryName: "NIGERIA",
      regionCode: "PL",
      regionName: "PLATEAU",
    },
    {
      countryName: "NIGERIA",
      regionCode: "RI",
      regionName: "RIVERS",
    },
    {
      countryName: "NIGERIA",
      regionCode: "SO",
      regionName: "SOKOTO",
    },
    {
      countryName: "NIGERIA",
      regionCode: "TA",
      regionName: "TARABA",
    },
    {
      countryName: "NIGERIA",
      regionCode: "YO",
      regionName: "YOBE",
    },
    {
      countryName: "NIGERIA",
      regionCode: "ZA",
      regionName: "ZAMFARA",
    },
    {
      countryName: "NIUE",
      regionCode: "NU",
      regionName: "NIUE",
    },
    {
      countryName: "NORFOLK ISLAND",
      regionCode: "NF",
      regionName: "NORFOLK ISLAND",
    },
    {
      countryName: "NORTHERN MARIANA ISLANDS (THE)",
      regionCode: "MP",
      regionName: "NORTHERN MARIANA ISLANDS (THE)",
    },
    {
      countryName: "NORWAY",
      regionCode: 2,
      regionName: "AKERSHUS",
    },
    {
      countryName: "NORWAY",
      regionCode: 9,
      regionName: "AUST-ADGER",
    },
    {
      countryName: "NORWAY",
      regionCode: 6,
      regionName: "BUSKERUD",
    },
    {
      countryName: "NORWAY",
      regionCode: 20,
      regionName: "FINNMARK (NB, NN) / FINNMARKU",
    },
    {
      countryName: "NORWAY",
      regionCode: 4,
      regionName: "HEDMARK",
    },
    {
      countryName: "NORWAY",
      regionCode: 12,
      regionName: "HORDALAND",
    },
    {
      countryName: "NORWAY",
      regionCode: 22,
      regionName: "JAN MAYEN (ARCTIC REGION)",
    },
    {
      countryName: "NORWAY",
      regionCode: 15,
      regionName: "MORE OG ROMSDAL",
    },
    {
      countryName: "NORWAY",
      regionCode: 18,
      regionName: "NORDLAND",
    },
    {
      countryName: "NORWAY",
      regionCode: 17,
      regionName: "NORD-TRONDELAG",
    },
    {
      countryName: "NORWAY",
      regionCode: 5,
      regionName: "OPPLAND",
    },
    {
      countryName: "NORWAY",
      regionCode: 3,
      regionName: "OSLO",
    },
    {
      countryName: "NORWAY",
      regionCode: 1,
      regionName: "OSTFOLD",
    },
    {
      countryName: "NORWAY",
      regionCode: 11,
      regionName: "ROGALAND",
    },
    {
      countryName: "NORWAY",
      regionCode: 14,
      regionName: "SOGN OG FJORDANE",
    },
    {
      countryName: "NORWAY",
      regionCode: 16,
      regionName: "SOR-TRONDELAG",
    },
    {
      countryName: "NORWAY",
      regionCode: 21,
      regionName: "SVALBARD (ARCTIC REGION)",
    },
    {
      countryName: "NORWAY",
      regionCode: 8,
      regionName: "TELEMARK",
    },
    {
      countryName: "NORWAY",
      regionCode: 19,
      regionName: "TROMS (NB, NN) / ROMSA (SE)",
    },
    {
      countryName: "NORWAY",
      regionCode: 10,
      regionName: "VEST-ADGER",
    },
    {
      countryName: "NORWAY",
      regionCode: 7,
      regionName: "VESTFOLD",
    },
    {
      countryName: "OMAN",
      regionCode: "DA",
      regionName: "AD DAKHILIYAH",
    },
    {
      countryName: "OMAN",
      regionCode: "BA",
      regionName: "AL BATINAH",
    },
    {
      countryName: "OMAN",
      regionCode: "JA",
      regionName: "AL JANUBIYAH (ZUFAR)",
    },
    {
      countryName: "OMAN",
      regionCode: "WU",
      regionName: "AL WUSTA",
    },
    {
      countryName: "OMAN",
      regionCode: "SH",
      regionName: "ASH SHARQIYAH",
    },
    {
      countryName: "OMAN",
      regionCode: "ZA",
      regionName: "AZ ZAHIRAH",
    },
    {
      countryName: "OMAN",
      regionCode: "MA",
      regionName: "MASQAT",
    },
    {
      countryName: "OMAN",
      regionCode: "MU",
      regionName: "MUSANDAM",
    },
    {
      countryName: "PAKISTAN",
      regionCode: "JK",
      regionName: "AZAD KASHMIR",
    },
    {
      countryName: "PAKISTAN",
      regionCode: "BA",
      regionName: "BALUCHISTAN (EN) BALOCHISTAN",
    },
    {
      countryName: "PAKISTAN",
      regionCode: "IS",
      regionName: "ISLAMABAD",
    },
    {
      countryName: "PAKISTAN",
      regionCode: "NA",
      regionName: "NORTHERN AREAS",
    },
    {
      countryName: "PAKISTAN",
      regionCode: "NW",
      regionName: "NORTH-WEST FRONTIER",
    },
    {
      countryName: "PAKISTAN",
      regionCode: "PB",
      regionName: "PUNJAB",
    },
    {
      countryName: "PAKISTAN",
      regionCode: "SD",
      regionName: "SIND (EN)",
    },
    {
      countryName: "PAKISTAN",
      regionCode: "TA",
      regionName: "FEDERALLY ADMINISTERED TRIBAL AREAS",
    },
    {
      countryName: "PALAU",
      regionCode: 2,
      regionName: "AIMELIIK",
    },
    {
      countryName: "PALAU",
      regionCode: 4,
      regionName: "AIRAI",
    },
    {
      countryName: "PALAU",
      regionCode: 10,
      regionName: "ANGAUR",
    },
    {
      countryName: "PALAU",
      regionCode: 50,
      regionName: "HATOBOHEI",
    },
    {
      countryName: "PALAU",
      regionCode: 100,
      regionName: "KAYANGEL",
    },
    {
      countryName: "PALAU",
      regionCode: 150,
      regionName: "KOROR",
    },
    {
      countryName: "PALAU",
      regionCode: 212,
      regionName: "MELEKEOK",
    },
    {
      countryName: "PALAU",
      regionCode: 214,
      regionName: "NGARAARD",
    },
    {
      countryName: "PALAU",
      regionCode: 218,
      regionName: "NGARCHELONG",
    },
    {
      countryName: "PALAU",
      regionCode: 222,
      regionName: "NGARDMAU",
    },
    {
      countryName: "PALAU",
      regionCode: 224,
      regionName: "NGATPANG",
    },
    {
      countryName: "PALAU",
      regionCode: 226,
      regionName: "NGCHESAR",
    },
    {
      countryName: "PALAU",
      regionCode: 227,
      regionName: "NGEREMLENGUI",
    },
    {
      countryName: "PALAU",
      regionCode: 228,
      regionName: "NGIWAL",
    },
    {
      countryName: "PALAU",
      regionCode: 350,
      regionName: "PELELIU",
    },
    {
      countryName: "PALAU",
      regionCode: 370,
      regionName: "SONSOROL",
    },
    {
      countryName: "PALESTINIAN TERRITORY, OCCUPIED",
      regionCode: "PS",
      regionName: "PALESTINE, STATE OF",
    },
    {
      countryName: "PANAMA",
      regionCode: 1,
      regionName: "BOCAS DEL TORO",
    },
    {
      countryName: "PANAMA",
      regionCode: 4,
      regionName: "CHIRIQUI",
    },
    {
      countryName: "PANAMA",
      regionCode: 2,
      regionName: "COCLE",
    },
    {
      countryName: "PANAMA",
      regionCode: 3,
      regionName: "COLON",
    },
    {
      countryName: "PANAMA",
      regionCode: 0,
      regionName: "COMARCA DE SAN BLAS",
    },
    {
      countryName: "PANAMA",
      regionCode: 5,
      regionName: "DARIEN",
    },
    {
      countryName: "PANAMA",
      regionCode: 6,
      regionName: "HERRERA",
    },
    {
      countryName: "PANAMA",
      regionCode: 7,
      regionName: "LOS SANTOS",
    },
    {
      countryName: "PANAMA",
      regionCode: 8,
      regionName: "PANAMA",
    },
    {
      countryName: "PANAMA",
      regionCode: 9,
      regionName: "VERAGUAS",
    },
    {
      countryName: "PAPUA NEW GUINEA",
      regionCode: "CPK",
      regionName: "CHIMBU",
    },
    {
      countryName: "PAPUA NEW GUINEA",
      regionCode: "CPM",
      regionName: "CENTRAL",
    },
    {
      countryName: "PAPUA NEW GUINEA",
      regionCode: "EBR",
      regionName: "EAST NEW BRITAIN",
    },
    {
      countryName: "PAPUA NEW GUINEA",
      regionCode: "EHG",
      regionName: "EASTERN HIGHLANDS",
    },
    {
      countryName: "PAPUA NEW GUINEA",
      regionCode: "EPW",
      regionName: "ENGA",
    },
    {
      countryName: "PAPUA NEW GUINEA",
      regionCode: "ESW",
      regionName: "EAST SEPIK",
    },
    {
      countryName: "PAPUA NEW GUINEA",
      regionCode: "GPK",
      regionName: "GULF",
    },
    {
      countryName: "PAPUA NEW GUINEA",
      regionCode: "MBA",
      regionName: "MILNE BAY",
    },
    {
      countryName: "PAPUA NEW GUINEA",
      regionCode: "MPL",
      regionName: "MOROBE",
    },
    {
      countryName: "PAPUA NEW GUINEA",
      regionCode: "MPM",
      regionName: "MADANG",
    },
    {
      countryName: "PAPUA NEW GUINEA",
      regionCode: "MRL",
      regionName: "MANUS",
    },
    {
      countryName: "PAPUA NEW GUINEA",
      regionCode: "NCD",
      regionName: "NATIONAL CAPITAL DISTRICT",
    },
    {
      countryName: "PAPUA NEW GUINEA",
      regionCode: "NIK",
      regionName: "NEW IRELAND",
    },
    {
      countryName: "PAPUA NEW GUINEA",
      regionCode: "NPP",
      regionName: "NORTHERN",
    },
    {
      countryName: "PAPUA NEW GUINEA",
      regionCode: "NSA",
      regionName: "NORTH SOLOMONS (BOUGAINVILLE)",
    },
    {
      countryName: "PAPUA NEW GUINEA",
      regionCode: "SAN",
      regionName: "SANDAUN (WEST SEPIK)",
    },
    {
      countryName: "PAPUA NEW GUINEA",
      regionCode: "SHM",
      regionName: "SOUTHERN HIGHLANDS",
    },
    {
      countryName: "PAPUA NEW GUINEA",
      regionCode: "WBK",
      regionName: "WEST NEW BRITAIN",
    },
    {
      countryName: "PAPUA NEW GUINEA",
      regionCode: "WHM",
      regionName: "WESTERN HIGHLANDS",
    },
    {
      countryName: "PAPUA NEW GUINEA",
      regionCode: "WPD",
      regionName: "WESTERN",
    },
    {
      countryName: "PARAGUAY",
      regionCode: 16,
      regionName: "ALTO PARAGUAY",
    },
    {
      countryName: "PARAGUAY",
      regionCode: 10,
      regionName: "ALTO PARANA",
    },
    {
      countryName: "PARAGUAY",
      regionCode: 13,
      regionName: "AMAMBAY",
    },
    {
      countryName: "PARAGUAY",
      regionCode: "ASU",
      regionName: "ASUNCION",
    },
    {
      countryName: "PARAGUAY",
      regionCode: 19,
      regionName: "BOQUERON",
    },
    {
      countryName: "PARAGUAY",
      regionCode: 5,
      regionName: "CAAGUAZU",
    },
    {
      countryName: "PARAGUAY",
      regionCode: 6,
      regionName: "CAAZAPA",
    },
    {
      countryName: "PARAGUAY",
      regionCode: 14,
      regionName: "CANINDEYU",
    },
    {
      countryName: "PARAGUAY",
      regionCode: 11,
      regionName: "CENTRAL",
    },
    {
      countryName: "PARAGUAY",
      regionCode: 1,
      regionName: "CONCEPCION",
    },
    {
      countryName: "PARAGUAY",
      regionCode: 3,
      regionName: "CORDILLERA",
    },
    {
      countryName: "PARAGUAY",
      regionCode: 4,
      regionName: "GUAIRA",
    },
    {
      countryName: "PARAGUAY",
      regionCode: 7,
      regionName: "ITAPUA",
    },
    {
      countryName: "PARAGUAY",
      regionCode: 8,
      regionName: "MISIONES",
    },
    {
      countryName: "PARAGUAY",
      regionCode: 12,
      regionName: "NEEMBUCU",
    },
    {
      countryName: "PARAGUAY",
      regionCode: 9,
      regionName: "PARAGUARI",
    },
    {
      countryName: "PARAGUAY",
      regionCode: 15,
      regionName: "PRESIDENTE HAYES",
    },
    {
      countryName: "PARAGUAY",
      regionCode: 2,
      regionName: "SAN PEDRO",
    },
    {
      countryName: "PERU",
      regionCode: "AMA",
      regionName: "AMAZONAS",
    },
    {
      countryName: "PERU",
      regionCode: "ANC",
      regionName: "ANCASH",
    },
    {
      countryName: "PERU",
      regionCode: "APU",
      regionName: "APURIMAC",
    },
    {
      countryName: "PERU",
      regionCode: "ARE",
      regionName: "AREQUIPA",
    },
    {
      countryName: "PERU",
      regionCode: "AYA",
      regionName: "AYACUCHO",
    },
    {
      countryName: "PERU",
      regionCode: "CAJ",
      regionName: "CAJAMARCA",
    },
    {
      countryName: "PERU",
      regionCode: "CUS",
      regionName: "CUZCO",
    },
    {
      countryName: "PERU",
      regionCode: "CAL",
      regionName: "EL CALLAO",
    },
    {
      countryName: "PERU",
      regionCode: "HUV",
      regionName: "HUANCAVELICA",
    },
    {
      countryName: "PERU",
      regionCode: "HUC",
      regionName: "HUANUCO",
    },
    {
      countryName: "PERU",
      regionCode: "ICA",
      regionName: "ICA",
    },
    {
      countryName: "PERU",
      regionCode: "JUN",
      regionName: "JUNIN",
    },
    {
      countryName: "PERU",
      regionCode: "LAL",
      regionName: "LA LIBERTAD",
    },
    {
      countryName: "PERU",
      regionCode: "LAM",
      regionName: "LAMBAYEQUE",
    },
    {
      countryName: "PERU",
      regionCode: "LIM",
      regionName: "LIMA",
    },
    {
      countryName: "PERU",
      regionCode: "LOR",
      regionName: "LORETO",
    },
    {
      countryName: "PERU",
      regionCode: "MDD",
      regionName: "MADRE DE DIOS",
    },
    {
      countryName: "PERU",
      regionCode: "MOQ",
      regionName: "MOQUEGUA",
    },
    {
      countryName: "PERU",
      regionCode: "PAS",
      regionName: "PASCO",
    },
    {
      countryName: "PERU",
      regionCode: "PIU",
      regionName: "PIURA",
    },
    {
      countryName: "PERU",
      regionCode: "PUN",
      regionName: "PUNO",
    },
    {
      countryName: "PERU",
      regionCode: "SAM",
      regionName: "SAN MARTIN",
    },
    {
      countryName: "PERU",
      regionCode: "TAC",
      regionName: "TACNA",
    },
    {
      countryName: "PERU",
      regionCode: "TUM",
      regionName: "TUMBES",
    },
    {
      countryName: "PERU",
      regionCode: "UCA",
      regionName: "UCAYALI",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "ABR",
      regionName: "ABRA",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "AGN",
      regionName: "AGUSAN DEL NORTE",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "AGS",
      regionName: "AGUSAN DEL SUR",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "AKL",
      regionName: "AKLAN",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "ALB",
      regionName: "ALBAY",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "ANT",
      regionName: "ANTIQUE",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "APA",
      regionName: "APAYAO",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "AUR",
      regionName: "AURORA",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "BAN",
      regionName: "BATAAN",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "BAS",
      regionName: "BASILAN",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "BEN",
      regionName: "BENGUET",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "BIL",
      regionName: "BILIRAN",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "BOH",
      regionName: "BOHOL",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "BTG",
      regionName: "BATANGAS",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "BTN",
      regionName: "BATANES",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "BUK",
      regionName: "BUKIDNON",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "BUL",
      regionName: "BULACAN",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "CAG",
      regionName: "CAGAYAN",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "CAM",
      regionName: "CAMIGUIN",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "CAN",
      regionName: "CAMARINES NORTE",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "CAP",
      regionName: "CAPIZ",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "CAS",
      regionName: "CAMARINES SUR",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "CAT",
      regionName: "CATANDUANES",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "CAV",
      regionName: "CAVITE",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "CEB",
      regionName: "CEBU",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "COM",
      regionName: "COMPOSTELA VALLEY",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "DAO",
      regionName: "DAVAO ORIENTAL",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "DAS",
      regionName: "DAVAO DEL SUR",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "DAV",
      regionName: "DAVAO DEL NORTE",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "EAS",
      regionName: "EASTERN SAMAR",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "GUI",
      regionName: "GUIMARAS",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "IFU",
      regionName: "IFUGAO",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "ILI",
      regionName: "ILOILO",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "ILN",
      regionName: "ILOCOS NORTE",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "ILS",
      regionName: "ILOCOS SUR",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "ISA",
      regionName: "ISABELA",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "KAL",
      regionName: "KALINGA",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "LAG",
      regionName: "LAGUNA",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "LAN",
      regionName: "LANAO DEL NORTE",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "LAS",
      regionName: "LANAO DEL SUR",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "LEY",
      regionName: "LEYTE",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "LUN",
      regionName: "LA UNION",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "MAD",
      regionName: "MARINDUQUE",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "MAG",
      regionName: "MAGUINDANAO",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "MAS",
      regionName: "MASBATE",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "MDC",
      regionName: "MINDORO OCCIDENTAL",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "MDR",
      regionName: "MINDORO ORIENTAL",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "MOU",
      regionName: "MOUNTAIN PROVINCE",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "MSC",
      regionName: "MISAMIS OCCIDENTAL",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "MSR",
      regionName: "MISAMIS ORIENTAL",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "NCO",
      regionName: "NORTH COTABATO",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "NEC",
      regionName: "NEGROS OCCIDENTAL",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "NER",
      regionName: "NEGROS ORIENTAL",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "NSA",
      regionName: "NORTHERN SAMAR",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "NUE",
      regionName: "NUEVA ECIJA",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "NUV",
      regionName: "NUEVA VIZCAYA",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "PAM",
      regionName: "PAMPANGA",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "PAN",
      regionName: "PANGASINAN",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "PLW",
      regionName: "PALAWAN",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "QUE",
      regionName: "QUEZON",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "QUI",
      regionName: "QUIRINO",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "RIZ",
      regionName: "RIZAL",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "ROM",
      regionName: "ROMBLON",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "SAR",
      regionName: "SARANGANI",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "SCO",
      regionName: "SOUTH COTABATO",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "SIG",
      regionName: "SIQUIJOR",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "SLE",
      regionName: "SOUTHERN LEYTE",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "SLU",
      regionName: "SULU",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "SOR",
      regionName: "SORSOGON",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "SUK",
      regionName: "SULTAN KUDARAT",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "SUN",
      regionName: "SURIGAO DEL NORTE",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "SUR",
      regionName: "SURIGAO DEL SUR",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "TAR",
      regionName: "TARLAC",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "TAW",
      regionName: "TAWI-TAWI",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "WSA",
      regionName: "WESTERN SAMAR",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "ZAN",
      regionName: "ZAMBOANGA DEL NORTE",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "ZAS",
      regionName: "ZAMBOANGA DEL SUR",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "ZMB",
      regionName: "ZAMBALES",
    },
    {
      countryName: "PHILIPPINES (THE)",
      regionCode: "ZSI",
      regionName: "ZAMBOANGA SIBUGUEY",
    },
    {
      countryName: "PITCAIRN",
      regionCode: "PN",
      regionName: "PITCAIRN",
    },
    {
      countryName: "POLAND",
      regionCode: "DS",
      regionName: "DOLNOSLASKIE",
    },
    {
      countryName: "POLAND",
      regionCode: "KP",
      regionName: "KUJAWSKO-POMORSKIE",
    },
    {
      countryName: "POLAND",
      regionCode: "LB",
      regionName: "LUBUSKIE",
    },
    {
      countryName: "POLAND",
      regionCode: "LD",
      regionName: "LODZKIE",
    },
    {
      countryName: "POLAND",
      regionCode: "LU",
      regionName: "LUBELSKIE",
    },
    {
      countryName: "POLAND",
      regionCode: "MA",
      regionName: "MALOPOLSKIE",
    },
    {
      countryName: "POLAND",
      regionCode: "MZ",
      regionName: "MAZOWIECKIE",
    },
    {
      countryName: "POLAND",
      regionCode: "OP",
      regionName: "OPOLSKIE",
    },
    {
      countryName: "POLAND",
      regionCode: "PD",
      regionName: "PODLASKIE",
    },
    {
      countryName: "POLAND",
      regionCode: "PK",
      regionName: "PODKARPACKIE",
    },
    {
      countryName: "POLAND",
      regionCode: "PM",
      regionName: "POMORSKIE",
    },
    {
      countryName: "POLAND",
      regionCode: "SK",
      regionName: "SWIETOKRZYSKIE",
    },
    {
      countryName: "POLAND",
      regionCode: "SL",
      regionName: "SLASKIE",
    },
    {
      countryName: "POLAND",
      regionCode: "WN",
      regionName: "WARMINSKO-MAZURSKIE",
    },
    {
      countryName: "POLAND",
      regionCode: "WP",
      regionName: "WIELKOPOLSKIE",
    },
    {
      countryName: "POLAND",
      regionCode: "ZP",
      regionName: "ZACHODNIOPOMORSKIE",
    },
    {
      countryName: "PORTUGAL",
      regionCode: 1,
      regionName: "AVEIRO",
    },
    {
      countryName: "PORTUGAL",
      regionCode: 2,
      regionName: "BEJA",
    },
    {
      countryName: "PORTUGAL",
      regionCode: 3,
      regionName: "BRAGA",
    },
    {
      countryName: "PORTUGAL",
      regionCode: 4,
      regionName: "BRAGANCA",
    },
    {
      countryName: "PORTUGAL",
      regionCode: 5,
      regionName: "CASTELO BRANCO",
    },
    {
      countryName: "PORTUGAL",
      regionCode: 6,
      regionName: "COIMBRA",
    },
    {
      countryName: "PORTUGAL",
      regionCode: 7,
      regionName: "EVORA",
    },
    {
      countryName: "PORTUGAL",
      regionCode: 8,
      regionName: "FARO",
    },
    {
      countryName: "PORTUGAL",
      regionCode: 9,
      regionName: "GUARDA",
    },
    {
      countryName: "PORTUGAL",
      regionCode: 10,
      regionName: "LEIRIA",
    },
    {
      countryName: "PORTUGAL",
      regionCode: 11,
      regionName: "LISBOA",
    },
    {
      countryName: "PORTUGAL",
      regionCode: 12,
      regionName: "PORTALEGRE",
    },
    {
      countryName: "PORTUGAL",
      regionCode: 13,
      regionName: "PORTO",
    },
    {
      countryName: "PORTUGAL",
      regionCode: 14,
      regionName: "SANTAREM",
    },
    {
      countryName: "PORTUGAL",
      regionCode: 15,
      regionName: "SETUBAL",
    },
    {
      countryName: "PORTUGAL",
      regionCode: 16,
      regionName: "VIANA DO CASTELO",
    },
    {
      countryName: "PORTUGAL",
      regionCode: 17,
      regionName: "VILA REAL",
    },
    {
      countryName: "PORTUGAL",
      regionCode: 18,
      regionName: "VISEU",
    },
    {
      countryName: "PORTUGAL",
      regionCode: 20,
      regionName: "REGIAO AUTONOMA DOS ACORES",
    },
    {
      countryName: "PORTUGAL",
      regionCode: 30,
      regionName: "REGIAO AUTONOMA DA MADEIRA",
    },
    {
      countryName: "PUERTO RICO",
      regionCode: "PR",
      regionName: "PUERTO RICO",
    },
    {
      countryName: "QATAR",
      regionCode: "DA",
      regionName: "AD DAWHAH",
    },
    {
      countryName: "QATAR",
      regionCode: "GH",
      regionName: "AL GHUWAYRIYAH",
    },
    {
      countryName: "QATAR",
      regionCode: "JU",
      regionName: "AL JUMAYLIYAH",
    },
    {
      countryName: "QATAR",
      regionCode: "KH",
      regionName: "AL KHAWR",
    },
    {
      countryName: "QATAR",
      regionCode: "WA",
      regionName: "AL WAKRAH",
    },
    {
      countryName: "QATAR",
      regionCode: "RA",
      regionName: "AR RAYYAN",
    },
    {
      countryName: "QATAR",
      regionCode: "JB",
      regionName: "JARIYAN AL BATNAH",
    },
    {
      countryName: "QATAR",
      regionCode: "MS",
      regionName: "MADINAT ASH SHAMAL",
    },
    {
      countryName: "QATAR",
      regionCode: "US",
      regionName: "UMM SALAL",
    },
    {
      countryName: "REUNION",
      regionCode: "RE",
      regionName: "REUNION",
    },
    {
      countryName: "ROMANIA",
      regionCode: "AB",
      regionName: "ALBA",
    },
    {
      countryName: "ROMANIA",
      regionCode: "AG",
      regionName: "ARGES",
    },
    {
      countryName: "ROMANIA",
      regionCode: "AR",
      regionName: "ARAD",
    },
    {
      countryName: "ROMANIA",
      regionCode: "B",
      regionName: "BUCURESTI",
    },
    {
      countryName: "ROMANIA",
      regionCode: "BC",
      regionName: "BACAU",
    },
    {
      countryName: "ROMANIA",
      regionCode: "BH",
      regionName: "BIHOR",
    },
    {
      countryName: "ROMANIA",
      regionCode: "BN",
      regionName: "BISTRITA-NASAUD",
    },
    {
      countryName: "ROMANIA",
      regionCode: "BR",
      regionName: "BRAILA",
    },
    {
      countryName: "ROMANIA",
      regionCode: "BT",
      regionName: "BOTOSANI",
    },
    {
      countryName: "ROMANIA",
      regionCode: "BV",
      regionName: "BRASOV",
    },
    {
      countryName: "ROMANIA",
      regionCode: "BZ",
      regionName: "BUZAU",
    },
    {
      countryName: "ROMANIA",
      regionCode: "CJ",
      regionName: "CLUJ",
    },
    {
      countryName: "ROMANIA",
      regionCode: "CL",
      regionName: "CALARASI",
    },
    {
      countryName: "ROMANIA",
      regionCode: "CS",
      regionName: "CARAS-SEVERIN",
    },
    {
      countryName: "ROMANIA",
      regionCode: "CT",
      regionName: "CONSTANTA",
    },
    {
      countryName: "ROMANIA",
      regionCode: "CV",
      regionName: "COVASNA",
    },
    {
      countryName: "ROMANIA",
      regionCode: "DB",
      regionName: "DAMBOVITA",
    },
    {
      countryName: "ROMANIA",
      regionCode: "DJ",
      regionName: "DOLJ",
    },
    {
      countryName: "ROMANIA",
      regionCode: "GJ",
      regionName: "GORJJ",
    },
    {
      countryName: "ROMANIA",
      regionCode: "GL",
      regionName: "GALATI",
    },
    {
      countryName: "ROMANIA",
      regionCode: "GR",
      regionName: "GIURGIU",
    },
    {
      countryName: "ROMANIA",
      regionCode: "HD",
      regionName: "HUNEDOARA",
    },
    {
      countryName: "ROMANIA",
      regionCode: "HR",
      regionName: "HARGHITA",
    },
    {
      countryName: "ROMANIA",
      regionCode: "IF",
      regionName: "ILFOV",
    },
    {
      countryName: "ROMANIA",
      regionCode: "IL",
      regionName: "IALOMITA",
    },
    {
      countryName: "ROMANIA",
      regionCode: "IS",
      regionName: "IASIS",
    },
    {
      countryName: "ROMANIA",
      regionCode: "MH",
      regionName: "MEHEDINTI",
    },
    {
      countryName: "ROMANIA",
      regionCode: "MM",
      regionName: "MARAMURES",
    },
    {
      countryName: "ROMANIA",
      regionCode: "MS",
      regionName: "MURES",
    },
    {
      countryName: "ROMANIA",
      regionCode: "NT",
      regionName: "NEAMT",
    },
    {
      countryName: "ROMANIA",
      regionCode: "OT",
      regionName: "OLT",
    },
    {
      countryName: "ROMANIA",
      regionCode: "PH",
      regionName: "PRAHOVA",
    },
    {
      countryName: "ROMANIA",
      regionCode: "SB",
      regionName: "SIBIU",
    },
    {
      countryName: "ROMANIA",
      regionCode: "SJ",
      regionName: "SALAJ",
    },
    {
      countryName: "ROMANIA",
      regionCode: "SM",
      regionName: "SATU MARE",
    },
    {
      countryName: "ROMANIA",
      regionCode: "SV",
      regionName: "SUCEAVA",
    },
    {
      countryName: "ROMANIA",
      regionCode: "TL",
      regionName: "TULCEA",
    },
    {
      countryName: "ROMANIA",
      regionCode: "TM",
      regionName: "TIMIS",
    },
    {
      countryName: "ROMANIA",
      regionCode: "TR",
      regionName: "TELEORMAN",
    },
    {
      countryName: "ROMANIA",
      regionCode: "VL",
      regionName: "VALCEA",
    },
    {
      countryName: "ROMANIA",
      regionCode: "VN",
      regionName: "VRANCEA",
    },
    {
      countryName: "ROMANIA",
      regionCode: "VS",
      regionName: "VASLUI",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "AD",
      regionName: "ADYGEYA RESPUBLIKA",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "AL",
      regionName: "ALTAY RESPUBLIKA",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "ALT",
      regionName: "ALTAYSKIY KRAY",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "AMU",
      regionName: "AMURSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "ARK",
      regionName: "ARKHANGEL‘SKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "AST",
      regionName: "ASTRAKHANSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "AGB",
      regionName: "AGINSKIY BURYATSKIY AVTONOMNYY OKRUG",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "BA",
      regionName: "BASHKORTOSTAN RESPUBLIKA",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "BEL",
      regionName: "BELGORODSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "BRY",
      regionName: "BRYANSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "BU",
      regionName: "BURYATIYA RESPUBLIKA",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "CE",
      regionName: "CHECHENSKAYA RESPUBLIKA",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "CHE",
      regionName: "CHELYABINSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "CHI",
      regionName: "CHITINSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "CHU",
      regionName: "CHUKOTSKIY AVTONOMNYY OKRUG",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "CU",
      regionName: "CHUVASHSKAYA RESPUBLIKA",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "DA",
      regionName: "DAGESTAN RESPUBLIKA",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "IN",
      regionName: "INGUSHETIYA RESPUBLIKA",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "IRK",
      regionName: "IRKUTSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "IVA",
      regionName: "IVANOVSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "KAM",
      regionName: "KAMCHATSKIY KRAY",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "KB",
      regionName: "KABARDINO-BALKARSKAYA  RESPUBLIKA",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "KC",
      regionName: "KARACHAYEVO-CHERKESSKAYA     RESPUBLIKA",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "KDA",
      regionName: "KRASNODARSKIY KRAY",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "KEM",
      regionName: "KEMEROVSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "KGD",
      regionName: "KALININGRADSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "KGN",
      regionName: "KURGANSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "KHA",
      regionName: "KHABAROVSKIY KRAY",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "KHM",
      regionName: "KHANTY-MANSIYSKIY AVTONOMNYY  OKRUG",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "KIR",
      regionName: "KIROVSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "KK",
      regionName: "KHAKASIYA RESPUBLIKA",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "KL",
      regionName: "KALMYKIYA RESPUBLIKA",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "KLU",
      regionName: "KALUZHSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "KO",
      regionName: "KOMI RESPUBLIKA",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "KOS",
      regionName: "KOSTROMSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "KR",
      regionName: "KARELIYA RESPUBLIKA",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "KRS",
      regionName: "KURSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "KYA",
      regionName: "KRASNOYARSKIY KRAY",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "LEN",
      regionName: "LENINGRADSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "LIP",
      regionName: "LIPETSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "MAG",
      regionName: "MAGADANSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "ME",
      regionName: "MARIY EL RESPUBLIKA",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "MO",
      regionName: "MORDOVIYA RESPUBLIKA",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "MOS",
      regionName: "MOSKOVSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "MOW",
      regionName: "MOSKVA",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "MUR",
      regionName: "MURMANSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "NEN",
      regionName: "NENETSKIY AVTONOMNYY OKRUG",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "NGR",
      regionName: "NOVGORODSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "NIZ",
      regionName: "NIZHEGORODSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "NVS",
      regionName: "NOVOSIBIRSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "OMS",
      regionName: "OMSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "ORE",
      regionName: "ORENBURGSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "ORL",
      regionName: "ORLOVSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "PER",
      regionName: "PERMSKIY KRAY",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "PNZ",
      regionName: "PENZENSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "PRI",
      regionName: "PRIMORSKIY KRAY",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "PSK",
      regionName: "PSKOVSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "ROS",
      regionName: "ROSTOVSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "RYA",
      regionName: "RYAZANSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "SA",
      regionName: "SAKHA RESPUBLIKA",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "SAK",
      regionName: "SAKHALINSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "SAM",
      regionName: "SAMARSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "SAR",
      regionName: "SARATOVSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "SE",
      regionName: "SEVERNAYA OSETIYA-ALANIYA",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "SMO",
      regionName: "SMOLENSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "SPE",
      regionName: "SANKT-PETERBURG",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "STA",
      regionName: "STAVROPOL’SKIY KRAY",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "SVE",
      regionName: "SVERDLOVSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "TA",
      regionName: "TATARSTAN RESPUBLIKA",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "TAM",
      regionName: "TAMBOVSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "TOM",
      regionName: "TOMSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "TUL",
      regionName: "TUL’SKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "TVE",
      regionName: "TVERSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "TY",
      regionName: "TYVA RESPUBLIKA",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "TYU",
      regionName: "TYUMENSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "UD",
      regionName: "UDMURTSKAYA RESPUBLIKA",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "ULY",
      regionName: "UL’YANOVSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "UOB",
      regionName: "UST’-ORDYNSKIY BURYATSKIY",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "VGG",
      regionName: "VOLGOGRADSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "VLA",
      regionName: "VLADIMIRSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "VLG",
      regionName: "VOLOGODSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "VOR",
      regionName: "VORONEZHSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "YAN",
      regionName: "YAMALO-NENETSKIY AVTONOMNYY  OKRUG",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "YAR",
      regionName: "YAROSLAVSKAYA OBLAST",
    },
    {
      countryName: "RUSSIAN FEDERATION (THE)",
      regionCode: "YEV",
      regionName: "YEVREYSKAYA AVTONOMNAYA OBLAST",
    },
    {
      countryName: "RWANDA",
      regionCode: 2,
      regionName: "EST",
    },
    {
      countryName: "RWANDA",
      regionCode: 3,
      regionName: "NORD",
    },
    {
      countryName: "RWANDA",
      regionCode: 4,
      regionName: "OUEST",
    },
    {
      countryName: "RWANDA",
      regionCode: 5,
      regionName: "SUD",
    },
    {
      countryName: "RWANDA",
      regionCode: 1,
      regionName: "VILLE DE KIGALI",
    },
    {
      countryName: "ST. BARTHELEMY",
      regionCode: "BL",
      regionName: "SAINT BARTHELEMY",
    },
    {
      countryName: "ST. HELENA",
      regionCode: "SH",
      regionName: "SAINT HELENA",
    },
    {
      countryName: "ST. KITTS-NEVIS",
      regionCode: 1,
      regionName: "CHRIST CHURCH NICHOLA TOWN",
    },
    {
      countryName: "ST. KITTS-NEVIS",
      regionCode: 2,
      regionName: "SAINT ANNE SANDY POINT",
    },
    {
      countryName: "ST. KITTS-NEVIS",
      regionCode: 3,
      regionName: "SAINT GEORGE BASSETERRE",
    },
    {
      countryName: "ST. KITTS-NEVIS",
      regionCode: 4,
      regionName: "SAINT GEORGE GINGERLAND",
    },
    {
      countryName: "ST. KITTS-NEVIS",
      regionCode: 5,
      regionName: "SAINT JAMES WINDWARD",
    },
    {
      countryName: "ST. KITTS-NEVIS",
      regionCode: 6,
      regionName: "SAINT JOHN CAPISTERRE",
    },
    {
      countryName: "ST. KITTS-NEVIS",
      regionCode: 7,
      regionName: "SAINT JOHN FIGTREE",
    },
    {
      countryName: "ST. KITTS-NEVIS",
      regionCode: 8,
      regionName: "SAINT MARY CAYON",
    },
    {
      countryName: "ST. KITTS-NEVIS",
      regionCode: 9,
      regionName: "SAINT PAUL CAPISTERRE",
    },
    {
      countryName: "ST. KITTS-NEVIS",
      regionCode: 10,
      regionName: "SAINT PAUL CHARLESTOWN",
    },
    {
      countryName: "ST. KITTS-NEVIS",
      regionCode: 11,
      regionName: "SAINT PETER BASSETERRE",
    },
    {
      countryName: "ST. KITTS-NEVIS",
      regionCode: 12,
      regionName: "SAINT THOMAS LOWLAND",
    },
    {
      countryName: "ST. KITTS-NEVIS",
      regionCode: 13,
      regionName: "SAINT THOMAS MIDDLE ISLAND",
    },
    {
      countryName: "ST. KITTS-NEVIS",
      regionCode: 15,
      regionName: "TRINITY PALMETTO POINT",
    },
    {
      countryName: "ST. LUCIA",
      regionCode: 1,
      regionName: "ANSE LA RAYE",
    },
    {
      countryName: "ST. LUCIA",
      regionCode: 2,
      regionName: "CASTRIES",
    },
    {
      countryName: "ST. LUCIA",
      regionCode: 3,
      regionName: "CHOISEUL",
    },
    {
      countryName: "ST. LUCIA",
      regionCode: 4,
      regionName: "DAUPHIN",
    },
    {
      countryName: "ST. LUCIA",
      regionCode: 5,
      regionName: "DENNERY",
    },
    {
      countryName: "ST. LUCIA",
      regionCode: 6,
      regionName: "GROS ISLET",
    },
    {
      countryName: "ST. LUCIA",
      regionCode: 7,
      regionName: "LABORIE",
    },
    {
      countryName: "ST. LUCIA",
      regionCode: 8,
      regionName: "MICOUD",
    },
    {
      countryName: "ST. LUCIA",
      regionCode: 9,
      regionName: "PRASLIN",
    },
    {
      countryName: "ST. LUCIA",
      regionCode: 10,
      regionName: "SOUFRIERE",
    },
    {
      countryName: "ST. LUCIA",
      regionCode: 11,
      regionName: "VIEUX FORT",
    },
    {
      countryName: "ST. MARTIN",
      regionCode: "MF",
      regionName: "SAINT MARTIN",
    },
    {
      countryName: "ST. PIERRE AND MIQUELON",
      regionCode: "PM",
      regionName: "SAINT PIERRE AND MIQUELON",
    },
    {
      countryName: "ST. VINCENT AND THE GRENADINES",
      regionCode: 1,
      regionName: "CHARLOTTE",
    },
    {
      countryName: "ST. VINCENT AND THE GRENADINES",
      regionCode: 6,
      regionName: "GRENADINES",
    },
    {
      countryName: "ST. VINCENT AND THE GRENADINES",
      regionCode: 2,
      regionName: "SAINT ANDREW",
    },
    {
      countryName: "ST. VINCENT AND THE GRENADINES",
      regionCode: 3,
      regionName: "SAINT DAVID",
    },
    {
      countryName: "ST. VINCENT AND THE GRENADINES",
      regionCode: 4,
      regionName: "SAINT GEORGE",
    },
    {
      countryName: "ST. VINCENT AND THE GRENADINES",
      regionCode: 5,
      regionName: "SAINT PATRICK",
    },
    {
      countryName: "SAMOA",
      regionCode: "AA",
      regionName: "AANA",
    },
    {
      countryName: "SAMOA",
      regionCode: "AL",
      regionName: "AIGA-I-LE-TAI",
    },
    {
      countryName: "SAMOA",
      regionCode: "AT",
      regionName: "ATUA",
    },
    {
      countryName: "SAMOA",
      regionCode: "FA",
      regionName: "FAASALELEAGA",
    },
    {
      countryName: "SAMOA",
      regionCode: "GE",
      regionName: "GAGAEMAUGA",
    },
    {
      countryName: "SAMOA",
      regionCode: "GI",
      regionName: "GAGAIFOMAUGA",
    },
    {
      countryName: "SAMOA",
      regionCode: "PA",
      regionName: "PALAULI",
    },
    {
      countryName: "SAMOA",
      regionCode: "SA",
      regionName: "SATUPAITEA",
    },
    {
      countryName: "SAMOA",
      regionCode: "TU",
      regionName: "TUAMASAGA",
    },
    {
      countryName: "SAMOA",
      regionCode: "VG",
      regionName: "VAA-O-FONOTI",
    },
    {
      countryName: "SAMOA",
      regionCode: "VS",
      regionName: "VAISIGANO",
    },
    {
      countryName: "SAN MARINO",
      regionCode: 1,
      regionName: "ACQUAVIVA",
    },
    {
      countryName: "SAN MARINO",
      regionCode: 6,
      regionName: "BORGO MAGGIORE",
    },
    {
      countryName: "SAN MARINO",
      regionCode: 2,
      regionName: "CHIESANUOVA",
    },
    {
      countryName: "SAN MARINO",
      regionCode: 3,
      regionName: "DOMAGNANO",
    },
    {
      countryName: "SAN MARINO",
      regionCode: 4,
      regionName: "FAETANO",
    },
    {
      countryName: "SAN MARINO",
      regionCode: 5,
      regionName: "FIORENTINO",
    },
    {
      countryName: "SAN MARINO",
      regionCode: 8,
      regionName: "MONTEGIARDINO",
    },
    {
      countryName: "SAN MARINO",
      regionCode: 7,
      regionName: "SAN MARINO",
    },
    {
      countryName: "SAN MARINO",
      regionCode: 9,
      regionName: "SERRAVALLE",
    },
    {
      countryName: "SAO TOME AND PRINCIPE",
      regionCode: "P",
      regionName: "PRINCIPE",
    },
    {
      countryName: "SAO TOME AND PRINCIPE",
      regionCode: "S",
      regionName: "SAO TOME",
    },
    {
      countryName: "SAUDI ARABIA",
      regionCode: 11,
      regionName: "AL BAHAH",
    },
    {
      countryName: "SAUDI ARABIA",
      regionCode: 8,
      regionName: "AL HUDUD ASH SHAMALIYAH",
    },
    {
      countryName: "SAUDI ARABIA",
      regionCode: 12,
      regionName: "AL JAWF",
    },
    {
      countryName: "SAUDI ARABIA",
      regionCode: 3,
      regionName: "AL MADINAH",
    },
    {
      countryName: "SAUDI ARABIA",
      regionCode: 5,
      regionName: "AL QASIM",
    },
    {
      countryName: "SAUDI ARABIA",
      regionCode: 1,
      regionName: "AR RIYAD",
    },
    {
      countryName: "SAUDI ARABIA",
      regionCode: 4,
      regionName: "ASH SHARQIYAH",
    },
    {
      countryName: "SAUDI ARABIA",
      regionCode: 14,
      regionName: "ASIR",
    },
    {
      countryName: "SAUDI ARABIA",
      regionCode: 6,
      regionName: "HA’IL",
    },
    {
      countryName: "SAUDI ARABIA",
      regionCode: 9,
      regionName: "JIZAN",
    },
    {
      countryName: "SAUDI ARABIA",
      regionCode: 2,
      regionName: "MAKKAH",
    },
    {
      countryName: "SAUDI ARABIA",
      regionCode: 10,
      regionName: "NAJRAN",
    },
    {
      countryName: "SAUDI ARABIA",
      regionCode: 7,
      regionName: "TABUK",
    },
    {
      countryName: "SENEGAL",
      regionCode: "DB",
      regionName: "DIOURBEL",
    },
    {
      countryName: "SENEGAL",
      regionCode: "DK",
      regionName: "DAKAR",
    },
    {
      countryName: "SENEGAL",
      regionCode: "FK",
      regionName: "FATICK",
    },
    {
      countryName: "SENEGAL",
      regionCode: "KD",
      regionName: "KOLDA",
    },
    {
      countryName: "SENEGAL",
      regionCode: "KL",
      regionName: "KAOLACK",
    },
    {
      countryName: "SENEGAL",
      regionCode: "LG",
      regionName: "LOUGA",
    },
    {
      countryName: "SENEGAL",
      regionCode: "MT",
      regionName: "MATAM",
    },
    {
      countryName: "SENEGAL",
      regionCode: "SL",
      regionName: "SAINT-LOUIS",
    },
    {
      countryName: "SENEGAL",
      regionCode: "TC",
      regionName: "TAMBACOUNDA",
    },
    {
      countryName: "SENEGAL",
      regionCode: "TH",
      regionName: "THIES",
    },
    {
      countryName: "SENEGAL",
      regionCode: "ZG",
      regionName: "ZIGUINCHOR",
    },
    {
      countryName: "SERBIA",
      regionCode: 0,
      regionName: "BEOGRAD",
    },
    {
      countryName: "SERBIA",
      regionCode: 14,
      regionName: "BOR",
    },
    {
      countryName: "SERBIA",
      regionCode: 11,
      regionName: "BRANICEVO",
    },
    {
      countryName: "SERBIA",
      regionCode: 23,
      regionName: "JABLANICA",
    },
    {
      countryName: "SERBIA",
      regionCode: 6,
      regionName: "JUZNA BACKA",
    },
    {
      countryName: "SERBIA",
      regionCode: 4,
      regionName: "JUZNI BANAT",
    },
    {
      countryName: "SERBIA",
      regionCode: 9,
      regionName: "KOLUBARA",
    },
    {
      countryName: "SERBIA",
      regionCode: 25,
      regionName: "KOSOVO",
    },
    {
      countryName: "SERBIA",
      regionCode: 29,
      regionName: "KOSOVO-POMORAVLJE",
    },
    {
      countryName: "SERBIA",
      regionCode: 28,
      regionName: "KOSOVSKA MITROVICA",
    },
    {
      countryName: "SERBIA",
      regionCode: 8,
      regionName: "MACVA",
    },
    {
      countryName: "SERBIA",
      regionCode: 17,
      regionName: "MORAVICA",
    },
    {
      countryName: "SERBIA",
      regionCode: 20,
      regionName: "NISAVA",
    },
    {
      countryName: "SERBIA",
      regionCode: 24,
      regionName: "PCINJA",
    },
    {
      countryName: "SERBIA",
      regionCode: 26,
      regionName: "PEC",
    },
    {
      countryName: "SERBIA",
      regionCode: 22,
      regionName: "PIROT",
    },
    {
      countryName: "SERBIA",
      regionCode: 10,
      regionName: "PODUNAVLJE",
    },
    {
      countryName: "SERBIA",
      regionCode: 13,
      regionName: "POMORAVLJE",
    },
    {
      countryName: "SERBIA",
      regionCode: 27,
      regionName: "PRIZREN",
    },
    {
      countryName: "SERBIA",
      regionCode: 19,
      regionName: "RASINA",
    },
    {
      countryName: "SERBIA",
      regionCode: 18,
      regionName: "RASKA",
    },
    {
      countryName: "SERBIA",
      regionCode: 1,
      regionName: "SEVERNA BACKA",
    },
    {
      countryName: "SERBIA",
      regionCode: 3,
      regionName: "SEVERNI BANAT",
    },
    {
      countryName: "SERBIA",
      regionCode: 2,
      regionName: "SREDNJI BANAT",
    },
    {
      countryName: "SERBIA",
      regionCode: 7,
      regionName: "SREM",
    },
    {
      countryName: "SERBIA",
      regionCode: 12,
      regionName: "SUMADIJA",
    },
    {
      countryName: "SERBIA",
      regionCode: 21,
      regionName: "TOPLICA",
    },
    {
      countryName: "SERBIA",
      regionCode: 15,
      regionName: "ZAJECAR",
    },
    {
      countryName: "SERBIA",
      regionCode: 5,
      regionName: "ZAPADNA BACKA",
    },
    {
      countryName: "SERBIA",
      regionCode: 16,
      regionName: "ZLATIBOR",
    },
    {
      countryName: "SEYCHELLES",
      regionCode: 1,
      regionName: "ANSE AUX PINS",
    },
    {
      countryName: "SEYCHELLES",
      regionCode: 2,
      regionName: "ANSE BOILEAU",
    },
    {
      countryName: "SEYCHELLES",
      regionCode: 3,
      regionName: "ANSE ETOILE",
    },
    {
      countryName: "SEYCHELLES",
      regionCode: 4,
      regionName: "ANSE LOUIS",
    },
    {
      countryName: "SEYCHELLES",
      regionCode: 5,
      regionName: "ANSE ROYALE",
    },
    {
      countryName: "SEYCHELLES",
      regionCode: 6,
      regionName: "BAIE LAZARE",
    },
    {
      countryName: "SEYCHELLES",
      regionCode: 7,
      regionName: "BAIE SAINTE ANNE",
    },
    {
      countryName: "SEYCHELLES",
      regionCode: 8,
      regionName: "BEAU VALLON",
    },
    {
      countryName: "SEYCHELLES",
      regionCode: 9,
      regionName: "BEL AIR",
    },
    {
      countryName: "SEYCHELLES",
      regionCode: 10,
      regionName: "BEL OMBRE",
    },
    {
      countryName: "SEYCHELLES",
      regionCode: 11,
      regionName: "CASCADE",
    },
    {
      countryName: "SEYCHELLES",
      regionCode: 12,
      regionName: "GLACIS",
    },
    {
      countryName: "SEYCHELLES",
      regionCode: 13,
      regionName: "GRAND ANSE (MAHE)",
    },
    {
      countryName: "SEYCHELLES",
      regionCode: 14,
      regionName: "GRAND ANSE (PRASLIN)",
    },
    {
      countryName: "SEYCHELLES",
      regionCode: 15,
      regionName: "LA DIGUE",
    },
    {
      countryName: "SEYCHELLES",
      regionCode: 16,
      regionName: "LA RIVIERE ANGLAISE",
    },
    {
      countryName: "SEYCHELLES",
      regionCode: 17,
      regionName: "MONT BUXTON",
    },
    {
      countryName: "SEYCHELLES",
      regionCode: 18,
      regionName: "MONT FLEURI",
    },
    {
      countryName: "SEYCHELLES",
      regionCode: 19,
      regionName: "PLAISANCE",
    },
    {
      countryName: "SEYCHELLES",
      regionCode: 20,
      regionName: "POINTE LA RUE",
    },
    {
      countryName: "SEYCHELLES",
      regionCode: 21,
      regionName: "PORT GLAUD",
    },
    {
      countryName: "SEYCHELLES",
      regionCode: 22,
      regionName: "SAINT LOUIS",
    },
    {
      countryName: "SEYCHELLES",
      regionCode: 23,
      regionName: "TAKAMAKA",
    },
    {
      countryName: "SIERRA LEONE",
      regionCode: "E",
      regionName: "EASTERN",
    },
    {
      countryName: "SIERRA LEONE",
      regionCode: "N",
      regionName: "NORTHERN",
    },
    {
      countryName: "SIERRA LEONE",
      regionCode: "S",
      regionName: "SOUTHERN",
    },
    {
      countryName: "SIERRA LEONE",
      regionCode: "W",
      regionName: "WESTERN AREA (FREETOWN)",
    },
    {
      countryName: "SINGAPORE",
      regionCode: 1,
      regionName: "CENTRAL SINGAPORE",
    },
    {
      countryName: "SINGAPORE",
      regionCode: 2,
      regionName: "NORTH EAST",
    },
    {
      countryName: "SINGAPORE",
      regionCode: 3,
      regionName: "NORTH WEST",
    },
    {
      countryName: "SINGAPORE",
      regionCode: 4,
      regionName: "SOUTH EAST",
    },
    {
      countryName: "SINGAPORE",
      regionCode: 5,
      regionName: "SOUTH WEST",
    },
    {
      countryName: "SINT MAARTEN (DUTCH PART)",
      regionCode: "SX",
      regionName: "SINT MAARTEN (DUTCH PART)",
    },
    {
      countryName: "SLOVAKIA",
      regionCode: "BC",
      regionName: "BANSKOBYSTRICKY KRAJ",
    },
    {
      countryName: "SLOVAKIA",
      regionCode: "BL",
      regionName: "BRATISLAVSKY KRAJ",
    },
    {
      countryName: "SLOVAKIA",
      regionCode: "KI",
      regionName: "KOSICKY KRAJ",
    },
    {
      countryName: "SLOVAKIA",
      regionCode: "NI",
      regionName: "NITRIANSKY KRAJ",
    },
    {
      countryName: "SLOVAKIA",
      regionCode: "PV",
      regionName: "PRESOVSKY KRAJ",
    },
    {
      countryName: "SLOVAKIA",
      regionCode: "TA",
      regionName: "TRNAVSKY KRAJ",
    },
    {
      countryName: "SLOVAKIA",
      regionCode: "TC",
      regionName: "TRENCIANSKY KRAJ",
    },
    {
      countryName: "SLOVAKIA",
      regionCode: "ZI",
      regionName: "ZILINSKY KRAJ",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 1,
      regionName: "AJDOVSCINA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 2,
      regionName: "BELTINCI",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 148,
      regionName: "BENEDIKT",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 149,
      regionName: "BISTRICA OB SOTLI",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 3,
      regionName: "BLED",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 150,
      regionName: "BLOKE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 4,
      regionName: "BOHINJ",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 5,
      regionName: "BOROVNICA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 6,
      regionName: "BOVEC",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 151,
      regionName: "BRASLOVCE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 7,
      regionName: "BRDA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 9,
      regionName: "BREZICE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 8,
      regionName: "BREZOVICA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 152,
      regionName: "CANKOVA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 11,
      regionName: "CELJE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 12,
      regionName: "CERKLJE NA GORENJSKEM",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 13,
      regionName: "CERKNICA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 14,
      regionName: "CERKNO",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 153,
      regionName: "CERKVENJAK",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 15,
      regionName: "CRENSOVCI",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 16,
      regionName: "CRNA NA KOROSKEM",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 17,
      regionName: "CRNOMELJ",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 18,
      regionName: "DESTRNIK",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 19,
      regionName: "DIVACA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 154,
      regionName: "DOBJE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 20,
      regionName: "DOBREPOLJE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 155,
      regionName: "DOBRNA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 21,
      regionName: "DOBROVA-HORJUL-POLHOV GRADEC",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 156,
      regionName: "DOBROVNIK/DOBRONAK",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 22,
      regionName: "DOL PRI LJUBLJANI",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 157,
      regionName: "DOLENJSKE TOPLICE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 23,
      regionName: "DOMZALE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 24,
      regionName: "DORNAVA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 25,
      regionName: "DRAVOGRAD",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 26,
      regionName: "DUPLEK",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 27,
      regionName: "GORENJA VAS-POLJANE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 28,
      regionName: "GORISNICA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 29,
      regionName: "GORNJA RADGONA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 30,
      regionName: "GORNJI GRAD",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 31,
      regionName: "GORNJI PETROVCI",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 158,
      regionName: "GRAD",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 32,
      regionName: "GROSUPLJE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 159,
      regionName: "HAJDINA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 160,
      regionName: "HOCE-SLIVNICA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 161,
      regionName: "HODOS/HODOS",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 162,
      regionName: "HORJUL",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 34,
      regionName: "HRASTNIK",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 35,
      regionName: "HRPELJE-KOZINA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 36,
      regionName: "IDRIJA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 37,
      regionName: "IG",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 38,
      regionName: "ILIRSKA BISTRICA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 39,
      regionName: "IVANCNA GORICA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 40,
      regionName: "IZOLA/ISOLA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 41,
      regionName: "JESENICE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 163,
      regionName: "JEZERSKO",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 42,
      regionName: "JURSINCI",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 43,
      regionName: "KAMNIK",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 44,
      regionName: "KANAL",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 45,
      regionName: "KIDRICEVO",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 46,
      regionName: "KOBARID",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 47,
      regionName: "KOBILJE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 48,
      regionName: "KOCEVJE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 49,
      regionName: "KOMEN",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 164,
      regionName: "KOMENDA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 50,
      regionName: "KOPER/CAPODISTRIA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 165,
      regionName: "KOSTEL",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 51,
      regionName: "KOZJE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 52,
      regionName: "KRANJ",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 53,
      regionName: "KRANJSKA GORA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 166,
      regionName: "KRIZEVCI",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 54,
      regionName: "KRSKO",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 55,
      regionName: "KUNGOTA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 56,
      regionName: "KUZMA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 57,
      regionName: "LASKO",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 58,
      regionName: "LENART",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 59,
      regionName: "LENDAVA/LENDVA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 60,
      regionName: "LITIJA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 61,
      regionName: "LJUBLJANA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 62,
      regionName: "LJUBNO",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 63,
      regionName: "LJUTOMER",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 64,
      regionName: "LOGATEC",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 65,
      regionName: "LOSKA DOLINA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 66,
      regionName: "LOSKI POTOK",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 167,
      regionName: "LOVRENC NA POHORJU",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 67,
      regionName: "LUCE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 68,
      regionName: "LUKOVICA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 69,
      regionName: "MAJSPERK",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 70,
      regionName: "MARIBOR",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 168,
      regionName: "MARKOVCI",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 71,
      regionName: "MEDVODE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 72,
      regionName: "MENGES",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 73,
      regionName: "METLIKA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 74,
      regionName: "MEZICA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 169,
      regionName: "MIKLAVZ NA DRAVSKEM POLJU",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 75,
      regionName: "MIREN-KOSTANJEVICA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 170,
      regionName: "MIRNA PEC",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 76,
      regionName: "MISLINJA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 77,
      regionName: "MORAVCE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 78,
      regionName: "MORAVSKE TOPLICE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 79,
      regionName: "MOZIRJE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 80,
      regionName: "MURSKA SOBOTA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 81,
      regionName: "MUTA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 82,
      regionName: "NAKLO",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 83,
      regionName: "NAZARJE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 84,
      regionName: "NOVA GORIVA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 85,
      regionName: "NOVO MESTO",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 86,
      regionName: "ODRANCI",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 171,
      regionName: "OPLOTNICA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 87,
      regionName: "ORMOZ",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 88,
      regionName: "OSILNICA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 89,
      regionName: "PESNICA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 90,
      regionName: "PIRAN/PIRANO",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 91,
      regionName: "PIVKA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 92,
      regionName: "PODCETRTEK",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 172,
      regionName: "PODLEHNIK",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 93,
      regionName: "PODVELKA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 173,
      regionName: "POLZELA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 94,
      regionName: "POSTOJNA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 174,
      regionName: "PREBOLD",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 95,
      regionName: "PREDDVOR",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 175,
      regionName: "PREVALJE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 96,
      regionName: "PTUJ",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 97,
      regionName: "PUCONCI",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 98,
      regionName: "RACE-FRAM",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 99,
      regionName: "RADECE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 100,
      regionName: "RADENCI",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 101,
      regionName: "RADLJE OB DRAVI",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 102,
      regionName: "RADOVLJICA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 103,
      regionName: "RAVNE NA KOROSKEM",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 176,
      regionName: "RAZKRIZJE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 104,
      regionName: "RIBNICA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 177,
      regionName: "RIBNICA NA POHORJU",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 106,
      regionName: "ROGASKA SLATINA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 105,
      regionName: "ROGASOVCI",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 107,
      regionName: "ROGATEC",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 108,
      regionName: "RUSE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 33,
      regionName: "SALOVCI",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 178,
      regionName: "SELNICA OB DRAVI",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 109,
      regionName: "SEMIC",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 183,
      regionName: "SEMPETER-VRTOJBA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 117,
      regionName: "SENCUR",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 118,
      regionName: "SENTILJ",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 119,
      regionName: "SENTJERNEJ",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 120,
      regionName: "SENTJUR PRI CELJU",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 110,
      regionName: "SEVNICA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 111,
      regionName: "SEZANA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 121,
      regionName: "SKOCJAN",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 122,
      regionName: "SKOFJA LOKA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 123,
      regionName: "SKOFLJICA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 112,
      regionName: "SLOVENJ GRADEC",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 113,
      regionName: "SLOVENSKA BISTRICA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 114,
      regionName: "SLOVENSKE KONJICE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 124,
      regionName: "SMARJE PRI JELSAH",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 125,
      regionName: "SMARTNO OB PAKI",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 194,
      regionName: "SMARTNO PRI LITIJI",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 179,
      regionName: "SODRAZICA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 180,
      regionName: "SOLCAVA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 126,
      regionName: "SOSTANJ",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 115,
      regionName: "STARSE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 127,
      regionName: "STORE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 181,
      regionName: "SVETA ANA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 182,
      regionName: "SVETI ANDRAZ V SLOVENSKIH GORI",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 116,
      regionName: "SVETI JURIJ",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 184,
      regionName: "TABOR",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 10,
      regionName: "TISINA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 128,
      regionName: "TOLMIN",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 129,
      regionName: "TRBOVLJE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 130,
      regionName: "TREBNJE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 185,
      regionName: "TRNOVSKA VAS",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 131,
      regionName: "TRZIC",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 186,
      regionName: "TRZIN",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 132,
      regionName: "TURNISCE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 133,
      regionName: "VELENJE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 187,
      regionName: "VELIKA POLANA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 134,
      regionName: "VELIKE LASCE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 188,
      regionName: "VERZEJ",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 135,
      regionName: "VIDEM",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 136,
      regionName: "VIPAVA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 137,
      regionName: "VITANJE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 138,
      regionName: "VODICE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 139,
      regionName: "VOJNIK",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 189,
      regionName: "VRANSKO",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 140,
      regionName: "VRHNIKA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 141,
      regionName: "VUZENICA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 142,
      regionName: "ZAGORJE OB SAVI",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 190,
      regionName: "ZALEC",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 143,
      regionName: "ZAVRC",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 146,
      regionName: "ZELEZNIKI",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 191,
      regionName: "ZETALE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 147,
      regionName: "ZIRI",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 192,
      regionName: "ZIROVNICA",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 144,
      regionName: "ZRECE",
    },
    {
      countryName: "SLOVENIA",
      regionCode: 193,
      regionName: "ZUZEMBERK",
    },
    {
      countryName: "SOLOMON ISLANDS",
      regionCode: "CE",
      regionName: "CENTRAL",
    },
    {
      countryName: "SOLOMON ISLANDS",
      regionCode: "CH",
      regionName: "CHOISEUL",
    },
    {
      countryName: "SOLOMON ISLANDS",
      regionCode: "CT",
      regionName: "CAPITAL TERRITORY",
    },
    {
      countryName: "SOLOMON ISLANDS",
      regionCode: "GU",
      regionName: "GUADALCANAL",
    },
    {
      countryName: "SOLOMON ISLANDS",
      regionCode: "IS",
      regionName: "ISABEL",
    },
    {
      countryName: "SOLOMON ISLANDS",
      regionCode: "MK",
      regionName: "MAKIRA-ULAWA",
    },
    {
      countryName: "SOLOMON ISLANDS",
      regionCode: "ML",
      regionName: "MALAITA",
    },
    {
      countryName: "SOLOMON ISLANDS",
      regionCode: "RB",
      regionName: "RENNELL AND BELLONA",
    },
    {
      countryName: "SOLOMON ISLANDS",
      regionCode: "TE",
      regionName: "TEMOTU",
    },
    {
      countryName: "SOLOMON ISLANDS",
      regionCode: "WE",
      regionName: "WESTERN",
    },
    {
      countryName: "SOMALIA",
      regionCode: "AW",
      regionName: "AWDAL",
    },
    {
      countryName: "SOMALIA",
      regionCode: "BK",
      regionName: "BAKOOL",
    },
    {
      countryName: "SOMALIA",
      regionCode: "BN",
      regionName: "BANAADIR",
    },
    {
      countryName: "SOMALIA",
      regionCode: "BR",
      regionName: "BARI",
    },
    {
      countryName: "SOMALIA",
      regionCode: "BY",
      regionName: "BAY",
    },
    {
      countryName: "SOMALIA",
      regionCode: "GA",
      regionName: "GALGUDUUD",
    },
    {
      countryName: "SOMALIA",
      regionCode: "GE",
      regionName: "GEDO",
    },
    {
      countryName: "SOMALIA",
      regionCode: "HI",
      regionName: "HIIRAAN",
    },
    {
      countryName: "SOMALIA",
      regionCode: "JD",
      regionName: "JUBBADA DHEXE",
    },
    {
      countryName: "SOMALIA",
      regionCode: "JH",
      regionName: "JUBBADA HOOSE",
    },
    {
      countryName: "SOMALIA",
      regionCode: "MU",
      regionName: "MUDUG",
    },
    {
      countryName: "SOMALIA",
      regionCode: "NU",
      regionName: "NUGAAL",
    },
    {
      countryName: "SOMALIA",
      regionCode: "SA",
      regionName: "SANAAG",
    },
    {
      countryName: "SOMALIA",
      regionCode: "SD",
      regionName: "SHABEELLAHA DHEXE",
    },
    {
      countryName: "SOMALIA",
      regionCode: "SH",
      regionName: "SHABEELLAHA HOOSE",
    },
    {
      countryName: "SOMALIA",
      regionCode: "SO",
      regionName: "SOOL",
    },
    {
      countryName: "SOMALIA",
      regionCode: "TO",
      regionName: "TOGDHEER",
    },
    {
      countryName: "SOMALIA",
      regionCode: "WO",
      regionName: "WOQOOYI GALBEED",
    },
    {
      countryName: "SOUTH AFRICA",
      regionCode: "EC",
      regionName: "EASTERN CAPE",
    },
    {
      countryName: "SOUTH AFRICA",
      regionCode: "FS",
      regionName: "FREE STATE",
    },
    {
      countryName: "SOUTH AFRICA",
      regionCode: "GT",
      regionName: "GAUTENG",
    },
    {
      countryName: "SOUTH AFRICA",
      regionCode: "LP",
      regionName: "LIMPOPO",
    },
    {
      countryName: "SOUTH AFRICA",
      regionCode: "MP",
      regionName: "MPUMALANGA",
    },
    {
      countryName: "SOUTH AFRICA",
      regionCode: "NC",
      regionName: "NORTHERN CAPE",
    },
    {
      countryName: "SOUTH AFRICA",
      regionCode: "NL",
      regionName: "KWAZULU-NATAL",
    },
    {
      countryName: "SOUTH AFRICA",
      regionCode: "NW",
      regionName: "NORTH-WEST",
    },
    {
      countryName: "SOUTH AFRICA",
      regionCode: "WC",
      regionName: "WESTERN CAPE",
    },
    {
      countryName: "SOUTH GEORGIA & SOUTH SANDWICH",
      regionCode: "GS",
      regionName: "SOUTH GEORGIAAND THE",
    },
    {
      countryName: "SOUTH SUDAN",
      regionCode: "EC",
      regionName: "CENTRAL EQUATORIA",
    },
    {
      countryName: "SOUTH SUDAN",
      regionCode: "EE",
      regionName: "EASTERN EQUATORIA",
    },
    {
      countryName: "SOUTH SUDAN",
      regionCode: "EG",
      regionName: "JONGLEI",
    },
    {
      countryName: "SOUTH SUDAN",
      regionCode: "LK",
      regionName: "LAKES",
    },
    {
      countryName: "SOUTH SUDAN",
      regionCode: "BN",
      regionName: "NORTHERN BAHR EL GHAZAL",
    },
    {
      countryName: "SOUTH SUDAN",
      regionCode: "UY",
      regionName: "UNITY",
    },
    {
      countryName: "SOUTH SUDAN",
      regionCode: "NU",
      regionName: "UPPER NILE",
    },
    {
      countryName: "SOUTH SUDAN",
      regionCode: "WR",
      regionName: "WARRAP",
    },
    {
      countryName: "SOUTH SUDAN",
      regionCode: "BW",
      regionName: "WESTERN BAHR EL GHAZAL",
    },
    {
      countryName: "SOUTH SUDAN",
      regionCode: "EW",
      regionName: "WESTERN EQUATORIA",
    },
    {
      countryName: "SPAIN",
      regionCode: "C",
      regionName: "A CORUNA",
    },
    {
      countryName: "SPAIN",
      regionCode: "VI",
      regionName: "ALAVA",
    },
    {
      countryName: "SPAIN",
      regionCode: "AB",
      regionName: "ALBACETE",
    },
    {
      countryName: "SPAIN",
      regionCode: "A",
      regionName: "ALICANTE",
    },
    {
      countryName: "SPAIN",
      regionCode: "AL",
      regionName: "ALMERIA",
    },
    {
      countryName: "SPAIN",
      regionCode: "O",
      regionName: "ASTURIAS",
    },
    {
      countryName: "SPAIN",
      regionCode: "AV",
      regionName: "AVILA",
    },
    {
      countryName: "SPAIN",
      regionCode: "BA",
      regionName: "BADAJOZ",
    },
    {
      countryName: "SPAIN",
      regionCode: "PM",
      regionName: "BALEARES",
    },
    {
      countryName: "SPAIN",
      regionCode: "B",
      regionName: "BARCELONA",
    },
    {
      countryName: "SPAIN",
      regionCode: "BU",
      regionName: "BURGOS",
    },
    {
      countryName: "SPAIN",
      regionCode: "CC",
      regionName: "CACERES",
    },
    {
      countryName: "SPAIN",
      regionCode: "CA",
      regionName: "CADIZ",
    },
    {
      countryName: "SPAIN",
      regionCode: "S",
      regionName: "CANTABRIA",
    },
    {
      countryName: "SPAIN",
      regionCode: "CS",
      regionName: "CASTELLON",
    },
    {
      countryName: "SPAIN",
      regionCode: "CE",
      regionName: "CEUTA",
    },
    {
      countryName: "SPAIN",
      regionCode: "CR",
      regionName: "CIUDAD REAL",
    },
    {
      countryName: "SPAIN",
      regionCode: "CO",
      regionName: "CORDOBA",
    },
    {
      countryName: "SPAIN",
      regionCode: "CU",
      regionName: "CUENCA",
    },
    {
      countryName: "SPAIN",
      regionCode: "GI",
      regionName: "GIRONA",
    },
    {
      countryName: "SPAIN",
      regionCode: "GR",
      regionName: "GRANADA",
    },
    {
      countryName: "SPAIN",
      regionCode: "GU",
      regionName: "GUADALAJARA",
    },
    {
      countryName: "SPAIN",
      regionCode: "SS",
      regionName: "GUIPUZCOA",
    },
    {
      countryName: "SPAIN",
      regionCode: "H",
      regionName: "HUELVA",
    },
    {
      countryName: "SPAIN",
      regionCode: "HU",
      regionName: "HUESCA",
    },
    {
      countryName: "SPAIN",
      regionCode: "J",
      regionName: "JAEN",
    },
    {
      countryName: "SPAIN",
      regionCode: "LO",
      regionName: "LA RIOJA",
    },
    {
      countryName: "SPAIN",
      regionCode: "GC",
      regionName: "LAS PALMAS",
    },
    {
      countryName: "SPAIN",
      regionCode: "LE",
      regionName: "LEON",
    },
    {
      countryName: "SPAIN",
      regionCode: "L",
      regionName: "LLEIDA",
    },
    {
      countryName: "SPAIN",
      regionCode: "LU",
      regionName: "LUGO",
    },
    {
      countryName: "SPAIN",
      regionCode: "M",
      regionName: "MADRID",
    },
    {
      countryName: "SPAIN",
      regionCode: "MA",
      regionName: "MALAGA",
    },
    {
      countryName: "SPAIN",
      regionCode: "ML",
      regionName: "MELILLA",
    },
    {
      countryName: "SPAIN",
      regionCode: "MU",
      regionName: "MURCIA",
    },
    {
      countryName: "SPAIN",
      regionCode: "NA",
      regionName: "NAVARRA",
    },
    {
      countryName: "SPAIN",
      regionCode: "OR",
      regionName: "OURENSE",
    },
    {
      countryName: "SPAIN",
      regionCode: "P",
      regionName: "PALENCIA",
    },
    {
      countryName: "SPAIN",
      regionCode: "PO",
      regionName: "PONTEVEDRA",
    },
    {
      countryName: "SPAIN",
      regionCode: "SA",
      regionName: "SALAMANCA",
    },
    {
      countryName: "SPAIN",
      regionCode: "TF",
      regionName: "SANTA CRUZ DE TENERIFE",
    },
    {
      countryName: "SPAIN",
      regionCode: "SG",
      regionName: "SEGOVIA",
    },
    {
      countryName: "SPAIN",
      regionCode: "SE",
      regionName: "SEVILLA",
    },
    {
      countryName: "SPAIN",
      regionCode: "SO",
      regionName: "SORIA",
    },
    {
      countryName: "SPAIN",
      regionCode: "T",
      regionName: "TARRAGONA",
    },
    {
      countryName: "SPAIN",
      regionCode: "TE",
      regionName: "TERUEL",
    },
    {
      countryName: "SPAIN",
      regionCode: "TO",
      regionName: "TOLEDO",
    },
    {
      countryName: "SPAIN",
      regionCode: "V",
      regionName: "VALENCIA",
    },
    {
      countryName: "SPAIN",
      regionCode: "VA",
      regionName: "VALLADOLID",
    },
    {
      countryName: "SPAIN",
      regionCode: "BI",
      regionName: "VIZCAYA",
    },
    {
      countryName: "SPAIN",
      regionCode: "ZA",
      regionName: "ZAMORA",
    },
    {
      countryName: "SPAIN",
      regionCode: "Z",
      regionName: "ZARAGOZA",
    },
    {
      countryName: "SRI LANKA",
      regionCode: 52,
      regionName: "AMPARA",
    },
    {
      countryName: "SRI LANKA",
      regionCode: 71,
      regionName: "ANURADHAPURA",
    },
    {
      countryName: "SRI LANKA",
      regionCode: 81,
      regionName: "BADULLA",
    },
    {
      countryName: "SRI LANKA",
      regionCode: 51,
      regionName: "BATTICALOA",
    },
    {
      countryName: "SRI LANKA",
      regionCode: 11,
      regionName: "COLOMBO",
    },
    {
      countryName: "SRI LANKA",
      regionCode: 31,
      regionName: "GALLE",
    },
    {
      countryName: "SRI LANKA",
      regionCode: 12,
      regionName: "GAMPAHA",
    },
    {
      countryName: "SRI LANKA",
      regionCode: 33,
      regionName: "HAMBANTOTA",
    },
    {
      countryName: "SRI LANKA",
      regionCode: 41,
      regionName: "JAFFNA",
    },
    {
      countryName: "SRI LANKA",
      regionCode: 13,
      regionName: "KALUTARA",
    },
    {
      countryName: "SRI LANKA",
      regionCode: 21,
      regionName: "KANDY",
    },
    {
      countryName: "SRI LANKA",
      regionCode: 92,
      regionName: "KEGALLA",
    },
    {
      countryName: "SRI LANKA",
      regionCode: 42,
      regionName: "KILINOCHCHI",
    },
    {
      countryName: "SRI LANKA",
      regionCode: 61,
      regionName: "KURUNEGALA",
    },
    {
      countryName: "SRI LANKA",
      regionCode: 43,
      regionName: "MANNAR",
    },
    {
      countryName: "SRI LANKA",
      regionCode: 22,
      regionName: "MATALE",
    },
    {
      countryName: "SRI LANKA",
      regionCode: 32,
      regionName: "MATARA",
    },
    {
      countryName: "SRI LANKA",
      regionCode: 82,
      regionName: "MONARAGALA",
    },
    {
      countryName: "SRI LANKA",
      regionCode: 45,
      regionName: "MULLAITTIVU",
    },
    {
      countryName: "SRI LANKA",
      regionCode: 23,
      regionName: "NUWARA ELIYA",
    },
    {
      countryName: "SRI LANKA",
      regionCode: 72,
      regionName: "POLONNARUWA",
    },
    {
      countryName: "SRI LANKA",
      regionCode: 62,
      regionName: "PUTTALAM",
    },
    {
      countryName: "SRI LANKA",
      regionCode: 91,
      regionName: "RATNAPURA",
    },
    {
      countryName: "SRI LANKA",
      regionCode: 53,
      regionName: "TRINCOMALEE",
    },
    {
      countryName: "SRI LANKA",
      regionCode: 44,
      regionName: "VAVUNIYA",
    },
    {
      countryName: "SURINAME",
      regionCode: "BR",
      regionName: "BROKOPONDO",
    },
    {
      countryName: "SURINAME",
      regionCode: "CM",
      regionName: "COMMEWIJNE",
    },
    {
      countryName: "SURINAME",
      regionCode: "CR",
      regionName: "CARONIE",
    },
    {
      countryName: "SURINAME",
      regionCode: "MA",
      regionName: "MAROWIJNE",
    },
    {
      countryName: "SURINAME",
      regionCode: "NI",
      regionName: "NICKERIE",
    },
    {
      countryName: "SURINAME",
      regionCode: "PM",
      regionName: "PARAMARIBO",
    },
    {
      countryName: "SURINAME",
      regionCode: "PR",
      regionName: "PARA",
    },
    {
      countryName: "SURINAME",
      regionCode: "SA",
      regionName: "SARAMACCA",
    },
    {
      countryName: "SURINAME",
      regionCode: "SI",
      regionName: "SIPALIWINI",
    },
    {
      countryName: "SURINAME",
      regionCode: "WA",
      regionName: "WANICA",
    },
    {
      countryName: "SVALBARD AND JAN MAYEN ISLANDS",
      regionCode: "SJ",
      regionName: "SVALBARD AND JAN",
    },
    {
      countryName: "SWAZILAND",
      regionCode: "HH",
      regionName: "HHOHHO",
    },
    {
      countryName: "SWAZILAND",
      regionCode: "LU",
      regionName: "LUBOMBO",
    },
    {
      countryName: "SWAZILAND",
      regionCode: "MA",
      regionName: "MANZINI",
    },
    {
      countryName: "SWAZILAND",
      regionCode: "SH",
      regionName: "SHISELWENI",
    },
    {
      countryName: "SWEDEN",
      regionCode: "K",
      regionName: "BLEKINGE LAN",
    },
    {
      countryName: "SWEDEN",
      regionCode: "W",
      regionName: "DALARNAS LAN",
    },
    {
      countryName: "SWEDEN",
      regionCode: "X",
      regionName: "GAVLEBORGS LAN",
    },
    {
      countryName: "SWEDEN",
      regionCode: "I",
      regionName: "GOTLANDS LAN",
    },
    {
      countryName: "SWEDEN",
      regionCode: "N",
      regionName: "HALLANDS LAN",
    },
    {
      countryName: "SWEDEN",
      regionCode: "Z",
      regionName: "JAMTLANDS LAN",
    },
    {
      countryName: "SWEDEN",
      regionCode: "F",
      regionName: "JONKOPINGS LAN",
    },
    {
      countryName: "SWEDEN",
      regionCode: "H",
      regionName: "KALMAR LAN",
    },
    {
      countryName: "SWEDEN",
      regionCode: "G",
      regionName: "KRONOBERGS LAN",
    },
    {
      countryName: "SWEDEN",
      regionCode: "BD",
      regionName: "NORRBOTTENS LAN",
    },
    {
      countryName: "SWEDEN",
      regionCode: "T",
      regionName: "OREBRO LAN",
    },
    {
      countryName: "SWEDEN",
      regionCode: "E",
      regionName: "OSTERGOTLANDS LAN",
    },
    {
      countryName: "SWEDEN",
      regionCode: "M",
      regionName: "SKANE LAN",
    },
    {
      countryName: "SWEDEN",
      regionCode: "D",
      regionName: "SODERMANLANDS LAN",
    },
    {
      countryName: "SWEDEN",
      regionCode: "AB",
      regionName: "STOCKHOLMS LAN",
    },
    {
      countryName: "SWEDEN",
      regionCode: "C",
      regionName: "UPPSALA LAN",
    },
    {
      countryName: "SWEDEN",
      regionCode: "S",
      regionName: "VARMLANDS LAN",
    },
    {
      countryName: "SWEDEN",
      regionCode: "AC",
      regionName: "VASTERBOTTENS LAN",
    },
    {
      countryName: "SWEDEN",
      regionCode: "Y",
      regionName: "VASTERNORRLANDS LAN",
    },
    {
      countryName: "SWEDEN",
      regionCode: "U",
      regionName: "VASTMANLANDS LAN",
    },
    {
      countryName: "SWEDEN",
      regionCode: "O",
      regionName: "VASTRA GOTALANDS LAN",
    },
    {
      countryName: "SWITZERLAND",
      regionCode: "AG",
      regionName: "AARGAU",
    },
    {
      countryName: "SWITZERLAND",
      regionCode: "AI",
      regionName: "APPENZELL INNERRHODEN",
    },
    {
      countryName: "SWITZERLAND",
      regionCode: "AR",
      regionName: "APPENZELL AUSSERRHODEN",
    },
    {
      countryName: "SWITZERLAND",
      regionCode: "BE",
      regionName: "BERN",
    },
    {
      countryName: "SWITZERLAND",
      regionCode: "BL",
      regionName: "BASEL-LANDSCHAFT",
    },
    {
      countryName: "SWITZERLAND",
      regionCode: "BS",
      regionName: "BASEL-STADT",
    },
    {
      countryName: "SWITZERLAND",
      regionCode: "FR",
      regionName: "FRIBOURG",
    },
    {
      countryName: "SWITZERLAND",
      regionCode: "GE",
      regionName: "GENEVE",
    },
    {
      countryName: "SWITZERLAND",
      regionCode: "GL",
      regionName: "GLARUS",
    },
    {
      countryName: "SWITZERLAND",
      regionCode: "GR",
      regionName: "GRAUBUNDEN",
    },
    {
      countryName: "SWITZERLAND",
      regionCode: "JU",
      regionName: "JURA",
    },
    {
      countryName: "SWITZERLAND",
      regionCode: "LU",
      regionName: "LUZERN",
    },
    {
      countryName: "SWITZERLAND",
      regionCode: "NE",
      regionName: "NEUCHATEL",
    },
    {
      countryName: "SWITZERLAND",
      regionCode: "NW",
      regionName: "NIDWALDEN",
    },
    {
      countryName: "SWITZERLAND",
      regionCode: "OW",
      regionName: "OBWALDEN",
    },
    {
      countryName: "SWITZERLAND",
      regionCode: "SG",
      regionName: "SANKT GALLEN",
    },
    {
      countryName: "SWITZERLAND",
      regionCode: "SH",
      regionName: "SCHAFFHAUSEN",
    },
    {
      countryName: "SWITZERLAND",
      regionCode: "SO",
      regionName: "SOLOTHURN",
    },
    {
      countryName: "SWITZERLAND",
      regionCode: "SZ",
      regionName: "SCHWYZ",
    },
    {
      countryName: "SWITZERLAND",
      regionCode: "TG",
      regionName: "THURGAU",
    },
    {
      countryName: "SWITZERLAND",
      regionCode: "TI",
      regionName: "TICINO",
    },
    {
      countryName: "SWITZERLAND",
      regionCode: "UR",
      regionName: "URI",
    },
    {
      countryName: "SWITZERLAND",
      regionCode: "VD",
      regionName: "VAUD",
    },
    {
      countryName: "SWITZERLAND",
      regionCode: "VS",
      regionName: "VALAIS",
    },
    {
      countryName: "SWITZERLAND",
      regionCode: "ZG",
      regionName: "ZUG",
    },
    {
      countryName: "SWITZERLAND",
      regionCode: "ZH",
      regionName: "ZURICH",
    },
    {
      countryName: "SYRIAN ARAB REPUBLIC",
      regionCode: "HA",
      regionName: "AL HASAKAH",
    },
    {
      countryName: "SYRIAN ARAB REPUBLIC",
      regionCode: "LA",
      regionName: "AL LADHIQIYAH",
    },
    {
      countryName: "SYRIAN ARAB REPUBLIC",
      regionCode: "QU",
      regionName: "AL QUNAYTIRAH",
    },
    {
      countryName: "SYRIAN ARAB REPUBLIC",
      regionCode: "RA",
      regionName: "AR RAQQAH",
    },
    {
      countryName: "SYRIAN ARAB REPUBLIC",
      regionCode: "SU",
      regionName: "AS SUWAYDA",
    },
    {
      countryName: "SYRIAN ARAB REPUBLIC",
      regionCode: "DR",
      regionName: "DARA",
    },
    {
      countryName: "SYRIAN ARAB REPUBLIC",
      regionCode: "DY",
      regionName: "DAYR AZ ZAWR",
    },
    {
      countryName: "SYRIAN ARAB REPUBLIC",
      regionCode: "DI",
      regionName: "DIMASHQ",
    },
    {
      countryName: "SYRIAN ARAB REPUBLIC",
      regionCode: "HL",
      regionName: "HALAB",
    },
    {
      countryName: "SYRIAN ARAB REPUBLIC",
      regionCode: "HM",
      regionName: "HAMAH",
    },
    {
      countryName: "SYRIAN ARAB REPUBLIC",
      regionCode: "HI",
      regionName: "HIMS",
    },
    {
      countryName: "SYRIAN ARAB REPUBLIC",
      regionCode: "ID",
      regionName: "IDLIB",
    },
    {
      countryName: "SYRIAN ARAB REPUBLIC",
      regionCode: "RD",
      regionName: "RIF DIMASHQ",
    },
    {
      countryName: "SYRIAN ARAB REPUBLIC",
      regionCode: "TA",
      regionName: "TARTUS",
    },
    {
      countryName: "TAIWAN (PROVINCE OF CHINA)",
      regionCode: "CHA",
      regionName: "CHANGHUA",
    },
    {
      countryName: "TAIWAN (PROVINCE OF CHINA)",
      regionCode: "CYI",
      regionName: "CHIAYI",
    },
    {
      countryName: "TAIWAN (PROVINCE OF CHINA)",
      regionCode: "CYQ",
      regionName: "CHIAYI",
    },
    {
      countryName: "TAIWAN (PROVINCE OF CHINA)",
      regionCode: "HSQ",
      regionName: "HSINCHU",
    },
    {
      countryName: "TAIWAN (PROVINCE OF CHINA)",
      regionCode: "HSZ",
      regionName: "HSINCHU",
    },
    {
      countryName: "TAIWAN (PROVINCE OF CHINA)",
      regionCode: "HUA",
      regionName: "HUALIEN",
    },
    {
      countryName: "TAIWAN (PROVINCE OF CHINA)",
      regionCode: "ILA",
      regionName: "ILAN",
    },
    {
      countryName: "TAIWAN (PROVINCE OF CHINA)",
      regionCode: "KEE",
      regionName: "KEELUNG",
    },
    {
      countryName: "TAIWAN (PROVINCE OF CHINA)",
      regionCode: "KHH",
      regionName: "KAOHSIUNG",
    },
    {
      countryName: "TAIWAN (PROVINCE OF CHINA)",
      regionCode: "KHQ",
      regionName: "KAOHSIUNG",
    },
    {
      countryName: "TAIWAN (PROVINCE OF CHINA)",
      regionCode: "MIA",
      regionName: "MIAOLI",
    },
    {
      countryName: "TAIWAN (PROVINCE OF CHINA)",
      regionCode: "NAN",
      regionName: "NANTOU",
    },
    {
      countryName: "TAIWAN (PROVINCE OF CHINA)",
      regionCode: "PEN",
      regionName: "PENGHU",
    },
    {
      countryName: "TAIWAN (PROVINCE OF CHINA)",
      regionCode: "PIF",
      regionName: "PINGTUNG",
    },
    {
      countryName: "TAIWAN (PROVINCE OF CHINA)",
      regionCode: "TAO",
      regionName: "TAOYUAN",
    },
    {
      countryName: "TAIWAN (PROVINCE OF CHINA)",
      regionCode: "TNN",
      regionName: "TAINAN",
    },
    {
      countryName: "TAIWAN (PROVINCE OF CHINA)",
      regionCode: "TNQ",
      regionName: "TAINAN",
    },
    {
      countryName: "TAIWAN (PROVINCE OF CHINA)",
      regionCode: "TPE",
      regionName: "TAIPEI",
    },
    {
      countryName: "TAIWAN (PROVINCE OF CHINA)",
      regionCode: "TPQ",
      regionName: "TAIPEI",
    },
    {
      countryName: "TAIWAN (PROVINCE OF CHINA)",
      regionCode: "TTT",
      regionName: "TAITUNG",
    },
    {
      countryName: "TAIWAN (PROVINCE OF CHINA)",
      regionCode: "TXG",
      regionName: "TAICHUNG",
    },
    {
      countryName: "TAIWAN (PROVINCE OF CHINA)",
      regionCode: "TXQ",
      regionName: "TAICHUNG",
    },
    {
      countryName: "TAIWAN (PROVINCE OF CHINA)",
      regionCode: "YUN",
      regionName: "YUNLIN",
    },
    {
      countryName: "TAJIKISTAN",
      regionCode: "GB",
      regionName: "KUHISTONI BADAKHSHON",
    },
    {
      countryName: "TAJIKISTAN",
      regionCode: "KT",
      regionName: "KHATLON",
    },
    {
      countryName: "TAJIKISTAN",
      regionCode: "SU",
      regionName: "SUGHD",
    },
    {
      countryName: "TANZANIA, UNITED REPUBLIC OF",
      regionCode: 1,
      regionName: "ARUSHA",
    },
    {
      countryName: "TANZANIA, UNITED REPUBLIC OF",
      regionCode: 2,
      regionName: "DAR ES SALAAM",
    },
    {
      countryName: "TANZANIA, UNITED REPUBLIC OF",
      regionCode: 3,
      regionName: "DODOMA",
    },
    {
      countryName: "TANZANIA, UNITED REPUBLIC OF",
      regionCode: 4,
      regionName: "IRINGA",
    },
    {
      countryName: "TANZANIA, UNITED REPUBLIC OF",
      regionCode: 5,
      regionName: "KAGERA",
    },
    {
      countryName: "TANZANIA, UNITED REPUBLIC OF",
      regionCode: 6,
      regionName: "KASKAZINI PEMBA",
    },
    {
      countryName: "TANZANIA, UNITED REPUBLIC OF",
      regionCode: 7,
      regionName: "KASKAZINI UNGUJA",
    },
    {
      countryName: "TANZANIA, UNITED REPUBLIC OF",
      regionCode: 8,
      regionName: "KIGOMA",
    },
    {
      countryName: "TANZANIA, UNITED REPUBLIC OF",
      regionCode: 9,
      regionName: "KILIMANJARO",
    },
    {
      countryName: "TANZANIA, UNITED REPUBLIC OF",
      regionCode: 10,
      regionName: "KUSINI PEMBA",
    },
    {
      countryName: "TANZANIA, UNITED REPUBLIC OF",
      regionCode: 11,
      regionName: "KUSINI UNGUJA",
    },
    {
      countryName: "TANZANIA, UNITED REPUBLIC OF",
      regionCode: 12,
      regionName: "LINDI",
    },
    {
      countryName: "TANZANIA, UNITED REPUBLIC OF",
      regionCode: 26,
      regionName: "MANYARA",
    },
    {
      countryName: "TANZANIA, UNITED REPUBLIC OF",
      regionCode: 13,
      regionName: "MARA",
    },
    {
      countryName: "TANZANIA, UNITED REPUBLIC OF",
      regionCode: 14,
      regionName: "MBEYA",
    },
    {
      countryName: "TANZANIA, UNITED REPUBLIC OF",
      regionCode: 15,
      regionName: "MJINI MAGHARIBI",
    },
    {
      countryName: "TANZANIA, UNITED REPUBLIC OF",
      regionCode: 16,
      regionName: "MOROGORO",
    },
    {
      countryName: "TANZANIA, UNITED REPUBLIC OF",
      regionCode: 17,
      regionName: "MTWARA",
    },
    {
      countryName: "TANZANIA, UNITED REPUBLIC OF",
      regionCode: 18,
      regionName: "MWANZA",
    },
    {
      countryName: "TANZANIA, UNITED REPUBLIC OF",
      regionCode: 19,
      regionName: "PWANI",
    },
    {
      countryName: "TANZANIA, UNITED REPUBLIC OF",
      regionCode: 20,
      regionName: "RUKWA",
    },
    {
      countryName: "TANZANIA, UNITED REPUBLIC OF",
      regionCode: 21,
      regionName: "RUVUMA",
    },
    {
      countryName: "TANZANIA, UNITED REPUBLIC OF",
      regionCode: 22,
      regionName: "SHINYANGA",
    },
    {
      countryName: "TANZANIA, UNITED REPUBLIC OF",
      regionCode: 23,
      regionName: "SINGIDA",
    },
    {
      countryName: "TANZANIA, UNITED REPUBLIC OF",
      regionCode: 24,
      regionName: "TABORA",
    },
    {
      countryName: "TANZANIA, UNITED REPUBLIC OF",
      regionCode: 25,
      regionName: "TANGA",
    },
    {
      countryName: "THAILAND",
      regionCode: 37,
      regionName: "AMNAT CHAROEN",
    },
    {
      countryName: "THAILAND",
      regionCode: 15,
      regionName: "ANG THONG",
    },
    {
      countryName: "THAILAND",
      regionCode: 31,
      regionName: "BURI RAM",
    },
    {
      countryName: "THAILAND",
      regionCode: 24,
      regionName: "CHACHOENGSAO",
    },
    {
      countryName: "THAILAND",
      regionCode: 18,
      regionName: "CHAI NAT",
    },
    {
      countryName: "THAILAND",
      regionCode: 36,
      regionName: "CHAIYAPHUM",
    },
    {
      countryName: "THAILAND",
      regionCode: 22,
      regionName: "CHANTHABURI",
    },
    {
      countryName: "THAILAND",
      regionCode: 50,
      regionName: "CHIANG MAI",
    },
    {
      countryName: "THAILAND",
      regionCode: 57,
      regionName: "CHIANG RAI",
    },
    {
      countryName: "THAILAND",
      regionCode: 20,
      regionName: "CHON BURI",
    },
    {
      countryName: "THAILAND",
      regionCode: 86,
      regionName: "CHUMPHON",
    },
    {
      countryName: "THAILAND",
      regionCode: 46,
      regionName: "KALASIN",
    },
    {
      countryName: "THAILAND",
      regionCode: 62,
      regionName: "KAMPHAENG PHET",
    },
    {
      countryName: "THAILAND",
      regionCode: 71,
      regionName: "KANCHANABURI",
    },
    {
      countryName: "THAILAND",
      regionCode: 40,
      regionName: "KHON KAEN",
    },
    {
      countryName: "THAILAND",
      regionCode: 81,
      regionName: "KRABI",
    },
    {
      countryName: "THAILAND",
      regionCode: 10,
      regionName: "KRUNG THEP MAHA NAKHON (BANGKOK)",
    },
    {
      countryName: "THAILAND",
      regionCode: 52,
      regionName: "LAMPANG",
    },
    {
      countryName: "THAILAND",
      regionCode: 51,
      regionName: "LAMPHUN",
    },
    {
      countryName: "THAILAND",
      regionCode: 42,
      regionName: "LOEI",
    },
    {
      countryName: "THAILAND",
      regionCode: 16,
      regionName: "LOP BURI",
    },
    {
      countryName: "THAILAND",
      regionCode: 58,
      regionName: "MAE HONG SON",
    },
    {
      countryName: "THAILAND",
      regionCode: 44,
      regionName: "MAHA SARAKHAM",
    },
    {
      countryName: "THAILAND",
      regionCode: 49,
      regionName: "MUKDAHAN",
    },
    {
      countryName: "THAILAND",
      regionCode: 26,
      regionName: "NAKHON NAYOK",
    },
    {
      countryName: "THAILAND",
      regionCode: 73,
      regionName: "NAKHON PATHOM",
    },
    {
      countryName: "THAILAND",
      regionCode: 48,
      regionName: "NAKHON PHANOM",
    },
    {
      countryName: "THAILAND",
      regionCode: 30,
      regionName: "NAKHON RATCHASIMA",
    },
    {
      countryName: "THAILAND",
      regionCode: 60,
      regionName: "NAKHON SAWAN",
    },
    {
      countryName: "THAILAND",
      regionCode: 80,
      regionName: "NAKHON SI THAMMARAT",
    },
    {
      countryName: "THAILAND",
      regionCode: 55,
      regionName: "NAN",
    },
    {
      countryName: "THAILAND",
      regionCode: 96,
      regionName: "NARATHIWAT",
    },
    {
      countryName: "THAILAND",
      regionCode: 39,
      regionName: "NONG BUA LAM PHU",
    },
    {
      countryName: "THAILAND",
      regionCode: 43,
      regionName: "NONG KHAI",
    },
    {
      countryName: "THAILAND",
      regionCode: 12,
      regionName: "NONTHABURI",
    },
    {
      countryName: "THAILAND",
      regionCode: 13,
      regionName: "PATHUM THANI",
    },
    {
      countryName: "THAILAND",
      regionCode: 94,
      regionName: "PATTANI",
    },
    {
      countryName: "THAILAND",
      regionCode: 82,
      regionName: "PHANGNGA",
    },
    {
      countryName: "THAILAND",
      regionCode: 93,
      regionName: "PHATTHALUNG",
    },
    {
      countryName: "THAILAND",
      regionCode: "S",
      regionName: "PHATTHAYA",
    },
    {
      countryName: "THAILAND",
      regionCode: 56,
      regionName: "PHAYAO",
    },
    {
      countryName: "THAILAND",
      regionCode: 67,
      regionName: "PHETCHABUN",
    },
    {
      countryName: "THAILAND",
      regionCode: 76,
      regionName: "PHETCHABURI",
    },
    {
      countryName: "THAILAND",
      regionCode: 66,
      regionName: "PHICHIT",
    },
    {
      countryName: "THAILAND",
      regionCode: 65,
      regionName: "PHITSANULOK",
    },
    {
      countryName: "THAILAND",
      regionCode: 14,
      regionName: "PHRA NAKHON SI AYUTTHAYA",
    },
    {
      countryName: "THAILAND",
      regionCode: 54,
      regionName: "PHRAE",
    },
    {
      countryName: "THAILAND",
      regionCode: 83,
      regionName: "PHUKET",
    },
    {
      countryName: "THAILAND",
      regionCode: 25,
      regionName: "PRACHIN BURI",
    },
    {
      countryName: "THAILAND",
      regionCode: 77,
      regionName: "PRACHUAP KHIRI KHAN",
    },
    {
      countryName: "THAILAND",
      regionCode: 85,
      regionName: "RANONG",
    },
    {
      countryName: "THAILAND",
      regionCode: 70,
      regionName: "RATCHABURI",
    },
    {
      countryName: "THAILAND",
      regionCode: 21,
      regionName: "RAYONG",
    },
    {
      countryName: "THAILAND",
      regionCode: 45,
      regionName: "ROI ET",
    },
    {
      countryName: "THAILAND",
      regionCode: 27,
      regionName: "SA KAEO",
    },
    {
      countryName: "THAILAND",
      regionCode: 47,
      regionName: "SAKON NAKHON",
    },
    {
      countryName: "THAILAND",
      regionCode: 11,
      regionName: "SAMUT PRAKAN",
    },
    {
      countryName: "THAILAND",
      regionCode: 74,
      regionName: "SAMUT SAKHON",
    },
    {
      countryName: "THAILAND",
      regionCode: 75,
      regionName: "SAMUT SONGKHRAM",
    },
    {
      countryName: "THAILAND",
      regionCode: 19,
      regionName: "SARABURI",
    },
    {
      countryName: "THAILAND",
      regionCode: 91,
      regionName: "SATUN",
    },
    {
      countryName: "THAILAND",
      regionCode: 33,
      regionName: "SI SA KET",
    },
    {
      countryName: "THAILAND",
      regionCode: 17,
      regionName: "SING BURI",
    },
    {
      countryName: "THAILAND",
      regionCode: 90,
      regionName: "SONGKHLA",
    },
    {
      countryName: "THAILAND",
      regionCode: 64,
      regionName: "SUKHOTHAI",
    },
    {
      countryName: "THAILAND",
      regionCode: 72,
      regionName: "SUPHAN BURI",
    },
    {
      countryName: "THAILAND",
      regionCode: 84,
      regionName: "SURAT THANI",
    },
    {
      countryName: "THAILAND",
      regionCode: 32,
      regionName: "SURIN",
    },
    {
      countryName: "THAILAND",
      regionCode: 63,
      regionName: "TAK",
    },
    {
      countryName: "THAILAND",
      regionCode: 92,
      regionName: "TRANG",
    },
    {
      countryName: "THAILAND",
      regionCode: 23,
      regionName: "TRAT",
    },
    {
      countryName: "THAILAND",
      regionCode: 34,
      regionName: "UBON RATCHATHANI",
    },
    {
      countryName: "THAILAND",
      regionCode: 41,
      regionName: "UDON THANI",
    },
    {
      countryName: "THAILAND",
      regionCode: 61,
      regionName: "UTHAI THANI",
    },
    {
      countryName: "THAILAND",
      regionCode: 53,
      regionName: "UTTARADIT",
    },
    {
      countryName: "THAILAND",
      regionCode: 95,
      regionName: "YALA",
    },
    {
      countryName: "THAILAND",
      regionCode: 35,
      regionName: "YASOTHON",
    },
    {
      countryName: "TIMOR-LESTE",
      regionCode: "AL",
      regionName: "AILEU",
    },
    {
      countryName: "TIMOR-LESTE",
      regionCode: "AN",
      regionName: "AINARO",
    },
    {
      countryName: "TIMOR-LESTE",
      regionCode: "BA",
      regionName: "BAUCAU",
    },
    {
      countryName: "TIMOR-LESTE",
      regionCode: "BO",
      regionName: "BOBONARO",
    },
    {
      countryName: "TIMOR-LESTE",
      regionCode: "CO",
      regionName: "COVA LIMA",
    },
    {
      countryName: "TIMOR-LESTE",
      regionCode: "DI",
      regionName: "DILI",
    },
    {
      countryName: "TIMOR-LESTE",
      regionCode: "ER",
      regionName: "ERMERA",
    },
    {
      countryName: "TIMOR-LESTE",
      regionCode: "LA",
      regionName: "LAUTEM",
    },
    {
      countryName: "TIMOR-LESTE",
      regionCode: "LI",
      regionName: "LIQUICA",
    },
    {
      countryName: "TIMOR-LESTE",
      regionCode: "MF",
      regionName: "MANUFAHI",
    },
    {
      countryName: "TIMOR-LESTE",
      regionCode: "MT",
      regionName: "MANATUTO",
    },
    {
      countryName: "TIMOR-LESTE",
      regionCode: "OE",
      regionName: "OECUSSI",
    },
    {
      countryName: "TIMOR-LESTE",
      regionCode: "VI",
      regionName: "VIQUEQUE",
    },
    {
      countryName: "TOGO",
      regionCode: "C",
      regionName: "CENTRE",
    },
    {
      countryName: "TOGO",
      regionCode: "K",
      regionName: "KARA",
    },
    {
      countryName: "TOGO",
      regionCode: "M",
      regionName: "MARITIME (REGION)",
    },
    {
      countryName: "TOGO",
      regionCode: "P",
      regionName: "PLATEAUX",
    },
    {
      countryName: "TOGO",
      regionCode: "S",
      regionName: "SAVANES",
    },
    {
      countryName: "TOKELAU",
      regionCode: "TK",
      regionName: "TOKELAU",
    },
    {
      countryName: "TONGA",
      regionCode: 1,
      regionName: "EUA",
    },
    {
      countryName: "TONGA",
      regionCode: 2,
      regionName: "HA’APAI",
    },
    {
      countryName: "TONGA",
      regionCode: 3,
      regionName: "NIUAS",
    },
    {
      countryName: "TONGA",
      regionCode: 4,
      regionName: "TONGATAPU",
    },
    {
      countryName: "TONGA",
      regionCode: 5,
      regionName: "VAVA’U",
    },
    {
      countryName: "TRINIDAD AND TOBAGO",
      regionCode: "ARI",
      regionName: "ARIMA",
    },
    {
      countryName: "TRINIDAD AND TOBAGO",
      regionCode: "CHA",
      regionName: "CHAGUANAS",
    },
    {
      countryName: "TRINIDAD AND TOBAGO",
      regionCode: "CTT",
      regionName: "COUVA-TABAQUITE-TALPARO",
    },
    {
      countryName: "TRINIDAD AND TOBAGO",
      regionCode: "DMN",
      regionName: "DIEGO MARTIN",
    },
    {
      countryName: "TRINIDAD AND TOBAGO",
      regionCode: "ETO",
      regionName: "EASTERN TOBAGO",
    },
    {
      countryName: "TRINIDAD AND TOBAGO",
      regionCode: "PED",
      regionName: "PENAL-DEBE",
    },
    {
      countryName: "TRINIDAD AND TOBAGO",
      regionCode: "POS",
      regionName: "PORT OF SPAIN",
    },
    {
      countryName: "TRINIDAD AND TOBAGO",
      regionCode: "PRT",
      regionName: "PRINCES TOWN",
    },
    {
      countryName: "TRINIDAD AND TOBAGO",
      regionCode: "PTF",
      regionName: "POINT FORTIN",
    },
    {
      countryName: "TRINIDAD AND TOBAGO",
      regionCode: "RCM",
      regionName: "RIO CLARO-MAYARO",
    },
    {
      countryName: "TRINIDAD AND TOBAGO",
      regionCode: "SFO",
      regionName: "SAN FERNANDO",
    },
    {
      countryName: "TRINIDAD AND TOBAGO",
      regionCode: "SGE",
      regionName: "SANGRE GRANDE",
    },
    {
      countryName: "TRINIDAD AND TOBAGO",
      regionCode: "SIP",
      regionName: "SIPARIA",
    },
    {
      countryName: "TRINIDAD AND TOBAGO",
      regionCode: "SJL",
      regionName: "SAN JUAN-LAVENTILLE",
    },
    {
      countryName: "TRINIDAD AND TOBAGO",
      regionCode: "TUP",
      regionName: "TUNAPUNA-PIARCO",
    },
    {
      countryName: "TRINIDAD AND TOBAGO",
      regionCode: "WTO",
      regionName: "WESTERN TOBAGO",
    },
    {
      countryName: "TUNISIA",
      regionCode: 31,
      regionName: "BEJA",
    },
    {
      countryName: "TUNISIA",
      regionCode: 13,
      regionName: "BEN AROUS",
    },
    {
      countryName: "TUNISIA",
      regionCode: 23,
      regionName: "BIZERTE",
    },
    {
      countryName: "TUNISIA",
      regionCode: 81,
      regionName: "GABES",
    },
    {
      countryName: "TUNISIA",
      regionCode: 71,
      regionName: "GAFSA",
    },
    {
      countryName: "TUNISIA",
      regionCode: 32,
      regionName: "JENDOUBA",
    },
    {
      countryName: "TUNISIA",
      regionCode: 41,
      regionName: "KAIROUAN",
    },
    {
      countryName: "TUNISIA",
      regionCode: 42,
      regionName: "KASSERINE",
    },
    {
      countryName: "TUNISIA",
      regionCode: 73,
      regionName: "KEBILI",
    },
    {
      countryName: "TUNISIA",
      regionCode: 12,
      regionName: "L’ARIANA",
    },
    {
      countryName: "TUNISIA",
      regionCode: 14,
      regionName: "LA MANOUBA",
    },
    {
      countryName: "TUNISIA",
      regionCode: 33,
      regionName: "LE KEF",
    },
    {
      countryName: "TUNISIA",
      regionCode: 53,
      regionName: "MAHDIA",
    },
    {
      countryName: "TUNISIA",
      regionCode: 82,
      regionName: "MEDENINE",
    },
    {
      countryName: "TUNISIA",
      regionCode: 52,
      regionName: "MONASTIR",
    },
    {
      countryName: "TUNISIA",
      regionCode: 21,
      regionName: "NABEUL",
    },
    {
      countryName: "TUNISIA",
      regionCode: 61,
      regionName: "SFAX",
    },
    {
      countryName: "TUNISIA",
      regionCode: 43,
      regionName: "SIDI BOUZID",
    },
    {
      countryName: "TUNISIA",
      regionCode: 34,
      regionName: "SILIANA",
    },
    {
      countryName: "TUNISIA",
      regionCode: 51,
      regionName: "SOUSSE",
    },
    {
      countryName: "TUNISIA",
      regionCode: 83,
      regionName: "TATAOUINE",
    },
    {
      countryName: "TUNISIA",
      regionCode: 72,
      regionName: "TOZEUR",
    },
    {
      countryName: "TUNISIA",
      regionCode: 11,
      regionName: "TUNIS",
    },
    {
      countryName: "TUNISIA",
      regionCode: 22,
      regionName: "ZAGHOUAN",
    },
    {
      countryName: "TURKEY",
      regionCode: 1,
      regionName: "ADANA",
    },
    {
      countryName: "TURKEY",
      regionCode: 2,
      regionName: "ADIYAMAN",
    },
    {
      countryName: "TURKEY",
      regionCode: 3,
      regionName: "AFYON",
    },
    {
      countryName: "TURKEY",
      regionCode: 4,
      regionName: "AGRI",
    },
    {
      countryName: "TURKEY",
      regionCode: 68,
      regionName: "AKSARAY",
    },
    {
      countryName: "TURKEY",
      regionCode: 5,
      regionName: "AMASYA",
    },
    {
      countryName: "TURKEY",
      regionCode: 6,
      regionName: "ANKARA",
    },
    {
      countryName: "TURKEY",
      regionCode: 7,
      regionName: "ANTALYA",
    },
    {
      countryName: "TURKEY",
      regionCode: 75,
      regionName: "ARDAHAN",
    },
    {
      countryName: "TURKEY",
      regionCode: 8,
      regionName: "ARTVIN",
    },
    {
      countryName: "TURKEY",
      regionCode: 9,
      regionName: "AYDIN",
    },
    {
      countryName: "TURKEY",
      regionCode: 10,
      regionName: "BALIKESIR",
    },
    {
      countryName: "TURKEY",
      regionCode: 74,
      regionName: "BARTIN",
    },
    {
      countryName: "TURKEY",
      regionCode: 72,
      regionName: "BATMAN",
    },
    {
      countryName: "TURKEY",
      regionCode: 69,
      regionName: "BAYBURT",
    },
    {
      countryName: "TURKEY",
      regionCode: 11,
      regionName: "BILECIK",
    },
    {
      countryName: "TURKEY",
      regionCode: 12,
      regionName: "BINGOL",
    },
    {
      countryName: "TURKEY",
      regionCode: 13,
      regionName: "BITLIS",
    },
    {
      countryName: "TURKEY",
      regionCode: 14,
      regionName: "BOLU",
    },
    {
      countryName: "TURKEY",
      regionCode: 15,
      regionName: "BURDUR",
    },
    {
      countryName: "TURKEY",
      regionCode: 16,
      regionName: "BURSA",
    },
    {
      countryName: "TURKEY",
      regionCode: 17,
      regionName: "CANAKKALE",
    },
    {
      countryName: "TURKEY",
      regionCode: 18,
      regionName: "CANKIRI",
    },
    {
      countryName: "TURKEY",
      regionCode: 19,
      regionName: "CORUM",
    },
    {
      countryName: "TURKEY",
      regionCode: 20,
      regionName: "DENIZLI",
    },
    {
      countryName: "TURKEY",
      regionCode: 21,
      regionName: "DIYARBAKIR",
    },
    {
      countryName: "TURKEY",
      regionCode: 81,
      regionName: "DUZCE",
    },
    {
      countryName: "TURKEY",
      regionCode: 22,
      regionName: "EDIRNE",
    },
    {
      countryName: "TURKEY",
      regionCode: 23,
      regionName: "ELAZIG",
    },
    {
      countryName: "TURKEY",
      regionCode: 24,
      regionName: "ERZINCAN",
    },
    {
      countryName: "TURKEY",
      regionCode: 25,
      regionName: "ERZURUM",
    },
    {
      countryName: "TURKEY",
      regionCode: 26,
      regionName: "ESKISEHIR",
    },
    {
      countryName: "TURKEY",
      regionCode: 27,
      regionName: "GAZIANTEP",
    },
    {
      countryName: "TURKEY",
      regionCode: 28,
      regionName: "GIRESUN",
    },
    {
      countryName: "TURKEY",
      regionCode: 29,
      regionName: "GUMUSHANE",
    },
    {
      countryName: "TURKEY",
      regionCode: 30,
      regionName: "HAKKARI",
    },
    {
      countryName: "TURKEY",
      regionCode: 31,
      regionName: "HATAY",
    },
    {
      countryName: "TURKEY",
      regionCode: 33,
      regionName: "ICEL",
    },
    {
      countryName: "TURKEY",
      regionCode: 76,
      regionName: "IGDIR",
    },
    {
      countryName: "TURKEY",
      regionCode: 32,
      regionName: "ISPARTA",
    },
    {
      countryName: "TURKEY",
      regionCode: 34,
      regionName: "ISTANBUL",
    },
    {
      countryName: "TURKEY",
      regionCode: 35,
      regionName: "IZMIR",
    },
    {
      countryName: "TURKEY",
      regionCode: 46,
      regionName: "KAHRAMANMARAS",
    },
    {
      countryName: "TURKEY",
      regionCode: 78,
      regionName: "KARABUK",
    },
    {
      countryName: "TURKEY",
      regionCode: 70,
      regionName: "KARAMAN",
    },
    {
      countryName: "TURKEY",
      regionCode: 36,
      regionName: "KARS",
    },
    {
      countryName: "TURKEY",
      regionCode: 37,
      regionName: "KASTAMONU",
    },
    {
      countryName: "TURKEY",
      regionCode: 38,
      regionName: "KAYSERI",
    },
    {
      countryName: "TURKEY",
      regionCode: 79,
      regionName: "KILIS",
    },
    {
      countryName: "TURKEY",
      regionCode: 71,
      regionName: "KIRIKKALE",
    },
    {
      countryName: "TURKEY",
      regionCode: 39,
      regionName: "KIRKLARELI",
    },
    {
      countryName: "TURKEY",
      regionCode: 40,
      regionName: "KIRSEHIR",
    },
    {
      countryName: "TURKEY",
      regionCode: 41,
      regionName: "KOCAELI",
    },
    {
      countryName: "TURKEY",
      regionCode: 42,
      regionName: "KONYA",
    },
    {
      countryName: "TURKEY",
      regionCode: 43,
      regionName: "KUTAHYA",
    },
    {
      countryName: "TURKEY",
      regionCode: 44,
      regionName: "MALATYA",
    },
    {
      countryName: "TURKEY",
      regionCode: 45,
      regionName: "MANISA",
    },
    {
      countryName: "TURKEY",
      regionCode: 47,
      regionName: "MARDIN",
    },
    {
      countryName: "TURKEY",
      regionCode: 48,
      regionName: "MUGLA",
    },
    {
      countryName: "TURKEY",
      regionCode: 49,
      regionName: "MUS",
    },
    {
      countryName: "TURKEY",
      regionCode: 50,
      regionName: "NEVSEHIR",
    },
    {
      countryName: "TURKEY",
      regionCode: 51,
      regionName: "NIGDE",
    },
    {
      countryName: "TURKEY",
      regionCode: 52,
      regionName: "ORDU",
    },
    {
      countryName: "TURKEY",
      regionCode: 80,
      regionName: "OSMANIYE",
    },
    {
      countryName: "TURKEY",
      regionCode: 53,
      regionName: "RIZE",
    },
    {
      countryName: "TURKEY",
      regionCode: 54,
      regionName: "SAKARYA",
    },
    {
      countryName: "TURKEY",
      regionCode: 55,
      regionName: "SAMSUN",
    },
    {
      countryName: "TURKEY",
      regionCode: 63,
      regionName: "SANLIURFA",
    },
    {
      countryName: "TURKEY",
      regionCode: 56,
      regionName: "SIIRT",
    },
    {
      countryName: "TURKEY",
      regionCode: 57,
      regionName: "SINOP",
    },
    {
      countryName: "TURKEY",
      regionCode: 73,
      regionName: "SIRNAK",
    },
    {
      countryName: "TURKEY",
      regionCode: 58,
      regionName: "SIVAS",
    },
    {
      countryName: "TURKEY",
      regionCode: 59,
      regionName: "TEKIRDAG",
    },
    {
      countryName: "TURKEY",
      regionCode: 60,
      regionName: "TOKAT",
    },
    {
      countryName: "TURKEY",
      regionCode: 61,
      regionName: "TRABZON",
    },
    {
      countryName: "TURKEY",
      regionCode: 62,
      regionName: "TUNCELI",
    },
    {
      countryName: "TURKEY",
      regionCode: 64,
      regionName: "USAK",
    },
    {
      countryName: "TURKEY",
      regionCode: 65,
      regionName: "VAN",
    },
    {
      countryName: "TURKEY",
      regionCode: 77,
      regionName: "YALOVA",
    },
    {
      countryName: "TURKEY",
      regionCode: 66,
      regionName: "YOZGAT",
    },
    {
      countryName: "TURKEY",
      regionCode: 67,
      regionName: "ZONGULDAK",
    },
    {
      countryName: "TURKMENISTAN",
      regionCode: "A",
      regionName: "AHAL",
    },
    {
      countryName: "TURKMENISTAN",
      regionCode: "B",
      regionName: "BALKAN",
    },
    {
      countryName: "TURKMENISTAN",
      regionCode: "D",
      regionName: "DASOGUZ",
    },
    {
      countryName: "TURKMENISTAN",
      regionCode: "L",
      regionName: "LEBAP",
    },
    {
      countryName: "TURKMENISTAN",
      regionCode: "M",
      regionName: "MARY",
    },
    {
      countryName: "TURKS AND CAICOS ISLANDS (THE)",
      regionCode: "TC",
      regionName: "TURKS AND CAICOS ISLANDS (THE)",
    },
    {
      countryName: "TUVALU",
      regionCode: "FUN",
      regionName: "FUNAFUTI",
    },
    {
      countryName: "TUVALU",
      regionCode: "NIT",
      regionName: "NIUTAO",
    },
    {
      countryName: "TUVALU",
      regionCode: "NKF",
      regionName: "NUKUFETAU",
    },
    {
      countryName: "TUVALU",
      regionCode: "NKL",
      regionName: "NUKULAELAE",
    },
    {
      countryName: "TUVALU",
      regionCode: "NMA",
      regionName: "NANUMEA",
    },
    {
      countryName: "TUVALU",
      regionCode: "NMG",
      regionName: "NANUMANGA",
    },
    {
      countryName: "TUVALU",
      regionCode: "NUI",
      regionName: "NUI",
    },
    {
      countryName: "TUVALU",
      regionCode: "VAI",
      regionName: "VAITUPU",
    },
    {
      countryName: "UGANDA",
      regionCode: 317,
      regionName: "ABIM",
    },
    {
      countryName: "UGANDA",
      regionCode: 301,
      regionName: "ADJUMANI",
    },
    {
      countryName: "UGANDA",
      regionCode: 314,
      regionName: "AMOLATAR",
    },
    {
      countryName: "UGANDA",
      regionCode: 216,
      regionName: "AMURIA",
    },
    {
      countryName: "UGANDA",
      regionCode: 319,
      regionName: "AMURU (KILAK)",
    },
    {
      countryName: "UGANDA",
      regionCode: 302,
      regionName: "APAC",
    },
    {
      countryName: "UGANDA",
      regionCode: 303,
      regionName: "ARUA",
    },
    {
      countryName: "UGANDA",
      regionCode: 217,
      regionName: "BUDAKA",
    },
    {
      countryName: "UGANDA",
      regionCode: 201,
      regionName: "BUGIRI",
    },
    {
      countryName: "UGANDA",
      regionCode: 218,
      regionName: "BUKWA",
    },
    {
      countryName: "UGANDA",
      regionCode: 419,
      regionName: "BULISA",
    },
    {
      countryName: "UGANDA",
      regionCode: 401,
      regionName: "BUNDIBUGYO",
    },
    {
      countryName: "UGANDA",
      regionCode: 402,
      regionName: "BUSHENYI",
    },
    {
      countryName: "UGANDA",
      regionCode: 202,
      regionName: "BUSIA",
    },
    {
      countryName: "UGANDA",
      regionCode: 219,
      regionName: "BUTALEJA",
    },
    {
      countryName: "UGANDA",
      regionCode: 318,
      regionName: "DOKOLO",
    },
    {
      countryName: "UGANDA",
      regionCode: 304,
      regionName: "GULU",
    },
    {
      countryName: "UGANDA",
      regionCode: 403,
      regionName: "HOIMA",
    },
    {
      countryName: "UGANDA",
      regionCode: 416,
      regionName: "IBANDA",
    },
    {
      countryName: "UGANDA",
      regionCode: 203,
      regionName: "IGANGA",
    },
    {
      countryName: "UGANDA",
      regionCode: 417,
      regionName: "ISINGIRO (KABINGO)",
    },
    {
      countryName: "UGANDA",
      regionCode: 204,
      regionName: "JINJA",
    },
    {
      countryName: "UGANDA",
      regionCode: 315,
      regionName: "KAABONG",
    },
    {
      countryName: "UGANDA",
      regionCode: 407,
      regionName: "KABAALE",
    },
    {
      countryName: "UGANDA",
      regionCode: 404,
      regionName: "KABALE",
    },
    {
      countryName: "UGANDA",
      regionCode: 405,
      regionName: "KABAROLE",
    },
    {
      countryName: "UGANDA",
      regionCode: 213,
      regionName: "KABERAMAIDO",
    },
    {
      countryName: "UGANDA",
      regionCode: 101,
      regionName: "KALANGALA",
    },
    {
      countryName: "UGANDA",
      regionCode: 220,
      regionName: "KALIRO",
    },
    {
      countryName: "UGANDA",
      regionCode: 102,
      regionName: "KAMPALA",
    },
    {
      countryName: "UGANDA",
      regionCode: 205,
      regionName: "KAMULI",
    },
    {
      countryName: "UGANDA",
      regionCode: 413,
      regionName: "KAMWENGE",
    },
    {
      countryName: "UGANDA",
      regionCode: 414,
      regionName: "KANUNGU",
    },
    {
      countryName: "UGANDA",
      regionCode: 206,
      regionName: "KAPCHORWA",
    },
    {
      countryName: "UGANDA",
      regionCode: 406,
      regionName: "KASESE",
    },
    {
      countryName: "UGANDA",
      regionCode: 207,
      regionName: "KATAKWI",
    },
    {
      countryName: "UGANDA",
      regionCode: 112,
      regionName: "KAYUNGA",
    },
    {
      countryName: "UGANDA",
      regionCode: 103,
      regionName: "KIBOGA",
    },
    {
      countryName: "UGANDA",
      regionCode: 418,
      regionName: "KIRUHURA",
    },
    {
      countryName: "UGANDA",
      regionCode: 408,
      regionName: "KISORO",
    },
    {
      countryName: "UGANDA",
      regionCode: 305,
      regionName: "KITGUM",
    },
    {
      countryName: "UGANDA",
      regionCode: 316,
      regionName: "KOBOKO",
    },
    {
      countryName: "UGANDA",
      regionCode: 306,
      regionName: "KOTIDO",
    },
    {
      countryName: "UGANDA",
      regionCode: 208,
      regionName: "KUMI",
    },
    {
      countryName: "UGANDA",
      regionCode: 415,
      regionName: "KYENJOJO",
    },
    {
      countryName: "UGANDA",
      regionCode: 307,
      regionName: "LIRA",
    },
    {
      countryName: "UGANDA",
      regionCode: 104,
      regionName: "LUWERO",
    },
    {
      countryName: "UGANDA",
      regionCode: 221,
      regionName: "MANAFWA",
    },
    {
      countryName: "UGANDA",
      regionCode: 320,
      regionName: "MARACHA (MARACHA-TEREGO)",
    },
    {
      countryName: "UGANDA",
      regionCode: 105,
      regionName: "MASAKA",
    },
    {
      countryName: "UGANDA",
      regionCode: 409,
      regionName: "MASINDI",
    },
    {
      countryName: "UGANDA",
      regionCode: 214,
      regionName: "MAYUGE",
    },
    {
      countryName: "UGANDA",
      regionCode: 209,
      regionName: "MBALE",
    },
    {
      countryName: "UGANDA",
      regionCode: 410,
      regionName: "MBARARA",
    },
    {
      countryName: "UGANDA",
      regionCode: 114,
      regionName: "MITYANA",
    },
    {
      countryName: "UGANDA",
      regionCode: 308,
      regionName: "MOROTO",
    },
    {
      countryName: "UGANDA",
      regionCode: 309,
      regionName: "MOYO",
    },
    {
      countryName: "UGANDA",
      regionCode: 106,
      regionName: "MPIGI",
    },
    {
      countryName: "UGANDA",
      regionCode: 107,
      regionName: "MUBENDE",
    },
    {
      countryName: "UGANDA",
      regionCode: 108,
      regionName: "MUKONO",
    },
    {
      countryName: "UGANDA",
      regionCode: 311,
      regionName: "NAKAPIRIPIRIT",
    },
    {
      countryName: "UGANDA",
      regionCode: 115,
      regionName: "NAKASEKE",
    },
    {
      countryName: "UGANDA",
      regionCode: 109,
      regionName: "NAKASONGOLA",
    },
    {
      countryName: "UGANDA",
      regionCode: 222,
      regionName: "NAMUTUMBA (BUSIKI)",
    },
    {
      countryName: "UGANDA",
      regionCode: 310,
      regionName: "NEBBI",
    },
    {
      countryName: "UGANDA",
      regionCode: 411,
      regionName: "NTUNGAMO",
    },
    {
      countryName: "UGANDA",
      regionCode: 321,
      regionName: "OYAM",
    },
    {
      countryName: "UGANDA",
      regionCode: 312,
      regionName: "PADER",
    },
    {
      countryName: "UGANDA",
      regionCode: 210,
      regionName: "PALLISA",
    },
    {
      countryName: "UGANDA",
      regionCode: 110,
      regionName: "RAKAI",
    },
    {
      countryName: "UGANDA",
      regionCode: 412,
      regionName: "RUKUNGIRI",
    },
    {
      countryName: "UGANDA",
      regionCode: 111,
      regionName: "SEMBABULE",
    },
    {
      countryName: "UGANDA",
      regionCode: 215,
      regionName: "SIRONKO",
    },
    {
      countryName: "UGANDA",
      regionCode: 211,
      regionName: "SOROTI",
    },
    {
      countryName: "UGANDA",
      regionCode: 212,
      regionName: "TORORO",
    },
    {
      countryName: "UGANDA",
      regionCode: 113,
      regionName: "WAKISO",
    },
    {
      countryName: "UGANDA",
      regionCode: 313,
      regionName: "YUMBE",
    },
    {
      countryName: "UKRAINE",
      regionCode: 71,
      regionName: "CHERKASKA OBLAST",
    },
    {
      countryName: "UKRAINE",
      regionCode: 74,
      regionName: "CHERNIHIVSKA OBLAST",
    },
    {
      countryName: "UKRAINE",
      regionCode: 77,
      regionName: "CHERNIVETSKA OBLAST",
    },
    {
      countryName: "UKRAINE",
      regionCode: 12,
      regionName: "DNIPROPETROVSKA OBLAST",
    },
    {
      countryName: "UKRAINE",
      regionCode: 14,
      regionName: "DONETSKA OBLAST",
    },
    {
      countryName: "UKRAINE",
      regionCode: 26,
      regionName: "IVANO-FRANKIVSKA OBLAST",
    },
    {
      countryName: "UKRAINE",
      regionCode: 63,
      regionName: "KHARKIVSKA OBLAST",
    },
    {
      countryName: "UKRAINE",
      regionCode: 65,
      regionName: "KHERSONSKA OBLAST",
    },
    {
      countryName: "UKRAINE",
      regionCode: 68,
      regionName: "KHMELNYTSKA OBLAST",
    },
    {
      countryName: "UKRAINE",
      regionCode: 35,
      regionName: "KIROVOHRADSKA OBLAST",
    },
    {
      countryName: "UKRAINE",
      regionCode: 30,
      regionName: "KYIV",
    },
    {
      countryName: "UKRAINE",
      regionCode: 32,
      regionName: "KYIVSKA OBLAST",
    },
    {
      countryName: "UKRAINE",
      regionCode: 9,
      regionName: "LUHANSKA OBLAST",
    },
    {
      countryName: "UKRAINE",
      regionCode: 46,
      regionName: "LVIVSKA OBLAST",
    },
    {
      countryName: "UKRAINE",
      regionCode: 48,
      regionName: "MYKOLAIVSKA OBLAST",
    },
    {
      countryName: "UKRAINE",
      regionCode: 51,
      regionName: "ODESKA OBLAST",
    },
    {
      countryName: "UKRAINE",
      regionCode: 53,
      regionName: "POLTAVSKA OBLAST",
    },
    {
      countryName: "UKRAINE",
      regionCode: 43,
      regionName: "RESPUBLIKA KRYM",
    },
    {
      countryName: "UKRAINE",
      regionCode: 56,
      regionName: "RIVNENSKA OBLAST",
    },
    {
      countryName: "UKRAINE",
      regionCode: 40,
      regionName: "SEVASTOPOL",
    },
    {
      countryName: "UKRAINE",
      regionCode: 59,
      regionName: "SUMSKA OBLAST",
    },
    {
      countryName: "UKRAINE",
      regionCode: 61,
      regionName: "TERNOPILSKA OBLAST",
    },
    {
      countryName: "UKRAINE",
      regionCode: 5,
      regionName: "VINNYTSKA OBLAST",
    },
    {
      countryName: "UKRAINE",
      regionCode: 7,
      regionName: "VOLYNSKA OBLAST",
    },
    {
      countryName: "UKRAINE",
      regionCode: 21,
      regionName: "ZAKARPATSKA OBLAST",
    },
    {
      countryName: "UKRAINE",
      regionCode: 23,
      regionName: "ZAPORIZKA OBLAST",
    },
    {
      countryName: "UKRAINE",
      regionCode: 18,
      regionName: "ZHYTOMYRSKA OBLAST",
    },
    {
      countryName: "UNITED ARAB EMIRATES (THE)",
      regionCode: "AZ",
      regionName: "ABU ZABY (ABU DHABI)",
    },
    {
      countryName: "UNITED ARAB EMIRATES (THE)",
      regionCode: "AJ",
      regionName: "AJMAN",
    },
    {
      countryName: "UNITED ARAB EMIRATES (THE)",
      regionCode: "FU",
      regionName: "AL FUJAYRAH",
    },
    {
      countryName: "UNITED ARAB EMIRATES (THE)",
      regionCode: "SH",
      regionName: "ASH SHARIQAH (SHARJAH)",
    },
    {
      countryName: "UNITED ARAB EMIRATES (THE)",
      regionCode: "DU",
      regionName: "DUBAYY (DUBAI)",
    },
    {
      countryName: "UNITED ARAB EMIRATES (THE)",
      regionCode: "RK",
      regionName: "RA’S AL KHAYMAH",
    },
    {
      countryName: "UNITED ARAB EMIRATES (THE)",
      regionCode: "UQ",
      regionName: "UMM AL QAYWAYN",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "ABE",
      regionName: "ABERDEEN CITY",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "ABD",
      regionName: "ABERDEENSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "ANS",
      regionName: "ANGUS",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "ANT",
      regionName: "ANTRIM",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "ARD",
      regionName: "ARDS",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "AGB",
      regionName: "ARGYLL AND BUTE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "ARM",
      regionName: "ARMAGH",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "BLA",
      regionName: "BALLYMENA",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "BLY",
      regionName: "BALLYMONEY",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "BNB",
      regionName: "BANBRIDGE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "BDG",
      regionName: "BARKING AND DAGENHAM",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "BNE",
      regionName: "BARNET",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "BNS",
      regionName: "BARNSLEY",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "BAS",
      regionName: "BATH AND NORTH EAST SOMERSET",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "BDF",
      regionName: "BEDFORDSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "BFS",
      regionName: "BELFAST",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "BEX",
      regionName: "BEXLEY",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "BIR",
      regionName: "BIRMINGHAM",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "BBD",
      regionName: "BLACKBURN WITH DARWEN",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "BPL",
      regionName: "BLACKPOOL",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "BGW",
      regionName: "BLAENAU GWENT",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "BOL",
      regionName: "BOLTON",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "BMH",
      regionName: "BOURNEMOUTH",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "BRC",
      regionName: "BRACKNELL FOREST",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "BRD",
      regionName: "BRADFORD",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "BEN",
      regionName: "BRENT",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "BGE",
      regionName: "BRIDGEND",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "BNH",
      regionName: "BRIGHTON AND HOVE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "BST",
      regionName: "BRISTOL, CITY OF",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "BRY",
      regionName: "BROMLEY",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "BKM",
      regionName: "BUCKINGHAMSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "BUR",
      regionName: "BURY",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "CAY",
      regionName: "CAERPHILLY (CAERFFILI)",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "CLD",
      regionName: "CALDERDALE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "CAM",
      regionName: "CAMBRIDGESHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "CMD",
      regionName: "CAMDEN",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "CRF",
      regionName: "CARDIFF (CAERDYDD CRD)",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "CMN",
      regionName: "CARMARTHENSHIRE (SIR GAERFYRDDIN)",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "CKF",
      regionName: "CARRICKFERGUS",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "CSR",
      regionName: "CASTLEREAGH",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "CGN",
      regionName: "CEREDIGION (SIR CEREDIGION)",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "CHS",
      regionName: "CHESHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "CLK",
      regionName: "CLACKMANNANSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "CLR",
      regionName: "COLERAINE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "CWY",
      regionName: "CONWY",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "CKT",
      regionName: "COOKSTOWN",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "CON",
      regionName: "CORNWALL",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "COV",
      regionName: "COVENTRY",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "CGV",
      regionName: "CRAIGAVON",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "CRY",
      regionName: "CROYDON",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "CMA",
      regionName: "CUMBRIA",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "DAL",
      regionName: "DARLINGTON",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "DEN",
      regionName: "DENBIGHSHIRE (SIR DDINBYCH)",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "DER",
      regionName: "DERBY",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "DBY",
      regionName: "DERBYSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "DRY",
      regionName: "DERRY",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "DEV",
      regionName: "DEVON",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "DNC",
      regionName: "DONCASTER",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "DOR",
      regionName: "DORSET",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "DOW",
      regionName: "DOWN",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "DUD",
      regionName: "DUDLEY",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "DGY",
      regionName: "DUMFRIES AND GALLOWAY",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "DND",
      regionName: "DUNDEE CITY",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "DGN",
      regionName: "DUNGANNON",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "DUR",
      regionName: "DURHAM",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "EAL",
      regionName: "EALING",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "EAY",
      regionName: "EAST AYRSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "EDU",
      regionName: "EAST DUNBARTONSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "ELN",
      regionName: "EAST LOTHIAN",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "ERW",
      regionName: "EAST RENFREWSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "ERY",
      regionName: "EAST RIDING OF YORKSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "ESX",
      regionName: "EAST SUSSEX",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "EDH",
      regionName: "EDINBURGH, CITY OF",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "ELS",
      regionName: "EILEAN SIAR",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "ENF",
      regionName: "ENFIELD",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "ESS",
      regionName: "ESSEX",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "FAL",
      regionName: "FALKIRK",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "FER",
      regionName: "FERMANAGH",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "FIF",
      regionName: "FIFE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "FLN",
      regionName: "FLINTSHIRE (SIR Y FFLINT F)",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "GAT",
      regionName: "GATESHEAD",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "GLG",
      regionName: "GLASGOW CITY",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "GLS",
      regionName: "GLOUCESTERSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "GRE",
      regionName: "GREENWICH",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "GWN",
      regionName: "GWYNEDD",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "HCK",
      regionName: "HACKNEY",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "HAL",
      regionName: "HALTON",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "HMF",
      regionName: "HAMMERSMITH AND FULHAM",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "HAM",
      regionName: "HAMPSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "HRY",
      regionName: "HARINGEY",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "HRW",
      regionName: "HARROW",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "HPL",
      regionName: "HARTLEPOOL",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "HAV",
      regionName: "HAVERING",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "HEF",
      regionName: "HEREFORDSHIRE, COUNTY OF",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "HRT",
      regionName: "HERTFORDSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "HLD",
      regionName: "HIGHLAND",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "HIL",
      regionName: "HILLINGDON",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "HNS",
      regionName: "HOUNSLOW",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "IVC",
      regionName: "INVERCLYDE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "AGY",
      regionName: "ISLE OF ANGLESEY (SIR YNYS MON)",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "IOW",
      regionName: "ISLE OF WIGHT",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "IOS",
      regionName: "ISLES OF SCILLY",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "ISL",
      regionName: "ISLINGTON",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "KEC",
      regionName: "KENSINGTON AND CHELSEA",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "KEN",
      regionName: "KENT",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "KHL",
      regionName: "KINGSTON UPON HULL, CITY OF",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "KTT",
      regionName: "KINGSTON UPON THAMES",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "KIR",
      regionName: "KIRKLEES",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "KWL",
      regionName: "KNOWSLEY",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "LBH",
      regionName: "LAMBETH",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "LAN",
      regionName: "LANCASHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "LRN",
      regionName: "LARNE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "LDS",
      regionName: "LEEDS",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "LCE",
      regionName: "LEICESTER",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "LEC",
      regionName: "LEICESTERSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "LEW",
      regionName: "LEWISHAM",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "LMV",
      regionName: "LIMAVADY",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "LIN",
      regionName: "LINCOLNSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "LSB",
      regionName: "LISBURN",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "LIV",
      regionName: "LIVERPOOL",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "LND",
      regionName: "LONDON, CITY OF",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "LUT",
      regionName: "LUTON",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "MFT",
      regionName: "MAGHERAFELT",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "MAN",
      regionName: "MANCHESTER",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "MDW",
      regionName: "MEDWAY",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "MTY",
      regionName: "MERTHYR TYDFIL",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "MRT",
      regionName: "MERTON",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "MDB",
      regionName: "MIDDLESBROUGH",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "MLN",
      regionName: "MIDLOTHIAN",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "MIK",
      regionName: "MILTON KEYNES",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "MON",
      regionName: "MONMOUTHSHIRE (SIR FYNWY)",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "MRY",
      regionName: "MORAY",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "MYL",
      regionName: "MOYLE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "NTL",
      regionName: "NEATH PORT TALBOT (CASTELL-NEDD)",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "NET",
      regionName: "NEWCASTLE UPON TYNE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "NWM",
      regionName: "NEWHAM",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "NWP",
      regionName: "NEWPORT (CASNEWYDD)",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "NYM",
      regionName: "NEWRY AND MOURNE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "NTA",
      regionName: "NEWTOWNABBEY",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "NFK",
      regionName: "NORFOLK",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "NAY",
      regionName: "NORTH AYRSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "NDN",
      regionName: "NORTH DOWN",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "NEL",
      regionName: "NORTH EAST LINCOLNSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "NLK",
      regionName: "NORTH LANARKSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "NLN",
      regionName: "NORTH LINCOLNSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "NSM",
      regionName: "NORTH SOMERSET",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "NTY",
      regionName: "NORTH TYNESIDE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "NYK",
      regionName: "NORTH YORKSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "NTH",
      regionName: "NORTHAMPTONSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "NBL",
      regionName: "NORTHUMBERLAND",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "NTT",
      regionName: "NOTTHINGHAMSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "NGM",
      regionName: "NOTTINGHAM",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "OLD",
      regionName: "OLDHAM",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "OMH",
      regionName: "OMAGH",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "ORK",
      regionName: "ORKNEY ISLANDS",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "OXF",
      regionName: "OXFORDSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "PEM",
      regionName: "PEMBROKESHIRE (SIR BENFRO)",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "PKN",
      regionName: "PERTH AND KINROSS",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "PTE",
      regionName: "PETERBOROUGH",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "PLY",
      regionName: "PLYMOUTH",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "POL",
      regionName: "POOLE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "POR",
      regionName: "PORTSMOUTH",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "POW",
      regionName: "POWYS",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "RDG",
      regionName: "READING",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "RDB",
      regionName: "REDBRIDGE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "RCC",
      regionName: "REDCARE AND CLEVELAND",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "RFW",
      regionName: "RENFREWSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "RCT",
      regionName: "RHONDDA, CYNON, TAFF",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "RIC",
      regionName: "RICHMOND UPON THAMES",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "RCH",
      regionName: "ROCHDALE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "ROT",
      regionName: "ROTHERHAM",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "RUT",
      regionName: "RUTLAND",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "SLF",
      regionName: "SALFORD",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "SAW",
      regionName: "SANDWELL",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "SCB",
      regionName: "SCOTTISH BORDERS, THE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "SFT",
      regionName: "SEFTON",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "SHF",
      regionName: "SHEFFIELD",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "ZET",
      regionName: "SHETLAND ISLANDS",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "SHR",
      regionName: "SHROPSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "SLG",
      regionName: "SLOUGH",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "SOL",
      regionName: "SOLIHULL",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "SOM",
      regionName: "SOMERSET",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "SAY",
      regionName: "SOUTH AYRSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "SGC",
      regionName: "SOUTH GLOUCESTERSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "SLK",
      regionName: "SOUTH LANARKSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "STY",
      regionName: "SOUTH TYNESIDE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "STH",
      regionName: "SOUTHAMPTON",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "SOS",
      regionName: "SOUTHEND-ON-SEA",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "SWK",
      regionName: "SOUTHWARK",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "SHN",
      regionName: "ST. HELENS",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "STS",
      regionName: "STAFFORDSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "STG",
      regionName: "STIRLING",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "SKP",
      regionName: "STOCKPORT",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "STT",
      regionName: "STOCKTON-ON-TEES",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "STE",
      regionName: "STOKE-ON-TRENT",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "STB",
      regionName: "STRABANE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "SFK",
      regionName: "SUFFOLK",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "SND",
      regionName: "SUNDERLAND",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "SRY",
      regionName: "SURREY",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "STN",
      regionName: "SUTTON",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "SWA",
      regionName: "SWANSEA (ABERTAWE)",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "SWD",
      regionName: "SWINDON",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "TAM",
      regionName: "TAMESIDE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "TFW",
      regionName: "TELFORD AND WREKIN",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "THR",
      regionName: "THURROCK",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "TOB",
      regionName: "TORBAY",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "TOF",
      regionName: "TORFAEN (TOR-FAEN)",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "TWH",
      regionName: "TOWER HAMLETS",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "TRF",
      regionName: "TRAFFORD",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "VGL",
      regionName: "VALE OF GLAMORGAN",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "WKF",
      regionName: "WAKEFIELD",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "WLL",
      regionName: "WALSALL",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "WFT",
      regionName: "WALTHAM FORST",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "WND",
      regionName: "WANDSWORTH",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "WRT",
      regionName: "WARRINGTON",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "WAR",
      regionName: "WARWICKSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "WBK",
      regionName: "WEST BERKSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "WDU",
      regionName: "WEST DUNBARTONSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "WLN",
      regionName: "WEST LOTHIAN",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "WSX",
      regionName: "WEST SUSSEX",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "WSM",
      regionName: "WESTMINSTER",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "WGN",
      regionName: "WIGAN",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "WIL",
      regionName: "WILTSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "WNM",
      regionName: "WINDSOR AND MAIDENHEAD",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "WRL",
      regionName: "WIRRAL",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "WOK",
      regionName: "WOKINGHAM",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "WLV",
      regionName: "WOLVERHAMPTON",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "WOR",
      regionName: "WORCESTERSHIRE",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "WRX",
      regionName: "WREXHAM (WRECSAM)",
    },
    {
      countryName: "UNITED KINGDOM OF GREAT BRITAIN",
      regionCode: "YOR",
      regionName: "YORK",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "AL",
      regionName: "ALABAMA",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "AK",
      regionName: "ALASKA",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "AZ",
      regionName: "ARIZONA",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "AR",
      regionName: "ARKANSAS",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "CA",
      regionName: "CALIFORNIA",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "CO",
      regionName: "COLORADO",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "CT",
      regionName: "CONNETICUT",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "DE",
      regionName: "DELAWARE",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "DC",
      regionName: "DISTRICT OF COLOMBIA",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "FL",
      regionName: "FLORIDA",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "GA",
      regionName: "GEORGIA",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "HI",
      regionName: "HAWAII",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "ID",
      regionName: "IDAHO",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "IL",
      regionName: "ILLINOIS",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "IN",
      regionName: "INDIANA",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "IA",
      regionName: "IOWA",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "KS",
      regionName: "KANSAS",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "KY",
      regionName: "KENTUCKY",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "LA",
      regionName: "LOUSIANA",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "ME",
      regionName: "MAINE",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "MD",
      regionName: "MARYLAND",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "MA",
      regionName: "MASSACHUSETTS",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "MI",
      regionName: "MICHIGAN",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "MN",
      regionName: "MINNESOTA",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "MS",
      regionName: "MISSISSIPPI",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "MO",
      regionName: "MISSOURI",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "MT",
      regionName: "MONTANA",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "NE",
      regionName: "NEBRASKA",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "NV",
      regionName: "NEVADA",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "NH",
      regionName: "NEW HAMPSHIRE",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "NJ",
      regionName: "NEW JERSEY",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "NM",
      regionName: "NEW MEXICO",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "NY",
      regionName: "NEW YORK",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "NC",
      regionName: "NORTH CAROLINA",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "ND",
      regionName: "NORTH DAKOTA",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "OH",
      regionName: "OHIO",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "OK",
      regionName: "OKLAHOMA",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "OR",
      regionName: "OREGON",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "PA",
      regionName: "PENNSYLVANIA",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "RI",
      regionName: "RHODE ISLAND",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "SC",
      regionName: "SOUTH CAROLINA",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "SD",
      regionName: "SOUTH DAKOTA",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "TN",
      regionName: "TENNESSEE",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "TX",
      regionName: "TEXAS",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "UT",
      regionName: "UTAH",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "UT",
      regionName: "VERMONT",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "VA",
      regionName: "VIRGINIA",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "WA",
      regionName: "WASHINGTON",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "WV",
      regionName: "WEST VIRGINIA",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "WI",
      regionName: "WISCONSIN",
    },
    {
      countryName: "UNITED STATES of AMERICA (THE)",
      regionCode: "WY",
      regionName: "WYOMING",
    },
    {
      countryName: "U.S. MINOR OUTLYING ISLANDS",
      regionCode: 81,
      regionName: "BAKER ISLAND",
    },
    {
      countryName: "U.S. MINOR OUTLYING ISLANDS",
      regionCode: 84,
      regionName: "HOWLAND ISLAND",
    },
    {
      countryName: "U.S. MINOR OUTLYING ISLANDS",
      regionCode: 86,
      regionName: "JARVIS ISLAND",
    },
    {
      countryName: "U.S. MINOR OUTLYING ISLANDS",
      regionCode: 67,
      regionName: "JOHNSTON ATOLL",
    },
    {
      countryName: "U.S. MINOR OUTLYING ISLANDS",
      regionCode: 89,
      regionName: "KINGMAN REEF",
    },
    {
      countryName: "U.S. MINOR OUTLYING ISLANDS",
      regionCode: 71,
      regionName: "MIDWAY ISLANDS",
    },
    {
      countryName: "U.S. MINOR OUTLYING ISLANDS",
      regionCode: 76,
      regionName: "NAVASSA ISLAND",
    },
    {
      countryName: "U.S. MINOR OUTLYING ISLANDS",
      regionCode: 95,
      regionName: "PALMYRA ATOLL",
    },
    {
      countryName: "U.S. MINOR OUTLYING ISLANDS",
      regionCode: 79,
      regionName: "WAKE ISLAND",
    },
    {
      countryName: "URUGUAY",
      regionCode: "AR",
      regionName: "ARTIGAS",
    },
    {
      countryName: "URUGUAY",
      regionCode: "CA",
      regionName: "CANELONES",
    },
    {
      countryName: "URUGUAY",
      regionCode: "CL",
      regionName: "CERRO LARGO",
    },
    {
      countryName: "URUGUAY",
      regionCode: "CO",
      regionName: "COLONIA",
    },
    {
      countryName: "URUGUAY",
      regionCode: "DU",
      regionName: "DURAZNO",
    },
    {
      countryName: "URUGUAY",
      regionCode: "FD",
      regionName: "FLORIDA",
    },
    {
      countryName: "URUGUAY",
      regionCode: "FS",
      regionName: "FLORES",
    },
    {
      countryName: "URUGUAY",
      regionCode: "LA",
      regionName: "LAVELLEJA",
    },
    {
      countryName: "URUGUAY",
      regionCode: "MA",
      regionName: "MALDONADO",
    },
    {
      countryName: "URUGUAY",
      regionCode: "MO",
      regionName: "MONTEVIDEO",
    },
    {
      countryName: "URUGUAY",
      regionCode: "PA",
      regionName: "PAYSANDU",
    },
    {
      countryName: "URUGUAY",
      regionCode: "RN",
      regionName: "RIO NEGRO",
    },
    {
      countryName: "URUGUAY",
      regionCode: "RO",
      regionName: "ROCHA",
    },
    {
      countryName: "URUGUAY",
      regionCode: "RV",
      regionName: "RIVERA",
    },
    {
      countryName: "URUGUAY",
      regionCode: "SA",
      regionName: "SALTO",
    },
    {
      countryName: "URUGUAY",
      regionCode: "SJ",
      regionName: "SAN JOSE",
    },
    {
      countryName: "URUGUAY",
      regionCode: "SO",
      regionName: "SORIANO",
    },
    {
      countryName: "URUGUAY",
      regionCode: "TA",
      regionName: "TACUAREMBO",
    },
    {
      countryName: "URUGUAY",
      regionCode: "TT",
      regionName: "TREINTA Y TRES",
    },
    {
      countryName: "UZBEKISTAN",
      regionCode: "AN",
      regionName: "ANDIJON",
    },
    {
      countryName: "UZBEKISTAN",
      regionCode: "BU",
      regionName: "BUXORO",
    },
    {
      countryName: "UZBEKISTAN",
      regionCode: "FA",
      regionName: "FARGONA",
    },
    {
      countryName: "UZBEKISTAN",
      regionCode: "JI",
      regionName: "JIZZAX",
    },
    {
      countryName: "UZBEKISTAN",
      regionCode: "NG",
      regionName: "NAMANGAN",
    },
    {
      countryName: "UZBEKISTAN",
      regionCode: "NW",
      regionName: "NAVOIY",
    },
    {
      countryName: "UZBEKISTAN",
      regionCode: "QA",
      regionName: "QASHQADARYO",
    },
    {
      countryName: "UZBEKISTAN",
      regionCode: "QR",
      regionName: "QORAQALPOGISTON RESPUBLIKASI",
    },
    {
      countryName: "UZBEKISTAN",
      regionCode: "SA",
      regionName: "SAMARQAND",
    },
    {
      countryName: "UZBEKISTAN",
      regionCode: "SI",
      regionName: "SIRDARYO",
    },
    {
      countryName: "UZBEKISTAN",
      regionCode: "SU",
      regionName: "SURXONDARYO",
    },
    {
      countryName: "UZBEKISTAN",
      regionCode: "TK",
      regionName: "TOSHKENT",
    },
    {
      countryName: "UZBEKISTAN",
      regionCode: "TO",
      regionName: "TOSHKENT",
    },
    {
      countryName: "UZBEKISTAN",
      regionCode: "XO",
      regionName: "XORAZM",
    },
    {
      countryName: "VANUATU",
      regionCode: "MAP",
      regionName: "MALAMPA",
    },
    {
      countryName: "VANUATU",
      regionCode: "PAM",
      regionName: "PENAMA",
    },
    {
      countryName: "VANUATU",
      regionCode: "SAM",
      regionName: "SANMA",
    },
    {
      countryName: "VANUATU",
      regionCode: "SEE",
      regionName: "SHEFA",
    },
    {
      countryName: "VANUATU",
      regionCode: "TAE",
      regionName: "TAFEA",
    },
    {
      countryName: "VANUATU",
      regionCode: "TOB",
      regionName: "TORBA",
    },
    {
      countryName: "VENEZUELA",
      regionCode: "Z",
      regionName: "AMAZONAS",
    },
    {
      countryName: "VENEZUELA",
      regionCode: "B",
      regionName: "ANZOATEGUI",
    },
    {
      countryName: "VENEZUELA",
      regionCode: "C",
      regionName: "APURE",
    },
    {
      countryName: "VENEZUELA",
      regionCode: "D",
      regionName: "ARAGUA",
    },
    {
      countryName: "VENEZUELA",
      regionCode: "E",
      regionName: "BARINAS",
    },
    {
      countryName: "VENEZUELA",
      regionCode: "F",
      regionName: "BOLIVAR",
    },
    {
      countryName: "VENEZUELA",
      regionCode: "G",
      regionName: "CARABOBO",
    },
    {
      countryName: "VENEZUELA",
      regionCode: "H",
      regionName: "COJEDES",
    },
    {
      countryName: "VENEZUELA",
      regionCode: "Y",
      regionName: "DELTA AMACURO",
    },
    {
      countryName: "VENEZUELA",
      regionCode: "W",
      regionName: "DEPENDENCIAS FEDERALES",
    },
    {
      countryName: "VENEZUELA",
      regionCode: "A",
      regionName: "DISTRITO CAPTAL",
    },
    {
      countryName: "VENEZUELA",
      regionCode: "I",
      regionName: "FALCON",
    },
    {
      countryName: "VENEZUELA",
      regionCode: "J",
      regionName: "GUARICO",
    },
    {
      countryName: "VENEZUELA",
      regionCode: "K",
      regionName: "LARA",
    },
    {
      countryName: "VENEZUELA",
      regionCode: "L",
      regionName: "MERIDA",
    },
    {
      countryName: "VENEZUELA",
      regionCode: "M",
      regionName: "MIRANDA",
    },
    {
      countryName: "VENEZUELA",
      regionCode: "N",
      regionName: "MONAGAS",
    },
    {
      countryName: "VENEZUELA",
      regionCode: "O",
      regionName: "NUEVA ESPARTA",
    },
    {
      countryName: "VENEZUELA",
      regionCode: "P",
      regionName: "PORTUGUESA",
    },
    {
      countryName: "VENEZUELA",
      regionCode: "R",
      regionName: "SUCRE",
    },
    {
      countryName: "VENEZUELA",
      regionCode: "S",
      regionName: "TACHIRA",
    },
    {
      countryName: "VENEZUELA",
      regionCode: "T",
      regionName: "TRUJILLO",
    },
    {
      countryName: "VENEZUELA",
      regionCode: "X",
      regionName: "VARGAS",
    },
    {
      countryName: "VENEZUELA",
      regionCode: "U",
      regionName: "YARACUY",
    },
    {
      countryName: "VENEZUELA",
      regionCode: "V",
      regionName: "ZULIA",
    },
    {
      countryName: "VIETNAM",
      regionCode: 44,
      regionName: "AN GIANG",
    },
    {
      countryName: "VIETNAM",
      regionCode: 43,
      regionName: "BA RIA VUNG TAU",
    },
    {
      countryName: "VIETNAM",
      regionCode: 54,
      regionName: "BAC GIANG",
    },
    {
      countryName: "VIETNAM",
      regionCode: 53,
      regionName: "BAC KAN",
    },
    {
      countryName: "VIETNAM",
      regionCode: 55,
      regionName: "BAC LIEU",
    },
    {
      countryName: "VIETNAM",
      regionCode: 56,
      regionName: "BAC NINH",
    },
    {
      countryName: "VIETNAM",
      regionCode: 50,
      regionName: "BEN TRE",
    },
    {
      countryName: "VIETNAM",
      regionCode: 58,
      regionName: "BINH PHUOC",
    },
    {
      countryName: "VIETNAM",
      regionCode: 40,
      regionName: "BINH THUAN",
    },
    {
      countryName: "VIETNAM",
      regionCode: 31,
      regionName: "BINHDINH",
    },
    {
      countryName: "VIETNAM",
      regionCode: 57,
      regionName: "BINHDUONG",
    },
    {
      countryName: "VIETNAM",
      regionCode: 59,
      regionName: "CA MAU",
    },
    {
      countryName: "VIETNAM",
      regionCode: 48,
      regionName: "CAN THO, THANH PHO",
    },
    {
      countryName: "VIETNAM",
      regionCode: 4,
      regionName: "CAOBANG",
    },
    {
      countryName: "VIETNAM",
      regionCode: 60,
      regionName: "DA NANG, THANH PHO",
    },
    {
      countryName: "VIETNAM",
      regionCode: 33,
      regionName: "DAK LAK",
    },
    {
      countryName: "VIETNAM",
      regionCode: 72,
      regionName: "DAK NONG",
    },
    {
      countryName: "VIETNAM",
      regionCode: 71,
      regionName: "DIENBIEN",
    },
    {
      countryName: "VIETNAM",
      regionCode: 39,
      regionName: "DONG NAI",
    },
    {
      countryName: "VIETNAM",
      regionCode: 45,
      regionName: "DONG THAP",
    },
    {
      countryName: "VIETNAM",
      regionCode: 30,
      regionName: "GIA LAI",
    },
    {
      countryName: "VIETNAM",
      regionCode: 3,
      regionName: "HA GIANG",
    },
    {
      countryName: "VIETNAM",
      regionCode: 63,
      regionName: "HA NAM",
    },
    {
      countryName: "VIETNAM",
      regionCode: 64,
      regionName: "HA NOI, THANH PHO",
    },
    {
      countryName: "VIETNAM",
      regionCode: 15,
      regionName: "HA TAY",
    },
    {
      countryName: "VIETNAM",
      regionCode: 23,
      regionName: "HA TINH",
    },
    {
      countryName: "VIETNAM",
      regionCode: 62,
      regionName: "HAI PHONG, THANH PHO",
    },
    {
      countryName: "VIETNAM",
      regionCode: 61,
      regionName: "HAIDUONG",
    },
    {
      countryName: "VIETNAM",
      regionCode: 73,
      regionName: "HAU GIANG",
    },
    {
      countryName: "VIETNAM",
      regionCode: 14,
      regionName: "HOABINH",
    },
    {
      countryName: "VIETNAM",
      regionCode: 65,
      regionName: "HOCHI MINH, THANH PHO (SAI GON)",
    },
    {
      countryName: "VIETNAM",
      regionCode: 66,
      regionName: "HUNG YEN",
    },
    {
      countryName: "VIETNAM",
      regionCode: 34,
      regionName: "KHANHHOA",
    },
    {
      countryName: "VIETNAM",
      regionCode: 47,
      regionName: "KIEN GIANG",
    },
    {
      countryName: "VIETNAM",
      regionCode: 28,
      regionName: "KON TUM",
    },
    {
      countryName: "VIETNAM",
      regionCode: 1,
      regionName: "LAICHAU",
    },
    {
      countryName: "VIETNAM",
      regionCode: 35,
      regionName: "LAMDONG",
    },
    {
      countryName: "VIETNAM",
      regionCode: 9,
      regionName: "LANG SON",
    },
    {
      countryName: "VIETNAM",
      regionCode: 2,
      regionName: "LAOCAI",
    },
    {
      countryName: "VIETNAM",
      regionCode: 41,
      regionName: "LONG AN",
    },
    {
      countryName: "VIETNAM",
      regionCode: 67,
      regionName: "NAMDINH",
    },
    {
      countryName: "VIETNAM",
      regionCode: 22,
      regionName: "NGHE AN",
    },
    {
      countryName: "VIETNAM",
      regionCode: 36,
      regionName: "NINH THUAN",
    },
    {
      countryName: "VIETNAM",
      regionCode: 18,
      regionName: "NINHBINH",
    },
    {
      countryName: "VIETNAM",
      regionCode: 68,
      regionName: "PHU THO",
    },
    {
      countryName: "VIETNAM",
      regionCode: 32,
      regionName: "PHU YEN",
    },
    {
      countryName: "VIETNAM",
      regionCode: 27,
      regionName: "QUANG NAM",
    },
    {
      countryName: "VIETNAM",
      regionCode: 29,
      regionName: "QUANG NGAI",
    },
    {
      countryName: "VIETNAM",
      regionCode: 13,
      regionName: "QUANG NINH",
    },
    {
      countryName: "VIETNAM",
      regionCode: 25,
      regionName: "QUANG TRI",
    },
    {
      countryName: "VIETNAM",
      regionCode: 24,
      regionName: "QUANGBINH",
    },
    {
      countryName: "VIETNAM",
      regionCode: 52,
      regionName: "SOC TRANG",
    },
    {
      countryName: "VIETNAM",
      regionCode: 5,
      regionName: "SON LA",
    },
    {
      countryName: "VIETNAM",
      regionCode: 37,
      regionName: "TAY NINH",
    },
    {
      countryName: "VIETNAM",
      regionCode: 69,
      regionName: "THAI NGUYEN",
    },
    {
      countryName: "VIETNAM",
      regionCode: 20,
      regionName: "THAIBINH",
    },
    {
      countryName: "VIETNAM",
      regionCode: 21,
      regionName: "THANHHOA",
    },
    {
      countryName: "VIETNAM",
      regionCode: 26,
      regionName: "THUA THIEN-HUE",
    },
    {
      countryName: "VIETNAM",
      regionCode: 46,
      regionName: "TIEN GIANG",
    },
    {
      countryName: "VIETNAM",
      regionCode: 51,
      regionName: "TRA VINH",
    },
    {
      countryName: "VIETNAM",
      regionCode: 7,
      regionName: "TUYEN QUANG",
    },
    {
      countryName: "VIETNAM",
      regionCode: 49,
      regionName: "VINH LONG",
    },
    {
      countryName: "VIETNAM",
      regionCode: 70,
      regionName: "VINH PHUC",
    },
    {
      countryName: "VIETNAM",
      regionCode: 6,
      regionName: "YENBAI",
    },
    {
      countryName: "VIRGIN ISLANDS (BRITISH)",
      regionCode: "VG",
      regionName: "VIRGIN ISLANDS (BRITISH)",
    },
    {
      countryName: "VIRGIN ISLANDS (U.S.)",
      regionCode: "VI",
      regionName: "VIRGIN ISLANDS (U.S.)",
    },
    {
      countryName: "WALLIS AND FUTUNA ISLANDS",
      regionCode: "WF",
      regionName: "WALLIS AND FUTUNA",
    },
    {
      countryName: "WESTERN SAHARA",
      regionCode: "EH",
      regionName: "WESTERN SAHARA",
    },
    {
      countryName: "YEMEN",
      regionCode: "AB",
      regionName: "ABYAN",
    },
    {
      countryName: "YEMEN",
      regionCode: "DA",
      regionName: "AD DALI",
    },
    {
      countryName: "YEMEN",
      regionCode: "AD",
      regionName: "ADAN",
    },
    {
      countryName: "YEMEN",
      regionCode: "BA",
      regionName: "AL BAYDA",
    },
    {
      countryName: "YEMEN",
      regionCode: "HU",
      regionName: "AL H UDAYDAH",
    },
    {
      countryName: "YEMEN",
      regionCode: "JA",
      regionName: "AL JAWF",
    },
    {
      countryName: "YEMEN",
      regionCode: "MR",
      regionName: "AL MAHRAH",
    },
    {
      countryName: "YEMEN",
      regionCode: "MW",
      regionName: "AL MAHWIT",
    },
    {
      countryName: "YEMEN",
      regionCode: "AM",
      regionName: "AMRAN",
    },
    {
      countryName: "YEMEN",
      regionCode: "DH",
      regionName: "DHAMAR",
    },
    {
      countryName: "YEMEN",
      regionCode: "HD",
      regionName: "HADRAMAWT",
    },
    {
      countryName: "YEMEN",
      regionCode: "HJ",
      regionName: "HAJJAH",
    },
    {
      countryName: "YEMEN",
      regionCode: "IB",
      regionName: "IBB",
    },
    {
      countryName: "YEMEN",
      regionCode: "LA",
      regionName: "LAHIJ",
    },
    {
      countryName: "YEMEN",
      regionCode: "MA",
      regionName: "MARIB",
    },
    {
      countryName: "YEMEN",
      regionCode: "SD",
      regionName: "SADAH",
    },
    {
      countryName: "YEMEN",
      regionCode: "SN",
      regionName: "SANA",
    },
    {
      countryName: "YEMEN",
      regionCode: "SA",
      regionName: "SANA (CITY)",
    },
    {
      countryName: "YEMEN",
      regionCode: "SH",
      regionName: "SHABWAH",
    },
    {
      countryName: "YEMEN",
      regionCode: "TA",
      regionName: "TAIZZ",
    },
    {
      countryName: "ZAMBIA",
      regionCode: 2,
      regionName: "CENTRAL",
    },
    {
      countryName: "ZAMBIA",
      regionCode: 8,
      regionName: "COPPERBELT",
    },
    {
      countryName: "ZAMBIA",
      regionCode: 3,
      regionName: "EASTERN",
    },
    {
      countryName: "ZAMBIA",
      regionCode: 4,
      regionName: "LUAPULA",
    },
    {
      countryName: "ZAMBIA",
      regionCode: 9,
      regionName: "LUSAKA",
    },
    {
      countryName: "ZAMBIA",
      regionCode: 5,
      regionName: "NORTHERN",
    },
    {
      countryName: "ZAMBIA",
      regionCode: 6,
      regionName: "NORTH-WESTERN",
    },
    {
      countryName: "ZAMBIA",
      regionCode: 7,
      regionName: "SOUTHERN",
    },
    {
      countryName: "ZAMBIA",
      regionCode: 1,
      regionName: "WESTERN",
    },
    {
      countryName: "ZIMBABWE",
      regionCode: "BU",
      regionName: "BULAWAYO",
    },
    {
      countryName: "ZIMBABWE",
      regionCode: "HA",
      regionName: "HARARE",
    },
    {
      countryName: "ZIMBABWE",
      regionCode: "MA",
      regionName: "MANICALAND",
    },
    {
      countryName: "ZIMBABWE",
      regionCode: "MC",
      regionName: "MASHONALAND CENTRAL",
    },
    {
      countryName: "ZIMBABWE",
      regionCode: "ME",
      regionName: "MASHONALAND EAST",
    },
    {
      countryName: "ZIMBABWE",
      regionCode: "MW",
      regionName: "MASHONALAND WEST",
    },
    {
      countryName: "ZIMBABWE",
      regionCode: "MV",
      regionName: "MASVINGO",
    },
    {
      countryName: "ZIMBABWE",
      regionCode: "MN",
      regionName: "MATABELELAND NORTH",
    },
    {
      countryName: "ZIMBABWE",
      regionCode: "MS",
      regionName: "MATABELELAND SOUTH",
    },
    {
      countryName: "ZIMBABWE",
      regionCode: "MI",
      regionName: "MIDLANDS",
    },
  ];
  const options = regions
    .filter((region) => region.countryName === countryName)
    .map((region) => ({
      title: `${region.regionCode}:${region.regionName}`,
      value: region.regionCode,
      key: `${region.regionCode}:${region.regionName}`,
    }));

  if (typeof countryName === "string") {
    return options;
  }
  return [];
};

export default AmexRegionOptions;
